webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(0);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/1Bq8TbP/%3F1731411132662&title=La%20profec%C3%ADa%20del%20drag%C3%B3n&summary=%EF%BF%BDEs%20posible%20que%20lo%20que%20estamos%20presenciando%20en%20el%20final%20de%20los%20tiempos%20sea%20la%20respuesta%20a%20una%20revelaci%EF%BF%BDn%20antigua%2C%20y%20que%20ahora%20estemos%20viendo%20su%20despliegue%3F%20%EF%BF%BDHay%20m%EF%BF%BDs%20en%20este%20mundo%20de%20lo%20que%20ven%20nuestros%20ojos%3F%20%EF%BF%BDExiste%20una%20visi%EF%BF%BDn%20antigua%20que%20revela%20lo%20que%20es&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/1Bq8TbP/%3F1731411132662",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=%EF%BF%BDEs%20posible%20que%20lo%20que%20estamos%20presenciando%20en%20el%20final%20de%20los%20tiempos%20sea%20la%20respuesta%20a%20una%20revelaci%EF%BF%BDn%20antigua%2C%20y%20que%20ahora%20estemos%20viendo%20su%20%0Dhttps://textcafe.co/books/1Bq8TbP/%3F1731411132662&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/1Bq8TbP/%3F1731411132662&posttype=link&caption=%EF%BF%BDEs%20posible%20que%20lo%20que%20estamos%20presenciando%20en%20el%20final%20de%20los%20tiempos%20sea%20la%20respuesta%20a%20una%20revelaci%EF%BF%BDn%20antigua%2C%20y%20que%20ahora%20estemos%20viendo%20su%20despliegue%3F%20%EF%BF%BDHay%20m%EF%BF%BDs%20en%20este%20mundo%20de%20lo%20que%20ven%20nuestros%20ojos%3F%20%EF%BF%BDExiste%20una%20visi%EF%BF%BDn%20antigua%20que%20revela%20lo%20que%20es",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/1Bq8TbP/%3F1731411132662&description=%EF%BF%BDEs%20posible%20que%20lo%20que%20estamos%20presenciando%20en%20el%20final%20de%20los%20tiempos%20sea%20la%20respuesta%20a%20una%20revelaci%EF%BF%BDn%20antigua%2C%20y%20que%20ahora%20estemos%20viendo%20su%20despliegue%3F%20%EF%BF%BDHay%20m%EF%BF%BDs%20en%20este%20mundo%20de%20lo%20que%20ven%20nuestros%20ojos%3F%20%EF%BF%BDExiste%20una%20visi%EF%BF%BDn%20antigua%20que%20revela%20lo%20que%20es&media=https://textcafe.co/books/1Bq8TbP/tc-custom/9781960436634.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781960436634&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=zN8LEQAAQBAJ&amp;rdid=book-zN8LEQAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781960436634').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/1Bq8TbP/tc-custom/9781960436634.jpg?1731411132662',
        alt: 'La profecía del dragón'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "cover", "La_profecía_del_dragón-Cahn_INT", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/1Bq8TbP/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(0);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_La_profeci_a_del_drago_n_Cahn_INT__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_La_profeci_a_del_drago_n_Cahn_INT___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_La_profeci_a_del_drago_n_Cahn_INT__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_last__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_last__);
/*jshint esversion: 6 */









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/cover",
    "name": "cover",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_cover___default.a
  }, {
    "path": "/La_profecía_del_dragón-Cahn_INT",
    "name": "La_profecía_del_dragón-Cahn_INT",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_La_profeci_a_del_drago_n_Cahn_INT___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Bq8TbP/tc-custom/9781960436634.jpg?1731411132662",
      "alt": "This image is the cover for the book La profecía del dragón"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("La profecía del dragón\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("¿Es posible que lo que estamos presenciando en el final de los tiempos sea la respuesta a una revelación antigua, y que ahora estemos viendo su despliegue? ¿Hay más en este mundo de lo que ven nuestros ojos? ¿Existe una visión antigua que revela lo que está ocurriendo ahora en nuestro mundo? ¿Hay una profecía antigua que nos dice lo que el futuro nos depara? ¿Existe una fuerza antigua que operó en tiempos antiguos y que ahora está actuando en el mundo moderno, determinando el curso de los eventos actuales, desde Israel hasta lo que amenaza con una Tercera Guerra Mundial, y tocando cada una de nuestras vidas? ¿Cuál es el misterio del dragón? ¿Estamos en medio de una guerra que ni siquiera nos damos cuenta que se está librando contra nosotros? ¿Cuál es el cronómetro más preciso que señala los últimos días? ¿Podemos descubrir sus planes y estrategias, incluso aquellos dirigidos contra nuestras propias vidas? ¿Hubo una revelación de hace tres mil años que determinó el ataque de Hamas a Israel, hasta el año, el mes, la semana y el día exacto? ¿Qué es el Fin de los Días, y están aquí? ¿Qué nos depara el futuro? Y mucho, mucho más Después de ocho bestsellers en el New York Times, Jonathan Cahn lanza ahora su nuevo éxito de ventas, LA PROFECÍA DEL DRAGÓN: Israel, la resurrección oscura y el fin de los tiempos, la revelación asombrosa que abre el misterio de nuestros tiempos, los eventos que sacuden nuestro mundo y lo que nos espera en los días venideros. El último libro de Jonathan Cahn abrirá los misterios de lo que ha sido, lo que está ocurriendo ahora y lo que está por suceder, incluso el fin de la era, desbloqueando revelaciones impactantes que te permitirán ver lo que está sucediendo en tu mundo de una manera completamente nueva.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jonathan Cahn\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('figure', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "epub:type": "cover"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "",
      "role": "doc-cover",
      "src": "image/CVR_la_profecia_del_dragon.jpg"
    }
  })])])])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "aria-label": "1",
      "epub:type": "pagebreak",
      "id": "page1",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "3",
      "epub:type": "pagebreak",
      "id": "page3",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "DEDICATION"
  }, [_vm._v("Y apareció en el cielo otra señal: "), _c('br'), _vm._v("un enorme dragón de color rojo encendido.")]), _vm._v(" "), _c('p', {
    staticClass: "DEDICATION _idGenParaOverride-1"
  }, [_vm._v("—Apocalipsis 12:3")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "4",
      "epub:type": "pagebreak",
      "id": "page4",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/4.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "5",
      "epub:type": "pagebreak",
      "id": "page5",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer091"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("Parte 1")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("El misterio")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "7",
      "epub:type": "pagebreak",
      "id": "page7",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("Capítulo 1")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("El misterio del mundo")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("n el mundo, ")]), _c('span', [_vm._v("hay mucho más que lo que vemos con nuestros ojos.")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Detrás de lo que observamos físicamente hay otro mundo, hay mucho más de lo que podemos captar, cuantificar o palpar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Tras la historia de este mundo se esconde otra no escrita, no hablada, desconocida.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Sin embargo, detrás de eso que mueve y transforma el mundo hay fuerzas invisibles, causas y agentes primordiales e imperecederos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Podrían esas cosas realmente ocultarse tras los acontecimientos concretos del mundo moderno?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Hemos sido avisados sobre tales cosas en los escritos de eras antiguas o recibido advertencias de una fuerza y agente específicos?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Además, ¿podrían esa fuerza o ese agente estar tras el surgimiento de guerras, males y calamidades?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Podría eso haber dirigido un evento que haya conmocionado recientemente a nuestro mundo y que haya contenido un misterio acerca del fin de los tiempos?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Somos todos protagonistas de un misterio que comenzó mucho antes de que naciéramos, que ha abarcado siglos y que —en los tiempos modernos— ha amenazado el futuro de nuestra planeta?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Fue todo predicho en las palabras de alguna profecía antigua? ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Estamos viviendo en los últimos tiempos?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Qué nos depara el futuro y hacia dónde nos lleva todo ello?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Qué es el misterio del Dragón?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Y qué tiene que ver todo esto contigo que estás leyendo estas palabras?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Este libro responderá esas cuestiones y, en el proceso, revelará los misterios de…")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "8",
      "epub:type": "pagebreak",
      "id": "page8",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("la resurrección oscura,")]), _vm._v(" "), _c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("el regreso de los pueblos del mar,")]), _vm._v(" "), _c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("la venganza de los tres mil,")]), _vm._v(" "), _c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("el sábado negro,")]), _vm._v(" "), _c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("la Sefelá,")]), _vm._v(" "), _c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("la fiesta del Dragón,")]), _vm._v(" "), _c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("el secreto en la montaña,")]), _vm._v(" "), _c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("el día 18.263,")]), _vm._v(" "), _c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("los colores del apocalipsis,")]), _vm._v(" "), _c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("la Bestia,")]), _vm._v(" "), _c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("la antigua visión que revela lo que está sucediendo en nuestro mundo y lo que está por venir,")]), _vm._v(" "), _c('p', {
    staticClass: "LIST-1"
  }, [_vm._v("y mucho más.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Todo empezó un viernes, en la noche, en octubre.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "9",
      "epub:type": "pagebreak",
      "id": "page9",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_vm._v("Capítulo 2")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Octubre")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("o planifiqué escribir ")]), _c('span', [_vm._v("este libro. El que iba a publicar era la continuación de ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("El regreso de los dioses")]), _vm._v(". Sin embargo, lo sucedido a través del mundo se combinó con una fuerte instrucción en mi espíritu de que la obra que estaba a punto de elaborar era para un tiempo futuro. Ahora, otro misterio iba a ser revelado.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Era octubre. Estaba preparando el mensaje que iba a exponer en el servicio nocturno del viernes en la congregación Beth Israel Worship Center, que dirijo en Wayne, Nueva Jersey. Debía hablar sobre uno de los misterios del libro anterior que había escrito, que acababa de publicarse un mes antes, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("El manifiesto de Josías")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A la mañana siguiente, Hamas lanzaría una masiva invasión —desde la Franja de Gaza— al interior de Israel. Este país sería tomado por sorpresa. Lo que ocurrió ese día en Israel conmocionó la sensibilidad de muchas personas en todo el mundo. Sin embargo, también sería la manifestación del misterio que yo había expresado la noche anterior.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El misterio presagiaba un evento venidero:")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Predijo que Israel sería atacado por sus enemigos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El ataque implicaría una invasión terrestre masiva, la primera de ese tipo en medio siglo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Tomaría a la nación por sorpresa.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aunque habría advertencias sobre su llegada, no se tomarían en serio.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La invasión ocurriría un sábado, el día de descanso hebreo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Sucedería en una de las fechas sagradas señaladas por Dios, indicadas en la Torá.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Conduciría a la guerra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ocurriría el primer sábado de octubre de 2023.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Todo sucedería a la mañana siguiente de que yo hablara sobre los fundamentos y parámetros del misterio. En este libro contaré la manera en que el misterio preordenó y predijo exactamente qué sucedería y cuándo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Esa noche, y lo que siguió, llevarían a la revelación de un misterio que comenzó en la antigüedad y se oculta tras los acontecimientos de los tiempos modernos.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "10",
      "epub:type": "pagebreak",
      "id": "page10",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_vm._v("Parte 2")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_vm._v("El Dragón")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "11",
      "epub:type": "pagebreak",
      "id": "page11",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_vm._v("Capítulo 3")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("El misterio del mal")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("l mal es ")]), _vm._v("una entidad antigua. En la cultura popular, a menudo, se representa en forma casi caricaturesca. Por esa razón es que, a veces, se descarta su existencia. Pero su presencia es muy real y su impacto en nuestro mundo, sumamente crucial. Si lo descartamos o lo ignoramos, lo hacemos bajo nuestro propio riesgo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Lo trascendente")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Qué es el mal? ¿Y cómo surgió? Eso es algo misterioso y, a la vez, conflictivo. El misterio "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("es")]), _vm._v(" el problema. Este problema se emplea en innumerables argumentos para intentar refutar la existencia o naturaleza de Dios. Para encontrar la respuesta, debemos comenzar por los cimientos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Que el mal existe no se puede debatir. Negarlo es descartar la realidad. Pero el hecho de que el mal exista no refuta la existencia de Dios. Tampoco rebate la existencia de un reino sobrenatural o espiritual, ni mucho menos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si no hubiera nada más en la vida o en la existencia que el reino material o el universo físico, no podríamos hablar de lo bueno o de lo malo. Por tanto la guerra, la muerte, el asesinato y la destrucción no serían malos, ni siquiera un problema; sino simplemente el surgimiento de fuerzas y la reordenación de moléculas y átomos. Si no hubiera nada más en el universo, no podríamos juzgar como malvado a un asesino nazi de niños judíos ni como buenos a los justos que arriesgaron sus vidas para salvar a los pequeños judíos de los asesinos nazis. Tampoco podríamos estimar que la vida tenga mayor valor que la muerte. Al igual que ocurre con el significado, los valores y la relevancia, el bien y el mal requieren una realidad más allá de lo físico. Sin ello, todos los valores, todos los códigos morales, carecen de sentido, son arbitrarios y adolecen de valor. El mal, como el bien, es —en última instancia— trascendente. Su existencia no refuta que el reino espiritual exista; al contrario, la prueba.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "13",
      "epub:type": "pagebreak",
      "id": "page13",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Lo increado")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Esto lleva a la siguiente pregunta: si el mal existe, ¿cómo llegó a existir? Más específicamente, si Dios es bueno, ¿cómo podría haber maldad? Y si Dios creó el mal, ¿cómo podría ser él bueno? Pero si Dios no creó el mal, ¿cómo puede este existir? ¿O cómo podría Dios ser Dios? Ahí radica el problema y el misterio. Pero el propio problema del mal contiene su respuesta. Si el mal fue creado, no sería un problema ni sería malo. El mal es un problema por la misma razón de que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("no")]), _vm._v(" fue creado. No debería existir, porque no fue creado y, sin embargo, existe. La existencia del mal desafía el orden creado. No es de la creación y, por tanto, existe en oposición al orden creado. El mal existe en desafío a la vida misma.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Personalidad")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Además, el mal no es simplemente una fuerza, como la de un terremoto, un huracán o un incendio. Todo eso trae calamidad y destrucción. Pero ninguno de ellos constituiría un verdadero mal. Tanto los huracanes como los asesinos en serie traen muerte. Pero los huracanes no son malos. Los asesinos en serie sí lo son. ¿Por qué? Porque el huracán es una fuerza impersonal. Actúa sin conciencia, disposición, elección, voluntad o intención. Pero el asesino en serie comete sus actos con intención, determinación y volición conscientes, como también lo hace el mal. Por tanto, el mal no es una fuerza impersonal, sino personal, que requiere conciencia, voluntad, propósito e intención. Así, en nuestra búsqueda de una respuesta al mal, somos conducidos a la personalidad.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El antiser")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Qué es lo que hace que el mal sea "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("malo")]), _vm._v("? El mal es una inversión: una alteración de la verdad, de la realidad, de la existencia. El mal es, por naturaleza, inverso e, intrínsecamente, alterado. Retuerce, doblega y hace que la existencia gire sobre sí misma. Vive como antiexistencia. Su ser es anti sí mismo y su naturaleza, antinatura. Es una negación y, por tanto, busca negar; es una supresión que existe para anular. No tiene existencia verdadera, definitiva ni absoluta y, por lo tanto, actúa para hacer que lo que existe pierda su esencia. Y así el mal, por naturaleza, persigue la destrucción. Se opone a lo que es.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "14",
      "epub:type": "pagebreak",
      "id": "page14",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Al no poseer existencia propia absoluta ni verdadera, el mal es también, por naturaleza, parasitario. Al no ser del orden creado, solo puede existir extrayendo su existencia de ese orden. El mal debe utilizar el bien. Sin embargo, aunque el bien puede existir sin el mal, el mal no puede existir sin el bien. La verdad puede existir sin la falsedad, pero la falsedad no puede existir sin la verdad. Pueden existir leyes sin crímenes, matrimonio sin adulterio y vida sin asesinato. Pero no pueden existir crímenes sin leyes, ni adulterio sin matrimonio, ni asesinato sin vida. La destrucción requiere estructura, la inmoralidad requiere moralidad y el pecado requiere que exista lo santo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El bien es esencial. El mal es la variación parasitaria del bien. De modo que la existencia del mal —de manera inadvertida— testifica no contra la existencia del bien, sino a favor de este. Da testimonio, contra su voluntad, de la existencia del bien: la existencia de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Orígenes")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Todo esto nos lleva al misterio del origen. Si el mal no es creado, ¿cómo llegó a existir? Dios no creó el mal, aunque sí la personalidad, la conciencia y la volición: el libre albedrío. Este libre albedrío es una necesidad. Si alguien hace lo que es bueno porque no tiene otra opción, entonces no es bueno. El bien debe ser elegido libremente, por lo que requiere el libre albedrío. Y ese es el riesgo. Para permitir la elección del bien, uno debe permitir la elección de lo opuesto al bien. Y lo opuesto al bien es el mal. Es la concesión y el riesgo del bien lo que permite el peligro del mal.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El ángel invertido")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Unamos ahora las piezas del misterio. El mal requiere personalidad, voluntad, conciencia y resolución. Por lo tanto, nos enfocamos en la personalidad, en busca de una entidad consciente. Debe ser un ente creado que, por su voluntad, se volvió contra el orden establecido, contra la existencia misma, un ser que se convirtió en antiser, un invertido.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y eso es exactamente lo que revelan las Escrituras. Hay dos entidades con capacidad para elegir el bien o el mal: una, humana y —la otra— angelical. Dado que el mal es espiritual y está más allá de la carne y la sangre, su origen debe encontrarse más allá de la carne y la sangre, más allá de lo humano, en el ámbito de lo espiritual y lo angélico.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "15",
      "epub:type": "pagebreak",
      "id": "page15",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Y es en ese reino donde encontramos la entidad que cumple todos los prerrequisitos —conciencia, resolución, libre albedrío e inversión y, sin embargo, no de carne ni sangre—, un ser angelical que se volvió contra el tejido del orden creado y contra la existencia misma. Y al hacerlo, eso —o él— se convirtió en el alterador y el que altera invirtiendo las cosas. Se convirtió en la realidad retorcida y el tornado de la realidad. En su inversión se convirtió en el antiser, la inversión parasitaria del bien, la némesis de la realidad. Se convirtió en aquel que no debería existir pero, aún así, existe.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Se convirtió en el Diablo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Qué es exactamente el Diablo?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "16",
      "epub:type": "pagebreak",
      "id": "page16",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-11"
    }
  }, [_vm._v("Capítulo 4")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-12"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("El enemigo")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("o llaman ")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Príncipe ")])]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("de las tinieblas, Beelzebú, Padre de mentiras, Lucifer, Señor de las moscas y Diablo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la cultura popular se lo representa como un ser con forma humana, con un rostro anguloso, dos cuernos, un tridente y una capa —o unas alas—, y todo de color rojo. Por eso, a menudo se le considera producto de la imaginación humana. Pero detrás de lo folclórico, tras las representaciones y fantasías de la creatividad popular, se oculta un peligro muy real, antiguo, mortal, tenebroso y presente.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Sahtan")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El vocablo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Satán")]), _vm._v(" proviene del hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sahtan")]), _vm._v(", que se traduce como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("oponente")]), _vm._v(", "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("adversario")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("enemigo")]), _vm._v(". Es una palabra que va al corazón de su esencia. Satán es el que se alejó de Dios y, por tanto, de la existencia. Él se convirtió en la negación, la anulación, el que niega y anula. El que desafía la existencia. El que se opone a lo que es. Él no es un enemigo, sino el Enemigo, el que está enemistado con todos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando los antiguos escribas tuvieron que traducir el vocablo hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sahtan")]), _vm._v(" al griego, eligieron la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("diabolos")]), _vm._v(", que significa “el que lanza o arroja”. Término que se refiere a alguien que lanza acusaciones o calumnias, que divide, que acusa, que ataca y que, en consecuencia, es adversario. El enemigo es el que lanza acusaciones contra todo lo que es, contra la existencia misma. Y así fue como la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("diabolos")]), _vm._v(" se convirtió en la versión griega del hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sahtan")]), _vm._v(": enemigo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En latín, la palabra se convirtió en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Diabolus")]), _vm._v("; en italiano, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Diavolo")]), _vm._v("; en inglés "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Devil")]), _vm._v(" y en castellano "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Diablo")]), _vm._v(". De modo que el vocablo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Diablo")]), _vm._v(" es la versión hispana del término hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sahtan")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El oponente")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Tanto las palabras como los nombres coinciden con el misterio y la esencia del mal. Así como este —básicamente— se opone a la existencia, el nombre de la entidad que lo personifica significa oponente, opositor, misma "), _c('span', {
    attrs: {
      "aria-label": "17",
      "epub:type": "pagebreak",
      "id": "page17",
      "role": "doc-pagebreak"
    }
  }), _vm._v("que —en hebreo— es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sahtan")]), _vm._v(" o Satanás en castellano. Y así como el mal, por naturaleza, está en enemistad con todo lo que existe, el nombre del ser que lo encarna es enemigo, adversario, los cuales son traducciones de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sahtan")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("diabolos")]), _vm._v(", Satanás y el Diablo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Padre de mentiras")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Dado que el mal es lo contrario al bien y, además, es mentira —lo cual es la inversión de la verdad—, está escrito que el Enemigo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("¡Es el padre de la mentira!"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Por tanto, el padre de la mentira es el progenitor de las inversiones o las contradicciones, y así como la mentira existe en relación parasitaria con la verdad, el enemigo existe en relación con Dios, la inversión del bien.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El destructor")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Como opositor de la existencia, el Enemigo le hace la guerra a ella. Dios "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("es")]), _vm._v(" existencia. Su sacro nombre es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Yo Soy")]), _vm._v(". Él es aquel que es y por quien todas las cosas llegan a existir. Por tanto, la guerra del Enemigo se enfoca en Dios. Así está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Seré como el Altísimo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Ese es un voto de desafío y de reemplazo. El Enemigo anhela tomar el lugar de Dios y provocar su destronamiento. Si pudiera destruir al Altísimo, podría acabar con la existencia. Pero no puede. Por eso, enfoca su guerra en las cosas de Dios. Ataca la voluntad de Dios. Trata de frustrar los planes y los propósitos divinos. Lucha contra la creación de Dios. Intenta destruir las obras de Dios. Él es, por tanto, el destructor. Y así está escrito de él:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Fue asesino desde el principio."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El hombre es el centro de la creación de Dios, por lo que lleva la imagen de Dios. Por eso, el Enemigo busca —sobre todo— la destrucción del ser humano. Si puede destruir al hombre, puede erradicar la imagen de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Cómo intenta provocar esa destrucción? Separando al hombre de Dios. Si puede alejarlo de Dios, si puede separar la creación de su Creador, "), _c('span', {
    attrs: {
      "aria-label": "18",
      "epub:type": "pagebreak",
      "id": "page18",
      "role": "doc-pagebreak"
    }
  }), _vm._v("entonces puede separarlo del propósito de su existencia. Y aquello que es alejado del propósito de su ser puede ser anulado y llevado a la destrucción.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Diabólico")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("De forma que la tarea del Enemigo es destruir la obra de Dios. Él es el creador de la destrucción y el destructor de la creación. Sus actos son opuestos a toda obra y, por tanto, desafían la causalidad natural y la explicación racional. Porque tienen su origen en aquel que no debería existir pero existe. Tanto así que, incluso los más ateos y secularistas, se ven obligados a describir al nazismo y el Holocausto como diabólicos, voz procedente de la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("diabolos")]), _vm._v("; demoníacos, del vocablo demonio; o satánicos, del nombre "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Satanás")]), _vm._v(", cada uno de esos términos arraigados en el ámbito que está más allá de lo natural; los cuales testifican de aquello que está más allá de toda explicación racional.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Tales males son manifestaciones de una guerra que no nace en lo natural ni en lo racional, sino que desafía a ambos dominios y es librada por el que existe para poner fin a la existencia: el Enemigo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Lo que veremos en las páginas siguientes es que el ente que muchos —en el mundo moderno— descartarían como un ser gracioso con una capa roja y que no solo es absoluta y peligrosamente real; es, además, el agente activo que yace tras algunos de los fenómenos y movimientos más cruciales de la historia y de los acontecimientos concretos del mundo moderno, incluso, y más específicamente, de nuestro tiempo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Para revelarlo, debemos introducir otro grupo de actores en el misterio, el más peculiar y contradictorio de los pueblos.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "19",
      "epub:type": "pagebreak",
      "id": "page19",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-13"
    }
  }, [_vm._v("Capítulo 5")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-14"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("El pueblo misterioso")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("ay algo intrigante ")]), _vm._v("acerca de los judíos. Lo hay en estos tiempos y lo ha habido siempre. Nunca han encajado del todo en el mundo. Incluso desde el principio, cuando iban por el desierto rumbo a la Tierra Prometida, se decía de ellos:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Es un pueblo que vive apartado, que no se cuenta entre las naciones."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La anomalía")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El pueblo judío siempre ha sido un misterio para el mundo. Ninguna comunidad ha conocido jamás tanto rechazo, antipatía y odio como ellos. Unidos a una tierra como nadie lo ha estado jamás y, sin embargo, separados de ella; sin posesiones terrenales como ningún otro pueblo, el judío ha estado muy aislado y desprovisto de todo. Vivir apartados y separados de los países como ningún otro pueblo lo ha experimentado y, sin embargo, tan entretejidos con la comunidad de naciones y tan criticados en toda la historia mundial como ningún otro pueblo lo ha sido. Ningún pueblo ha estado nunca tan conectado con su tiempo y su espacio que el judío y, sin embargo, ninguno ha trascendido tanto los parámetros del tiempo y el espacio para volverse casi atemporal y universal.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ellos han sido la más débil de las naciones y, sin embargo, la más fuerte, el pueblo más vulnerable y el que más ha estado en peligro de exterminio; no obstante ha sido el más persistente. Ningún otro pueblo, que haya estado sobre la tierra, ha conocido jamás tanto la presencia de Dios como las glorias del cielo; sin embargo, ningún otro ha conocido jamás ni tan bien las profundidades del infierno. Ellos son un enigma, una anomalía, una paradoja, un pueblo misterioso.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Un reino de sacerdotes")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Por qué? ¿Qué hace que Israel sea único entre las naciones y que los judíos se distingan entre los pueblos? La respuesta es: Dios. Aunque a los judíos "), _c('span', {
    attrs: {
      "aria-label": "20",
      "epub:type": "pagebreak",
      "id": "page20",
      "role": "doc-pagebreak"
    }
  }), _vm._v("se les conoce como “el pueblo elegido”, la etiqueta puede resultar engañosa. No es que existieran entre otros pueblos y luego fueran elegidos por Dios. Más bien, las Escrituras registran que Dios los llamó a la existencia. No fueron elegidos por ningún atributo especial que poseyeran. Si Dios llamara a otro pueblo, otra vez terminaría siendo el judío. Entonces, ¿por qué surgió? La razón se dio en los albores de su historia en el Monte Sinaí:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Ustedes serán para mí un reino de sacerdotes y una nación santa."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Israel fue llamado a existir para ser un pueblo santo, un reino de sacerdotes. El sacerdote es el que ministra los propósitos de Dios. De modo que Israel debía ser un vaso de Dios, un conducto e instrumento central para el cumplimiento de sus planes y propósitos con el orbe. Vino al mundo a causa de todos los demás pueblos y naciones, para que en ellos todas las naciones fueran benditas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Fue así que Israel recibió la revelación de Dios primero y luego, a través de ellos, se les dio a las otras naciones. Fue por medio de los profetas de Israel que la Palabra de Dios se extendió a otros pueblos y luego, a través de ellos, al mundo. Fue por el pueblo judío que gran parte del globo terráqueo recibió su sentido de la historia, el tiempo y la santidad, así como también el valor de la vida humana. Fue a través de Israel que gran parte del mundo recibió el fundamento espiritual sobre el cual descansarían sus valores y sus leyes, su concepto de fe, oración, significado y propósito. Fue mediante Israel que el conocimiento de Dios fue dado al mundo. Y fue a través de ese pueblo que personas de todos los países, de todas las tribus y lenguas, fueron transformadas y recibieron esperanza, libertad y propósito.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Testigos de la existencia")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Según las Escrituras, Israel está en el centro de los propósitos de Dios, no solo en los tiempos pasados y antiguos, sino en todas las épocas. Ellos ocupan el punto central de la historia y la profecía. Y más allá de todo eso hay algo aún más fundamental. En el Libro de Isaías, Dios le dice al pueblo de Israel: ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Ustedes son mis testigos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "21",
      "epub:type": "pagebreak",
      "id": "page21",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("Y así, más allá de cualquier obra o logro del pueblo judío hay algo aún más crucial y trascendente: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("su existencia")]), _vm._v(". La existencia misma del pueblo judío es un testimonio de la existencia de Dios. Es gracias a Dios que vinieron al mundo y, por él, continúan existiendo en un mundo que ha sido hostil a su presencia desde hace mucho tiempo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("De manera que ahora tenemos el misterio de dos realidades opuestas: un pueblo en el que está el misterio de Dios y un ser en el que está el misterio del mal. ¿Qué pasa cuando se unen? Lo que sucederá es una explosión y una guerra que han determinado y alterado el curso de la historia mundial y han desconcertado por mucho tiempo a quienes han tratado de entenderla.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "22",
      "epub:type": "pagebreak",
      "id": "page22",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-15"
    }
  }, [_vm._v("Capítulo 6")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-16"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("El ángel antisemita")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("N")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("uestra familiaridad con ")]), _vm._v("el mundo puede impedirnos ver con claridad uno de sus fenómenos más dramáticos. Para eso debemos retirarnos temporalmente de nuestro planeta.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los ojos de un extraterrestre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Imaginemos que hemos llegado al mundo desde otro planeta. No sabemos nada de su cultura, nada de su fe, nada de las naciones ni de la historia humana. Solo se nos dice dos cosas: primero, que hay una entidad espiritual que lucha contra los propósitos y obras de Dios, y que hace todo lo que está a su alcance para frustrarlos, atacarlos y destruirlos; y segundo, que hay un pueblo especialmente traído al mundo como obra de Dios y que existe para cumplir los propósitos divinos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Sin más conocimiento que estas dos cosas, ¿qué esperaríamos que sucediera en la tierra? Esperaríamos que la entidad que hace la guerra contra los propósitos de Dios hiciera lo mismo — especialmente— contra las personas traídas al mundo vinculadas a los propósitos de Dios. Trataría de borrarlos del mapa para poder destruir el testimonio de la existencia de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como el nombre "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Satanás")]), _vm._v(" significa opositor, era inevitable que los judíos se convirtieran en el pueblo más opuesto de la tierra. Aquellos que habían sido llamados a ocupar el centro de los propósitos de Dios en la tierra inevitablemente ocuparían también el centro de la furia del Enemigo. Buscaría frustrarlos, oprimirlos, perseguirlos, anularlos, exterminarlos. Inflamaría a otros con su odio y los utilizaría como recipientes para lograr esos fines. Y así, el pueblo llamado a existir para los propósitos de Dios se convertiría en el más odiado de todos y, su existencia, en la más combatida de cualquier otro pueblo en la historia de la humanidad. Vivirían en este mundo en continuo peligro de aniquilación.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El diablo en hebreo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Lo que acabamos de describir como la conclusión lógica de un ejercicio hipotético es la historia real de los judíos. Que podamos describirlo así "), _c('span', {
    attrs: {
      "aria-label": "23",
      "epub:type": "pagebreak",
      "id": "page23",
      "role": "doc-pagebreak"
    }
  }), _vm._v("sin tener conocimiento de ello, aparte de ser conscientes de una guerra espiritual, revela cuán poderosamente se ven impactados y determinados los acontecimientos de este mundo por las realidades que se encuentran más allá de él.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si Dios tuviera que elegir un pueblo a través del cual cumplir sus propósitos, la verdad es que no tendría que hacerlo porque ya lo hizo. Y si el Enemigo enfocara todas las fuerzas de su ira y su odio en un pueblo por encima de todos los demás de este mundo, lo cierto es que él también ya lo ha hecho. Lo que podría parecer la trama de un relato de ciencia ficción es, en realidad, la verdadera matriz subyacente a uno de los dramas más cruciales y extensos de la historia mundial.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Todo estuvo ahí desde el principio. El hecho mismo de que el nombre "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Satanás")]), _vm._v(" provenga de Israel no es casualidad. No solo se refiere al Enemigo, al oponente y al adversario, sino que lo hace en hebreo. Entre los habitantes de este mundo, Satanás es ante todo el adversario de Israel, el Enemigo del pueblo judío. El Diablo es, ante todo, demonio para el pueblo judío, su oponente, su archienemigo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Un virus antiguo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Al considerar la realidad del ámbito espiritual, no es casualidad que el pueblo que trajo a Dios y su Palabra al mundo se convierta en el más odiado y con mayor oposición. Tampoco es un accidente que, desde el mundo antiguo hasta el moderno, hayan caminado sobre la tierra corriendo peligro de exterminio. Son tan despreciados entre los pueblos que su odio tiene nombre propio: antisemitismo. Pero ese odio precede mucho al nombre. Fueron odiados y combatidos en el mundo medieval, lo mismo en el mundo antiguo, y no menos en el mundo moderno, hasta el día de hoy.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Las razones y fundamentos para explicar este odio nunca han sido coherentes. En el mundo comunista los judíos eran odiados por ser capitalistas. En el mundo capitalista eran odiados por ser comunistas. Entre la extrema derecha eran odiados por ser de izquierda, y entre la extrema izquierda, por encarnar los valores tradicionales o conservadores de la derecha. Han sido odiados por ser reservados, por su exclusividad y, al mismo tiempo, por su compromiso e implicación con la cultura más amplia, por su universalidad, por no ser reservados. La verdad es que son odiados porque existen.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El antisemitismo es el más resistente e inmortal de los virus espirituales. Y como lo hace un virus, muta de generación en generación, adoptando nuevas formas, reviviendo siempre y, sin embargo, manteniendo su "), _c('span', {
    attrs: {
      "aria-label": "24",
      "epub:type": "pagebreak",
      "id": "page24",
      "role": "doc-pagebreak"
    }
  }), _vm._v("núcleo tóxico y mortal. E incluso en aquellos momentos en los que parece haber disminuido, siempre está ahí, esperando la siguiente oportunidad a través de la cual asomar la cabeza e infectar a la siguiente generación. Tiene el sueño ligero.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El antisemita primitivo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La guerra contra la existencia judía no se parece a ninguna otra. No conoce límites espaciales ni temporales. No es racional ni natural. Sucede sin importar qué, sin importar cuándo, sin importar quién y sin importar dónde. Es sobrenatural e irracional, la rama oscura y virulenta del misterio del mal. Es obra de un ser espiritual y sobrenatural caído, retorcido, invertido.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La verdad es que el primero de todos los antisemitas fue un ángel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Todos los que odian al pueblo judío, todos los antisemitas de cualquier lugar y época son hijos de él; él es su padre. Las palabras que hablan contra los hijos de Israel son de él. Los actos que cometen contra ellos son suyos. Y así, si recordamos —a través de los siglos— los ataques lanzados y las batallas libradas contra el pueblo judío, esperaríamos encontrar allí sus huellas. Y eso es, exactamente, lo que encontramos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El acusado")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Porque ha sido expulsado el acusador de nuestros hermanos, el que los acusaba día y noche delante de nuestro Dios."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Por eso se le describe como el acusador de los hermanos. Su naturaleza y su función como lanzador de acusaciones es, como hemos visto, intrínseco al nombre de Satán y Diablo. Por lo tanto, esperaríamos que el pueblo judío se convirtiera en el más calumniado de la historia de la humanidad, en el eterno foco de acusaciones, imputaciones, vilipendio y demonización. Y eso es lo que son. Es la característica distintiva del acusador.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Más allá de eso, como es un mentiroso, esperaríamos que el pueblo judío se convirtiera en el punto focal no solo de las acusaciones sino —además— de las imputaciones falsas, las mentiras y las calumnias. Y han sido eso. En el antiguo mundo pagano eran acusados de ateísmo y sacrilegio. En la Edad Media se les acusaba de envenenar las fuentes acuíferas y de extraer la sangre de sus víctimas. En el mundo moderno se les acusa de ser los autores intelectuales de prácticamente todos los grandes males y conspiraciones que tienen como fin dominar el mundo. No importa "), _c('span', {
    attrs: {
      "aria-label": "25",
      "epub:type": "pagebreak",
      "id": "page25",
      "role": "doc-pagebreak"
    }
  }), _vm._v("cuán infundadas o rebuscadas sean las acusaciones. Sus orígenes, como hemos visto, no son racionales. Pero son coherentes con aquel en quien "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("no hay verdad")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La methodeia")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La rabia contra Israel y el pueblo judío ha sido considerada el odio más antiguo. Un fenómeno antiguo debe tener una causa antigua. En el Libro de Apocalipsis la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("archaios")]), _vm._v(" se usa para describir al Enemigo. Puede traducirse como desde el principio o primordial y, en este caso, comúnmente se traduce como antiguo o antiguo. Y así como el odio a Israel y al pueblo judío es el más duradero de los aborrecimientos, y abarca milenios, también hay un solo sospechoso cuya existencia, de la misma manera, abarca milenios: el Enemigo. Y así como este nunca descansa, el odio antiisraelí y antijudío tampoco descansa nunca; es eterno.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como el Enemigo no está limitado por el tiempo ni el espacio, por parámetros físicos ni geográficos, así también su antiguo odio trasciende todos los parámetros físicos y geográficos. Se puede encontrar en todas partes del mundo, prácticamente en todos los países y culturas, y puede hacer erupción en cualquier momento o lugar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En el Libro de Efesios está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Pónganse toda la armadura de Dios para que puedan hacer frente a las artimañas del diablo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La palabra traducida como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("astucia")]), _vm._v(" es el vocablo griego "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("methodeia")]), _vm._v(", del que proviene el término inglés "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("método")]), _vm._v(". Este habla de un plan cuidadosamente diseñado, de una estrategia bien elaborada, como en un plan creado con el propósito de engañar y hacer el mal. El Enemigo es un intrigante. Por lo tanto, esperaríamos que el pueblo judío se convirtiera en blanco y víctima de planes diseñados para dañarlo o destruirlo. Y así, el pueblo judío ha sido exactamente eso: el objetivo y las víctimas de tales planes de siglo en siglo, de época en época.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El objetivo del destructor")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Desde los tiempos de las tiendas de campaña de los generales asirios hasta los palacios de los emperadores romanos, las salas de planificación de la Inquisición española, las oficinas administrativas de la Rusia imperial, "), _c('span', {
    attrs: {
      "aria-label": "26",
      "epub:type": "pagebreak",
      "id": "page26",
      "role": "doc-pagebreak"
    }
  }), _vm._v("los búnkeres de la Alemania nazi y los túneles subterráneos de Hamas, en Gaza, el Enemigo ha tejido planes contra los hijos de Israel: planes de exterminio.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Es, como hemos visto, un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("asesino desde el principio")]), _vm._v(", el Destructor. Por tanto, esperaríamos que lanzara no solo guerras de palabras, difamación y calumnia contra el pueblo judío, sino también batallas destructoras. Y por eso los judíos no solo han sido vilipendiados y perseguidos sino, además, masacrados, aniquilados... desde el lanzamiento de los niños hebreos al Nilo hasta la conducción de hombres, mujeres y niños judíos a las cámaras de gases de Auschwitz. Nada de eso es natural. Es satánico.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Sus hijos tenebrosos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Tenemos la prueba irrefutable de todo ello. Las páginas de la historia judía están cubiertas con las huellas dactilares del Enemigo. Y por encima y más allá de todos los atributos del adversario está el atributo del mal. Por lo tanto, esperaríamos que la guerra contra el pueblo judío estuviera especial y exclusivamente relacionada con el mal. Esperaríamos que esas potencias y personas especialmente utilizadas para librar esa guerra se manifestaran esencialmente y encarnaran de manera única la naturaleza del Enemigo: el mal.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Esto también es exactamente lo que encontramos: desde los faraones del antiguo Egipto hasta Josef Mengele, desde Heinrich Himmler hasta Saddam Hussein, desde Joseph Stalin hasta Osama Bin Laden, Al Qaeda, los supremacistas arios blancos, ISIS, Hezbolá, revolucionarios violentos y dictaduras marxistas, hasta los terroristas de Hamas. Aunque a menudo representan ideologías diametralmente opuestas, por extraño que parezca, comparten la misma animosidad e igual grado de odio hacia el mismo pueblo específico: los judíos; así como el Enemigo. Y al igual que con el adversario, cada uno de ellos ha sido percibido como personificaciones y encarnaciones del mal.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y luego, por supuesto, está el que encabeza la lista, cuyo nombre, más que cualquier otro, se convirtió en sinónimo de maldad: Adolf Hitler. No es casualidad que la persona más universalmente reconocida como la figura más maligna de la historia mundial fuera, al mismo tiempo, la más impulsada, inflamada y poseída por la furia y la misión de destruir a un pueblo específico: los judíos. Al igual que los demás de la lista oscura, tenía los rasgos de su padre espiritual, el ángel invertido.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "27",
      "epub:type": "pagebreak",
      "id": "page27",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Que el mal esté tan fuertemente conectado con el odio específico de este pueblo en particular revela su origen y su fuente: la antigua entidad en la que ambos, el mal y el odio a Israel, también están unidos. Se remonta al misterio del mal. Es un odio injustificado e irracional, una rabia que —así como la entidad de la que surge—, no debería existir, pero existe.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("A continuación abriremos una profecía de dos mil años de antigüedad que ha de revelar la guerra tal como fue, cómo es y cómo será, y con ello el misterio de una criatura antigua y mortal.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "28",
      "epub:type": "pagebreak",
      "id": "page28",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-17"
    }
  }, [_vm._v("Capítulo 7")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-18"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("La profecía del Dragón rojo")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("a Biblia concluye ")]), _c('span', [_vm._v("con el Libro de Apocalipsis. El vocablo ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("apocalipsis")]), _c('span', [_vm._v(" —revelación, en español— proviene de la palabra griega ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("apokalupto")]), _vm._v(", que significa quitar el velo. En el capítulo doce de Apocalipsis se quita el velo en forma de una visión acerca del Enemigo y del antiguo pueblo de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La mujer celestial")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Apareció en el cielo una señal maravillosa: una mujer revestida del sol, con la luna debajo de sus pies y con una corona de doce estrellas en la cabeza."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Quién es esa mujer? Aun cuando algunos han interpretado que es una representación de la iglesia, y aunque la visión ciertamente tiene relevancia para la iglesia, la mujer es algo más y más antigua. Se la identifica por sus prendas. Está vestida del sol, con la luna bajo sus pies y coronada con doce estrellas. Las imágenes aparecen por primera vez en el Libro de Génesis:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Después José tuvo otro sueño y se lo contó a sus hermanos. Les dijo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("—Tuve otro sueño en el que veía que el sol, la luna y once estrellas se inclinaban ante mí."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El que soñó eso fue el patriarca hebreo José. El sol representaba a su padre, Jacob; la luna, su madre, Raquel; y las once estrellas, a sus once hermanos, que junto con él formaban los doce hijos de Israel y de los cuales procedían las doce tribus de Israel. Es una de las primeras representaciones simbólicas de Israel que se dan en la Biblia. Más adelante, en los escritos de los profetas, a menudo se simboliza a Israel como mujer. Así que aquí tenemos a una mujer vestida del sol, con la luna a sus pies y coronada con doce estrellas. La mujer es, ante todo, Israel.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "29",
      "epub:type": "pagebreak",
      "id": "page29",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Dragón rojo")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y apareció en el cielo otra señal: un enorme Dragón de color rojo encendido que tenía siete cabezas, diez cuernos y una diadema en cada cabeza."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El segundo de los símbolos de la visión es una monstruosidad. La palabra utilizada para describirlo es el vocablo griego "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("drakohn")]), _vm._v(", del que proviene la palabra castellana "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("dragón")]), _vm._v(". En griego también puede traducirse como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("el que ve")]), _vm._v(". En ese idioma, el término también indica un ser parecido a una serpiente, como una gran víbora constrictora o venenosa. En cuanto a la identidad del Dragón en Apocalipsis, las Escrituras son tajantes:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Así fue expulsado el gran Dragón, aquella serpiente antigua que se llama Diablo y Satanás."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Como dragón o serpiente, el Diablo es un ser aterrador, devorador, venenoso, ponzoñoso y mortal. Los dragones de la mitología griega aparecían en diversas formas y normalmente poseían poderes sobrenaturales. A menudo se les describía con un aliento tóxico o fogoso. Y, sin embargo, el Dragón del Apocalipsis es único. Su cuerpo es rojo: el color del fuego, de la destrucción, del derramamiento de sangre, del pecado, de la furia y la guerra. Su apariencia es monstruosa: siete cabezas, diez cuernos y siete coronas. El Dragón es a la vez sobrenatural y antinatural, una criatura transformada y alterada. Así como los dragones suelen ser representados como criaturas cuya ferocidad y furia son mortales, también lo es el Diablo. Finalmente, así como el dragón es un ser monstruoso, también lo es el ser invertido que lucha contra la creación y la existencia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El niño")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La mujer está embarazada:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Estaba embarazada y gritaba por los dolores y angustias del parto."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La imagen de una mujer embarazada apunta nuevamente a Israel, cuyo llamado era llevar al mundo la Palabra, la revelación, la presencia y el "), _c('span', {
    attrs: {
      "aria-label": "30",
      "epub:type": "pagebreak",
      "id": "page30",
      "role": "doc-pagebreak"
    }
  }), _vm._v("conocimiento de Dios. Ese llamado alcanza su punto álgido cuando la nación trae al mundo al niño que llevaría el nombre de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Yeshúa")]), _vm._v(" y sería conocido por gran parte de la humanidad como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jesús")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Ella dio a luz un hijo varón que “gobernará a todas las naciones con cetro de hierro”. Pero su hijo fue arrebatado y llevado hasta Dios, que está en su trono."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Que el niño gobernará a todas las naciones deja claro que solo él puede ser el Mesías. Este es otro indicador de la identidad de la mujer. La iglesia no dio a luz al Mesías sino que nació de él. Pero Israel sí dio a luz al Mesías. Tampoco, como algunos han interpretado, se podría identificar a la mujer con María. Porque según la visión, ella está viva no solo en el momento de su nacimiento sino también al final de los tiempos. La mujer solo puede ser Israel y, su hijo, solo el Mesías.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El perseguidor")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Cuando el Dragón se vio arrojado a la tierra, persiguió a la mujer que había dado a luz al , se plantó delante de ella para devorar a su hijo tan pronto como naciera."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El Dragón espera junto a la mujer para devorar a su hijo en el momento en que nazca. Entonces el Enemigo lucha contra los propósitos de Dios e intenta destruirlos desde su inicio. La escena corresponde, entre otras cosas, al intento del rey Herodes de matar al bebé nacido en Belén.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y cuando el Dragón vio que había sido arrojado a la tierra, persiguió a la mujer que había dado a luz al varón."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La visión se centra en dos períodos de tiempo, uno en el momento del nacimiento del Mesías y el otro, aún por venir, al final de los tiempos. Comprenden dos batallas en una guerra milenaria. La visión y la guerra abarcan así milenios. La guerra es la que se ha librado contra el pueblo judío durante siglos. La visión revela sus fundamentos ocultos y espirituales.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La ira del Dragón contra la mujer se manifiesta en su "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("persecución")]), _vm._v(". Por eso no es casualidad que la historia judía, más que cualquier otra, esté unida a la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("persecución")]), _vm._v(". Hay que tener en cuenta que la visión fue "), _c('span', {
    attrs: {
      "aria-label": "31",
      "epub:type": "pagebreak",
      "id": "page31",
      "role": "doc-pagebreak"
    }
  }), _vm._v("escrita siglos antes de las innumerables persecuciones, atrocidades y matanzas que marcarían la historia hebrea, particularmente en la era moderna.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El cazador y la cazada")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La palabra griega utilizada en Apocalipsis para describir el ataque del Dragón a la mujer es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("dioko")]), _vm._v(", que puede traducirse como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("perseguir")]), _vm._v(", pero también como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("acosar")]), _vm._v(", "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("apremiar agresivamente")]), _vm._v(", "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cazar")]), _vm._v(" como un cazador tras su presa. Así como el Dragón persigue, acosa y caza a la mujer, el Enemigo perseguiría, acosaría y cazaría al pueblo judío.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La persecución del Dragón contra “la mujer que dio a luz al varón” implica una especial rabia contra ella derivada de ese hecho. Fue el hecho de que Israel llevara al niño Yeshúa al mundo lo que difundió el conocimiento de Dios por toda la tierra, lo que alteraría la historia mundial. De modo que, tras la persecución del pueblo judío a lo largo de los siglos hay una antigua ira y un sentimiento de venganza por haber traído al mundo no solo la revelación de Dios sino también el Mesías.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Diluvio")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("La serpiente, persiguiendo a la mujer, arrojó por sus fauces agua como un río para que la corriente la arrastrara."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Así como el ataque se origina en la boca de la criatura, la persecución del pueblo judío a lo largo de la historia a menudo se ha iniciado a través de la boca, por medio de palabras, calumnias, falsedades, edictos, decretos, órdenes y propaganda mortal. El Dragón desata un diluvio contra la mujer. De modo que el pueblo judío se ha encontrado, una y otra vez, en el extremo receptor de una tóxica inundación de odio, abrumado por la persecución y aplastado por un diluvio de males y calamidades.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al mismo tiempo, la visión revela un principio de redención. Aunque la mujer es atacada, se le proporciona un refugio. Aunque venga contra ella un diluvio, la tierra se abrirá y se lo tragará. El mismo principio también se puede ver a lo largo de la historia judía. Cuando una nación se ha vuelto contra el pueblo judío, lo ha expulsado o ha luchado contra él, otra se ha abierto para darle refugio. Cuando una potencia ha luchado contra ellos, otra ha luchado contra sus adversarios.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "32",
      "epub:type": "pagebreak",
      "id": "page32",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El "), _c('span', {
    staticClass: "Impa-i _idGenCharOverride-1"
  }, [_vm._v("orgidzo")]), _vm._v(" del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Entonces el Dragón se enfureció contra la mujer."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("enfurecido")]), _vm._v(" es una traducción del vocablo griego "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("orgidzo")]), _vm._v(". También puede traducirse como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("furia")]), _vm._v(", "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ira")]), _vm._v(", "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hostilidad")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("pasión violenta")]), _vm._v(". Se ha utilizado para describir una ira prolongada, latente y eterna, así como un deseo de venganza. Y por eso no es casualidad que en cada generación el pueblo judío haya estado sujeto a una ira antigua y persistente, a una furia latente desde hace mucho tiempo. Y aunque puede esconderse durante una temporada, siempre logra —con el tiempo— levantar la cabeza. Su objetivo es derramar sangre, muerte y destrucción. Lo que ha definido las eras de la historia judía en la tierra, desde las matanzas de antiguos enemigos hasta el horror de las cámaras de gases, es el orgidzo —o ira—, la locura de un monstruo, un Dragón furioso.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "paa _idGenParaOverride-1"
  }, [_vm._v("Así como la visión de Apocalipsis se refiere al Enemigo como el Dragón, también se le llamará —a menudo— con esa descripción y ese nombre. La profecía del Dragón proporcionará la clave para desbloquear un misterio de lo que está por venir y de lo que ya está comenzando.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "33",
      "epub:type": "pagebreak",
      "id": "page33",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-19"
    }
  }, [_vm._v("Parte 3")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-20"
    }
  }, [_vm._v("La resurrección oscura")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "34",
      "epub:type": "pagebreak",
      "id": "page34",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-21"
    }
  }, [_vm._v("Capítulo 8")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-22"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v("Los días de la visión")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("a visión de ")]), _vm._v("Apocalipsis 12 tiene un requisito esencial para su cumplimiento. ¿Cuál es?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Especificidad")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En la visión, el Dragón se encuentra en un lugar específico en un momento específico. La mujer huye a un desierto específico, donde permanece durante un número específico de días. Tanto la mujer como el Dragón existen en lugares y tiempos específicos. Normalmente ese hecho sería algo evidente y tendría poca importancia. Pero este caso es diferente.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la mayor parte de los últimos dos mil años, el pueblo judío no ha existido en un tiempo y lugar determinados. Al contrario, fueron esparcidos por todas las naciones. Tampoco ha habido, durante la mayor parte de esos dos mil años, una nación de Israel en el mundo que exista como un cuerpo o entidad política unificada. El cumplimiento de la visión se basa en ese estado unificado o cohesionado. Tendría que haber una nación o Estado de Israel en el mundo en un lugar y un tiempo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La odisea judía")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El comienzo de la visión, con la mujer dando a luz al niño, corresponde al comienzo de la era. Entonces el Mesías nació en un Israel que existía como un sistema político unificado en la tierra de Israel. Pero después de Su venida todo cambió. Él mismo predijo lo que sucedería:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Ahora bien, cuando vean a Jerusalén rodeada de ejércitos, sepan que su destrucción ya está cerca … Caerán a filo de espada y los llevarán cautivos a todas las naciones. Los que no son "), _c('span', {
    attrs: {
      "aria-label": "35",
      "epub:type": "pagebreak",
      "id": "page35",
      "role": "doc-pagebreak"
    }
  }), _vm._v("judíos pisotearán a Jerusalén, hasta que se cumplan los tiempos señalados para ellos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En el año 70 d. C., los ejércitos de Roma destruyeron el Templo de Jerusalén y arrasaron la ciudad. El pueblo judío fue llevado cautivo a las naciones. Fue el comienzo de su destierro —de casi dos mil años— de su lugar natal. Sufrirían una odisea sin precedentes. Sin tierra, gobierno ni ejército, estuvieron dispersos por todo el mundo desde la antigüedad hasta el mundo moderno. La profecía del Mesías se cumplió.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“De uno al otro extremo de la tierra”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Y, sin embargo, todo fue predicho mucho antes de que sucediera, no solo en las palabras de Yeshúa, Jesús, sino desde Moisés en los días del Éxodo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("El Señor te dispersará entre todas las naciones, de uno al otro extremo de la tierra")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("No fue solo la magnitud de la dispersión lo que fue especial, ni el hecho de que todo estuviera predicho en las Escrituras. Igual de sin precedentes fue lo que les sucedió en las tierras donde se dispersaron. Eso también fue predicho:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Noche y día vivirás en constante zozobra, lleno de terror y nunca seguro de tu vida."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De modo que, en su peregrinar por la tierra, el pueblo judío sufriría una persecución que abarcaría el mundo y la era.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Tu Dios te reunirá”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Pero por más sin precedentes que fueran todas estas cosas, lo que sucedió después sería aún más sin precedentes. Y aunque esto solo se cumpliría en el siglo XX, también fue predicho en las Escrituras antiguas:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Entonces el Señor tu Dios restaurará tu fortuna y se compadecerá de ti. ¡Volverá a reunirte de todas las naciones por donde te haya dispersado! …Te hará volver a la tierra que perteneció a tus antepasados y tomarás posesión de ella."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "36",
      "epub:type": "pagebreak",
      "id": "page36",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("Según la profecía, después de ser esparcido hasta los confines de la tierra y después de “muchos días”,"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" el pueblo judío sería llevado a casa. Dios mismo los reuniría de regreso a la tierra como un pastor reúne a su rebaño. Así está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("He aquí, yo los traeré de la tierra del norte, y los reuniré desde los confines de la tierra …Vendrán con llanto, y con súplicas los guiaré."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Y así vinieron, tal como estaba profetizado, desde la tierra del norte y desde los confines de la tierra, mujeres con niños, cojos y llorando.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("En desafío a la historia")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Nunca antes había sucedido. Un antiguo pueblo de refugiados esparcidos por todo el mundo sin ningún vínculo originario que los mantuviera unidos, ni ninguna defensa natural que los sustentara, y con todo el infierno dispuesto contra ellos, eran devueltos a su tierra natal según la antigua profecía:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Naciones, escuchen la palabra del Señor, y anuncien en las costas más lejanas: “El que dispersó a Israel, lo reunirá; lo cuidará como un pastor a su rebaño”. "), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("En los últimos días")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El regreso del pueblo judío a la tierra de Israel está relacionado con lo que la Biblia llama los “últimos días”. En el Libro de Oseas se profetiza que los hijos de Israel estarán por “muchos días” sin reino ni templo. Pero después de eso")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("… Después ellos se arrepentirán y buscarán nuevamente al Señor su Dios y a David, su rey. En los últimos días acudirán con temor reverente al Señor y a sus bondades."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En algunas de las profecías la conexión es explícita; en otras, es implícita; pero la reunión del pueblo judío después de muchos días de regreso a la tierra de Israel está implícitamente vinculada a lo que se llama el fin "), _c('span', {
    attrs: {
      "aria-label": "37",
      "epub:type": "pagebreak",
      "id": "page37",
      "role": "doc-pagebreak"
    }
  }), _vm._v("de los tiempos. Por lo tanto, la generación que ve ese regreso está presenciando un signo bíblico, la señal del fin de los tiempos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Esto nos lleva otra vez a la visión del Dragón. Aunque la visión empieza con el nacimiento del Mesías al comienzo de la era, su enfoque está más bien en el fin de la era. De modo que el cumplimiento de la visión requiere que el pueblo judío regrese a su antigua patria, Israel. Para que esto realmente suceda como se profetizó en la Biblia, se ha abierto la puerta para el acto final en la guerra del Dragón y la mujer.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Comenzará en un valle de huesos secos.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "38",
      "epub:type": "pagebreak",
      "id": "page38",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-23"
    }
  }, [_vm._v("Capítulo 9")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-24"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  }), _vm._v("Los huesos secos reviven")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("l profeta fue ")]), _vm._v("llevado en una visión al medio de un valle lleno de huesos secos. El Señor le dijo que profetizara. Así lo hizo. Y mientras lo hacía")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("… se escuchó un ruido que sacudió la tierra, y los huesos comenzaron a unirse entre sí. 8 Yo me fijé y vi que en ellos aparecían tendones, les salía carne y se recubrían de piel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El valle de los huesos secos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así comienza la visión dada a Ezequiel acerca del valle de los huesos secos. A la palabra del profeta, los huesos se convierten en esqueletos y estos en cuerpos de carne y hueso, pero sin aliento. Luego se le dice al profeta que profetice al Espíritu. Luego, el Espíritu —o aliento— entra en los cuerpos inertes, los cuales cobran vida y se ponen de pie como un “ejército sumamente grande”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Luego, el Señor revela el significado de la visión:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Luego me dijo: “Hijo de hombre, estos huesos son el pueblo de Israel. Ellos andan diciendo: ‘Nuestros huesos se han secado. Ya no tenemos esperanza. ¡Estamos perdidos!’. Por eso, profetiza y adviérteles que así dice el Señor y Dios: ‘Pueblo mío, abriré tus tumbas, te sacaré de ellas y te haré regresar a la tierra de Israel’”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Aunque la visión hablaba de la reunión del pueblo judío en la tierra de Israel, la imagen no era de una reunión, sino de una resurrección. La reunión del pueblo judío sería parte de una resurrección.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Abriré vuestras tumbas”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los hijos de Israel nunca murieron como pueblo. Pero la entidad "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("política")]), _vm._v(", "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("estado")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("reino")]), _vm._v(" que lo encarnaba en la antigüedad fue destruido y, en ese sentido, murió. Pero la visión de Ezequiel predijo su ascenso: otra "), _c('span', {
    attrs: {
      "aria-label": "39",
      "epub:type": "pagebreak",
      "id": "page39",
      "role": "doc-pagebreak"
    }
  }), _vm._v("imposibilidad. Israel, desaparecido del mundo durante casi dos mil años y en una tierra que se había convertido en un páramo árido e inasequible, parecía estar tan muerto como cualquier otra nación lo haya estado jamás.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Durante su crucifixión, las palabras "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Rey de los judíos")]), _vm._v(" fueron clavadas en la cruz sobre la cabeza del Mesías."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" La crucifixión condujo a la resurrección. Una nación debe seguir a su rey. Si el Rey de los judíos resucitó, también lo haría su nación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En un mundo todavía tambaleante por la Segunda Guerra Mundial, con Estados Unidos y la Unión Soviética comenzando el primer capítulo tenso de la Guerra Fría, con los imperios de Europa en estado de colapso y con el pueblo judío emergiendo de los horrores del Holocausto nazi, las antiguas profecías y visiones de las Escrituras estaban a punto de cumplirse.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La nación que había cerrado los ojos a un mundo de flechas llameantes y emperadores romanos ahora abrió los ojos a un orbe de armas nucleares y superpotencias. En medio de la visión de Ezequiel, el Señor le había preguntado al profeta: “¿Podrán revivir estos huesos?”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" El 14 de mayo de 1948, esa pregunta recibió respuesta. Los huesos secos se habían levantado del valle de la muerte. La nación de Israel resucitó de entre los muertos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El esqueleto se levanta")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Más allá de predecir la resurrección de Israel, la visión de Ezequiel reveló cómo se produciría ese acontecimiento. Por orden del profeta, los huesos desunidos comienzan a unirse uno con otro. De modo que la resurrección de Israel comenzaría cuando los restos dispersos de la nación empezaran a regresar a la tierra y a unirse unos con otros. Los huesos secos formaron entonces esqueletos. De modo que la resurrección de Israel fue, al principio, esquelética. Primero vino el armazón, una cultura esquelética, un ejército esquelético, una estructura esquelética de viviendas, una nación esquelética. Y luego vino la carne y la sangre, cuando Israel se transformó en una nación viva y en pleno funcionamiento.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los organismos naturales nacen, crecen y se desarrollan hasta alcanzar su estado de plena formación. Se convierten en lo que nunca han sido. Pero con la resurrección todo sucede al revés. Comienza con el fin, con la estructura de un Estado plenamente formado. Los huesos secos de Ezequiel no crecen ni se desarrollan. Comienzan completamente formados. El ejército resucitado vuelve a su condición anterior. Lo que vino al "), _c('span', {
    attrs: {
      "aria-label": "40",
      "epub:type": "pagebreak",
      "id": "page40",
      "role": "doc-pagebreak"
    }
  }), _vm._v("mundo en 1948 fue una antigua nación que volvía a la vida, resucitaba a lo que ya había sido.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Tierra de resurrección")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Fue una resurrección nacional compuesta por muchos resucitados más pequeños. En el curso de la historia, el idioma de una nación aparece primero y luego se codifica en un diccionario. Pero en el caso de Israel, primero vino el diccionario y luego el idioma. La lengua se fue armando pieza por pieza, como ocurrió con el ensamblaje de los huesos secos. En el caso de las naciones son los padres quienes enseñan a los hijos la lengua nativa. Pero en el de la resurrección de Israel fueron los hijos los que enseñaron a sus padres el idioma nativo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No fue solo la nación la que resucitó sino la tierra. Los bosques surgieron en el mismo terreno en el que se habían levantado los bosques antiguos. Los campos de cereales y los viñedos florecieron en el mismo suelo en el que una vez progresaron los antiguos campos y viñedos. Y las ciudades se levantaron sobre las ruinas de otras poblaciones antiguas y usaron sus nombres. Incluso el dinero de la nación resucitó a partir de su antigua moneda: el shekel. Y la antigua imagen de la menorá, el candelabro de siete brazos que los romanos habían grabado en piedra para celebrar la destrucción de Israel, ahora se convirtió en el sello de su resurrección."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El regreso del israelita")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Sin embargo, más allá de la tierra y el sistema gubernamental estaba la resurrección de un pueblo. Los nuevos israelitas usaban los nombres resucitados de los antiguos israelitas que habían habitado la tierra miles de años antes. Incluso el hombre que dirigió a Israel en su regreso y que se convirtió en el primer ministro inicial, Ben-Gurión, usaba el nombre del antiguo líder que había dirigido a la nación en su antigua destrucción."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7 ")]), _vm._v("Hasta el nombre de la nación, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Israel")]), _vm._v(", fue parte de la resurrección, habiendo sido llevado miles de años antes por su contraparte antigua.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La resurrección estaba en todas partes: granjeros israelíes resucitados recogiendo nuevamente sus cosechas, pescadores israelíes resucitados arrojando nuevamente sus redes al Mar de Galilea, viñadores israelíes resucitados cuidando sus vides nuevamente, y tanto novias como novios israelíes resucitados nuevamente regocijándose en las calles de la ciudad. Las antiguas profecías habían predicho que en el día de su restauración el "), _c('span', {
    attrs: {
      "aria-label": "41",
      "epub:type": "pagebreak",
      "id": "page41",
      "role": "doc-pagebreak"
    }
  }), _vm._v("pueblo de Israel nuevamente “saldría a bailar con alegría”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8 ")]), _vm._v("De modo que, el 14 de mayo de 1948, el pueblo de Israel salió nuevamente y bailó con alegría. Incluso sus bailes resucitaron, al igual que su gozo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para que todas esas cosas se cumplieran, tenía que haber una convergencia de acontecimientos mundiales, movimientos masivos, fuerzas colosales, fusión de innumerables vidas, dos guerras mundiales y el ascenso y caída de varios imperios mundiales. Eso estaba más allá del control de cualquier persona, nación, organización, reino o potencia. Todas las cosas tenían que ponerse en movimiento y colocarse perfectamente en su lugar mediante el movimiento de una mano antigua e invisible.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Pero habría otra obra, nacida en oposición a la primera y de orígenes completamente diferentes.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "42",
      "epub:type": "pagebreak",
      "id": "page42",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-25"
    }
  }, [_vm._v("Capítulo 10")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-26"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("Imitaciones")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("on la resurrección ")]), _vm._v("de Israel se preparó el escenario para el cumplimiento de la profecía del fin de los tiempos. Su reunión en un lugar y tiempo específicos fue el requisito necesario para que se cumpliera la visión de Apocalipsis 12. Eso significaría que la guerra del Dragón contra la mujer, la batalla del Enemigo contra el pueblo judío, podría entrar ahora en su etapa final.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las últimas guerras")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Aun más allá de la visión de Apocalipsis, lo que se revela a lo largo de las Escrituras sería suficiente para que concluyéramos que el regreso de la nación en 1948 tendría ramificaciones masivas. Si el Enemigo hace la guerra contra las obras, los vasos y los propósitos de Dios, entonces, con mayor razón, haría la guerra contra un Israel resucitado. Supondría una amenaza especial para su existencia. Fue cuando Israel existía en un solo gobierno que se dieron las Escrituras, se impartió la palabra profética, se derramó el Espíritu de Dios y se entregó el Mesías al mundo. Y el simple hecho de que el pueblo judío estuviera ahora concentrado en un solo lugar y tiempo significaría que la guerra del Enemigo contra ellos se volvería cada vez más centrada y concentrada.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La metamorfosis del Orgidzo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Eso significaría que el antisemitismo se fusionaría cada vez más con —y se transformaría en— el antisionismo. La antigua animosidad hacia el pueblo judío se transformaría cada vez más en odio hacia la recién resucitada nación de Israel. Y el nuevo odio manifestado contra Israel se volvería tan universal, tan mortífero y tan satánico como lo había sido el antisemitismo durante siglos... y más. La guerra del Dragón contra la mujer haría que el Israel resucitado se convirtiera en la nación más combatida de la tierra.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "43",
      "epub:type": "pagebreak",
      "id": "page43",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El gran imitador")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Ahora estamos a punto de revelar un misterio oculto durante mucho tiempo que yace detrás de algunos de los acontecimientos más cruciales de los tiempos modernos. Que puso en marcha acontecimientos que amenazaron con romper el orden global y llevar al mundo a la guerra. Que todavía lo hace. Todo lo cual nos hace apuntar al Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si el Dragón optara por luchar contra la existencia de Israel, ¿cómo lo haría? Utilizaría vasijas, peones y jugadores: agentes humanos. Provocaría animosidad, odio y furia contra la nación resucitada. Más específicamente, si el Dragón fuera a librar una batalla —una guerra literal— contra Israel, ¿cómo sucedería eso? La respuesta está en la esencia y la naturaleza del Dragón, que se remonta al principio de los tiempos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Es propio de lo falso imitar lo verdadero, tomar su forma y apariencia para que finalmente pueda ocupar su lugar. Un engañador solo puede falsear haciendo que lo falso parezca verdadero. Una mentira debe buscar aparecer como la verdad y un mentiroso como alguien que dice la verdad: todos son imitaciones. Así también el Enemigo busca aparecer como lo opuesto. El apóstol Pablo escribe sobre su estrategia:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("No es de extrañar, ya que Satanás mismo se disfraza de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ángel de luz")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De forma que el ángel de las tinieblas aparece como un ángel de luz, y más que eso.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Seré como el Altísimo”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El profeta Isaías describe la caída del llamado "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Lucifer")]), _vm._v(", su voto y su misión contra Dios. De él se dice:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Decías en tu corazón: “Subiré hasta los cielos. ¡Levantaré mi trono por encima de las estrellas de Dios! Gobernaré desde el extremo norte, en el monte de la reunión. Subiré a la cresta de las más altas nubes, seré semejante al Altísimo»."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "44",
      "epub:type": "pagebreak",
      "id": "page44",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("El objetivo definitivo del Enemigo es llegar a ser como el Altísimo, como Dios, para poder destronarlo. Pero no pasa de ser una oscura imitación de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Ahora comenzaremos a ensamblar las piezas del rompecabezas. El Diablo intenta ser como Dios, tomar su lugar, imitar su apariencia y sus obras. Como invertido, trata de voltear las cosas de Dios sobre sí mismas, poner las obras y los caminos de Dios en contra de los propósitos divinos. Y como el Enemigo es el Dragón, persigue a la mujer; él hace la guerra contra Israel. El regreso de Israel es para él una amenaza que intentará eliminar. ¿Cómo imitará las obras de Dios, las invertirá y guerreará contra la nación de Israel para destruirla? Para lograr eso, necesitará un instrumento.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Así como Israel no solo regresó al mundo sino que resucitó en él, el Enemigo buscará anular ese milagro usando los mismos medios: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("una resurrección")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "45",
      "epub:type": "pagebreak",
      "id": "page45",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-27"
    }
  }, [_vm._v("Capítulo 11")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-28"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor010"
    }
  }), _vm._v("La resurrección del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("uando Dios trae ")]), _c('span', [_vm._v("una obra al mundo, el Enemigo busca traer otra obra alterna, una falsa, lo que llamaríamos una antiobra con el propósito de destruir la obra de Dios. En el Libro de Apocalipsis el Dragón concede autoridad y poder a aquel llamado “la Bestia”, también conocido como “el Anticristo” o el Antimesías. En el griego original, la palabra ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("anticristo")]), _c('span', [_vm._v(" significa no solo alguien que está en contra, opuesto y es la antítesis del Mesías, sino alguien que es su sustituto, su alternativa, alguien que tomaría su lugar. De modo que el Anticristo imitará al Mesías para anularlo.")]), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La invocación del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("De forma que, si Dios produjo la resurrección de Israel, el Enemigo trataría de hacer lo mismo; es decir, imitarlo, producir otra resurrección, su propia resurrección, una resurrección alterna y sustituta.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La resurrección del Dragón sería, por un lado, una antiresurrección, opuesta y antítesis de la resurrección de Israel y, por otro lado, una vulgar imitación. Con eso intentaría anular la resurrección de Israel y tomar su lugar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como Dios tomó una nación antigua y la colocó en el centro del escenario de la historia moderna, el Dragón también tomaría otra nación antigua y la pondría en el centro del escenario global moderno. Así como Dios tomó una nación que llevaba mucho tiempo muerta y la levantó de su tumba, el Dragón haría lo mismo. Haría que saliera de su tumba: una antinación, un antiisraelí. Y así como el Israel resucitado llevaría el nombre resucitado de su antiguo predecesor, el Dragón resucitaría a un pueblo que, de la misma manera, llevaría el nombre resucitado de sus antiguos predecesores.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Una palabra previa")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Antes de revelar el misterio y la resurrección de este antiguo pueblo, hay que tener en cuenta algunas cosas. El misterio no es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("las personas en sí")]), _vm._v(", "), _c('span', {
    attrs: {
      "aria-label": "46",
      "epub:type": "pagebreak",
      "id": "page46",
      "role": "doc-pagebreak"
    }
  }), _vm._v("sino la fuerza y la agenda que los utilizan. Sería lo mismo si estuviéramos tratando con Alemania bajo el Tercer Reich o Rusia bajo el comunismo. No afectaría a nada intrínseco a ninguno de los dos pueblos. Más bien, se trataría de las fuerzas que los superaron y de la agenda mediante la cual fueron manipulados y utilizados. Así que el misterio que ahora estamos a punto de revelar se refiere a aquello que alcanzó y utilizó a un pueblo para sus propios fines. La propia gente no tenía idea de que estaban siendo utilizados. Tampoco se dieron cuenta del plan que los impulsaba ni de cómo los conduciría a su propia destrucción. En esto eran peones en manos de una fuerza superior a su conocimiento.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Estamos tratando principalmente en el ámbito de los pueblos y las naciones, no de los individuos. Un pueblo puede emprender un rumbo que vaya en contra de los propósitos de Dios. Una nación puede elegir el mal así como el mal puede elegir a una nación. Al mismo tiempo, no podemos juzgar a los individuos por las naciones de las que forman parte o por el rumbo que dichas naciones elijan seguir. Y debemos recordar que el amor de Dios llega a todos y cada uno de manera imparcial. Aquellos que siguen a Dios deben, por un lado, reconocer y oponerse a lo que es malo y —sin embargo— por el otro, extender misericordia a aquellos que están bajo su influencia y su hechizo. Deben amar a quienes los odian y orar por su redención. Porque las naciones, los pueblos y los individuos tienen libre albedrío. Pueden cambiar de rumbo y la misericordia de Dios no tiene fin ni límites.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El tanim")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así que, ¿a qué pueblo o nación resucitaría el Enemigo? La resurrección del Enemigo sería "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("la resurrección de un contrincante")]), _vm._v(": el regreso del antiguo enemigo de Israel. La unión del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Enemigo de Dios ")]), _vm._v("con los enemigos de Israel se remonta a la antigüedad. El Libro de Jeremías contiene una profecía acerca de uno de los enemigos más poderosos del antiguo Israel, el rey Nabucodonosor de Babilonia. Dice esto:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Nabucodonosor, el rey de Babilonia …Me tragó como un monstruo marino dragón]."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La misma palabra hebrea usada para Nabucodonosor aparece en otra profecía dirigida contra otro de los antiguos enemigos de Israel, el faraón:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "47",
      "epub:type": "pagebreak",
      "id": "page47",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Yo estoy contra ti, faraón, rey de Egipto, gran monstruo que yaces en el cauce de tus arroyos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La palabra en ambos pasajes es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tanim")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tannin")]), _vm._v(". Se puede traducir como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("monstruo")]), _vm._v(". Pero también puede traducirse como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("serpiente")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("dragón")]), _vm._v(". Esto es especialmente sorprendente en vista de cómo habla Apocalipsis 12 acerca del Enemigo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Así fue expulsado el gran Dragón, aquella serpiente antigua que se llama Diablo y Satanás."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Así como la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tanim")]), _vm._v(" puede significar tanto dragón como serpiente, en Apocalipsis al Diablo se le llama tanto Dragón como serpiente. Cuando las Escrituras hebreas se tradujeron al griego, el tanim hebreo se convirtió en el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("drakohn")]), _vm._v(" griego, o dragón. En el Nuevo Testamento la palabra aparece solo en el Libro de Apocalipsis y principalmente en una sección: la visión del Dragón y la mujer de Apocalipsis 12.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los pequeños dragones")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Entonces, la palabra usada para identificar al Enemigo, Satanás, en el Libro de Apocalipsis es una traducción del vocablo usado en hebreo para hablar de los antiguos enemigos de carne y hueso de Israel. ¿Cuál es la conexión? Los antiguos enemigos de Israel fueron utilizados por el eterno Enemigo de Dios. Eran los agentes de carne y hueso empleados por el Enemigo para atacar, invadir y traer muerte y destrucción al pueblo de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la antigüedad, el Dragón guerreó contra Israel utilizando pueblos y naciones como sus vasos, pequeños “dragones” de carne y hueso. Su guerra se convirtió en la de ellos, y en la de ellos estaba la suya. Cuando atacaban a Israel, era el Dragón el que lo atacaba. Cuando invadían la tierra, fue el Dragón el que invadió. Y cuando se enfurecían contra el pueblo de Dios, era la furia del Dragón. Así como usó a un pueblo antiguo para guerrear contra un Israel antiguo, usaría a un pueblo resucitado para pelear contra un Israel resucitado. Y programaría y calibraría la resurrección del Enemigo para que coincidiera con el momento de la resurrección de Israel. Así como Israel se levantó de su antigua tumba, otros también se levantarían de sus antiguas sepulturas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "48",
      "epub:type": "pagebreak",
      "id": "page48",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Todo comenzaría en las aguas del Egeo.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "49",
      "epub:type": "pagebreak",
      "id": "page49",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-29"
    }
  }, [_vm._v("Parte 4")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-30"
    }
  }, [_vm._v("El regreso de los pueblos del mar")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "51",
      "epub:type": "pagebreak",
      "id": "page51",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-31"
    }
  }, [_vm._v("Capítulo 12")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-32"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _vm._v("Los pueblos del mar")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("e todos los ")]), _c('span', [_vm._v("enemigos que enfrentó Israel en la antigüedad, el que más merecía el título de archienemigo era el pueblo conocido como los ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("filisteos")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El archienemigo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Ningún otro pueblo guerreaba tan continuamente contra los israelitas, atacándolos, oprimiéndolos, burlándose de ellos, provocándolos y aterrorizándolos como lo hacían los filisteos. Ninguno estuvo tan presente en su historia ni luchó tan frecuentemente contra su presencia en la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los filisteos vencieron y mutilaron a Sansón, el héroe israelita. Se enfrentaron en batalla contra el pastor israelita David. Lucharon contra el primer rey de Israel, Saúl, y lo persiguieron hasta la muerte. Lucharon contra los reyes posteriores de Israel y siguieron siendo los enemigos jurados y arquetípicos de la nación siglo tras siglo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Quiénes eran ellos?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los "), _c('span', {
    staticClass: "Impa-i _idGenCharOverride-1"
  }, [_vm._v("pileshtim")])]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En su primera aparición en diversas inscripciones antiguas, figuran como uno de los conocidos "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("pueblos del mar")]), _vm._v(". Se acepta, generalmente, que eran originarios del sur de Europa, del Mediterráneo y, más concretamente, de las tierras que rodean el Mar Egeo. Parecen haber estado conectados con la antigua civilización micénica o protogriega."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A finales de la Edad del Bronce invadieron Egipto y lucharon contra los ejércitos de Faraón. Las inscripciones egipcias llaman a uno de los pueblos del mar invasores "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Pulasti")]), _vm._v(", o pueblo de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Peleset")]), _vm._v(", o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palusata")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En hebreo se les llama "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Pileshtim")]), _vm._v(", el plural de la palabra Pilishti, habitantes de la región llamada "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Peleset")]), _vm._v(". Se cree que del hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Pileshtim")]), _vm._v(" proviene la palabra griega "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Philistinoi")]), _vm._v(". Y del nombre griego vino el latín "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Philistinus")]), _vm._v(", y del latín, la palabra castellana filisteo.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "52",
      "epub:type": "pagebreak",
      "id": "page52",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las apariciones paralelas")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La primera aparición conocida de la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Israel")]), _vm._v(" fuera de las Escrituras ocurre en las inscripciones de los faraones egipcios. Ocurre en la estela de la victoria del faraón Merneptah. En esta, Faraón se jacta de haber conquistado a sus enemigos en la tierra de Canaán:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Canaán ha sido saqueada y sumida en todo tipo de aflicciones … "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Israel")]), _vm._v(" está arrasado."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La primera aparición conocida de la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("filisteo")]), _vm._v(" también ocurre en los registros de un faraón egipcio, Ramsés III. En los muros del templo mortuorio de Ramsés, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Madinat Habu")]), _vm._v(", los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("peleset")]), _vm._v(" —filisteos— aparecen como enemigos del imperio egipcio. Se los representa como guerreros que portan espadas de doble filo, lanzas largas, escudos redondos y tocados de plumas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4 ")]), _vm._v("Aparecen al mismo tiempo en los escritos del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Gran Papiro Harris")]), _vm._v(", en el que Ramsés afirma:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Extendí todas las fronteras de Egipto; derribé de sus tierras a quienes los invadieron … Los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Peleset")]), _vm._v(" [filisteos] fueron reducidos a cenizas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Tanto "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Israel")]), _vm._v(" como los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("filisteos")]), _vm._v(" hacen sus primeras apariciones conocidas en los anales de los faraones egipcios. Lo más sorprendente es el momento. La primera aparición de Israel se fecha a finales del siglo trece a. C. Las primeras apariciones de los filisteos se datan poco después, a mediados del siglo doce a. C. Para todos los efectos, vienen al mundo juntos: primero los israelitas, luego los filisteos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Tres mil años después, cuando Israel habría de regresar al mundo en los tiempos modernos, todo se repetiría. Reaparecerían juntos: primero el Israel resucitado y luego los filisteos resucitados.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Una relación mortal")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("pileshtim")]), _vm._v(", o filisteos, ocuparon la porción de la tierra de Canaán que limita con Egipto, o la península del Sinaí. Habitaban a orillas del Mediterráneo, en las tierras bajas de la costa suroeste de Israel. Esa porción llegaría a ser conocida como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Filistea")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" Aunque era parte de la tierra que Dios había prometido a Israel, los israelitas nunca pudieron obtener una "), _c('span', {
    attrs: {
      "aria-label": "53",
      "epub:type": "pagebreak",
      "id": "page53",
      "role": "doc-pagebreak"
    }
  }), _vm._v("posesión duradera de esa región. Y por eso fue, durante siglos, una espina clavada en el costado de la nación israelita.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El hecho de que los filisteos también reclamaran la tierra dada a Israel hizo que su conflicto con los israelitas fuera especialmente intenso, implacable y peligroso. Las Escrituras aluden a la profunda amargura y odio de los filisteos por Israel. Ellos continuaron y transmitieron ese odio de generación en generación. Y en el momento correcto, o incorrecto, estallaría con consecuencias mortales.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Resucitando a los filisteos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuando el rey Nabucodonosor de Babilonia invadió la tierra de Israel a finales del siglo doce y principios del seis a. C. y, en el proceso, destruyó las ciudades de Filistea, eso implicó el comienzo del fin de los filisteos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")]), _vm._v(" Pronto desaparecerían de los registros de la historia, existiendo a partir de entonces como la memoria de un pueblo desaparecido.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No obstante, si Dios iba a resucitar a la nación de Israel que también había desaparecido en tiempos antiguos, y dio a conocer en la profecía bíblica que así lo haría, es lógico pensar que el Enemigo e imitador de Dios también buscaría resucitar a una nación antigua: la de los antiguos enemigos de Israel. De ello se deduciría que intentaría resucitar de entre los muertos al más amargado, persistente e implacable de los antiguos enemigos de Israel. Haría regresar al pueblo que también reclamaba la tierra y luchaba incesantemente contra el reclamo de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si Dios abriera la antigua tumba de Israel, como se predijo en la visión de Ezequiel, se deduciría que el Dragón trataría de contrarrestar esa apertura abriendo las sepulturas de aquellos que, más que cualquier otro pueblo, constituían los archienemigos de la nación. Y habiéndolos levantado, los usaría para perturbar, frustrar, atacar, hacer guerra y buscar la destrucción de ese Israel resucitado. Y eso es exactamente lo que sucedería.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("El nombre se ha convertido en el centro de una controversia mortal que arde en el mundo moderno. Pero pocos conocen sus orígenes antiguos y aún más remotos, y la razón de su existencia.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "54",
      "epub:type": "pagebreak",
      "id": "page54",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-33"
    }
  }, [_vm._v("Capítulo 13")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-34"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _vm._v("La antitierra")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("i el Enemigo ")]), _vm._v("levantara a los filisteos, ¿cómo lo haría?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Fue en la antigüedad, en el momento de la destrucción de Israel, que Dios sembró las semillas de su resurrección. Así también fue en ese mismo tiempo que el Dragón sembró las semillas de la resurrección de los filisteos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La ciudad impía")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La destrucción del Templo de Jerusalén en el año 70 d. C. fue un momento decisivo y catastrófico en la historia judía. La ciudad santa quedó en ruinas, la tierra fue devastada, la nación de Judea fue borrada de la tierra y multitudes de judíos fueron asesinados o llevados cautivos a las naciones. Y, sin embargo, todavía quedaba un remanente considerable de judíos viviendo en la tierra. En el año 132 d. C., los judíos que habitaban la tierra se rebelaron nuevamente contra Roma liderados por un hombre llamado Simón Bar Kojba. En el año 135 d. C., Bar Kojba fue asesinado y la revuelta fue brutalmente aplastada."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En términos de estrategia, si la misión del Enemigo es destruir las obras de Dios y anular sus propósitos, y si los propósitos de Dios están más concretamente conectados con el pueblo judío y la ciudad de Jerusalén y, más específicamente, con la morada del pueblo judío en la ciudad de Jerusalén, entonces esperaríamos que él hiciera todo lo que estuviera en su poder para separar al pueblo judío de Jerusalén. Y eso es exactamente lo que pasó.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A raíz de la revuelta de Bar Kojba, el imperio romano prohibió al pueblo judío poner un pie en Jerusalén. Para obstruir aún más los propósitos de Dios, la ciudad pasó a llamarse "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Aelia Capitolina")]), _vm._v(", cuya palabra Capitolina se refiere al dios Júpiter."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Jerusalén ahora estaba dedicada al jefe del panteón romano. La ciudad santa de Israel fue reconstruida y rebautizada como una ciudad pagana de Roma.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Tierra de los filisteos”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Había más, sin embargo. No fue solo la ciudad la que se unió a los propósitos de Dios sino la tierra. Así que esperaríamos que el Enemigo hiciera todo lo que estuviera en su poder para separar a uno del otro. De modo que "), _c('span', {
    attrs: {
      "aria-label": "55",
      "epub:type": "pagebreak",
      "id": "page55",
      "role": "doc-pagebreak"
    }
  }), _vm._v("el exilio del pueblo judío de su tierra no sería suficiente: había que cambiar el nombre de la tierra. Había que darle una nueva identidad. Su conexión con el pueblo de Israel tenía que ser borrada de la historia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La tierra de Israel ahora llevaría el nombre del enemigo de Israel: los filisteos. Sería la versión romana del nombre que alguna vez denotó la costa sureste de Israel, la región que alguna vez estuvo ocupada por los pueblos del mar. Pero ahora toda la tierra de Israel, la Tierra Santa, pasaría a llamarse tierra de los filisteos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll ParaOverride-1"
  }, [_vm._v("El antinombre")]), _vm._v(" "), _c('p', {
    staticClass: "pab ParaOverride-2"
  }, [_vm._v("El cambio fue artificial y antihistórico. La tierra recibiría retroactivamente el nombre de un pueblo que no había existido durante medio milenio. El cambio no se trataba de los filisteos. Solo estaban siendo utilizados. Tampoco se trataba de los romanos. Tenían poco conocimiento del pueblo antiguo que una vez había luchado contra Israel. También estaban siendo utilizados. Aquello fue el intento del Enemigo de borrar la conexión del pueblo de Israel con la tierra de Israel y obstruir los futuros propósitos de Dios para ambos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Era un antinombre de lo que iba a ser una antitierra, la anti Tierra Prometida del antidios: el Enemigo. Dios le había puesto a la tierra el nombre del pueblo de Israel. El Enemigo había puesto a la tierra el nombre de sus enemigos. Los grandes anulados habían anulado la Tierra Prometida. El destructor ahora había cambiado el nombre de la tierra del pueblo de Dios en honor al pueblo que estaba decidido a destruirlos. El misterio lo había ordenado.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll ParaOverride-1"
  }, [_vm._v("Palestina")]), _vm._v(" "), _c('p', {
    staticClass: "pab ParaOverride-1"
  }, [_vm._v("La franja costera, en las Escrituras Hebreas, se llamaba la tierra de los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Pilishtim")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Peleset")]), _vm._v(". Traducida a otros idiomas, la raíz básica p-l-s-t permaneció. En griego, se convirtió en la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palaistine")]), _vm._v(" y en latín, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palaestina")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En castellano se tradujo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestina")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Durante casi dos mil años la Tierra Prometida sería llamada la tierra de los filisteos: Palestina. Pero el nombre iba más allá de la eliminación y la anulación. Fue la primera semilla de la siembra del Dragón en pro de una futura contraresurrección.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("La contraresurrección imitaría la resurrección de Israel, paralela a ella, desarrollándose al mismo tiempo, una al lado de la otra.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "56",
      "epub:type": "pagebreak",
      "id": "page56",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-35"
    }
  }, [_vm._v("Capítulo 14")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-36"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _vm._v("Filistea")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("sí como las ")]), _c('span', [_vm._v("palabras ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Satanás")]), _c('span', [_vm._v(" y ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Diablo")]), _vm._v(" denotan al que se opone, este último debía crear un pueblo que se opusiera y guerreara contra la existencia de Israel. Pero cuando Israel regresó al mundo como nación, los filisteos no habían existido durante casi dos mil quinientos años. Entonces, ¿a partir de qué orquestaría su resurrección?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Se convirtieron en filisteos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Aunque el Estado moderno de Israel está compuesto abrumadoramente por descendientes de carne y hueso del antiguo Israel,"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")]), _vm._v(" la resurrección fue más allá de la genética. Fue la resurrección de una "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("nación")]), _vm._v(", de su forma y su estructura, de su cultura, su naturaleza, sus características, su tierra, su nombre, sus íconos, sus instituciones, sus funciones, su llamado, su identidad y su papel entre las naciones. No todos los ciudadanos de la nación resucitada eran de su antiguo linaje. Estos se convirtieron en israelíes.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La resurrección de los filisteos se basaría en la identidad de los antiguos filisteos, sus características, su papel, su naturaleza, sus funciones, su cultura y su nombre. Sería una resurrección en la que un pueblo sería levantado y conformado a una imagen antigua.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El modelo para “convertirse en filisteos”, en realidad, comenzó en tiempos antiguos. Los filisteos eran originalmente un pueblo del Egeo que se estableció en la costa suroeste de Canaán. Pero la investigación moderna ha revelado que, con el tiempo, la composición genética de los enemigos de Israel cambió para reflejar la de los cananeos más nativos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Sin embargo, incluso con una composición genética diferente y cananea, seguían siendo filisteos de la misma cultura, las mismas características nacionales, las mismas costumbres, modos, naturaleza, rol e identidad. Así sería con su resurrección en el mundo moderno.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al mismo tiempo, cabe señalar que, aun cuando su resurrección trasciende la genética, esta sí desempeña un papel. Los estudios genómicos han revelado que los habitantes modernos de las tierras que formaban el antiguo Líbano, Siria, Israel o Canaán tienen conexiones genéticas con los antiguos habitantes de esas tierras y entre sí."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "57",
      "epub:type": "pagebreak",
      "id": "page57",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las reapariciones")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Esperaríamos que el Dragón, como imitación de Dios, uniera la resurrección de los filisteos a la resurrección de Israel. El regreso de Israel al mundo como entidad nacional comenzó oficialmente con el nacimiento del sionismo. Este sionismo, a su vez, comenzó en 1897, cuando Theodor Herzl convocó el Primer Congreso Sionista en Basilea, Suiza."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" No fue casualidad que fuera justo después de ese acontecimiento trascendental que la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("palestino")]), _vm._v(" comenzara a aparecer en el idioma árabe, marcando el inicio de su uso moderno. Los años siguientes verían su aparición en revistas musulmanas, judías y cristianas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y así como el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("filisteo")]), _vm._v(", o Peleset, hizo su aparición en el mundo antiguo inmediatamente después del israelita, manifestándose cada uno en los escritos de los faraones, también sucedió que, así como uno hizo su reaparición en el mundo moderno, también lo haría el otro.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A medida que avanzaba la resurrección de Israel a principios del siglo veinte, y específicamente con la emisión de la Declaración Balfour británica en apoyo de una patria judía, las palabras "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestina")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("palestino")]), _vm._v(" aparecieron cada vez más en libros, folletos y artículos. Aunque la palabra tenía más de una connotación, dependiendo de quién la usara, incluido el pueblo judío, se empleaba cada vez más para oponerse al nacimiento de una nación judía en la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El otro regreso de 1948")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El momento decisivo en la resurrección de Israel llegó en 1948, cuando su primer líder —David Ben-Gurión— leyó la declaración de independencia de la nación y proclamó su regreso al mundo. Hasta ese instante, la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("palestino")]), _vm._v(" podía referirse —y de hecho se refería— a cualquier habitante de la tierra: árabe, judío u otro. Pero a partir de entonces, el término se vincularía al habitante no judío de la tierra, es decir, al árabe.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El habitante judío de la tierra era ahora israelí. El habitante árabe de la tierra fuera del Estado judío se convertiría, con el tiempo, en palestino. Las implicaciones completas de lo que estaba sucediendo no eran evidentes en 1948 pero, a su debido tiempo, se volverían inconfundibles. La resurrección de los israelitas daría origen a la resurrección de los filisteos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y, sin embargo, las señales estuvieron ahí desde el principio para aquellos que tenían ojos para ver. En el año del renacimiento de Israel nació también otro Estado. Se llamó "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Protectorado de Toda Palestina")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" Fue la primera "), _c('span', {
    attrs: {
      "aria-label": "58",
      "epub:type": "pagebreak",
      "id": "page58",
      "role": "doc-pagebreak"
    }
  }), _vm._v("manifestación de un Estado palestino. Se formó en respuesta directa a la resurrección de Israel y fue creado con el objetivo específico de anularla. Del Protectorado de Palestina surgieron el Gobierno de Palestina y el Consejo Nacional de Palestina.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Fue, nuevamente, un caso de imitación. Así como 1948 fue el año de la declaración de independencia de Israel, también fue el año de la declaración de independencia del Consejo Nacional Palestino. Y así como 1948 fue el año en que Israel declaró su regreso a la tierra, también fue el año en que el Gobierno de Palestina declaró plena soberanía sobre la misma tierra y autorizó a un Ejército de Guerra Santa con el propósito expreso de destruir a la recién establecida nación judía."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Filastin")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("palestino")]), _vm._v(" se convertiría, con el tiempo, en el nombre oficial utilizado para etiquetar a los habitantes no judíos o árabes de la tierra. Se convertiría en el nombre que ellos mismos utilizarían para identificarse. En castellano, la palabra es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestina")]), _vm._v(". Pero quienes usaron la palabra hablaban árabe. Entonces, ¿cuál fue la verdadera palabra que usaron?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En árabe, la palabra se pronunciaba "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Filastinian")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Filastini")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")]), _vm._v(" La raíz de ambas es el vocablo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Filastin")]), _vm._v(". No se puede pasar por alto que la pronunciación de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Filastin")]), _vm._v(" es prácticamente idéntica a la de la palabra inglesa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Philistine")]), _vm._v(". De hecho, en los diccionarios de inglés la pronunciación de la palabra filisteo a menudo se representa exactamente así: filastin. Y en efecto, la palabra árabe para Palestina es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Filastin")]), _vm._v(", como en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("filisteo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dado que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Filastin")]), _vm._v(" es el término real utilizado por el pueblo conocido como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("palestinos")]), _vm._v(", se usará a lo largo de este libro.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Así que, por primera vez desde la antigüedad, habría un pueblo en el mundo y en la tierra de Israel que llevaría el nombre de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("filisteo")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("filastin")]), _vm._v(". Y al igual que con la resurrección de Israel, el momento decisivo en la resurrección de los filisteos llegó en el año 1948. Ese año comenzaría una oscura metamorfosis mediante la cual el antiguo Enemigo de Israel empezaría a manifestarse en la tierra.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "59",
      "epub:type": "pagebreak",
      "id": "page59",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-37"
    }
  }, [_vm._v("Capítulo 15")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-38"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _vm._v("Metamorfosis")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("a resurrección de ")]), _vm._v("los filisteos imitaría la de Israel, hasta el punto que imitaría el patrón de la visión de Ezequiel en el valle de los huesos secos. Comenzaría con huesos, las piezas de una identidad conectada con los antiguos filisteos. Luego, esos huesos empezarían a unirse para formar una estructura esqueletada. Y entonces la carne los cubriría.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El escenario")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Al momento del renacimiento de Israel, la mayoría de los habitantes no judíos del país se veían a sí mismos como árabes, no como palestinos. El primer intento de formar un Estado palestino —el Protectorado de Toda Palestina— finalmente fracasaría, pero sentaría las bases para una transformación venidera.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En 1947, las Naciones Unidas aprobaron un plan de partición mediante el cual la tierra de Israel se dividiría entre un Estado judío y un Estado árabe. La porción ofrecida al pueblo judío fue una fracción de su patria bíblica, pero la aceptaron. Sin embargo, el mundo árabe rechazó la oferta. No aceptarían la existencia de ningún Estado judío, pero exigieron soberanía sobre la tierra en su totalidad."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El día del regreso de Israel al mundo, la nación recién nacida fue atacada por todos lados por los ejércitos de múltiples naciones árabes comprometidas con su destrucción. Milagrosamente sobrevivió al ataque y ganó la guerra. ¿Qué pasó entonces con los habitantes árabes del país?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A quienes vivían dentro de las fronteras de Israel se les concedió la ciudadanía. Durante la guerra, Egipto se apoderó de la franja costera que bordea el Sinaí. Quienes vivían en esa región quedarían bajo soberanía egipcia. Los de los Altos del Golán, en el norte, estaban bajo soberanía siria. En cuanto a quienes vivan en lo que se conocería como Cisjordania, quedarían bajo la soberanía de Jordania, que se había apoderado de la región. Ahora eran jordanos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Para que la resurrección de los filisteos llegara a buen término, tendría que haber una transformación importante.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "60",
      "epub:type": "pagebreak",
      "id": "page60",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El niño mortal de Jerusalén")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El centro de Israel es y siempre ha sido su capital eterna, Jerusalén. Ahí estaba el Santo Templo, allí sus reyes se sentaban en sus tronos y ahí el pueblo se reunía para adorar al Señor. Incluso en su largo exilio de la tierra, no pasó un año sin que dejaran de orar: “El año que viene en Jerusalén”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si la tierra de Israel era el punto focal de los propósitos de Dios en la tierra, Jerusalén era el punto central de ese eje. Fue desde Jerusalén que los propósitos de Dios salieron al mundo: la Palabra, el Espíritu, el evangelio. Por lo tanto, esperaríamos que Jerusalén también se convirtiera en el punto focal de los propósitos del Enemigo. Así que fue en Jerusalén donde el Enemigo dio origen a una nueva entidad dedicada a esos propósitos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Fue en 1964 que la Liga Árabe inició la creación de una nueva entidad que se llamaría "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Organización para la Liberación de Palestina")]), _vm._v(" u OLP. Nacería en Jerusalén. El nombre resumió su propósito. La tierra que llamó Palestina iba a ser “liberada” de Israel. La única manera de que eso podría suceder era que Israel fuera destruido. Por lo tanto, se fundó otra organización para lograr ese fin: el EPL, el Ejército de Liberación de Palestina."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" Lo que ocurrió en Jerusalén en 1964 jugaría un papel central y fundamental en la resurrección de los filisteos y, sin embargo, sería otro acontecimiento que resultaría aún más crucial.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("1967")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Según los antiguos profetas, el pueblo judío debe regresar no solo a la tierra de Israel sino también a Jerusalén. Las profecías bíblicas sobre el fin de los tiempos no podrían cumplirse hasta que eso sucediera. Pero con Jordania controlando la Jerusalén bíblica y el mundo islámico reclamando la antigua ciudad para sí, era prácticamente imposible que algo así sucediera. Sin embargo, las profecías decían lo contrario.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la primavera de 1967, las naciones que rodeaban a Israel comenzaron a amenazar con su destrucción. Las intimidaciones iban seguidas por acciones militares, cuando los ejércitos combinados de los enemigos de Israel comenzaron a acumularse en sus fronteras. Para evitar la destrucción, Israel decidió actuar primero. Y así comenzó la Guerra de los Seis Días."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al tercer día de esa guerra, por primera vez en casi dos mil años, los soldados de Israel entraron por las puertas de Jerusalén. Avanzaron por sus calles y corredores hasta llegar al Muro Occidental del Monte del Templo, "), _c('span', {
    attrs: {
      "aria-label": "61",
      "epub:type": "pagebreak",
      "id": "page61",
      "role": "doc-pagebreak"
    }
  }), _vm._v("donde oraron y lloraron."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" Las antiguas profecías se cumplieron. Fue otro momento crítico en el resurgimiento de los huesos secos. La restauración de Israel nunca podría estar completa sin Jerusalén. De modo que el regreso de la Ciudad Santa fue otro momento decisivo en ese levantamiento.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La resurrección involuntaria")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Sin embargo, como el Enemigo imita las obras de Dios, esperaríamos que el mismo momento decisivo en la resurrección de Israel produjera un instante decisivo en la resurrección de los filisteos. Y así fue. En la victoria de Israel sobre Egipto, Siria y Jordania, las tierras ocupadas por esas naciones fueron liberadas. Los árabes de la franja costera ya no estaban bajo el dominio egipcio; los del norte, ya no quedaron sujetos a los sirios; y los de Cisjordania, tampoco quedaron bajo la autoridad jordana. Y así, el regreso del pueblo judío a Jerusalén abrió inadvertidamente la puerta para que una nueva identidad tomara posesión de los habitantes árabes de la tierra: la de los palestinos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El regreso del guerrero filisteo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La clave para la siguiente etapa de la resurrección filistea fue el hombre llamado "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Yasser Arafat")]), _vm._v(". Nacido en El Cairo, Egipto, Arafat —como estudiante— caería bajo la influencia de la ideología antisionista. En el momento del renacimiento de Israel, Arafat era un nacionalista árabe militante que luchaba para destruir el Estado judío desde sus inicios. A finales de la década de 1950 fundó la facción militante conocida como Fatah, acrónimo de Harakat al-Tahrir al-Watani al-Filastini, el “Movimiento de Liberación Nacional Palestino”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" A principios de la década de 1960, Arafat basó sus operaciones en Siria y, desde allí, lanzó incursiones a Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Días después del final de la Guerra de los Seis Días, cruzó el río Jordán y entró en Cisjordania para reclutar combatientes en su guerra contra Israel. Libraría esa batalla cada vez más mediante actos de terrorismo contra civiles israelíes. Fue en ese momento que sus combatientes terroristas se convirtieron en pioneros en el uso de la táctica de atentados suicidas. Y fue entonces cuando el presidente egipcio Gamal Abdel Nasser proclamó a Arafat líder de los palestinos. En febrero de 1969, Arafat se convirtió en jefe de la OLP y más tarde en comandante de las Fuerzas Revolucionarias Palestinas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")]), _vm._v(" Miles de jóvenes árabes fueron reclutados en su ejército y adoctrinados en su causa.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "62",
      "epub:type": "pagebreak",
      "id": "page62",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los asaltantes")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así como los huesos secos en la visión de Ezequiel asumieron la forma de los soldados caídos, y como los israelíes tomaron la figura de sus antiguos ancestros, ahora los habitantes árabes de aquella tierra comenzaron a asumir la forma de los antiguos enemigos de Israel. Serían conformados, paso a paso, a la imagen de los antiguos filisteos y de los viejos soldados filisteos. Tomar el nombre de los filisteos fue solo el comienzo. Ahora empezaron a asumir sus identidades, sus modos, sus funciones, sus estrategias y sus tácticas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La Biblia registra que los filisteos pelearon contra Israel lanzando ataques e incursiones contra sus ciudades y civiles. Ahora, a través de Arafat, Fatah y otros grupos terroristas, los militantes de Filastin comenzaron a resucitar las antiguas incursiones filisteas a la tierra de Israel, buscando aterrorizar a sus habitantes.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Una posesión antigua")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los filisteos eran conocidos como un pueblo guerrero y violento. Por lo tanto, no fue casualidad que los filisteos resucitados se asociaran cada vez más con el uso de la intimidación para lograr sus fines. Tampoco fue un accidente que el terrorismo en el mundo moderno estuviera especialmente vinculado a la agenda palestina, o Filastin, y a la rabia contra Israel. Fue una transformación mortal. Aquellos que serían conocidos como palestinos no habían planeado lo que ahora los estaba alcanzando. Tampoco eligieron el momento de su metamorfosis. El Enemigo lo había elegido por ellos y ahora se estaba apoderando de ellos. En ese sentido eran víctimas... víctimas de un espíritu antiguo. La posesión de sus antiguos predecesores ahora los poseía a ellos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Del río al mar")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Dios le había hecho una promesa a Israel acerca de la tierra. Le dijo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Extenderé las fronteras de tu país, desde el mar Rojo hasta el mar Mediterráneo, y desde el desierto hasta el río Éufrates."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La promesa aparece una y otra vez a lo largo de las Escrituras, al igual que las palabras "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("río")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("mar")]), _vm._v(". Observa también la aparición en esa promesa de la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("filisteos")]), _vm._v(". Por tanto, la oscura resurrección produciría un "), _c('span', {
    attrs: {
      "aria-label": "63",
      "epub:type": "pagebreak",
      "id": "page63",
      "role": "doc-pagebreak"
    }
  }), _vm._v("canto pronunciado por los pueblos filisteos, un canto que multitudes de todo el mundo gritarían junto con ellos:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("¡"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Del río al mar")]), _vm._v(", Palestina será libre!"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("No es casualidad que las mismas palabras clave dadas en la promesa de Dios a Israel acerca de la tierra fueran utilizadas en el canto filisteo. Fue la promesa invertida. El cumplimiento de esa promesa invertida requería la eliminación o aniquilación de todos los judíos que vivían en la tierra, desde el río hasta el mar. Fue, nuevamente, la tergiversación del Dragón: la amenaza de destruir la promesa de Dios, una antipromesa.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La Shoá y la Nakba")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Israel resucitó tras el genocidio, se levantó de las cenizas del Holocausto; vivió después de morir. Por lo tanto, es una tergiversación típicamente satánica y descarada que el mayor objetivo de genocidio en la historia de la humanidad, el pueblo judío —Israel— tenga que ser acusado, en cada oportunidad, tanto por sus enemigos como por el mundo de cometer genocidio, y principalmente por aquellos que en realidad anhelan el genocidio del pueblo judío.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cada año, el pueblo filisteo conmemoraba el renacimiento de Israel como un día de maldad y calamidad al que llamaban "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Nakba")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("11")]), _vm._v(" De hecho, las naciones del mundo se unieron a esa conmemoración, al igual que las Naciones Unidas. La palabra hebrea para Holocausto es "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Shoah")]), _vm._v(", que significa "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("catástrofe")]), _vm._v(". La palabra "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Nakba")]), _vm._v(" en árabe quiere decir lo mismo: "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("catástrofe")]), _vm._v(". Es una revelación de quien está detrás, aquel que invierte o tergiversa todas las cosas. Porque lo que hace que el pueblo judío se regocije es para él una catástrofe, y lo que es para el pueblo judío es un holocausto, es para él un motivo de regocijo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El conflicto israelí-filisteo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Debería haber sido obvio. Estuvo ahí desde el principio. Pero el mundo tenía poca idea de que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("palestino")]), _vm._v(", en realidad, significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("filisteo")]), _vm._v(" o que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestina")]), _vm._v(" —realmente— quiere decir: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tierra de los filisteos")]), _vm._v(". Por tanto, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Autoridad Palestina")]), _vm._v(" significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Autoridad Filistea")]), _vm._v(", y la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("bandera palestina")]), _vm._v(" es la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("bandera filistea")]), _vm._v("; la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("causa palestina")]), _vm._v(" es la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("causa filistea")]), _vm._v("; y el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("conflicto israelí-palestino")]), _vm._v(" es el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("conflicto israelí-filisteo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "64",
      "epub:type": "pagebreak",
      "id": "page64",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Mientras el pueblo judío se reunía nuevamente en el suelo de su antigua patria, ¿sería posible que se efectuara una segunda reunión al mismo tiempo: la de los filisteos resucitados de regreso al suelo de su antigua morada?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "65",
      "epub:type": "pagebreak",
      "id": "page65",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-39"
    }
  }, [_vm._v("Parte 5")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-40"
    }
  }, [_vm._v("PELESET")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "67",
      "epub:type": "pagebreak",
      "id": "page67",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-41"
    }
  }, [_vm._v("Capítulo 16")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-42"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("Peleset")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("hora veremos cómo ")]), _vm._v("una serie de diversas fuerzas y factores convergieron para hacer que un pueblo moderno se conformara a la imagen de uno antiguo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La llanura costera")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En algún momento alrededor del reinado del faraón egipcio Ramsés III, los filisteos se establecieron en la costa sudoriental del mar Mediterráneo, justo al norte de la península de Sinaí. La zona había sido colonizada anteriormente por Egipto con el establecimiento de una guarnición militar."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al ser un pueblo marinero, los filisteos tendían a gravitar hacia las regiones costeras. De modo que el asentamiento filisteo se centró en una franja de tierra que se extendía de norte a sur a lo largo de la costa oriental del Mediterráneo. Aunque había filisteos que se asentarían más allá de esa región, al norte y al este, fue esa franja costera la que seguiría siendo su cuartel general y el centro de su asentamiento en la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para el pueblo de Israel, la región de los filisteos era territorio hostil, una tierra enemiga dentro de la Tierra Prometida. Serviría como fuente de una enemistad secular e innumerables conflictos. Fue esa llanura costera la que se conocería como Peleset o Filistea, misma que se convertiría en la fuente de la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestina")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Levantamiento de Peleset")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuando Israel renació en 1948, Egipto invadió el Estado recién nacido a través de la franja costera que une las dos tierras. Aunque Israel ganó la guerra, Egipto retuvo el control de la franja. Desde el momento de esa guerra en adelante, decenas de miles de árabes se trasladarían allí bajo el dominio egipcio. La afluencia fue tan masiva que al final de la guerra, la población de la región se había triplicado. Aproximadamente una cuarta parte de la población árabe de Israel vivía ahora allí."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Y a medida que la población judía se multiplicaba en la tierra de Israel, la población palestina también se multiplicaría en esa franja costera. El aumento fue tan "), _c('span', {
    attrs: {
      "aria-label": "68",
      "epub:type": "pagebreak",
      "id": "page68",
      "role": "doc-pagebreak"
    }
  }), _vm._v("grande que a principios del siglo veintiuno era diez veces mayor que antes de que naciera Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Fue esa tierra la que pasaría a ser conocida como la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Franja de Gaza")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y aunque llegó a la conciencia mundial como de la noche a la mañana y debido a las exigencias de la guerra, la región estaba atormentada por un pasado antiguo. La "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Franja de Gaza")]), _vm._v(" era la tierra de los filisteos. Por un capricho de la historia, el nacimiento de Israel había llevado a una convergencia de habitantes árabes en el mismo suelo en el que una vez habitaron los antiguos filisteos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El regreso de Gaza")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Gaza")]), _vm._v(" era una palabra antigua. Aparece en la Biblia."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" Era el nombre de una ciudad que, en aquella época, se levantaba en la tierra de los filisteos. Los filisteos habían construido cinco ciudades importantes en Filistea: Asdod, Gat, Ecrón, Ascalón y Gaza."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" Más de una vez las Escrituras hablan de Gaza como representante de Filistea y de los filisteos. La encarnación moderna de Gaza sería conocida como Ciudad de Gaza. Así, la ciudad y la región de Gaza volverían a estar repletas de habitantes. Y la Franja de Gaza, que alguna vez fue la preocupación del antiguo Israel, pronto se convertiría en la intranquilidad del mundo entero.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La tierra de Filistea estaba ubicada a lo extenso de la frontera occidental de Israel. La Franja de Gaza está situada a lo largo de la frontera occidental de Israel. La tierra de Filistea corría hacia el sur, a lo largo de la costa oriental del mar Mediterráneo. La Franja de Gaza se extiende, de norte a sur, en la costa oriental del mar Mediterráneo. La tierra de Filistea terminaba en la península del Sinaí, limitando con territorio egipcio. La Franja de Gaza finaliza en la Península del Sinaí, limitando con territorio egipcio."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" La recreación y encarnación moderna de la antigua Peleset, Filistea, la tierra de los filisteos, es la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Franja de Gaza")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La reunión filistea")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Y así fue encajando otra pieza del antiguo misterio. El pueblo que habría de tomar el nombre de los antiguos filisteos, los palestinos, ahora fue traído de regreso para habitar el mismo suelo en el que habían habitado los antiguos filisteos. En otras palabras, Peleset, Filistea, la tierra de los filisteos, ahora estaba habitada otra vez por un pueblo que llevaba el nombre de filisteos. Insisto, no era el plan ni la intención de nadie. La afluencia de "), _c('span', {
    attrs: {
      "aria-label": "69",
      "epub:type": "pagebreak",
      "id": "page69",
      "role": "doc-pagebreak"
    }
  }), _vm._v("gente a la Franja de Gaza solo se produjo debido a la guerra y porque las fuerzas egipcias se apoderaron de esa franja de tierra en particular, que resultó ser la misma ocupada por los antiguos filisteos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por supuesto, había otros árabes viviendo en Cisjordania, pero incluso esto tenía un paralelo antiguo. En la antigüedad, los filisteos habían hecho incursiones hacia el norte y el este, pero su morada central y cuartel general era la tierra que llevaba su nombre, la franja costera mediterránea que se extendía hacia abajo en dirección al Sinaí, Filistea.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Cada uno a su antiguo terreno")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Hubo otra conexión que se manifestó en el momento de la resurrección de los filisteos. El Protectorado de Toda Palestina, que nació en el momento del renacimiento de Israel fue, como hemos visto, el primer Estado que llevó el nombre de Palestina. Pero ¿qué era exactamente? Se trataba de la Franja de Gaza. De hecho, el Protectorado de Toda Palestina fue el primer nombre de esa franja. Así que ahora la tierra de los filisteos, por primera vez desde la antigüedad, volvió a ser habitada por un pueblo que llevaba el nombre de filisteo, y así fue, después de dos mil quinientos años, en el momento del regreso de Israel a su antigua tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cada uno de esos regresos ocurrirían en 1948. Cada uno de ellos nacería en la guerra. Cada uno sería sellado con una declaración de Estado. Y cada uno implicaría una convergencia masiva: la reunión del pueblo judío en Israel y la reunión del pueblo filisteo en Filistea. El misterio había ordenado que todo volviera a su antiguo suelo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Los israelitas modernos ahora habitaban la tierra de los antiguos israelitas, y los filisteos modernos, la tierra de los antiguos filisteos. Ahora todo estaba preparado para que los espíritus y los odios antiguos los poseyeran.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "70",
      "epub:type": "pagebreak",
      "id": "page70",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-43"
    }
  }, [_vm._v("Capítulo 17")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-44"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  }), _vm._v("El odio antiguo")]), _vm._v(" "), _c('p', {
    staticClass: "pf-2"
  }, [_c('span', {
    staticClass: "DROP-CAP"
  }, [_c('span', {
    staticClass: "_ _idGenCharOverride-3"
  }, [_vm._v("¿")])]), _c('span', {
    staticClass: "_idGenDropcap-2"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("ómo eran exactamente ")]), _vm._v("los antiguos filisteos?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Cuando ven la guerra”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Una de las primeras referencias o pistas sobre la naturaleza o reputación de los filisteos proviene del Libro de Éxodo. Aparece justo cuando los israelitas salieron de Egipto:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y luego que Faraón dejó ir al pueblo, Dios no los llevó por el camino de la tierra de los filisteos, que estaba cerca; porque dijo Dios: Para que no se arrepienta el pueblo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cuando vea la guerra")]), _vm._v(", y se vuelva a Egipto."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La existencia de los filisteos en el momento del Éxodo alteró la travesía de Israel por el desierto. La ruta más corta y natural desde Egipto a la Tierra Prometida era a través de la Franja de Gaza, o Filistea. Pero se eligió una ruta alternativa para evitar la tierra de los filisteos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La razón se da en la frase “cuando vea la guerra”. Los israelitas, que acababan de salir de la esclavitud, no estaban preparados para la guerra. Había otros pueblos en la región, pero solo los filisteos presentaban un peligro tan grande que hubo que modificar todo el viaje. Y no fue “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("si ve la guerra")]), _vm._v("” sino “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cuando vea la guerra")]), _vm._v("”. Era una certeza. Los filisteos harían la guerra contra ellos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El guerrero")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Al definir a los filisteos, un comentarista bíblico escribe: ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Debido a que los filisteos eran un "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("pueblo guerrero")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("agresivo")]), _vm._v(", se temía que Israel se alarmara al enfrentarse a ellos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Otro escribe:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "71",
      "epub:type": "pagebreak",
      "id": "page71",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("En la época del Éxodo, los filisteos eran conocidos por su "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("naturaleza salvaje y guerrera")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En las descripciones de los antiguos filisteos, la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("guerrero")]), _vm._v(" aparece una y otra vez. La exactitud de la palabra se confirma en relatos bíblicos, en registros antiguos extrabíblicos y en hallazgos arqueológicos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La cultura filistea giraba en torno a la guerra. Se invirtieron grandes cantidades de tiempo, energía y recursos en la adquisición y producción de armas. Se glorificaba la guerra, se celebraba la violencia y se recompensaba la brutalidad. Aquellos que sobresalían en las artes de la guerra y la violencia, los más feroces y brutales entre ellos, eran reverenciados como héroes. Eran, como lo expresó un comentarista,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("los enemigos más temidos del pueblo de Dios. Eran guerreros brutales."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La veneración de la sangre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Si un pueblo moderno tuviera que ajustarse a la imagen de los filisteos, esperaríamos que la metamorfosis implicara la reaparición de las características que más definían sus antiguos prototipos. Cabría esperar que se volvieran cada vez más belicosos y predispuestos a la violencia. Eso es exactamente lo que sucedería. No estamos hablando aquí de la naturaleza intrínseca o del rasgo innato de un pueblo. Cada sociedad y pueblo está formado por individuos de diversas naturalezas, tendencias y rasgos. Pero las culturas pueden asumir características específicas y distintas. A lo que nos referimos es a la transformación de una cultura y, a través de ella, de un pueblo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para que el Dragón librara la guerra contra la existencia de Israel, necesitaría vasos de carne y sangre dispuestos y capaces de ejecutarla. No bastaba con resucitar la identidad de un pueblo antiguo ni de su tierra. Necesitaría resucitar sus costumbres y su cultura. Procuraría convertir a sus instrumentos resucitados en un pueblo guerrero. Tejería una cultura en la que el derramamiento de sangre fuera glorificado y venerado.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El oscurecimiento")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El líder palestino más destacado de la historia moderna fue Yasser Arafat. Un hombre violento. Pero cuando se propuso, por primera "), _c('span', {
    attrs: {
      "aria-label": "72",
      "epub:type": "pagebreak",
      "id": "page72",
      "role": "doc-pagebreak"
    }
  }), _vm._v("vez, crear su ejército palestino, pocos de sus asociados eran expertos en la lucha. Sin embargo, en cuestión de años los palestinos se jactarían de tener miles de jóvenes entrenados para la guerra y preparados para ejercer la violencia."), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El pueblo que ahora llevaba el nombre de los filisteos y habitaba en su tierra comenzó a transformarse a su imagen y naturaleza. Los invadió un espíritu tenebroso. Se volvieron cada vez más amargados, consumidos por el deseo no de construir una cultura próspera sino de cobrar venganza. Y, como sucedió con la cultura de los antiguos filisteos, la de ellos ahora glorificaba la violencia y la guerra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al igual que sus antiguos predecesores, los filisteos resucitados invirtieron enormes cantidades de tiempo, energía y recursos en la obtención y producción de armas. Así como la sociedad de la antigua Filistea veneraba a sus guerreros, la sociedad filistea moderna, o palestina, glorificaba a aquellos que habían derramado la sangre de los israelíes. Y así como la antigua cultura filistea premiaba la brutalidad, la moderna cultura filistea hizo lo mismo. Quienes asesinaban a ciudadanos israelíes eran recompensados con grandes sumas de dinero por parte de su gobierno, en una política condenada por los observadores como “pago por matar”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" A medida que avanzaba la metamorfosis, el pueblo palestino, filisteo, se centraba cada vez más en la muerte. Innumerables encuestas revelaron que la abrumadora mayoría de ellos estaba a favor de los ataques terroristas y la matanza de civiles israelíes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El odio antiguo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Para utilizar a un pueblo como instrumento de ira, el Enemigo tuvo que transmitir su odio por el pueblo judío a los filisteos resucitados. Así como la naturaleza del acusador es acusar y la del demoníaco endemoniar, la cultura palestina se saturó con la demonización de los israelíes y los judíos, convirtiéndose en una cultura de odio, difamación y rabia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Con esa mentalidad, cualquier acción adoptada contra los israelíes se justificaba como un acto de venganza. Incluso matarlos era justificado, ya que los israelíes habían sido deshumanizados. La ira de los antiguos filisteos se convirtió en la del moderno filisteo. E incluso en esto, las antiguas dinámicas resucitaron. En el Libro de Ezequiel está escrito acerca de los filisteos:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "73",
      "epub:type": "pagebreak",
      "id": "page73",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Yo, el Señor, digo: Los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("filisteos")]), _vm._v(" han tomado "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("venganza")]), _vm._v(", se han desquitado con corazón "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("lleno de desprecio")]), _vm._v("; como eternos enemigos de Israel, se han entregado a la destrucción."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Los antiguos filisteos eran conocidos por albergar una “eterna enemistad” u “odio antiguo” contra el pueblo de Israel. De modo que era inevitable que en la resurrección de los filisteos también se reviviera ese antiguo odio. Acerca de ese antiguo odio de los filisteos, un comentario bíblico dice lo siguiente:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Era un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("odio al nombre y al ser de Israel")]), _vm._v(", "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("los eliminarían")]), _vm._v("... con una "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("enemistad perpetua y sin fin persiguiéndolos")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Se podrían decir exactamente las mismas palabras sobre el odio palestino por el nombre actual de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Venganza cuando pudieron”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El comentario señala que los antiguos filisteos ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("aprovecharon la oportunidad para vengarse cuando los judíos estaban en una posición débil y desanimados."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De modo que el pueblo moderno de Filistea también buscaría vengarse de Israel cuando los judíos estuvieran “débiles y desanimados” o estuvieran en una posición de desventaja o no estuvieran preparados. Otro comentario sobre el antiguo odio de los filisteos dice esto:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Lo que guardaban era un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("viejo rencor")]), _vm._v(", tenían "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("odio")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("malicia")]), _vm._v(" "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("en sus corazones")]), _vm._v(" y querían una oportunidad para desahogarse; "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("habiendo decidido vengarse cuando pudieran y destruirlos por completo")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Insisto, se podrían decir exactamente las mismas palabras del pueblo filisteo de la Franja de Gaza y de Hamas: intentaron imponer “venganza cuando pudieron”. Estaban poseídos por lo que poseía a sus antiguos predecesores y lo que otro comentario denominó “su sed de venganza”. "), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("12")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "74",
      "epub:type": "pagebreak",
      "id": "page74",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Guerreros de negro y verde")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En la visión que Ezequiel tuvo acerca de la resurrección de Israel, los huesos secos se convirtieron no solo en una nación sino en un ejército, una nación de soldados. Lo mismo hicieron los filisteos resucitados. Mientras los israelíes se vestían con sus uniformes militares para defender su nación, los filisteos resucitados se cubrían la cara con tela negra y verde para ocultar sus identidades mientras se disponían a llevar la muerte a los israelíes.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Detrás de la “enemistad interminable” y el “antiguo odio” de los palestinos por los israelíes estaba el de los antiguos filisteos por los israelitas. Y detrás de eso estaba el odio aún más antiguo, el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("orgidzo")]), _vm._v(", del Dragón hacia Dios y su pueblo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así que no debería sorprendernos que la resurrección de Filistea hubiera producido una anticultura, una cultura de muerte basada en la negación y para provocar la eliminación de Israel. Se habían oscurecido, los vasos involuntarios del ángel tenebroso.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Ahora bien, uno de los misterios de la resurrección de los filisteos tiene que ver con los niños. La primera pista de ese misterio será un antiguo gigante.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "75",
      "epub:type": "pagebreak",
      "id": "page75",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-45"
    }
  }, [_vm._v("Capítulo 18")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE ParaOverride-3",
    attrs: {
      "id": "_idParaDest-46"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _vm._v("Hijos de la ira")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("as Escrituras nos ")]), _c('span', [_vm._v("dan otra pista sobre la cultura guerrera de los antiguos filisteos. Aparece en el relato de David y Goliat.")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Un hombre de guerra desde su juventud”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Goliat era un guerrero filisteo. Día tras día se presentaba ante los ejércitos de Israel, burlándose de ellos, desafiándolos a luchar para determinar qué pueblo gobernaría sobre el otro. Los soldados de Israel estaban aterrorizados. Pero un joven, el pastor David, aceptó el desafío. El rey de Israel, Saúl, trató de disuadirlo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y Saúl dijo a David: No podrás ir contra este filisteo para pelear contra él; porque tú "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("eres")]), _vm._v(" un joven, y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("él, un hombre de guerra desde su juventud")]), _vm._v("”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La palabra hebrea usada para describir la juventud de David es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("na’ar")]), _vm._v(", que habla de un niño, de un muchacho, desde la infancia hasta la adolescencia. La palabra utilizada para la juventud de Goliat es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("na’ur")]), _vm._v(", derivada de la misma palabra, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("na’ar")]), _vm._v(", y significa lo mismo. Así, Goliat fue descrito como un “hombre de guerra” desde su infancia. Supondríamos que no fue desde la infancia sino desde entonces hasta la adolescencia. La infancia de Goliat se enfocó en la guerra. Desde niño fue un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hombre de guerra")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Más allá de revelar la naturaleza de Goliat, las palabras revelan la esencia de la cultura en la que creció. Su iniciación en los caminos de la guerra no habría ocurrido en el vacío. Tampoco habría sucedido si no hubiera sido una parte aceptada de la sociedad filistea. No hay indicios de que fuera excepcional. Es un signo no solo de una civilización que está predispuesta a la violencia y la guerra, sino que lo está excepcionalmente.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los niños soldados")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así, sin duda, los filisteos educaron a sus pequeños hijos en el camino de la guerra. Inculcaron a sus hijos, desde edades tempranas, las prácticas y tácticas de violencia, batalla y derramamiento de sangre. Infundieron "), _c('span', {
    attrs: {
      "aria-label": "76",
      "epub:type": "pagebreak",
      "id": "page76",
      "role": "doc-pagebreak"
    }
  }), _vm._v("en ellos una mentalidad de guerra y una naturaleza insolente que podía, sin dudarlo, iniciar matanzas y destrucción. Fue eso lo que hizo que los guerreros filisteos fueran especialmente peligrosos y mortíferos. Y todo el entrenamiento tenía como objetivo específico un objetivo entre todos los demás: el israelita.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si los antiguos filisteos inducían a sus pequeños a la violencia y la guerra, esperaríamos que los que resucitaron en los tiempos modernos hicieran lo mismo. Y eso es exactamente lo que hicieron. Mientras que en la mayoría de las culturas los padres buscan proteger a sus hijos de los métodos de la guerra, en la cultura palestina —como lo fue en la cultura de los antiguos filisteos— los niños eran dedicados por sus padres y mentores a los propósitos de la guerra y la destrucción.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como se decía que Goliat fue un “hombre de guerra” desde su infancia —un niño soldado—, hoy se dice de los pequeños filisteos modernos que:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los chicos palestinos saben que se espera que sean niños soldados."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Nadar, hacer manualidades y matar judíos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Para la mayoría de los niños, los campamentos de verano evocan imágenes de juego, deportes, artes y manualidades, paseos en botes, fogatas y nuevas amistades. Para los niños filisteos de ayer como de hoy, el campamento de verano evoca diferentes imágenes: rifles, armas de fuego automáticas, entrenamiento militar, carga de municiones e instrucciones para cometer asesinatos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En cuanto al personal y las organizaciones que dirigen sus campamentos de verano, son representados por nombres como Hamas, Fatah, Yihad Islámica Palestina y las Brigadas Muyahidines. Los niños filisteos eran y son adoctrinados y radicalizados."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" La guerra es santa y el derramamiento de sangre, glorioso.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como los antiguos niños filisteos fueron entrenados para cometer violencia contra un pueblo específico, Israel, lo mismo ocurrió con el entrenamiento de sus homólogos modernos. Fueron entrenados para cometer derramamiento de sangre contra el pueblo judío de Israel. De la misma manera, se les enseñó a venerar a los terroristas como sus modelos a seguir, con la esperanza de que cuando crecieran cometieran también actos de terrorismo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" Así, la antigua sed de venganza de la que se habla en Ezequiel se transmitió a los hijos de los filisteos modernos. Y no fue "), _c('span', {
    attrs: {
      "aria-label": "77",
      "epub:type": "pagebreak",
      "id": "page77",
      "role": "doc-pagebreak"
    }
  }), _vm._v("casualidad que varios de los campos tuvieran en su nombre la palabra árabe que significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("venganza")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los tenebrosos jardines de infancia ")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El adoctrinamiento llegó a los hijos de los filisteos no solo a través de sus campamentos de verano sino también a través de su sociedad y su cultura. Llegó a través de sus televisores, a través del entretenimiento infantil, dibujos animados y libros de cuentos. Incluso llegó a través del plan de estudios que se enseña en sus escuelas públicas. Los jardines de infancia palestinos se utilizan para adoctrinar a niños de cuatro y cinco años en cuanto al derramamiento de sangre. Con pistolas de juguete en mano, son entrenados para realizar operaciones militares y realizar simulacros de ejecuciones de soldados israelíes. Un libro escolar palestino enseña física mostrando la dinámica y las fuerzas involucradas en atacar a los israelíes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" Otros enseñan a los niños filisteos que los judíos son malvados, un peligro y una amenaza. Algunas de esas lecciones se impartían y se enseñan en clases financiadas por las Naciones Unidas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("De modo que, la deshumanización y demonización de los judíos comenzó desde edades más tempranas. Por eso no fue casualidad que los sobrevivientes israelíes de las masacres palestinas describieran a sus asesinos como personas totalmente desprovistas de cualquier rastro de humanidad o piedad mientras cometían sus atrocidades. Era tan básico para los invasores como lo era el alfabeto que les habían enseñado cuando eran niños, junto con la yihad y la guerra contra los israelíes.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Niños en los altares")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La moderna cultura de la muerte filistea fue más allá de la celebración de la destrucción de sus enemigos. Celebró, a su vez, la muerte de los suyos. A los niños filisteos se les enseñó a añorar su propia muerte. Se les enseñó que ser asesinado mientras se buscaba derramar sangre judía era un acto de gloria. Y por eso los niños filisteos sueñan con ser asesinados. De la misma manera, a las madres filisteas se les enseñó a regocijarse por la muerte de sus hijos, mientras que a sus pequeños se les llevaba a realizar simulacros de funerales en los que uno de ellos tendría el honor de representar el papel de un cadáver, habiendo sido asesinado mientras cumplía su promesa: derramar sangre judía."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "78",
      "epub:type": "pagebreak",
      "id": "page78",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Entre los dioses adorados por los antiguos filisteos estaban Baal y Astoret. Ambos vinculados al sacrificio de niños."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")]), _vm._v(" Y así, a medida que los palestinos se fueron conformando progresivamente a la imagen de los antiguos filisteos, acabarían también sacrificando a sus hijos hasta la muerte. Porque el Dragón deseaba, sobre todas las cosas, la destrucción. Y por eso los palestinos también fueron víctimas del Dragón. Fueron engañados por él, burlados, utilizados, abusados y condenados a la destrucción. Porque el Enemigo es enemigo de todos y quiere la destrucción incluso de aquellos a quienes utiliza y que, sin saberlo, le sirven de instrumentos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así que, después de más de dos mil quinientos años, los hijos del pueblo filisteo fueron nuevamente bautizados en el antiguo odio a Israel, y nuevamente, adoctrinados y entrenados en las costumbres del derramamiento de sangre en el suelo de la Franja de Gaza, en el que habían recibido su formación en la antigüedad. Era como si el espíritu de los arcaicos filisteos hubiera regresado a sus antiguas costas para vengarse de sus antiguos enemigos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("La venganza habría de llegar por el cielo.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "79",
      "epub:type": "pagebreak",
      "id": "page79",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-47"
    }
  }, [_vm._v("Capítulo 19")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-48"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _vm._v("Los misiles")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("ntre todos los ")]), _c('span', [_vm._v("guerreros filisteos de la antigüedad se destacaban los arqueros. Por las excavaciones de las ruinas filisteas sabemos que utilizaban flechas de metal en vez de las de madera y piedra")]), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("1")]), _vm._v(" y, por tanto, eran especialmente letales. Los arqueros permitían a los filisteos asestar golpes mortales a los israelitas desde lejos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Arqueros en Gilboa")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El momento más célebre de los arqueros filisteos sucedió en el monte Gilboa, en la batalla contra el ejército israelita liderado por el rey Saúl y sus hijos. Saúl había abandonado los caminos de Dios y había ido a la batalla sin el favor de Dios, que una vez había reposado sobre su vida. El Libro de 1 Samuel registra los trágicos acontecimientos que siguieron:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los filisteos fueron a la guerra contra Israel y los israelitas huyeron ante ellos. Muchos cayeron muertos en el monte Guilboa. Entonces los filisteos se fueron en persecución de Saúl y lograron matar a sus hijos Jonatán, Abinadab y Malquisúa. La batalla se intensificó contra Saúl y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("los arqueros lo alcanzaron")]), _vm._v(" con sus flechas. Al verse gravemente herido."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De esta manera los arqueros filisteos pusieron fin no solo a la vida del rey Saúl sino también a su casa y su dinastía. Con ello, iniciaron el reinado del rey David. Para los filisteos, la muerte del rey Saúl y su casa sería el momento culminante de sus guerras contra Israel; mientras que para Israel, fue el más infame y traumático.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las armas de largo alcance de Filistea")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Es posible que los filisteos resucitados emplearan un armamento moderno similares a los arcos y flechas de sus antiguos predecesores, una versión modernizada del armamento con el que infligieron su golpe más letal al antiguo Israel? Puesto que los arcos y las flechas ya no se utilizan en la "), _c('span', {
    attrs: {
      "aria-label": "80",
      "epub:type": "pagebreak",
      "id": "page80",
      "role": "doc-pagebreak"
    }
  }), _vm._v("guerra, ¿cuál sería su equivalente moderno? El arco y la flecha pertenecían a una pequeña clase de armamentos antiguos caracterizados como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("armas de largo alcance")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" Golpeaban sus objetivos a largas distancias. El arquero filisteo lanzaba al aire un proyectil que volaba sobre el campo de batalla y, si su trayectoria tenía éxito, produciría muerte o destrucción al llegar al blanco.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Existe un equivalente moderno a los proyectiles voladores de las guerras antiguas? Sí, lo hay. Ahora se llama misil. Los misiles son la versión moderna —de alta tecnología— de las flechas que usaban los antiguos arqueros. Al igual que la flecha en la guerra antigua, el misil está a la vanguardia del armamento de larga distancia en la guerra moderna y, al igual que las flechas de los antiguos guerreros, el misil alcanza su objetivo a largas distancias.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El antiguo dispositivo de lanzamiento utilizado para impulsar las flechas hacia el cielo era el arco. En la guerra moderna, los misiles se lanzan desde estaciones y plataformas de lanzamiento. Así como las flechas de las guerras antiguas volaban sobre las murallas de las ciudades y los campos de batalla en trayectorias en forma de arco para traer destrucción al aterrizar, los misiles modernos también vuelan sobre campos de batalla, paisajes urbanos y regiones en trayectorias en forma de arco para destruir sus objetivos a larga distancia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los misiles de Gaza")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los antiguos filisteos disparaban proyectiles mortíferos contra los ejércitos y las viviendas de los israelitas. De modo que los filisteos resucitados harían lo mismo, disparando proyectiles mortíferos contra las ciudades y pueblos del Israel moderno. Los lanzadores de esos proyectiles fueron los militantes de Filistea y los terroristas de Hamas, Fatah y la Yihad Islámica. Las víctimas de esos misiles incluyeron, por supuesto, a los israelíes alcanzados y asesinados por ellos, pero también a los que sufrieron daños colaterales. Los estudios revelarían que más de la mitad de los niños israelíes en las regiones bajo bombardeos con misiles sufren trastornos de estrés. Los misiles comenzaron a dispararse desde Gaza hacia Israel en 2001. Desde entonces hasta la actualidad se han contabilizado decenas de miles."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La mayoría de las flechas antiguas disparadas por los filisteos contra el pueblo de Israel procedían de Filistea. Así que, en la resurrección filistea, la mayoría de los misiles disparados contra las ciudades y pueblos de Israel se originaron en la moderna Filistea, la Franja de Gaza. Fueron forjadas "), _c('span', {
    attrs: {
      "aria-label": "81",
      "epub:type": "pagebreak",
      "id": "page81",
      "role": "doc-pagebreak"
    }
  }), _vm._v("o puestas en movimiento en el mismo suelo sobre el que, en la antigüedad, se forjaron y se pusieron en movimiento las flechas de los filisteos. De modo que los armamentos de Filistea, una vez más, volaron por los cielos de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Bajo un intenso bombardeo de misiles”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La conexión entre las armas y tácticas de los filisteos antiguos y modernos va más allá. No se trata solo de que los antiguos filisteos dispararan flechas contra Israel y que los filisteos modernos dispararan proyectiles que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("parecían")]), _vm._v(" flechas. ¿Qué es un misil? Veamos su definición:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Un objeto que es impulsado con fuerza hacia un objetivo, ya sea con la mano o con un arma mecánica."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La definición de flecha es la siguiente:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Un misil disparado desde un arco y que generalmente tiene un eje delgado, una cabeza puntiaguda…"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En pocas palabras, una "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("flecha")]), _vm._v(" es un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("misil")]), _vm._v(". De manera que los antiguos filisteos dispararon misiles contra la nación de Israel. En consecuencia, los filisteos resucitados hicieron lo mismo. De hecho, un comentario bíblico relata la muerte del rey Saúl de esta manera:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Después de la caída de sus hijos, los arqueros descubrieron a Saúl y comenzaron a apuntarlo con sus proyectiles."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Otro lo expresa de esta manera:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Saúl… y sus hombres ahora se encontraban "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("bajo un intenso bombardeo de")]), _vm._v(" "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("misiles")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El antiguo misterio se repitió en la misma forma. Así como los guerreros filisteos de épocas pasadas disparaban sus misiles para traer la muerte al pueblo de Israel, los filisteos resucitados volvieron a disparar sus misiles para traer la muerte al pueblo de Israel. Así como los misiles de Gaza trajeron horror a los cielos del antiguo Israel, ahora los misiles de Gaza trajeron nuevamente horror a los cielos israelíes. Y el pueblo resucitado "), _c('span', {
    attrs: {
      "aria-label": "82",
      "epub:type": "pagebreak",
      "id": "page82",
      "role": "doc-pagebreak"
    }
  }), _vm._v("de Israel otra vez “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("se encontró bajo un intenso bombardeo de misiles")]), _vm._v("” de los filisteos resucitados.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Los misiles no fueron las únicas armas utilizadas por los enemigos resucitados de Israel. Ellos usarían otra arma, aún más estrechamente asociada con la nación judía: la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("kelah")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "83",
      "epub:type": "pagebreak",
      "id": "page83",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-49"
    }
  }, [_vm._v("Capítulo 20")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-50"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _vm._v("La kelah")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("i para los ")]), _vm._v("filisteos el momento culminante de sus guerras contra Israel fue la muerte del rey Saúl, el clímax para los israelitas fue la victoria de un pastorcillo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La honda del pastorcillo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La batalla entre el joven pastor israelita David y el guerrero filisteo Goliat es celebrada no solo por el pueblo de Israel sino por innumerables personas en todo el mundo. Así está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Entonces David venció al filisteo con una honda y una piedra, hirió al filisteo y lo mató."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Lo que fue tan impactante para los filisteos fue que su guerrero más feroz y formidable fue derribado por un pastor que empleó nada más que una "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("kelah")]), _vm._v(", palabra hebrea que se usa para "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ahorcamiento")]), _vm._v(", que en este caso se refería a una honda."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Es posible que la resurrección de los filisteos preservara una antigua "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("vendetta")]), _vm._v("? No es que los filisteos modernos fueran conscientes de la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("vendetta")]), _vm._v(", sino que el espíritu que los poseía haría que se manifestara.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La kelah invertida")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En diciembre de 1987, en la tierra de los antiguos filisteos, la ira palestina estalló en lo que se llamaría la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Primera Intifada")]), _vm._v(", o levantamiento, contra Israel. Por su naturaleza especial, también sería conocida como la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Intifada de Piedra")]), _vm._v(". Las mismas personas que más tarde emplearían misiles y armas de fuego para la guerra contra los israelíes utilizarían, en este levantamiento, armamento más rudimentario: la piedra y la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("kelah")]), _vm._v(", la antigua honda."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Qué tenían en común los dos armamentos? Ambos se remontan a los tiempos bíblicos y los dos emplearon en las guerras de los filisteos y los israelitas.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "84",
      "epub:type": "pagebreak",
      "id": "page84",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Ahora fueron revividos para ser usados en la guerra de los filisteos revividos y los israelitas revividos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La piedra y la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("kelah")]), _vm._v(" volverían a ser utilizadas por los palestinos en la segunda intifada. De modo que los filisteos resucitados estaban empleando ahora la misma arma utilizada por los antiguos israelitas contra los arcaicos filisteos: hacer la guerra contra los israelitas resucitados.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La venganza del gigante")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Era como si, después de tres mil años, un Goliat resucitado se estuviera vengando de un David resucitado usando el arma de este último para sus fines. Así como David había empleado la espada de Goliat contra el gigante,"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" ahora los filisteos modernos —el pueblo de Goliat— estaban usando el arma célebre de los israelitas: la honda de David, contra los israelitas del mundo moderno. Un observador árabe pro-palestino escribió que los “Hijos de las piedras” habían alterado la percepción del mundo")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("al "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("invertir el símbolo")]), _vm._v(" del David israelí y el Goliat "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("filisteo")]), _vm._v(", "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("transfiriendo la honda por primera vez en la historia a manos de un palestino")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v(" 5")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Es sorprendente que el comentarista haya sido inducido a hablar del conflicto palestino-israelí en términos del antiguo conflicto entre israelitas y filisteos. De hecho, fue una repetición de ese conflicto, una repetición invertida. Fue la venganza de Goliat. Era como si el espíritu del antiguo filisteo se hubiera apoderado de los palestinos para buscar venganza. Y entonces corearon: ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Queremos venganza en Cisjordania y Gaza, con la honda y la resortera")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El Dragón había resucitado de entre los muertos a una antigua nación para que operara como antinación, eliminara a Israel y ocupara su lugar. Siempre había sido la voluntad del Enemigo poner las obras de Dios en contra de las propias obras de Dios. Así que ahora invertiría la honda de David en la guerra contra el pueblo del pastorcillo.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "85",
      "epub:type": "pagebreak",
      "id": "page85",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La kelah como símbolo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El Dragón estaba invirtiendo el relato bíblico de David y Goliat para crear una narrativa alterada y, mediante esta, agitar el odio del mundo contra Israel. El maestro de la inversión arregló la antigua historia a su conveniencia, la invirtió. Cambió a David por Goliat y a Goliat por David. Y la honda se convirtió, nuevamente, en el arma más poderosa que blandía la mano del Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("El siguiente misterio abarca todas las épocas, desde los crisoles del mundo antiguo hasta los sistemas de defensa informática de una nación moderna.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "86",
      "epub:type": "pagebreak",
      "id": "page86",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-51"
    }
  }, [_vm._v("Capítulo 21")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-52"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _vm._v("Las guerras de hierro")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("U")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("no de los ")]), _vm._v("factores más importantes y menos conocidos de las guerras de los filisteos contra los israelitas fue el de la tecnología.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El poder del metal")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En las guerras antiguas, el metal era esencial. Las excavaciones arqueológicas de las ruinas de la antigua Filistea han descubierto hornos utilizados para fundir metales."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")]), _vm._v(" Algunos creen que los filisteos también importaban armas de hierro del extranjero para usarlas contra sus enemigos en la tierra. Los filisteos intentaron mantener su monopolio con las armas metálicas. La Biblia registra lo siguiente:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("En todo el territorio de Israel no había un solo herrero, pues los filisteos no permitían que los hebreos se forjaran espadas y lanzas."), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De modo que los filisteos hicieron todo lo que estuvo a su alcance para impedir que los israelitas practicaran la metalurgia. Y, cuando llegaba el momento de la guerra, eso les daba una ventaja decisiva.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los antiguos hornos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Será posible que los filisteos modernos siguieran los pasos de sus antiguos predecesores también en eso? Claro que sí. Bajo el liderazgo de Hamas, los palestinos de la Franja de Gaza aprenderían los secretos de la metalurgia. Y así como los antiguos filisteos aprendieron esos secretos con el fin de producir armas y hacer la guerra, también lo harían sus homólogos de hoy. Así como los antiguos filisteos produjeron esas armas específicamente con el propósito de herir a los israelitas, así los filisteos resucitados lo hicieron con el objetivo de lacerar a los israelitas modernos. Y lo hicieron en el mismo suelo que sus antiguos predecesores.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los que descubrieron las ruinas de los antiguos filisteos encontraron en sus viviendas hornos e instalaciones para fundir y forjar metales para la producción de armas. Así que, en las viviendas y cámaras subterráneas "), _c('span', {
    attrs: {
      "aria-label": "87",
      "epub:type": "pagebreak",
      "id": "page87",
      "role": "doc-pagebreak"
    }
  }), _vm._v("de la Filistea moderna, la Franja de Gaza, los filisteos actuales construyeron hornos e instalaciones para fundir y forjar metales para producir armas con fines de guerra y terrorismo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La clave del hierro")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Había un metal por encima de todos los demás que dio a los antiguos filisteos su mayor ventaja en sus guerras contra los israelitas: el hierro. El mundo estaba, en ese momento, pasando de la Edad del Bronce a la Edad del Hierro. Las armas de hierro eran más duraderas y destructivas que las de bronce. Los filisteos estaban por delante de los israelitas en el empleo de la nueva tecnología. De modo que mantuvieron al pueblo de Israel alejado de la producción de armas de metal y, más específicamente, de la producción de armas de hierro. Y como lo expresó un escritor:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Mientras los filisteos mantuvieran este monopolio, Israel no podía esperar desalojarlos de la llanura.3")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De modo que el hierro jugaría un papel central en las guerras de los israelitas y los filisteos. ¿Podría volver a desempeñar un papel central en las guerras de los filisteos resucitados y los israelitas resucitados?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Conversión de arados en espadas")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Para impedir que los habitantes de Gaza produjeran armas que usaran contra ciudadanos israelíes, se prohibió la importación de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hierro")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("acero aleado con hierro")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" En la antigüedad, los filisteos impedían a los israelitas fabricar armas de hierro. En los tiempos modernos, la saga continuó, mientras Israel buscaba impedir que el pueblo filisteo de Gaza también produjera armas de hierro.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Sin embargo, al igual que sus antiguos predecesores, los fabricaron de todos modos. Y como sucedió en la antigüedad en Filistea, lo mismo pasó en la región de la Franja de Gaza. Tomaron chatarra, una de sus principales exportaciones, y la reutilizaron para armamento.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Tomaron viejos casquillos de cañón de hierro y los convirtieron en cohetes. Agarraron la enorme afluencia de dinero que les enviaban desde todo el mundo para fines humanitarios y la utilizaron, en cambio, para forjar armas que usarían contra el pueblo de Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "88",
      "epub:type": "pagebreak",
      "id": "page88",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Resurrección de la guerra de hierro")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Fue el gobierno del rey David, que mató a Goliat, el que puso fin a la era del dominio filisteo en la guerra. Las victorias de David traerían a su nación los suministros de mineral de hierro que tanto necesitaba. El hierro entonces se utilizaría en beneficio de Israel, para resistir los ataques de los filisteos y para vencerlos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así también en las guerras modernas de los filisteos e israelitas resucitados, el hierro volvería a desempeñar un papel central, no solo en las armas de hierro y acero de Hamas sino en la respuesta de Israel a ellas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El escudo protector de Israel contra los cohetes entrantes y utilizado ampliamente contra los lanzados desde la tierra de los filisteos, la Franja de Gaza, se llamaría Cúpula de Hierro."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El sistema de defensa de Israel destinado a impedir que los filisteos de Hamas expandieran sus túneles hacia los centros de población israelíes, su Cúpula de Hierro subterránea, se llamaría Pala de Hierro."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La barrera protectora de Israel contra los militantes y terroristas filisteos en la Franja de Gaza se llamaría Muro de Hierro."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y la defensa adicional de Israel no solo contra los cohetes sino también contra los drones y las ráfagas de morteros enviadas desde la tierra de los filisteos se llamaría la Viga de Hierro."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La honda de alta tecnología de David")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En vista del papel fundamental que jugó el hierro en las antiguas guerras de los filisteos e israelitas, es sorprendente observar cuántos de los sistemas defensivos y de los armamentos utilizados por los israelitas resucitados en su guerra contra los filisteos resucitados llevaban el mismo nombre: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hierro")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y en vista del hecho de que fue el rey David quien demostró ser el líder máximo en las antiguas guerras entre Israel y los filisteos —el rey que cambió el rumbo de esas guerras a favor de Israel— también es sorprendente que el sistema militar diseñado para interceptar los cohetes de mediano y largo alcance disparados hacia su tierra se llamó Honda de David."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Para los antiguos israelitas, Filistea era la fuente en la que se concebían y de donde se enviaban los males mortales. Por eso, de la Filistea resucitada se concebirían y enviarían nuevamente otros males.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "89",
      "epub:type": "pagebreak",
      "id": "page89",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-53"
    }
  }, [_vm._v("Capítulo 22")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-54"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _vm._v("El caldero")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("stamos a punto ")]), _vm._v("de ver el misterio estallar en una explosión que ha de sacudir al mundo. Antes de hacerlo, debemos tomar nota de una pieza más del rompecabezas de la antigua resurrección.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La separación peligrosa")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Aunque los enfrentamientos entre filisteos e israelitas fueron muchos, los dos pueblos vivieron en gran medida separados. Y aunque Filistea era parte de la Tierra Prometida, para los israelitas era una tierra extranjera, un territorio enemigo. Los dos pueblos vivieron y funcionaron en dos mundos diferentes.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La separación entre los dos pueblos podría haber parecido un medio para la paz. Pero, en el caso de los filisteos, era algo peligroso. Porque fue en la separación de los filisteos, en su mundo separado, que pudieron alimentar su “antiguo odio” por Israel y su deseo de venganza; para luego manifestarse en violencia y derramamiento de sangre.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Entonces Filistea se convirtió para Israel en la plataforma de lanzamiento de muchas calamidades.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El caldero de Gaza")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así también, en la resurrección de los filisteos, Gaza o Filistea, se convirtió en un mundo completamente separado del de los israelíes. Y en esa separación los filisteos modernos alimentarían el antiguo odio e idearían planes de venganza que explotarían en actos de violencia, muerte y de destrucción.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Filistea volvería a ser la tierra de los planes mortíferos, la plataforma de lanzamiento de las calamidades. No fue casualidad que fuera en la antigua Filistea donde nació la primera Intifada y que desde allí se enviaran miles de misiles a la tierra de Israel. En la tercera década del siglo veintiuno, volvería a servir como matriz de otro mal, nacido y concebido en su suelo, que sería enviado a la tierra de Israel. Filistea volvería a convertirse en un caldero de maldad.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "90",
      "epub:type": "pagebreak",
      "id": "page90",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Las piezas del antiguo misterio convergerían para producir una calamidad que iba a conmoción al mundo.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "91",
      "epub:type": "pagebreak",
      "id": "page91",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-55"
    }
  }, [_vm._v("Parte 6")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-56"
    }
  }, [_vm._v("Depredadores y presas")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "93",
      "epub:type": "pagebreak",
      "id": "page93",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-57"
    }
  }, [_vm._v("Capítulo 23")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-58"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _vm._v("El depredador")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("s en las ")]), _c('span', [_vm._v("primeras páginas de la Biblia donde el Enemigo está personificado como una serpiente. En las últimas páginas de la Biblia, en efecto, se le llama la “")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Serpiente")]), _c('span', [_vm._v("”.")]), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("1")]), _c('span', [_vm._v(" En la carta de 1 Pedro se le llama “")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("león rugiente")]), _c('span', [_vm._v("”.")]), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("2")]), _c('span', [_vm._v(" En Apocalipsis 12 se le llama “")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Dragón")]), _c('span', [_vm._v("”.")]), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("3")]), _c('span', [_vm._v(" Y podemos encontrar otra alusión a su naturaleza en las Escrituras referentes a los lobos.")]), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Serpientes, dragones y lobos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Qué tienen todos estos (serpientes, dragones y lobos) en común? Todos ellos son depredadores. Cada uno busca una presa. Cada uno es feroz. Cada uno es, por naturaleza, asesino. Cada uno espera el momento adecuado para atacar. Cada uno lanza sus ataques contra su víctima para inmovilizarla, matarla y devorarla.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al mismo tiempo, todos estos son atributos del Enemigo. El Enemigo es un depredador o devorador. Busca presas. Es, por naturaleza, asesino. Espera el momento adecuado para atacar. Y lanza sus ataques para herir, matar y devorar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por eso nunca le bastaría haber resucitado a un pueblo para que sirviera de obstáculo, sustituto, imitación o enemigo de la nación de Israel. Los resucitaría para convertirlos en depredadores, para atacar y destruir. Ellos habrían de esperar el momento adecuado para atacar. Entonces, en ese momento, lanzarían su ataque para herir, matar y aterrorizar a los habitantes de la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los invasores de los hábitats")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Otro atributo compartido por las criaturas que representan al Enemigo es que todos se infiltran, todos irrumpen, todos invaden las moradas de sus presas para causar destrucción. Las serpientes invaden los nidos, los leones penetran a los abrevaderos y los lobos asaltan los rediles. Por tanto, el Enemigo impulsaría su vaso resucitado para que invadiera las moradas de Israel, para sacar sangre y causar muerte. De modo que esperaríamos "), _c('span', {
    attrs: {
      "aria-label": "94",
      "epub:type": "pagebreak",
      "id": "page94",
      "role": "doc-pagebreak"
    }
  }), _vm._v("que, en un momento de vulnerabilidad, llegara un ataque o una invasión, liderada por el espíritu del depredador.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("En cuanto a las presas, no iban a tener ni idea de lo que les esperaba hasta que fuera demasiado tarde.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "95",
      "epub:type": "pagebreak",
      "id": "page95",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-59"
    }
  }, [_vm._v("Capítulo 24")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-60"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _vm._v("La presa")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("as fronteras que ")]), _vm._v("separaban a la antigua Filistea del resto de Israel nunca estuvieron completamente definidas. Eso hacía aquello aún más peligroso para los israelitas, ya que vivían en esas regiones.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las tierras peligrosas")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("No lejos de las viviendas de los filisteos había ciudades, aldeas, asentamientos y hogares israelitas. Aun cuando la mayoría de los filisteos vivían en la costa occidental de Israel, en el mar Mediterráneo o cerca de él, las viviendas israelitas vecinas habrían estado ubicadas justo al este o tierra adentro de sus límites. Y mientras Filistea representaba el centro de la vida filistea, los israelitas vecinos vivían en las avanzadas de su nación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por tanto, eran especialmente vulnerables a un ataque o invasión filistea. Aunque llevaban su vida cotidiana con apariencia de normalidad, la verdad era que su existencia estaba en constante peligro. Y las vidas que conocían podrían, en un instante, desaparecer.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la resurrección de Israel y los filisteos se iba a repetir la misma dinámica antigua. Los civiles israelitas volverían a vivir en ciudades y aldeas que limitaban con la actual tierra de Filistea, la Franja de Gaza. Varios de ellos eran kibutzim (esto es plural de kibutz) o moshavs, asentamientos comunales, con nombres como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Be’eri, Nir Oz, Netiv HaAsara, Kfar Aza, Alumim y Ein HaShlosha")]), _vm._v(". Y como en la antigüedad, las viviendas israelíes estaban situadas justo al este y tierra adentro de las moradas filisteas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aunque las personas de esas aldeas y kibutzim vivían con apariencia de normalidad, la verdad era que —al igual que los israelitas que vivían en las zonas fronterizas—, sus vidas corrían peligro. Todo lo que sabían podía ser eliminado en un instante "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("y, en el momento en que menos lo esperaban, así sería")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las ciudades fortificadas")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Para proteger las ciudades de Israel en las fronteras del territorio filisteo o enemigo, los reyes de Israel las fortificaron. Así está escrito del rey Roboam:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "96",
      "epub:type": "pagebreak",
      "id": "page96",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Fortificó las fortalezas y puso en ellas capitanes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Se conocerían como ciudades fortificadas o cercadas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" De la misma manera, el gobierno israelí buscó fortificar la nación, además de los pueblos y las ciudades israelíes que bordeaban la Franja de Gaza construyendo una barrera protectora entre Israel y la antigua Filistea, la Franja de Gaza. La barrera se denominaría "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("muro de seguridad")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("valla de seguridad")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como el rey Roboam había estacionado soldados para vigilar, custodiar y proteger las ciudades y pueblos de Israel en las cercanías de Filistea, el gobierno israelí estacionó soldados para vigilar y proteger las ciudades, pueblos y kibutzim cerca de la Franja de Gaza. Estuvieron allí un sábado por la mañana en octubre, cuando lo que habían temido durante mucho tiempo comenzó a desarrollarse."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La invasión depredadora")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La dinámica que se había desarrollado en la antigüedad entre Filistea y las aldeas israelitas cercanas a sus fronteras estaba a punto de repetirse, y con venganza y mucho odio. Así como los antiguos filisteos pudieron, en el momento oportuno, neutralizar y superar las fortificaciones establecidas para la seguridad de las aldeas israelitas, los filisteos resucitados podrían, en el momento oportuno, neutralizar y superar la barrera de seguridad que Israel había creado para proteger a su gente, con las consecuencias más mortíferas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("El resultado sería el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("7 de octubre")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "97",
      "epub:type": "pagebreak",
      "id": "page97",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-61"
    }
  }, [_vm._v("Capítulo 25")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-62"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _vm._v("Los invasores")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("os filisteos, junto ")]), _c('span', [_vm._v("con otros pueblos del mar, causaron estragos en el mundo del Mediterráneo oriental al final de la Edad de Bronce. Saquearon las ciudades portuarias de Siria, Anatolia, Chipre y Egipto.")]), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("1")]), _vm._v(" Eran saqueadores.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll ParaOverride-2"
  }, [_vm._v("El retorno de los saqueadores ")]), _vm._v(" "), _c('p', {
    staticClass: "pab ParaOverride-2"
  }, [_vm._v("Incluso después de asentarse en la costa de Canaán, siguieron saqueando la tierra. Continuaron invadiendo las aldeas y ciudades de aquellos que vivían en el interior de Filistea. Y en sus guerras con Israel, el saqueo desempeñaría un papel importante. Así está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f ParaOverride-4"
  }, [_vm._v("Estos [los filisteos] fueron subyugados por los israelitas y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("no volvieron a invadir su territorio")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa ParaOverride-4"
  }, [_vm._v("La implicación del pasaje es que la invasión filistea de las viviendas israelitas era algo normal. El fin forzoso de sus saqueos fue notable, pero temporal. Con el tiempo, volverían a reanudarlos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El rey Joram de Judá fue un monarca malvado. Alejó a la nación de los caminos de Dios. Sin embargo, el juicio vendría en forma de invasiones filisteas:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f ParaOverride-4"
  }, [_vm._v("El Señor incitó a los filisteos y a los árabes vecinos de los cusitas para que se rebelaran contra Jorán. Así que marcharon contra Judá, la invadieron y se llevaron todos los objetos de valor que hallaron en el palacio real."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa ParaOverride-4"
  }, [_vm._v("La audacia de su incursión se evidencia por el hecho de que fue dirigida contra la capital de la nación, Jerusalén, y el palacio del propio rey.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll ParaOverride-2"
  }, [_vm._v("Desde las costas de Filistea ")]), _vm._v(" "), _c('p', {
    staticClass: "pab ParaOverride-2"
  }, [_vm._v("Los saqueos continuaron de generación en generación. Las crónicas de Israel registran que más tarde, en el reinado del rey Acaz, los filisteos realizaron incursiones masivas contra las ciudades y aldeas israelitas de los territorios del sur de la nación."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "98",
      "epub:type": "pagebreak",
      "id": "page98",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Así que ¿saquearían los filisteos revividos la tierra a los israelitas resucitados? El misterio ordenaría que así fuera. Y así lo hicieron el 7 de octubre de 2023. Tomarían a Israel por sorpresa y dejarían al mundo conmocionado. Pero no debería haber sido algo inesperado. Es exactamente lo que se esperaría que sucediera si el antiguo misterio se repitiera.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La brecha ")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En el versículo citado al principio de este capítulo, la palabra hebrea traducida como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("territorio")]), _vm._v(" es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("gebul")]), _vm._v(". Más que territorio, significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("límite")]), _vm._v(", "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("frontera")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("costa")]), _vm._v(". El 7 de octubre, las personas que llevaban el nombre de los filisteos invadieron el territorio israelí, atacaron desde la costa, abrumaron la frontera y rompieron el límite. La palabra hebrea traducida como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("invadieron")]), _vm._v(" es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("baqa")]), _vm._v(", que significa quebrar, brecha, estallido y romperse. Todas estas cosas también se manifestaron el 7 de octubre."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Guerreros filisteos en aldeas israelíes ")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así como los antiguos filisteos invadieron la tierra para asustar, conmocionar y aterrorizar a sus víctimas israelitas, sus homólogos modernos hicieron lo mismo el 7 de octubre. Los antiguos invasores filisteos saquearon la tierra de Israel desde la costa, moviéndose hacia el este, tierra adentro, para causar estragos y destrucción en las ciudades y aldeas israelitas a su paso. El 7 de octubre, los resucitados invasores de Filistea también saquearon la tierra desde la costa, moviéndose hacia el este, tierra adentro, causando estragos y destrucción en las ciudades y aldeas israelitas a su paso.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En las antiguas incursiones, el contraste entre los guerreros filisteos invasores y las aldeas israelitas desprevenidas no podría haber sido mayor. El conflicto era asimétrico. También el 7 de octubre, las dinámicas antiguas se repitieron cuando las aldeas israelitas desprevenidas fueron tomadas por los belicosos invasores de la costa.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como pasó con los antiguos israelitas, la llanura costera filistea —la Franja de Gaza— se había convertido para los israelitas modernos en la fuente de horror.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría haber un antiguo misterio que determinara la ubicación, la tierra y el suelo en el que ocurriría la calamidad del 7 de octubre?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "99",
      "epub:type": "pagebreak",
      "id": "page99",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-63"
    }
  }, [_vm._v("Capítulo 26")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-64"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _vm._v("Fantasmas de la Sefelá")]), _vm._v(" "), _c('p', {
    staticClass: "pf-2"
  }, [_c('span', {
    staticClass: "DROP-CAP"
  }, [_c('span', {
    staticClass: "_ _idGenCharOverride-3"
  }, [_vm._v("¿")])]), _c('span', {
    staticClass: "_idGenDropcap-2"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("uáles de las ")]), _vm._v("antiguas ciudades, pueblos y aldeas de Israel eran las más vulnerables a las invasiones filisteas?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Néguev")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En el relato de lo que parece ser la incursión filistea más masiva, se nos da una pista. Está registrado en 2 Crónicas 28:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Por su parte, los filisteos saquearon las ciudades de Judá que estaban en la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("llanura")]), _vm._v(" y en el Néguev. Se apoderaron de Bet Semes, Ayalón, Guederot, Soco, Timná y Guimzó, junto con sus respectivas aldeas, y se establecieron en ellas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El pasaje identifica varias de las ciudades y aldeas atacadas por los filisteos, pero también describe la vecindad. Estaban ubicadas en “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("la llanura y en el Néguev")]), _vm._v("”. El hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Néguev")]), _vm._v(" es aún más específica y se refiere al sur de Judá, como en el desierto del Néguev, la vasta extensión de tierra árida en la región más al sur de Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Así que los filisteos invadieron las aldeas y ciudades más al sur de Israel, aquellas que estaban en la tierra del Néguev.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La Sefelá")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El pasaje nos da otra pista, otra palabra para identificar la región. Los invasores apuntaron a las viviendas de la llanura. ¿Qué era exactamente la llanura? El hebreo tras la traducción es la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("shefelá")]), _vm._v(". En castellano, Sefelá es el nombre específico dado a una de las regiones de Israel. Algunos expanden o restringen su aplicación, pero la comprensión más simple y general de la palabra aparece en uno de los comentarios bíblicos más autorizados. Según esto, la Sefelá es:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("“El nombre dado a la tierra entre las montañas de Judá y el mar Mediterráneo”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "100",
      "epub:type": "pagebreak",
      "id": "page100",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("Otro comentario define aún más sus fronteras en relación con la tierra de Judá:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("“El valle” o la Sefelá, está limitado al sur por el Néguev, al oeste por el Mediterráneo, al norte por la llanura de Sarón, al este por “las montañas”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Todo esto coincide con lo que sabemos de los filisteos y sus viviendas que se centraban en la región suroeste y costera de la tierra. En el Libro de Josué, la Biblia identifica varias de las ciudades ubicadas en la Sefelá. Dos de ellas también aparecen en el relato previamente citado de las incursiones filisteas en la tierra en 2 Crónicas 28: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Soco ")]), _vm._v("y"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" Guederot")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Gaza con sus ciudades y aldeas”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Las ciudades y aldeas mencionadas en Josué al final de la lista y que se refieren a la parte más al sur de la Sefelá son de especial importancia:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("“Y en la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sefelá")]), _vm._v(" ... Desde "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Ecrón")]), _vm._v(" hasta el mar ... "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Asdod")]), _vm._v(" con sus ciudades y aldeas, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Gaza con sus ciudades y aldeas")]), _vm._v("”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Estas tres últimas ciudades son especialmente significativas ya que estaban ubicadas en Filistea. Por lo tanto, los filisteos, al menos, vivían en las llanuras en la frontera de la Sefelá y, por la comprensión más literal y simple del texto, dentro de sus parámetros.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así que, ¿cuáles de las ciudades, pueblos y aldeas de Israel eran las más vulnerables a ser atacadas por los invasores filisteos? Aquellos más cercanos, lindantes, y "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("justo al este y tierra adentro de Filistea")]), _vm._v(", y aquellos pueblos, ciudades y aldeas de la "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Sefelá")]), _vm._v(" y el "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Néguev")]), _vm._v(". Nota que la última región mencionada es "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Gaza con sus ciudades y aldeas")]), _vm._v(". ¿A qué correspondería esto? A la "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Franja de Gaza")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El 7 de octubre de 2023, la guerra que había comenzado siglos antes del nacimiento del imperio romano estalló ante los ojos del mundo. Las personas transformadas a la imagen de los antiguos filisteos cometieron los actos que infligieron sus antiguos predecesores. ¿Quiénes serían sus víctimas?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Al este de Filistea")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los antiguos invasores filisteos atacaron las aldeas y viviendas israelitas que bordeaban su región, justo tierra adentro y al este de Filistea.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "101",
      "epub:type": "pagebreak",
      "id": "page101",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("El 7 de octubre, los filisteos resucitados, igualmente, atacaron y saquearon las aldeas israelitas, los kibutzim y los hogares que bordeaban su región, justo tierra adentro y al este de la Franja de Gaza, Filistea. Los antiguos invasores filisteos atacaron y saquearon las aldeas y viviendas israelitas en la región más al sur de Israel. El 7 de octubre, los invasores modernos de Filistea atacaron y saquearon las aldeas israelitas, los kibutzim y los hogares de la región más al sur de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La tierra de la convergencia")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los antiguos atacantes filisteos invadieron las aldeas y viviendas israelitas ubicadas en las llanuras y el desierto, en la región de la "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Sefelá")]), _vm._v(" y el "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Néguev")]), _vm._v(". La Sefelá, como se identifica en el Libro de Josué, se extiende hacia "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("el sur hasta Gaza")]), _vm._v(". El Néguev se extiende hacia el "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("norte")]), _vm._v(" hasta "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Gaza")]), _vm._v(". ¿Dónde se intersectan estas dos regiones, el Néguev y la Sefelá? "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("En Gaza")]), _vm._v(". Más específicamente, en el terreno lindante y justo al este, tierra adentro, de la "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Franja de Gaza")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Fue en esa misma intersección, la convergencia del Néguev y la Sefelá")]), _vm._v(", justo al este y tierra adentro de la Franja de Gaza, el terreno atacado por los antiguos filisteos, donde los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("atacantes filisteos del 7 de octubre invadieron y trajeron destrucción, la misma tierra")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El antiguo misterio en la antigua tierra")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Fue en esa misma tierra, la más vulnerable a los antiguos invasores filisteos, donde los jóvenes israelíes se reunieron para participar en su festival de música cuando los invasores de Gaza convirtieron su celebración en calamidad. Y fue en ese mismo suelo donde se encontraban las aldeas, los kibutzim y los hogares de las familias israelíes que serían devastadas el 7 de octubre.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los filisteos resucitados habían hecho a las ciudades y aldeas resucitadas de los israelitas resucitados que habitaban en esa desafortunada región lo mismo que los antiguos filisteos a los arcaicos israelitas. Aquellos que lo veían en sus pantallas de televisión y en sus computadoras no tenían idea de que estaban presenciando en tiempo real la interpretación de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("un antiguo misterio en el mismo lugar donde se desarrolló hace miles de años")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría la repetición del misterio involucrar no solo las ubicaciones precisas sino también las estrategias y los actos con tal exactitud?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "102",
      "epub:type": "pagebreak",
      "id": "page102",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-65"
    }
  }, [_vm._v("Capítulo 27")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-66"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _vm._v("Los cautivos")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("a incursión en ")]), _vm._v("la casa del Rey Joram proporciona un detalle importante sobre las invasiones filisteas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Llevados cautivos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El relato de 2 Crónicas 21 revela lo que los invasores buscaban más que las riquezas de la casa del rey:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Así que marcharon contra Judá, la invadieron y se llevaron … [a los] "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("hijos")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("las mujeres de Jorán")]), _vm._v(". Ninguno de sus hijos escapó con vida, excepto Joacaz, que era el menor de todos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Lo que sucedió en la casa del rey Joram no fue una excepción. Era una práctica común de los filisteos llevarse cautivos a los israelíes de las tierras y viviendas que invadían.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El caso de Siclag")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Uno de los relatos bíblicos más famosos de una incursión antigua que resultó en la toma de civiles israelíes cautivos se refiere al de la ciudad de Siclag. Aunque fue llevada a cabo por otros de los antiguos enemigos de Israel, los amalecitas, el relato nos da más detalles sobre lo que implicaban tales invasiones.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando David y sus hombres regresaron de la batalla a Siclag, donde habían dejado a sus esposas e hijos, descubrieron que sus seres queridos habían desaparecido:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Vino, pues, David con los suyos a la ciudad, y he aquí que estaba quemada, y sus mujeres y sus hijos e hijas habían sido llevados cautivos. Entonces David y la gente que con él estaba alzaron su voz y lloraron, hasta que les faltaron las fuerzas para llorar."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "103",
      "epub:type": "pagebreak",
      "id": "page103",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("El enemigo había invadido la ciudad y tomado cautivos a sus habitantes, mujeres y niños. Además de eso, la incendiaron.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Cuál era el propósito de llevar civiles cautivos? Los invasores podían convertir a los cautivos en esclavos o venderlos como siervos a otros. También podían ser utilizados como monedas de cambio, como seguridad o apalancamiento para forzar o detener la mano de una potencia opuesta. Y podían ser llevados cautivos simplemente como un acto de dominio, venganza, brutalidad y furia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Para que los alejes”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En una profecía dada en el Libro de Joel, identificando los pecados de varios pueblos antiguos, se expone la maldad de los filisteos:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("¿Qué tienen en contra mía ... todas las regiones de Filistea?... "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("vendieron a los hijos de Judá y los hijos de Jerusalén... para alejarlos de su tierra")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Los filisteos llevaban cautiva a la gente de Israel, o Judá, y luego los vendían como esclavos a otras naciones, alejándolos de su tierra natal. Un comentario escrito sobre la condena de Amós a los filisteos señala que los estos")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("hacían frecuentes "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("incursiones contra los judíos e israelitas")]), _vm._v(". Y es probable por este pasaje que fueran culpables de alguna "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("injusticia y crueldad, más allá de la práctica usual de la guerra, al hacer cautivos")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("A partir de estas y otras escrituras, está claro que para los filisteos tomar civiles como rehenes no era excepcional, sino típico. Era su práctica común. Y los principales objetivos de estos secuestros eran civiles judíos o israelitas. Eran llevados atados desde sus hogares o aldeas a Filistea para ser esclavizados, vendidos o asesinados. La mayoría nunca volvería a ver a sus seres queridos, ni a ser vistos por ellos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los cautivos de otoño")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En la resurrección del Enemigo de los antiguos filisteos, podríamos esperar que la toma de civiles inocentes como cautivos se manifestara nuevamente. "), _c('span', {
    attrs: {
      "aria-label": "104",
      "epub:type": "pagebreak",
      "id": "page104",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Y así fue. ¿Quiénes esperaríamos que fueran los cautivos? Los israelitas resucitados. Eso fue lo que ocurrió. ¿Cómo serían llevados cautivos? Desde una invasión originada en Filistea. Esto es exactamente lo que sucedería el 7 de octubre. Los modernos invasores filisteos vendrían de Filistea, Gaza, saquearían las aldeas israelíes, y aquellos israelíes y sus vecinos que no mataran de inmediato, los llevarían como rehenes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los cautivos del 7 de octubre serían utilizados como escudos humanos, seguridad, moneda de cambio y apalancamiento para forzar la mano del gobierno israelí."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" Y más que los objetivos estratégicos, los invasores tomaron cautivos a los israelíes para mostrar su dominio, para humillarlos y traumatizarlos, como un acto de odio, venganza e ira.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ocurrió no en medio de la guerra, sino en tiempos de paz. Así, un comentarista de las incursiones filisteas antiguas contra Israel escribe que ellos fueron más allá de ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("la práctica usual de la guerra, al hacer cautivos, tal vez tomando a los habitantes pacíficos ... o haciendo esas incursiones cuando Judá e Israel estaban en paz con ellos”."), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Los invasores filisteos del 7 de octubre, de igual manera, enfocaron su ataque en los habitantes pacíficos y los hicieron cautivos. Las tranquilas aldeas del desierto del sur de Israel se despertaron con una pesadilla muy antigua.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Sus esposas, sus hijos y sus hijas”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los invasores de Jerusalén del rey Joram tomaron cautivos a las mujeres y niños, o jóvenes, del palacio real. Los invasores de Siclag tomaron las “esposas, sus hijos y sus hijas” de los hombres de David. Las mujeres y los niños siempre fueron los más vulnerables a ser llevados como cautivos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así, en octubre de 2023, el mundo observó con horror las fotografías y videoclips de los invasores filisteos llevando cautivos a mujeres israelíes, niños, jóvenes e infantes. Aunque no había videoclips de los antiguos filisteos, sus incursiones, sin duda, habrían parecido similares en cuanto a la brutalidad y el horror que produjeron.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Los ancianos y los enfermos”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Pero los antiguos invasores filisteos se llevaban más que mujeres y niños. El comentario continúa:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "105",
      "epub:type": "pagebreak",
      "id": "page105",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("...se llevaban a los habitantes pacíficos y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("a todos sin distinción, los ancianos y los enfermos, así como a los jóvenes y saludables")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Esto también se repitió el 7 de octubre. Los modernos invasores filisteos no mostraron distinción en su violencia ni en sus secuestros. Las imágenes de video los mostraban llevándose a los ancianos, los frágiles y los enfermos, abuelas judías de cabellos canos como sus cautivos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")]), _vm._v(" Entre los ancianos que estaban en esa tierra, aquella mañana, estaban muchos que podían recordar a los nazis reuniendo a sus familias en Alemania y Europa del Este para enviarlos a los campos de concentración. Habían venido a Israel para encontrar refugio de esos horrores, pero despertaron esa mañana sabatina para descubrir que el mal sufrido en su infancia nunca había muerto y ahora los había encontrado de nuevo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Quemados con fuego”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuando David y sus hombres regresaron a Siclag, encontraron que los invasores no solo habían llevado cautivos a sus mujeres y a sus niños, sino que habían destruido su aldea, como afirma el relato: “la ciudad había sido quemada”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")]), _vm._v(" Así que cuando los equipos de rescate entraron en las aldeas y los kibutzim atacados el 7 de octubre, encontraron que los invasores no solo habían asesinado y secuestrado a sus habitantes sino que, en muchos casos, habían incendiado las casas de sus víctimas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aunque no podemos confirmar su ubicación exacta, Siclag sin duda estaba ubicada en o cerca del Néguev, en el suroeste de Judá, y originalmente estaba ocupada por los filisteos. En otras palabras, las casas quemadas y las aldeas y los kibutzim desolados del 7 de octubre estaban en la misma región de los hogares de Siclag quemados y destruidos miles de años antes. Y era, nuevamente, como si los espíritus que habían poseído a los antiguos enemigos de Israel hubieran poseído a otros y, a través de ellos, hubieran regresado al terreno de caza.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Vayishbu")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En el relato de la incursión filistea en Jerusalén, la palabra utilizada para el secuestro de la familia real es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("vayishbu")]), _vm._v(", del verbo hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("shabah")]), _vm._v(", que puede traducirse como trasladar, transportar o llevar cautivo. Las imágenes del 7 de octubre muestran a los invasores filisteos llevando a sus víctimas cautivas a pie o transportándolas en sus vehículos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("12")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "106",
      "epub:type": "pagebreak",
      "id": "page106",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("¿Adónde llevaban los antiguos filisteos a sus cautivos israelíes? Los llevaban de regreso a Filistea. Así que el 7 de octubre, después de causar destrucción en las aldeas israelíes de la región, los invasores filisteos llevaron a sus rehenes de regreso al otro lado de la frontera hacia la Franja de Gaza, a Filistea."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("13")]), _vm._v(" Allí harían con ellos lo que quisieran.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En el caso de Siclag, David lideró un ataque contra aquellos que habían tomado cautivos a las mujeres y los niños, para liberarlos. Pero en el caso de Joram, nunca volvería a ver a los miembros de su familia que los filisteos se habían llevado. Habían decidido asesinarlos. En cuanto a los cautivos de octubre, su destino y sus vidas penderían del equilibrio entre esos dos desenlaces.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Ahora encontraremos, en las costas sudoccidentales de Israel, las huellas de la criatura mortal descrita en la antigua profecía como un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("monstruo")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "107",
      "epub:type": "pagebreak",
      "id": "page107",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-67"
    }
  }, [_vm._v("Parte 7")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-68"
    }
  }, [_vm._v("El día del dragón")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "109",
      "epub:type": "pagebreak",
      "id": "page109",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-69"
    }
  }, [_vm._v("Capítulo 28")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE ParaOverride-5",
    attrs: {
      "id": "_idParaDest-70"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  }), _vm._v("El reptiliano")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("o que el ")]), _c('span', [_vm._v("Dragón de Apocalipsis 12 guarda para los hijos de Israel, el pueblo judío, el ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("orgidzo")]), _vm._v(", abarca todo, desde la antipatía, la hostilidad, la ira latente, la furia, la rabia y la locura hasta la pasión violenta. El 7 de octubre, todo eso se manifestó.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll ParaOverride-4"
  }, [_vm._v("El día de la Ira del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab ParaOverride-4"
  }, [_vm._v("Dado que el Dragón es espíritu pero debe guerrear contra una nación física con instrumentos físicos, enemigos de carne y hueso de Israel, su "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("orgidzo")]), _vm._v(", su furia, tendría que apoderarse de ellos. Tendría que poseerlos, apoderarse de ellos, inflamarlos, hacerlos enfurecer contra el pueblo de Israel como solo lo hace el Dragón. Y así fue. El 7 de octubre, el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("orgidzo")]), _vm._v(" del Dragón explotó sobre el pueblo de Israel. Condujo a un frenesí de violencia. Superaría cualquier restricción natural de conciencia. Aquellos impulsados por él cometerían actos desprovistos de humanidad y misericordia, crímenes contra la humanidad.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll ParaOverride-4"
  }, [_vm._v("Sangre Fría")]), _vm._v(" "), _c('p', {
    staticClass: "pab ParaOverride-4"
  }, [_vm._v("En Apocalipsis 12, el Dragón intenta atacar y devorar al hijo de la mujer, el hijo de Israel."), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("1")]), _vm._v(" El 7 de octubre, el espíritu del Dragón se movió sobre los invasores filisteos para atacar a los hijos de Israel. Aunque los dragones son criaturas mitológicas, son reptiles y, por lo tanto, tienen sangre fría. Por eso, el 7 de octubre, los instrumentos del Dragón actuarían con sangre fría, cometiendo actos de sadismo sin escrúpulos contra los hijos de Israel. En su furia estaba la ira del Dragón; en su crueldad, la barbarie del Dragón; y en su odio hacia Israel y los judíos, el aborrecimiento del Dragón por la mujer y sus hijos. Fue un día de horrores, ya que fue el día del "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("orgidzo")]), _vm._v(" del Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Y sin embargo, lo que sucedió ese octubre fue el siguiente paso de la resurrección tenebrosa. Incluso los actos más malvados cometidos ese día estaban ligados a un misterio de orígenes antiguos.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "110",
      "epub:type": "pagebreak",
      "id": "page110",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-71"
    }
  }, [_vm._v("Capítulo 29")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-72"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor028"
    }
  }), _vm._v("Los terrores")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("n Ezequiel 32, ")]), _vm._v("el profeta ofrece una visión única del destino de aquellas naciones que guerrearon contra los caminos de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Los que sembraban el terror en la tierra de los vivientes”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Se habla de ellas como descendiendo al reino de los muertos. Gran parte de esas naciones son citadas en otros lugares de las Escrituras como enemigos de Israel. Y la mayoría comparte un tema común. De los asirios se escribe que ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sembraban el terror en la tierra de los vivientes")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1 ")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De los elamitas, ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sembraban el terror en la tierra de los vivientes.")]), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De Mesec y Tubal, ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("sembraron el terror en la tierra de los vivientes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Y de los sidonios, descenderán con vergüenza ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("A pesar del terror que sembraron con su poderío."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Lo que todas tienen en común es el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("terror")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Khitit")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La palabra traducida como "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("terror")]), _vm._v(" es el hebreo "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("khitit")]), _vm._v(". Proviene de la raíz "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("khatat")]), _vm._v(", que significa derribar por violencia o confusión, o infundir miedo, aterrorizar. Los antiguos enemigos de Israel trajeron terror a la tierra. Lo hicieron como derivado de su salvajismo y su derramamiento de sangre, y como un "), _c('span', {
    attrs: {
      "aria-label": "111",
      "epub:type": "pagebreak",
      "id": "page111",
      "role": "doc-pagebreak"
    }
  }), _vm._v("medio para doblegar la voluntad de la nación para hacer que se sometiera a la conquista y la subyugación. El estado de terror podía ser provocado por la espada o por la guerra psicológica. Los filisteos emplearon ambas tácticas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Fueron aterrorizados")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Uno de sus intentos más famosos de infundir terror entre los israelitas sucedió en el Valle de Elá e involucró al gigante Goliat. Como el más temido de los guerreros filisteos, de estatura colosal y portando armadura y armamento grandiosos, su presencia era suficiente para provocar pánico en todo el ejército israelita. Pero también sus palabras. Cada día, se paraba frente a los soldados israelitas, desafiándolos, intimidándolos y burlándose de ellos para que pelearan con él. La Escritura registra lo siguiente:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Al oír lo que decía el filisteo, Saúl y todos los israelitas se consternaron y tuvieron mucho miedo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La palabra traducida aquí como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("desmayaron")]), _vm._v(" es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("khatat")]), _vm._v(", de la misma raíz hebrea que significa infundir terror. Los israelitas estaban aterrorizados.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El retorno del terrorista")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Si el Enemigo iba a resucitar a los antiguos enemigos de Israel, deduciríamos que también resucitara su antigua táctica: el terror. Es digno de notar que uno de los poderes enemigos mencionados en la profecía de Ezequiel —por haber "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("causado terror en la tierra de los vivos")]), _vm._v(", la antigua Asiria—, es considerado el padre de lo que —en el mundo moderno— se conoce como "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("terrorismo")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("De manera que, si Israel iba a regresar al mundo moderno, esperaríamos que se enfrentara al homólogo moderno del antiguo terror: el terrorismo. Además, deduciríamos que el regreso del terror, o del terrorismo, al mundo moderno estaría especialmente conectado con el Medio Oriente. Esperaríamos que estuviera especialmente dirigido contra Israel. Y así fue.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como los antiguos filisteos emplearon el terror contra Israel, es de esperar que los filisteos resucitados hicieran lo mismo. Y así fue. No es casualidad que el líder filisteo más famoso, Yasser Arafat, fuera —durante gran parte de su vida— el terrorista más célebre del mundo. Tampoco es casualidad que los gobiernos palestinos de Gaza y Cisjordania estuvieran arraigados en el terrorismo y en organizaciones terroristas. Estos, a su vez, han "), _c('span', {
    attrs: {
      "aria-label": "112",
      "epub:type": "pagebreak",
      "id": "page112",
      "role": "doc-pagebreak"
    }
  }), _vm._v("adoctrinado a multitudes de su gente en las doctrinas y tácticas del terror. Y ese terror estaba destinado contra una sola nación, un pueblo: Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día de Khitit")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Como en tiempos antiguos, el terror del 7 de octubre vino de la llanura costera. Igual que en esos tiempos, vino a través de guerreros armados. Y como entonces, vino de la tierra de los filisteos, de la Franja de Gaza, de Filistea.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El 7 de octubre constituiría el peor día individual en la historia judía desde el Holocausto."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")]), _vm._v(" Era inevitable que las atrocidades cometidas ese día fueran comparadas con las efectuadas por los nazis. El terror estaba en todas partes, en las calles, en los hogares, en las habitaciones de los niños. El 7 de octubre se convertiría en el día de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("khitit")]), _vm._v(" de Israel, el día en que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("fue derribado por la violencia, la confusión, el miedo: el terror.")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día del monstruo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La profecía de Ezequiel contra aquellos que causaron terror en la tierra de los vivientes se centra en el faraón, rey de Egipto, y comienza con estas palabras:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Hijo de hombre, entona este lamento dedicado al faraón, rey de Egipto ... eres semejante a un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("monstruo")]), _vm._v(" marino."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La palabra aquí traducida como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("monstruo")]), _vm._v(" es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tanim")]), _vm._v(", término hebreo para "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("serpiente")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("dragón")]), _vm._v(". Así que la profecía de aquellos que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("causan terror en la tierra de los vivientes")]), _vm._v(" está conectada con las palabras "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("drakohn")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("serpiente")]), _vm._v(", las mismas usadas para el Enemigo, el Diablo. El maestro del terror y padre de los terroristas es el Dragón. Combina esto con el hecho de que la traducción griega de esa palabra, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("drakohn")]), _vm._v(", aparece en el último libro de la Biblia para hablar del que pelea contra la nación de Israel, y se llega a la conclusión de que el Dragón libraría guerra contra Israel mediante el uso del terror. Y así, el 7 de octubre fue el día del Tanim, el día del terror del Dragón y las atrocidades de la Serpiente. Ese fue el día del Monstruo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Uno de los misterios subyacentes al 7 de octubre se remonta a un evento registrado en el Primer Libro de Samuel, cuando los israelitas se encontraron abrumados ante una invasión filistea.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "113",
      "epub:type": "pagebreak",
      "id": "page113",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-73"
    }
  }, [_vm._v("Capítulo 30")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-74"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor029"
    }
  }), _vm._v("Las cuevas")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("n la mañana ")]), _c('span', [_vm._v("del 7 de octubre, jóvenes israelíes y sus amigos se reunieron en el desierto del Néguev cerca del kibutz Re’im para celebrar el festival de música Supernova. Se efectuó a solo cinco kilómetros de la Franja de Gaza.")]), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("1")]), _vm._v(" En la misma región donde los antiguos filisteos habían invadido y aterrorizado a los antiguos israelitas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Palestinos invasores e israelíes huyendo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Alrededor del amanecer, comenzaron a disparar cohetes sobre sus cabezas en los cielos del desierto. Luego vinieron las sirenas, y después, los hombres de Gaza. Llegaron en camiones, motocicletas y parapentes. Bloquearon las carreteras que podrían haber servido como rutas de escape."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los israelíes se escondieron. Algunos se ocultaron en árboles, otros tras arbustos, otros en los matorrales, unos en huertos y otros más en un bosque cercano. Varios se cubrieron con arena. Otros se escondieron en vehículos. Aun otros se dirigieron a refugios antiaéreos cercanos. Unos fueron masacrados en sus escondites; otros sobrevivieron. Algunos sobrevivieron fingiendo estar muertos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Asombroso. Fue algo sin precedentes. Nunca antes masas de israelíes habían huido por sus vidas ante grupos de hombres palestinos armados hasta los dientes. Jamás habían huido desesperadamente en todas direcciones para escapar de sus perseguidores palestinos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Guerreros filisteos e israelíes huyendo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Sin embargo, hubo un precedente ciertamente. Uno muy antiguo y registrado en las Escrituras:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los israelitas se dieron cuenta de que estaban en aprietos, pues todo el ejército se veía amenazado. Por eso tuvieron que esconderse en las cuevas, en los matorrales, entre las rocas, en las zanjas y en los pozos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "114",
      "epub:type": "pagebreak",
      "id": "page114",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("Ante una multitud de militantes armados, los antiguos israelitas huyeron aterrorizados, buscando lugares para esconderse. ¿De quién se estaban ocultando? De "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("los filisteos")]), _vm._v(". Fueron los masivos militantes armados filisteos los que los que hicieron que huyeran por sus vidas buscando lugares para esconderse.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En esa mañana de octubre, el antiguo drama se repitió. Los filisteos resucitados nuevamente habían invadido la tierra, y los israelíes igualmente resucitados se escondieron, manteniéndose en silencio y quietos por miedo a sus perseguidores.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Huyeron en todas direcciones”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Las siguientes palabras describen lo que ocurrió el 7 de octubre con respecto a los israelíes ante los palestinos invasores:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Huyeron en todas direcciones ... La mayoría se refugió en toda clase de escondites."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Esas palabras, sin embargo, no se escribieron sobre el 7 de octubre, sino sobre un evento que sucedió hace tres mil años. Son de un comentario bíblico que narra la antigua situación que enfrentaron los israelitas al huir de los guerreros filisteos, cuando "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("salieron en todas direcciones")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" Las siguientes palabras, sin embargo, fueron escritas sobre los eventos del 7 de octubre:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Huyeron en todas direcciones, algunos hacia el desierto abierto o los huertos circundantes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Huyeron en todas direcciones")]), _vm._v(": las mismas palabras exactas usadas para describir el evento antiguo y su repetición moderna protagonizada por sus actores resucitados.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Hacia los bosques y los arbustos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Un comentarista escribió sobre el antiguo evento, que los israelitas huyeron de los filisteos que los perseguían escondiéndose en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("bosques")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("selvas")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")]), _vm._v(" Otro contaría, acerca de los israelíes que huyeron de los militantes filisteos tres mil años después")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Empecé a correr hacia el bosque para esconderme")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "115",
      "epub:type": "pagebreak",
      "id": "page115",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("Una de las palabras usadas en las Escrituras para describir dónde se escondieron los israelitas de los filisteos puede traducirse como matorral, zarza o espino. Como dice un comentario sobre el sitio del conflicto: ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Había un gran número de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("zarzas y espinos")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De los israelíes que huyeron de los hombres armados el 7 de octubre se registró:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Ella buscó refugio en algunos arbustos para esconderse de los hombres armados de Hamas que merodeaban."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Y")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("otros se dispersaron en el desierto, escondiéndose bajo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("matorrales de cactus y arbustos")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Donde pudieran”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Sobre el conflicto antiguo con los filisteos, un comentarista bíblico escribe: ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("En ese momento de crisis, los israelitas se "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("escondieron donde pudieron")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Acerca de las víctimas israelíes del 7 de octubre, se registró: ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("A cientos de asistentes les dispararon desde todas direcciones, dispersándose y escondiéndose donde pudieran."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Las cuevas y los hoyos donde se escondieron”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En 1 Samuel 14, las Escrituras registran una confrontación entre Jonatán, el hijo del rey israelita Saúl, y una guarnición filistea. Jonatán y su escudero se presentan ante los soldados de la fortaleza filistea:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("—¡Miren —exclamaron los filisteos—, los hebreos empiezan a salir de la"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("s cuevas donde estaban escondidos")]), _vm._v("!"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Sobre la observación de los filisteos, un comentario bíblico dice: ")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "116",
      "epub:type": "pagebreak",
      "id": "page116",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los filisteos ofrecen esta declaración burlona y denigrante porque eran conscientes del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("terror que su presencia había producido en los hebreos")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La presencia de los filisteos generó terror entre los israelitas. El resultado de ese terror fue que los hebreos se escondieron en cuevas y hoyos para salvarse. Eso coincide con el relato mencionado anteriormente, cuando los israelitas se escondieron en hoyos y cisternas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“El pueblo se escondió... en hoyos y cisternas”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Podría este elemento antiguo y específico en la guerra de los filisteos y los israelitas manifestarse otra vez en el resurgimiento de ambos pueblos? ¿Podría el fenómeno de los israelitas, escondiéndose en hoyos y cisternas, ante el terror filisteo aparecer en estos tiempos, en el mundo moderno?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los siguientes son relatos que describen lo que hicieron los israelíes tras la invasión de los filisteos armados el 7 de octubre:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Se escondió en una fosa para salvarse")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Entonces vi un hoyo, como si alguien lo hubiera cavado. "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Nos metimos en él")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Un hombre escondido en una fosa")]), _vm._v(" durante el asalto de Hamas el 7 de octubre... dijo que escuchó a alguien cerca gritar."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Ella se escondió en un hoyo")]), _vm._v(" y fingió estar muerta para sobrevivir."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Yuval se escondió en un hoyo")]), _vm._v(" en el suelo durante horas y sobrevivió a la horrible masacre de Nova."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("La gente se estaba escondiendo en zanjas")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Y 1 Samuel 13, describe el intento de los israelitas por sobrevivir ante los filisteos:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Entonces "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("el pueblo se escondió... en hoyos y en cisternas")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("23")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "117",
      "epub:type": "pagebreak",
      "id": "page117",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("Así que el antiguo misterio se volvió a representar en el escenario del mundo moderno. Los filisteos resucitados aterrorizaron a los israelíes resucitados, y estos se escondieron —para salvar sus vidas— en cuevas, matorrales, peñascos, hoyos y cisternas, tal como lo hicieron los antiguos israelitas. Cada uno hizo exactamente lo que hicieron los otros en tiempos antiguos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("El próximo misterio comenzará con los actos de los antiguos invasores del Medio Oriente y terminará en las pantallas de las computadoras de todo el mundo.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "118",
      "epub:type": "pagebreak",
      "id": "page118",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-75"
    }
  }, [_vm._v("Capítulo 31")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-76"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor030"
    }
  }), _vm._v("El acto de Galah")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("l Señor le ")]), _vm._v("dio al profeta Isaías un mandato extraño:")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Anda, quítate la ropa de luto y las sandalias”. Así lo hizo Isaías; anduvo desnudo y descalzo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El profeta desnudo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Parecería una instrucción muy inapropiada: que un hombre de Dios caminara desnudo en público. Pero fue un acto profético:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Entonces el Señor dijo: “Así como durante tres años mi siervo Isaías ha andado desnudo y descalzo, como señal y presagio contra Egipto y Cus; así también, el rey de Asiria llevará desnudos y descalzos a los egipcios y a los desterrados de Cus, los llevará desnudos de la cintura hacia abajo, tanto a jóvenes como a viejos para vergüenza de Egipto”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La desnudez de Isaías era un signo que presagiaba la caída de los egipcios y los etíopes a manos de los asirios. Serían llevados cautivos, despojados de su ropa y humillados.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La humillación del cautivo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuando la Palabra de Dios pronuncia juicio sobre los filisteos, menciona que se llevaron cautiva a la gente de Israel. Ya hemos visto cómo los invasores filisteos, en la actualidad, llevaron cautivos a los israelíes. Pero había mucho más en el misterio.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Detrás de las palabras "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("llevaron cautivos")]), _vm._v(" está el vocablo hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("galah")]), _vm._v(", término que puede traducirse correctamente como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("llevar cautivo")]), _vm._v(", pero su significado es más profundo. Literalmente significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("descubrir, desvestir, desnudar")]), _vm._v(". Así que la misma palabra hebrea que significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("llevar cautivo")]), _vm._v(" también quiere decir "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("desnudar")]), _vm._v(". La conexión entre las dos traducciones es que era una práctica común entre los enemigos de Israel desnudar a sus cautivos. Era un acto de humillación, deshonra, dominación y degradación. La "), _c('span', {
    attrs: {
      "aria-label": "119",
      "epub:type": "pagebreak",
      "id": "page119",
      "role": "doc-pagebreak"
    }
  }), _vm._v("implicación es que los filisteos no solo llevaron cautiva a la gente de Israel, sino que los humillaron, los descubrieron, los desnudaron.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El acto de Galah")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los militantes filisteos que entraron en Israel el 7 de octubre hicieron más que llevar cautivos a los israelíes. Muchas de sus víctimas femeninas fueron encontradas desnudas. Los invasores las habían humillado, agredido sexualmente y bestializado. Algunas fueron violadas; otras fueron golpeadas; aun otras fueron torturadas; aunque la mayoría fueron asesinadas. Sus cuerpos fueron hallados en sus casas o en las arenas del Néguev, sin ropa."), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("3")]), _vm._v(" Los que tenían años de experiencia en trabajos de rescate se sorprendieron el 7 de octubre y en los días que siguieron con el número de víctimas que hallaron desnudas. Pero fue un mal que se remontaba a miles de años en el pasado, un acto de degradación realizado por los antiguos enemigos de Israel. Lo que enfrentaron fue el "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("acto de galah")]), _vm._v(", una expresión especialmente asociada con los antiguos filisteos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Entre las imágenes más famosas y tempranas de las atrocidades del 7 de octubre estaba la de una joven israelí que había asistido al festival de música Supernova. Poco después de la invasión, apareció un video que mostraba a militantes de Hamas en la parte trasera de una camioneta con el cuerpo de una joven. Era ella. La habían desnudado casi por completo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Galah.Com")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Más allá de desnudar a sus cautivos, los enemigos de Israel típicamente los llevaban de regreso a la tierra de la que habían venido y los hacían desfilar desnudos por las calles de la ciudad. Así que el 7 de octubre, los invasores filisteos llevaron a sus cautivos y víctimas de regreso a la Franja de Gaza. Mostraron con orgullo el cuerpo de la joven israelí en la camioneta más allá de las calles de Gaza mientras publicaban imágenes de su cuerpo en internet, desfilando en pantallas de computadora y desfilando por todo el mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No es que los modernos invasores filisteos tuvieran idea de la profecía que anunciaba el juicio de los filisteos o del antiguo acto que lo invocaba. Sin embargo, realizaron el acto de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("galah")]), _vm._v(" y lo hicieron ante el mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("El próximo misterio del 7 de octubre comienza en la montaña de un rey asesinado.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "120",
      "epub:type": "pagebreak",
      "id": "page120",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-77"
    }
  }, [_vm._v("Capítulo 32")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-78"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor031"
    }
  }), _vm._v("Espectros de Guilboa")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("l día siguiente ")]), _vm._v("de que el rey Saúl fuera abatido por los filisteos en el Monte Guilboa, sus enemigos descubrieron su cuerpo. La Biblia registra:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Al otro día, cuando los filisteos llegaron para despojar a los cadáveres, encontraron muertos a Saúl y a sus tres hijos en el monte Guilboa. Entonces lo decapitaron, le quitaron las armas, y enviaron mensajeros por todo el país filisteo para que proclamaran la noticia en el templo de sus ídolos y ante todo el pueblo. Después colocaron sus armas en el templo de la diosa Astarté, y su cadáver lo colgaron en el muro de Betseán."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El rey decapitado")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Aunque encontraron a su enemigo muerto, eso no fue suficiente para ellos. Le quitaron las armas, las colocaron en el templo de su diosa, Astarté, y sujetaron su cuerpo a las murallas de la ciudad. Y como un acto de dominio total, le cortaron la cabeza. Hicieron lo mismo con los cuerpos de sus tres hijos. Tales actos estaban en consonancia con la reputación brutal como filisteos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Sin embargo, había más en la historia. En el momento de la muerte del rey Saúl, otra batalla aún estaba fresca en la memoria colectiva de los filisteos, y otra decapitación. Cuando su guerrero más temido, Goliat, fue abatido, el joven pastor israelita David tomó la espada del gigante caído y le cortó la cabeza. El campeón de Filistea fue decapitado por un chico que representaba al ejército del rey Saúl.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ahora, en el Monte Guilboa, las cosas habían cambiado. Así como un soldado del rey Saúl había cortado la cabeza de un guerrero filisteo, los guerreros filisteos le cortaron la cabeza al rey Saúl. Cualesquiera que fueran los motivos, las victorias más celebradas en la guerra de los filisteos y los israelitas implicaban decapitaciones.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "121",
      "epub:type": "pagebreak",
      "id": "page121",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La cabeza del rey Saúl en el templo de Dagón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Qué ocurrió entonces con la cabeza del rey Saúl? La respuesta se encuentra en el Primer Libro de Crónicas:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Lo despojaron, tomaron su cabeza y sus armas, luego enviaron mensajeros por todo el país filisteo … para que proclamaran la noticia a sus ídolos y al pueblo. Después … colgaron la cabeza en el templo de Dagón."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Su cabeza fue llevada de regreso a Filistea y, se cree, a la ciudad de Asdod, donde se encontraba el gran templo de Dagón. La cabeza del rey fue colocada en la pared del santuario pagano como trofeo culminante de su victoria, los despojos de guerra, un regalo a Dagón y un signo que proclamaba la supremacía de sus dioses sobre el Dios de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para los israelitas, la exhibición de la cabeza de su rey en el templo de sus enemigos tuvo que ser una de las consecuencias más desmoralizadoras de la guerra. Los filisteos la usaron con todo su efecto para atormentar a sus enemigos. Así que el acto de la decapitación jugaba un papel central, estratégico y simbólico en las guerras de los filisteos y los israelitas. ¿Podría el acto culminante de las guerras antiguas abrirse camino en el mundo moderno? ¿Podrían los filisteos resucitados reavivarlo?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las barbaridades antiguas")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuando los militantes filisteos invadieron Israel el 7 de octubre, llegaron con armas y explosivos. Pero también con cuchillos y otros implementos cortantes. Lo que estaban a punto de hacer no sucedió de improviso, fue planificado antes de que pusieran un pie en la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Llegaron a hacer más que matar o tomar rehenes. Fueron a realizar decapitaciones. Y, en efecto, así lo hicieron. Les cortaron las cabezas a los que lucharon contra ellos. Les cortaron las cabezas a aquellos que no los resistieron y que estaban indefensos. Les cortaron las a los aldeanos israelíes. Les cortaron las a padres y madres israelíes. Les cortaron las a las mujeres israelíes que brutalizaron sexualmente. Les cortaron las a niños israelíes. Incluso se las cortaron a los bebés israelíes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los filisteos resucitados habían recreado los tenebrosos actos de sus antiguos predecesores. El Dragón los había poseído para asumir el papel "), _c('span', {
    attrs: {
      "aria-label": "122",
      "epub:type": "pagebreak",
      "id": "page122",
      "role": "doc-pagebreak"
    }
  }), _vm._v("de los antiguos invasores filisteos. Y ahora los conformó a sus antiguas barbaridades.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Cuando uno encuentra huellas digitales en la escena del crimen y puede compararlas con las halladas en otras escenas de crímenes, probablemente puede identificar al criminal. ¿Qué pasa si hacemos eso con las huellas digitales del 7 de octubre?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "123",
      "epub:type": "pagebreak",
      "id": "page123",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-79"
    }
  }, [_vm._v("Capítulo 33")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-80"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor032"
    }
  }), _vm._v("Las huellas del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("emos visto a ")]), _vm._v("más de un escritor describir a los antiguos filisteos como un pueblo de “guerreros brutales”. Uno de sus actos de guerra más bestiales era la mutilación.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las mutilaciones")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El hecho de que dos de los líderes más famosos del antiguo Israel sufrieran mutilaciones a manos de los filisteos confirma no solo la naturaleza violenta de ese viejo pueblo, sino su tendencia a realizar ese acto en particular: la mutilación. No solo cometían esa atrocidad, sino que la exhibían públicamente.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El 7 de octubre, el antiquísimo acto de los filisteos se efectuó contra el pueblo de Israel: la atrocidad de la mutilación. Insisto, aquellos que recuperaron los cuerpos de aquella calamidad quedaron sorprendidos y traumatizados por lo que descubrieron. Uno de los elementos principales de la invasión fue la mutilación. Se realizó de manera tan congruente en las víctimas de ese día que tuvo que haber sido planeado por aquellos que orquestaron la invasión."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La profecía de Eliseo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El profeta Eliseo reprendió a uno de los antiguos adversarios de Israel por las barbaridades que cometería contra este pueblo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Yo sé bien que vas a causarles mucho daño a los israelitas … "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Vas a incendiar sus fortalezas")]), _vm._v(", y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("a matar a sus jóvenes a filo de espada")]), _vm._v("; "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("despedazarás a los niños")]), _vm._v("..."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Cada uno de los actos mencionados por el profeta fue cometido por los invasores del 7 de octubre. Los enemigos resucitados de Israel “quemaron” las fortalezas israelíes. A los jóvenes israelíes los “mataron”. A los niños israelíes los “estrellaron”. Los invasores de Hamas no estaban leyendo las "), _c('span', {
    attrs: {
      "aria-label": "124",
      "epub:type": "pagebreak",
      "id": "page124",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Escrituras de Israel cuando planearon su invasión o sus atrocidades. Sin embargo, ese día repitieron los actos de sus antiguos homólogos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Otros crímenes del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Esa fue la hora de la barbarie del Dragón. Evocó sus otras bestialidades, crímenes y atrocidades contra los hijos de Israel. Cuando los jóvenes israelíes se escondieron detrás de cualquier cosa que los ocultara, eso evocó los días en que sus familiares se habían escondido de los Einsatzgruppen —“los escuadrones de la muerte nazis”— que los cazaban en los campos y de casa en casa."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" Pero eso también estaba presente en la profecía del Dragón en Apocalipsis 12. Estaba implícito en la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("dioko")]), _vm._v(": "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("perseguir agresivamente, cazar como un cazador que busca su presa")]), _vm._v(". Y cuando los invasores filisteos desnudaron a sus víctimas israelíes, evocó no solo el galah de los antiguos filisteos, asirios y babilonios, sino el desnudamiento de los judíos de Europa por la Schutzstaffel (SS) de Hitler, el acto de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("galah")]), _vm._v(" en los campos de concentración del Tercer Reich.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Aunque sorprendió al mundo, lo que sucedió el 7 de octubre fue solo la manifestación más reciente de una guerra que se inició en los días de las inscripciones cuneiformes y que se extiende hasta los tiempos de los medios electrónicos. Lo que sucedió ese día dio testimonio de la trascendencia del mal y de la criatura que lo encarnaba.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría una historia que muchos de nosotros escuchamos cuando éramos niños contener un antiguo misterio detrás del 7 de octubre?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "125",
      "epub:type": "pagebreak",
      "id": "page125",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-81"
    }
  }, [_vm._v("Parte 8")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-82"
    }
  }, [_vm._v("El misterio de Gaza")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "127",
      "epub:type": "pagebreak",
      "id": "page127",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-83"
    }
  }, [_vm._v("Capítulo 34")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-84"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor033"
    }
  }), _vm._v("La matriz oscura")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("emos hablado de ")]), _vm._v("la región conocida como la Franja de Gaza. Ahora nos enfocamos en el corazón de esa región, su capital, la ciudad de Gaza, también conocida como Gaza City. Allí encontraremos un misterio y un modelo que se remonta a tiempos antiguos. Nombrada numerosas veces en las Escrituras, Gaza fue —para Israel— una fuente constante de mal, conflicto y angustia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Matriz de males")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Con la resurrección de Israel vino el regreso de Gaza como matriz de conflicto y mal para el pueblo judío. Cuando Israel renació en su antigua tierra, la Franja de Gaza nació de la antigua ciudad. Fue allí donde el Consejo Nacional Palestino y el Gobierno de toda Palestina se reunieron. Fue desde allí que las tropas árabes partieron para destruir la recién nacida nación judía. Fue desde allí que se originó la primera gran intifada palestina contra Israel. Fue desde allí que se lanzaron misiles para llevar el terror a la tierra de Israel. Y fue desde allí que se planificó, preparó y lanzó la invasión y las atrocidades del 7 de octubre.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Lo que sucedió el 7 de octubre y su conexión con los filisteos y la ciudad de Gaza se remonta a un acontecimiento antiguo que precede a la invasión de Hamas por más de tres mil años. Se centra en un israelita llamado "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sol")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Shimshon")]), _vm._v(", nosotros lo llamamos Sansón.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "128",
      "epub:type": "pagebreak",
      "id": "page128",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-85"
    }
  }, [_vm._v("Capítulo 35")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-86"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor034"
    }
  }), _vm._v("El prototipo de Shimshon")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("a historia de ")]), _c('span', [_vm._v("Sansón está arraigada en la conciencia colectiva del mundo. Sin embargo ")]), _vm._v("¿podría contener un misterio y una clave para un evento del mundo moderno?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El complot gazatí")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El escenario de la historia es Filistea, las tierras fronterizas de Israel y Gaza. El mismo del 7 de octubre. La historia está impulsada por el conflicto entre los filisteos y los israelitas, al igual que los eventos del 7 de octubre.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la historia de Sansón, los filisteos buscan una manera de derribar el poder de Israel, encarnado en su hombre fuerte y héroe: Sansón. El 7 de octubre, los filisteos resucitados, igualmente, buscaron derribar el poder de Israel. Así está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("“Al pueblo de Gaza se le anunció: “¡Sansón ha venido aquí!”. Así que [los de Gaza] rodearon el lugar y toda la noche estuvieron al acecho junto a la puerta de la ciudad. Se quedaron quietos durante toda la noche."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El ardid para matar a Sansón fue ideado y puesto en marcha en la ciudad de Gaza. El complot subsiguiente, que realmente provocaría la caída de Sansón, se iba a centrar en Gaza. Así que el complot del 7 de octubre, que pretendía sacudir a Israel hasta sus cimientos, fue ideado y puesto en marcha desde Gaza.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la Biblia, a la gente de Gaza se les llama gazitas. Sus homólogos resucitados son conocidos en la actualidad como gazatíes: dos versiones de la misma palabra. Cada uno estaba involucrado en un complot contra el poder de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“¡Sansón, los filisteos se lanzan sobre ti!”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los filisteos sabían que nunca podrían vencer a Sansón en un enfrentamiento frente a frente. Su plan era atraparlo desprevenido en un momento de debilidad, sin vigilancia y derribarlo. Así mismo, los terroristas de "), _c('span', {
    attrs: {
      "aria-label": "129",
      "epub:type": "pagebreak",
      "id": "page129",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Hamas sabían que nunca podrían vencer a Israel en un enfrentamiento frontal. Su plan era atraparlo en un momento de debilidad, sin vigilancia y derribarlo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los filisteos aprovecharon ese momento de debilidad para atacar a Sansón. Este escuchó el estribillo: “¡Sansón, los filisteos se lanzan sobre ti!”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Así que al tratar de repeler el ataque, descubrió que su fuerza había desaparecido. En la mañana del 7 de octubre, los israelíes despertaron a la aterradora realidad de que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("los invasores filisteos estaban sobre ellos")]), _vm._v(". En otros momentos, podrían haber esperado una respuesta rápida de las fuerzas de defensa de la nación. Pero Israel fue tomado por sorpresa. Las víctimas se encontraron sin ayuda. Descubrieron que su fuerza había desaparecido.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Un israelita sin ojos")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Entonces los filisteos lo tomaron y le sacaron los ojos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Los filisteos ejecutaron otro acto de mutilación. Sacarle los ojos a Sansón fue un acto de humillación y degradación. También lo fue de incapacitación: era eliminar al hombre fuerte de Israel. El 7 de octubre, los invasores filisteos hicieron lo mismo. Una de las atrocidades cometidas ese día fue la misma que los filisteos le infligieron a Sansón: los invasores filisteos les sacaron los ojos a sus víctimas israelíes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" Y así como sacar los ojos de Sansón estaba conectado con la ciudad de Gaza, el 7 de octubre, el acto de extraer los ojos también estaba vinculado con esa misma ciudad.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Una nación sin ojos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Hubo otra mutilación de la vista ese día. Sucedió en el ámbito de la alta tecnología. El acto de sacarle los ojos a Sansón por parte de los filisteos lo dejó incapacitado para resistir y luchar contra ellos. La nación de Israel había instalado un intrincado sistema de defensa de alta tecnología a lo largo de su frontera con Gaza. Pero el 7 de octubre, falló. Una de las razones fue que el primer acto de los invasores fue dejar al sector ciego. Utilizando drones, granadas y otros explosivos, neutralizaron los sensores de seguridad y vigilancia con cámaras destinados a alertar a las Fuerzas de Defensa de Israel (FDI) en caso de un ataque inminente. Los siguientes son extractos de noticias de ese día. Observa la palabra que sigue apareciendo:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "130",
      "epub:type": "pagebreak",
      "id": "page130",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los centros de control fueron "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cegados")]), _vm._v(" y no podían determinar dónde surgían los problemas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Hamas probablemente apuntó a estas torres para “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cegar")]), _vm._v(" a los comandantes israelíes e impedir la comunicación entre sus unidades”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los soldados, que se suponía, que debían protegerlos estaban ciegos ante el desastre que se desarrollaba, o habían sido asesinados o secuestrados."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Así como los antiguos atacantes filisteos cegaron a su némesis israelita, Sansón, los invasores resucitados de Filistea ahora cegaron a las Fuerzas de Defensa de Israel. Cada uno había deshabilitado el poder de Israel y cegado al hombre fuerte.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los nechushtayim")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Lo sujetaron con cadenas de bronce."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Los antiguos filisteos ataban a sus cautivos para restringir sus movimientos y prevenir su escape. La palabra usada para describir las cadenas con las que ataron a Sansón es el hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("nechushtayim")]), _vm._v(". La palabra no es singular sino plural y, más específicamente, denota dualidad. Puede referirse a la atadura de manos y pies. Se traduce más literalmente como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("dos cadenas o grilletes")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Las cadenas o grilletes más conocidos del mundo moderno son las esposas. Como en el relato de Sansón, las esposas son un grillete metálico y, como en el relato antiguo, casi siempre se refiere en plural y, específicamente, como grilletes, es decir, un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("par de esposas")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como los asaltantes filisteos ataron a su cautivo Sansón —con grilletes o cadenas— los atacantes de Filistea del 7 de octubre hicieron lo mismo. Ataron a sus cautivos israelíes con esposas. Algunos fueron encadenados y vendados al mismo tiempo. Así como los antiguos atacantes filisteos cegaron e inmovilizaron a su cautivo israelita, Sansón, los atacantes de Filistea lo hicieron tres mil años después, el 7 de octubre.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "131",
      "epub:type": "pagebreak",
      "id": "page131",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Esto no fue, por supuesto, el final de la historia de Sansón. Tampoco fue el de lo que sucedió el 7 de octubre.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "132",
      "epub:type": "pagebreak",
      "id": "page132",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-87"
    }
  }, [_vm._v("Capítulo 36")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-88"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor035"
    }
  }), _vm._v("El prisionero")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los filisteos lo capturaron, le arrancaron los ojos "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("y lo llevaron a Gaza")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("a antigua historia ")]), _vm._v("solo podía concluir en un lugar: la ciudad de Gaza. Esta se convertiría en la prisión de Sansón, y este en su trofeo preciado, el cautivo de Gaza. Así como Gaza encarnaba el poder de los filisteos, Sansón representaba el poderío de Israel y el poder de Dios. En Gaza, Sansón parecía débil e indefenso, una sombra patética de su antiguo yo. En Gaza, todo se pondría en exhibición. Era en Gaza donde el poder de Israel debía ser derribado.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El 7 de octubre, el famoso y antiguo rol de Gaza, como la ciudad del cautivo israelí, fue resucitado. Los terroristas de Filistea llevaron a sus cautivos israelíes —hombres, mujeres y niños— de regreso a Gaza, tal como los antiguos filisteos habían llevado a su cautivo Sansón a ese mismo lugar. Y ahora nuevamente, fue en Gaza donde los cautivos israelíes parecían débiles e indefensos, degradados, como lo fue el cautivo Sansón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Beit Ha-Asorim: la casa de los prisioneros")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Las palabras hebreas en el relato del cautiverio de Sansón traducidas como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("prisión")]), _vm._v(" son “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("beit ha-asorim")]), _vm._v("”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Literalmente significa “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("lugar del cautiverio, la casa de los cautivos")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("el lugar de los atados")]), _vm._v("”. Puede incluir cualquier cámara de cautiverio, cualquier lugar donde se mantengan, restrinjan o aten a los cautivos. El 7 de octubre, Gaza estaba llena de cámaras de cautiverio, tanto en la superficie como bajo tierra, donde cientos de kilómetros de túneles construidos por Hamas servirían como una elaborada casa de prisioneros."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" Para los rehenes israelíes, Gaza se convirtió en su “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("beit ha-asorim")]), _vm._v("”, su casa de prisión, como había sido para Sansón.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "133",
      "epub:type": "pagebreak",
      "id": "page133",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las transgresiones de Gaza")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Sin embargo, la conexión de Gaza con los cautivos israelíes trasciende la historia de Sansón. En el primer capítulo de Amós se expone la maldad de ese lugar:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Por tres pecados de Gaza y por el cuarto, no anularé su castigo, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("porque tomaron cautivas poblaciones enteras")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Gaza era representativa de los filisteos. Su maldad era indudablemente la de toda Filistea. Al mismo tiempo, la profecía menciona específicamente a Gaza, por lo que debe aplicarse primero a esa antigua ciudad.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿En qué consistía la maldad de Gaza? En tomar cautivos de Israel. Los antiguos invasores filisteos ataban a los civiles israelitas y los transportaban a Gaza.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El 7 de octubre, los invasores resucitados de Filistea transportaron a sus cautivos israelíes a la misma ciudad. Fue la antigua “transgresión de Gaza” repitiéndose en el mundo moderno y, nuevamente, llevada a cabo por aquellos que lo hicieron sin saberlo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Porque tomaron cautivas poblaciones enteras”")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los invasores del 7 de octubre tenían, como objetivo, matar o llevar cautiva a comunidades enteras de israelíes. A la luz de ello, es especialmente llamativo leer algunas traducciones distintas de la escritura que expone los pecados de Gaza:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("“Porque [Gaza] "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("llevó cautiva a comunidades enteras")]), _vm._v("”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Otra traducción dice:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los habitantes de Gaza han pecado ... Enviaron a "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("pueblos enteros al destierro")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Así que el 7 de octubre, los cautivos provenían de las aldeas israelíes. Comunidades enteras y pueblos completos fueron invadidos y sus sobrevivientes llevados cautivos a Gaza.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "134",
      "epub:type": "pagebreak",
      "id": "page134",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Las aldeas indefensas de Judá fueron aplastadas”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Otro comentario sobre la profecía explica el pecado de Gaza en términos de la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("extrema barbarie")]), _vm._v(" cometida en las aldeas judías fronterizas. Eso involucraba ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("las guerras fronterizas, en las que las aldeas indefensas de Judá fueron vencidas")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Esto también coincide con lo que sucedió el 7 de octubre. Fue entonces cuando Gaza libró una "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("guerra fronteriza en la que las aldeas indefensas de Judá fueron vencidas y se cometieron actos de extrema barbarie")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La imagen profética")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Leer la siguiente traducción bíblica de la profecía de Amós contra Gaza y ver el paralelo con el 7 de octubre es sorprendente:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Por tres pecados de Gaza [Filistea] y por el cuarto, no anularé su castigo, porque tomaron cautivas poblaciones [judías] enteras [de las aldeas fronterizas indefensas de Judá, de las cuales ninguna fue perdonada] para venderlas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("¿Qué pasaría si simplemente tomáramos las palabras clave dadas en las traducciones bíblicas y comentarios sobre la profecía de Amós contra Gaza? ¿Qué conseguiríamos? Obtendríamos esto:")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“Filistea [la Franja de Gaza]... guerra de frontera... incursiones contra los judíos... aldeas fronterizas... incursiones realizadas en las aldeas de Judá... aldeas indefensas... aldeas vencidas... crueldad más allá de la práctica usual en la guerra... ancianos y enfermos, así como jóvenes... tomados cautivos... llevándose a los habitantes pacíficos... Gaza... extrema barbarie... ninguno fue perdonado”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los antiguos males de Gaza terminan generando una imagen compuesta de exactamente lo que sucedió el 7 de octubre.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "135",
      "epub:type": "pagebreak",
      "id": "page135",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría la historia de Sansón haber incluso presagiado lo que estallaría en Gaza, Cisjordania y otras partes del mundo del Medio Oriente a raíz de esa calamidad?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "136",
      "epub:type": "pagebreak",
      "id": "page136",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-89"
    }
  }, [_vm._v("Capítulo 37")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-90"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor036"
    }
  }), _vm._v("El espectáculo")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("l cautiverio de ")]), _vm._v("Sansón hizo que la gente de Gaza y el resto de Filistea se regocijaran.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La celebración en Gaza")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los gobernantes de los filisteos se reunieron para festejar y ofrecerle un gran sacrificio a Dagón, su dios, diciendo: “Nuestro dios ha entregado en nuestras manos a Sansón, nuestro enemigo”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Celebraron una gran fiesta para dar gracias a su dios Dagón, a quien atribuían su victoria. Pero el festejo no estaba completo sin que su causa estuviera presente:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Cuando ya estaban muy alegres, gritaron: “¡Saquen a Sansón para que nos divierta!”. Así que sacaron a Sansón de la cárcel y él les sirvió de diversión."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Les sirvió de diversión”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Entonces enviaron a buscar a Sansón para sacarlo de la cárcel y que los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("divirtiera")]), _vm._v(". La palabra hebrea traducida como “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("divertir")]), _vm._v("” es “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sakhak")]), _vm._v("”. Significa reír o reírse de, especialmente en un contexto de burla, desprecio y escarnio. Algunas traducciones dicen lo siguiente: “Llamen a Sansón, para que nos entretenga, nos divierta, nos haga reír”. Querían poner a Sansón en exhibición como un objeto de burla, para hacer de él un espectáculo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando se compara esto con lo que los filisteos le hicieron al rey Saúl, emerge un patrón. En el caso de Saúl, pusieron su armadura, su cuerpo y su cabeza en exhibición. En cada caso, el espectáculo implicaba mutilación: una cabeza cortada y un cautivo con los ojos arrancados.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El antiguo patrón resurgiría el 7 de octubre. Más de un observador notaría la diferencia entre los nazis y los invasores filisteos: los nazis buscaban ocultar sus atrocidades del mundo. Pero los filisteos resucitados se "), _c('span', {
    attrs: {
      "aria-label": "137",
      "epub:type": "pagebreak",
      "id": "page137",
      "role": "doc-pagebreak"
    }
  }), _vm._v("jactaban de ellas y las mostraban. Hicieron espectáculos de sus atrocidades ante multitudes que aplaudían y en internet ante el mundo entero."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“No te regocijes, toda Filistea”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Pero no solo es el espectáculo lo que destaca en el relato antiguo, sino la alegría y la celebración de los filisteos por la humillación y mutilación de su cautivo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los gobernantes de los filisteos se reunieron para "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("festejar")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Cuando ya "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("estaban muy alegres")]), _vm._v("...")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Para que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("nos divierta")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La alegría y la celebración no eran una casualidad. Eran tan parte de la práctica o cultura filistea que se mencionan en las Escrituras hebreas en más de una ocasión. Ante la muerte de un rey de Judá, se da una palabra a los filisteos a través del profeta Isaías:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("No te "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("regocijes")]), _vm._v(", toda "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Filistea")]), _vm._v(", porque la vara que te golpeó está rota."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Otra versión traduce la profecía de Isaías de esta manera:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("No te regocijes, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestina")]), _vm._v(" [Filistea]."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Para que no se regocijen las hijas de los filisteos”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así, ante la muerte del rey Saúl y sus hijos en el Monte Guilboa, David entona una canción de tristeza y luto. Esta comienza con una palabra sobre los filisteos:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("¡Ay, Israel! Tus héroes yacen heridos en las alturas de tus montes. ¡Cómo han caído los valientes! No lo anuncien en Gat ni lo pregonen en las calles de Ascalón para que no se alegren las filisteas ni lo celebren esas hijas de incircuncisos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "138",
      "epub:type": "pagebreak",
      "id": "page138",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("Gat y Ascalón eran dos de las principales ciudades de los filisteos. David las usa para hablar de todos los filisteos. Él sabía que cuando escucharan sobre la muerte del rey Saúl, habría regocijo en las calles de Filistea: la Franja de Gaza.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las celebraciones tenebrosas")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Desde el cautiverio de Sansón hasta la muerte del rey Saúl y las profecías de Isaías, las calamidades de Israel generaban celebraciones y alegría entre los filisteos. Las tenebrosas celebraciones de Filistea continuarían hasta que no hubiera más Filistea y no más Israel en la tierra. Hasta que desaparecieran del mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Pero con la resurrección de Israel y la de los filisteos, solo era cuestión de tiempo antes de que las tenebrosas celebraciones de Filistea volvieran. El 7 de octubre, volvió el fenómeno antiguo a manifestarse con toda su fuerza. Las calles de Filistea otra vez se llenaron de regocijo y celebraciones por la calamidad de Israel. En toda la Franja de Gaza —la antigua Filistea, Palestina— así como en Cisjordania, los filisteos resucitados se regocijaron.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Aplaudan con sus manos”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El regocijo de los antiguos enemigos de Israel por sus calamidades se describe también en el Libro de Ezequiel:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Ustedes … aplaudieron, saltaron de alegría y, maliciosamente, se rieron de Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Al escuchar las noticias de la calamidad de Israel, sus enemigos aplaudieron y golpearon con sus pies, alegres por los desastres de Israel. Así que el 7 de octubre, los festejantes de Filistea cantaron y corearon en las calles. Aplaudieron y golpearon con sus pies al unísono, alegres por el día de los horrores de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Alabaron a su Dios”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En la historia de Sansón, la gente de Gaza se regocijó por la tragedia de Israel. El 7 de octubre, la gente de Gaza nuevamente se alegró por la tragedia de Israel. En el relato antiguo, cuando la gente de Gaza vio lo que se había hecho a Sansón, está escrito:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "139",
      "epub:type": "pagebreak",
      "id": "page139",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Alabaron a su dios, pues dijeron: “Nuestro dios ha entregado en nuestras manos a nuestro enemigo”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Así que el 7 de octubre, cuando la gente de Gaza escuchó sobre el ataque a Israel, alabaron a su dios. Declararon: “¡Alá es grande!” y le agradecieron por entregar a los israelíes en sus manos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El juego de los niños")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En el relato antiguo, la gente de Gaza se regocijó por la mutilación de Sansón. El 7 de octubre, la gente de Gaza y Filistea se regocijó por el día en que los israelíes fueron mutilados.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("David había dicho a la gente de Filistea que no se regocijara por la muerte y decapitación del rey Saúl. Pero el 7 de octubre, la gente de Filistea —la Franja de Gaza— se regocijó por el día en que los israelíes fueron decapitados. La lamentación de David menciona específicamente el regocijo de las hijas de los filisteos. El 7 de octubre, los hijos e hijas de Filistea, jóvenes y niños pequeños, fueron llevados a la celebración y se regocijaron con sus padres por lo que se había hecho a los israelíes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Continuarían regocijándose en los días y semanas que siguieron, mientras sus maestros les impartían lecciones que celebraban las atrocidades de ese día con canciones, obras de teatro, artes y manualidades, diversión y juegos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La alegría del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El regocijo que estalló en las ciudades palestinas el 7 de octubre fue visto en televisores y pantallas de computadoras por millones de personas. Para la mayoría de esos millones, fue un apéndice impactante al día de horrores. Pero lo que estaban viendo era un fenómeno tan antiguo como la Biblia, las tenebrosas celebraciones de Filistea. Lo único nuevo era su reaparición. Otra pieza del rompecabezas en la oscura resurrección había caído en su antiguo lugar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ahora debemos plantear una pregunta: ¿Para quién es la calamidad una causa de regocijo y el mal la causa de la alegría? ¿Para quién es la atrocidad una causa de celebración? Tales cosas son inversiones malignas. Más que malvadas, son satánicas. Aquellos que participaron en tales cosas solo fueron instrumentos. Todos se convirtieron en partícipes de la alegría del Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "140",
      "epub:type": "pagebreak",
      "id": "page140",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría la historia antigua haber presagiado una manifestación de venganza tan precisa que involucrara números exactos?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "141",
      "epub:type": "pagebreak",
      "id": "page141",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-91"
    }
  }, [_vm._v("Capítulo 38")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-92"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor037"
    }
  }), _vm._v("El regreso de los gazatíes")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("a ceguera, el ")]), _vm._v("cautiverio, la burla y la degradación de Sansón no fueron, por supuesto, el final de la historia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La caída del templo de Dagón")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Cuando ya estaban muy alegres, gritaron: “¡Saquen a Sansón para que nos divierta!”. Así que sacaron a Sansón de la cárcel y él les sirvió de diversión. Cuando lo pusieron de pie entre las columnas, Sansón dijo al muchacho que lo llevaba de la mano: “Ponme donde pueda tocar las columnas que sostienen el templo, para que me pueda apoyar en ellas”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Después de pedirle al Señor que restaurara su fuerza, Sansón se apoyó en las dos columnas que sostenían el Templo de Dagón y empujó con todas sus fuerzas. El templo colapsó. En su caída, derribó a los “príncipes de los filisteos”"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" y a la multitud de filisteos que celebraban la degradación de su enemigo ciego.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La caída del Templo de Dagón a manos de Sansón y las fatalidades resultantes de ese hecho constituirían la derrota más dramática jamás sufrida por los filisteos a manos de un israelita y en su propio suelo de Filistea y, en particular, en Gaza. ¿Es posible que ese evento pudiera tener repercusiones en una era posterior?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La venganza de Gaza")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Si se pudiera decir de los filisteos que han actuado por "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("retaliación y que han cobrado venganza")]), _vm._v(", y si eso pudiera suceder en la actualidad, entonces, ¿qué pasaría con la gran calamidad que sufrieron en Gaza, la caída del Templo de Dagón a manos de Sansón? ¿Podría haber un evento moderno que corresponda y responda a eso: un acto de venganza?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El antiguo evento involucró una gran cantidad de muertes. El evento actual también supondría una gran cantidad de fallecimientos. El evento "), _c('span', {
    attrs: {
      "aria-label": "142",
      "epub:type": "pagebreak",
      "id": "page142",
      "role": "doc-pagebreak"
    }
  }), _vm._v("antiguo fue parte del conflicto entre Israel y los filisteos. El evento actual involucraría el mismo conflicto. El evento antiguo se centró en Gaza. El evento actual también se enfocaría en Gaza.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como la muerte llegó a Gaza desde Israel a través de Sansón, ¿podría significar que ahora llegaría a Israel desde Gaza? ¿Y podría implicar que la gente de Gaza trajera la muerte a la población de Israel? Con certeza que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("habría")]), _vm._v(" un evento paralelo: se manifestaría el 7 de octubre de 2023, sería la venganza de Gaza.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El festival")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los gobernantes de los filisteos se reunieron para festejar y ofrecerle un gran sacrificio a Dagón, su dios."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Los filisteos y sus líderes se reunieron para celebrar y dar gracias a su dios Dagón. Sin embargo, Sansón trajo calamidad a Gaza el día de su celebración.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así que el 7 de octubre, cuando los gazatíes trajeron calamidad a Israel, también lo hicieron en el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("día de celebración de Israel")]), _vm._v(", cuando la gente estaba celebrando un festival y daban gracias a Dios."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Simcha")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los gobernantes de los filisteos se reunieron para … festejar."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los gazatíes se reunieron “para festejar”. La palabra utilizada en el relato y traducida como festejar es el hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("simcha")]), _vm._v(". La calamidad vendría sobre los filisteos en Gaza el día de una celebración marcada por la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("simcha")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El 7 de octubre, todo fue al contrario. Los filisteos resucitados de Gaza trajeron calamidad a Israel en un día festivo judío en el que Israel debía "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("regocijarse")]), _vm._v(". De hecho, el nombre mismo de la festividad, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(", proviene de la misma palabra utilizada para describir a los filisteos en el relato de Sansón: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("simcha")]), _vm._v(". Así que la venganza de los filisteos vendría sobre Israel, igualmente, en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("el día de simcha")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "143",
      "epub:type": "pagebreak",
      "id": "page143",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día de un sacrificio")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Entonces los príncipes de los filisteos se reunieron para festejar y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ofrecerle un gran sacrificio")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El relato afirma que los líderes filisteos planeaban ofrecer un solo sacrificio a su dios. Sansón trajo calamidad a Gaza el día de ese sacrificio. ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El 7 de octubre era tanto un día festivo de regocijo, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(", como un día sagrado conocido como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sheminí Atzeret")]), _vm._v(". Sheminí Atzeret es único entre los días festivos hebreos en que se ordena que se ofrezca un solo sacrificio a Dios. Así que, al igual que Sansón trajo calamidad a Gaza, ahora Gaza trajo calamidad a Israel, en un día festivo en el que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("debía ofrecerse un solo sacrificio")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El retorno de los tres mil")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Cuántos militantes filisteos invadieron Israel el 7 de octubre? A las Fuerzas de Defensa de Israel (FDI) les tomó un tiempo determinar eso. La evaluación llegó casi un mes después del ataque. Un artículo resume los hallazgos:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Una nueva evaluación de las FDI sostiene que el número de terroristas de Hamas que invadieron Israel es mucho mayor de lo que se estimó inicialmente. Alrededor de 3.000 terroristas de Hamas invadieron el Néguev Occidental desde docenas de puntos de infiltración en la mañana del 7 de octubre."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El número se refiere específicamente a los hombres armados liderados por Hamas que entraron al país. (Una multitud de palestinos desarmados seguiría su ejemplo, llegando posteriormente). De forma que, el número de militantes filisteos que entraron al país el 7 de octubre fue, en palabras de las FDI, de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("alrededor de tres mil")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Cuántos gazatíes mató Sansón al derribar el Templo de Dagón?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Solo hay un número dado en el relato de la destrucción en el Libro de Jueces. Es el número de gazatíes que estaban en el techo viendo a Sansón “actuar”:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("..."), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("alrededor de tres mil ")]), _vm._v("hombres y mujeres en el techo viendo mientras Sansón actuaba."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "144",
      "epub:type": "pagebreak",
      "id": "page144",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("El número de gazatíes en el relato antiguo era de alrededor de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tres mil")]), _vm._v(". El 7 de octubre, la cantidad de terroristas que invadieron el país para matar a la gente de Israel era de alrededor de"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" tres mil")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No solo es el mismo número, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("es la misma frase exacta")]), _vm._v(". El hebreo antiguo dice "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("shiloshet alfanim")]), _vm._v(", cuya traducción es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("alrededor de tres mil")]), _vm._v(". El número de militantes gazatíes que invadieron Israel el 7 de octubre fue calculado por las FDI como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("alrededor de tres mil")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El conjuro del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("De manera que la resurrección del Dragón involucró no solo el retorno de los antiguos filisteos, sino que el 7 de octubre, también implicó "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("el regreso del mismo número exacto: el retorno de los tres mil gazitas")]), _vm._v(". En otras palabras, los palestinos de Gaza ahora se conformaban específicamente a la imagen de los tres mil antiguos gazitas que Sansón mató. Los invasores se habían comprometido durante mucho tiempo con la venganza, pero ahora era una represalia que abarcaba tres mil años desde la caída del Templo de Dagón.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Era como si el Dragón hubiera convocado a los tres mil al mundo moderno para que pudieran levantarse de entre los muertos y vengarse de los hijos de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Si los invasores del 7 de octubre eran los jugadores más recientes en una guerra antigua, ¿es posible que hubiera una línea de sucesión directa que condujera a su llegada? ¿Es probable encontrar predecesores, antecesores, que les pasaran sus antorchas y sus mantos a ellos? Y si esa guerra antigua es en última instancia una guerra espiritual, ¿es posible que incluso encontremos los espíritus familiares que los poseyeron, uno tras otro?")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_vm._v("Ahora encontraremos una línea que se extiende desde la Franja de Gaza el 7 de octubre hasta las cervecerías de Múnich, Alemania.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "145",
      "epub:type": "pagebreak",
      "id": "page145",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-93"
    }
  }, [_vm._v("Parte 9")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-94"
    }
  }, [_vm._v("Transmisión de espíritus")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "146",
      "epub:type": "pagebreak",
      "id": "page146",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-95"
    }
  }, [_vm._v("Capítulo 39")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-96"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor038"
    }
  }), _vm._v("El Muftí")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("S")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("i detrás de ")]), _c('span', [_vm._v("la furia mundial contra el pueblo judío hay una entidad espiritual representada por el Dragón, esperaríamos que esa guerra trascienda a cualquier persona, movimiento, organización, reino o poder.")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La antorcha del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("A través del paso del tiempo, el núcleo central y la esencia interna de la guerra permanecerían iguales, pero los nombres cambiarían y las formas se modificarían. La guerra se libraría de una generación a la siguiente y de una tierra a otra. Así, esperaríamos ver la transmisión de mantos, la superposición de jugadores, la convergencia de movimientos y el paso de antiguas antorchas. En el caso de la resurrección filistea, esperaríamos que otras corrientes y manifestaciones de la guerra y la furia del Dragón preparasen su camino, converjan con ella, la unjan y la empoderen. ¿Qué sucede entonces si profundizamos en los orígenes del 7 de octubre y la resurrección filistea? ¿Encontraremos precursores y la transmisión de la antorcha del Dragón?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Gran Mufti")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Mohammed Amin al-Husseini nació a finales del siglo diecinueve en Jerusalén, controlada por los otomanos. No mucho después de su nacimiento, la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("palestino")]), _vm._v(" comenzó a aparecer en el idioma árabe. Él jugaría un papel crucial en la resurrección filistea.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Durante la Primera Guerra Mundial, luchó en el ejército otomano. Después de esa conflagración, regresó a Jerusalén y se centró en descarrilar todo movimiento hacia el nacimiento de una nación judía en la tierra. Sus discursos inflamatorios incitaban disturbios árabes violentos, dejando muchos judíos muertos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")]), _vm._v(" A partir de 1921 sería conocido como el “Gran Mufti de Jerusalén”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" En los años siguientes, continuaría desempeñando un papel central en los levantamientos árabes violentos con un rastro de sangre judía en su estela. El último de estos, a finales de la década de 1930, "), _c('span', {
    attrs: {
      "aria-label": "147",
      "epub:type": "pagebreak",
      "id": "page147",
      "role": "doc-pagebreak"
    }
  }), _vm._v("resultaría en una orden de arresto en su contra. Escapó de la persecución huyendo al Líbano, luego a Irak y después a la Alemania nazi."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Aliados naturales")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El Mufti fue un temprano admirador de Adolf Hitler. En 1933, poco después de la ascensión de Hitler al poder en Alemania, el Mufti expresó su apoyo al nuevo gobierno, afirmando que los musulmanes palestinos eran fervientes partidarios del régimen nazi y esperaban con ansias la expansión del fascismo en todo el Medio Oriente. Estaba especialmente a favor de las campañas antijudías de los nazis. Apeló a Hitler para que eliminara los asentamientos judíos en Palestina."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En 1940, el Mufti redactó un documento que esperaba que el gobierno nazi aprobara en el que los países árabes tendrían el derecho de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("resolver la cuestión judía")]), _vm._v(" en sus tierras "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("como los nazis lo habían hecho en Alemania")]), _vm._v(". En noviembre de 1941, el Mufti logró una reunión con Hitler en la Cancillería del Reich en Berlín. Le dijo a Hitler que los árabes eran sus aliados naturales, ya que tenían los mismos enemigos, específicamente los judíos. Pidió a Hitler que se comprometiera con la eliminación de una patria nacional judía. Hitler afirmó su compromiso de destruir el elemento judío residente en la esfera árabe en el momento adecuado."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" El Holocausto debía llevarse a la tierra de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Holocausto del Mufti")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Al-Husseini se sintió cada vez más atraído por la Schutzstaffel (SS) de Hitler, los principales agentes del Holocausto, y por Heinrich Himmler, su principal supervisor. El diplomático alemán Fritz Grobba registró que en julio de 1942 el Mufti visitó un campo de concentración nazi y quedó favorablemente impresionado. Durante el Holocausto, el Mufti trabajaría incansablemente para bloquear las rutas de judíos que intentaban escapar de sus horrores. Fue personalmente responsable de impedir la huida de quinientos niños judíos, consignándolos a su muerte en el campo de concentración de Arbe."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Dondequiera que los encuentren”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Durante la guerra, al-Husseini trabajó para el Tercer Reich, difundiendo propaganda nazi por todo el mundo árabe. Los nazis, a su vez, asumieron "), _c('span', {
    attrs: {
      "aria-label": "148",
      "epub:type": "pagebreak",
      "id": "page148",
      "role": "doc-pagebreak"
    }
  }), _vm._v("la tarea de distribuir sus escritos, incluyendo un panfleto que escribió para la SS pidiendo la destrucción total del pueblo judío. Imploró a sus empleadores nazis que bombardearan Tel Aviv y Jerusalén para matar a los judíos que residían en esas ciudades. Trabajó con Himmler para organizar escuadrones de asesinos musulmanes de la SS en los Balcanes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")]), _vm._v(" Exhortó públicamente al mundo musulmán a seguir el ejemplo de los nazis en cuanto a una “solución definitiva al problema judío”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")]), _vm._v(" Esperaba una victoria nazi en el Medio Oriente por la cual el Holocausto pudiera llegar a la tierra de Israel. Cerca del final de la guerra, el Mufti transmitió desde Radio Berlín: “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Árabes... maten a los judíos dondequiera que los encuentren")]), _vm._v("”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Acusado de haber cometido crímenes de guerra, el Mufti nuevamente escapó de la persecución huyendo a Egipto donde, a su llegada, fue recibido como un héroe. Durante su tiempo con los nazis, su popularidad entre los árabes solo había aumentado. Retomó su liderazgo en el mundo árabe y trabajó extensamente con la Hermandad Musulmana. En el momento de la resurrección de Israel en 1948, trabajó activamente para su destrucción."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La convergencia nazi-árabe")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El Mufti sirvió como un canal a través del cual la virulenta toxicidad del antisemitismo nazi se fusionó con el nacionalismo árabe y el fanatismo islámico. Las doctrinas raciales del Tercer Reich, la creencia en una conspiración judía global y la convicción de que no podía haber negociación ni paz con el pueblo judío —solo aniquilación—, infectaron al mundo árabe e islámico, y en los años venideros, llevarían al Medio Oriente y al mundo al borde de la guerra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En términos de las fuerzas espirituales detrás de la transmisión, el orgidzo, la furia del Dragón que había inflamado y empoderado al mal y la locura del nazismo, ahora encendería al mundo árabe e islámico. Y como lo hizo con el pueblo de Alemania, prendió fuego al Medio Oriente con una furia satánica centrada en Israel y el pueblo judío.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("De Múnich a Gaza")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Y sin embargo, había más en la conexión. El Mufti no solo era "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("líder")]), _vm._v(" en el mundo árabe; también lo era en el ámbito "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("palestino")]), _vm._v(". Con razón, se le ha llamado el “padre del nacionalismo palestino”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("11")]), _vm._v(" Cuando Israel fue resucitado en 1948 y, al mismo tiempo, se fundó el primer Estado palestino, o Filistea, el presidente de ese Estado era el Mufti."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("12")]), _vm._v(" Así que, desde la ascensión de "), _c('span', {
    attrs: {
      "aria-label": "149",
      "epub:type": "pagebreak",
      "id": "page149",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Hitler en 1933 hasta la reunión en la Cancillería del Reich, los escuadrones de la muerte de la SS, la resurrección del soldado de Filistea, desde las cervecerías de Múnich en la década de 1920 hasta las costas de Gaza el 7 de octubre, la línea corre recta y profunda, las conexiones son centrales e intrínsecas, y las huellas del Dragón están por todas partes.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los empleados del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El final de la Segunda Guerra Mundial vio la desaparición de Hitler y de los líderes del Tercer Reich. Pero el Mufti sobrevivió y permaneció como un agente activo del antisemitismo nazi en todo el mundo árabe. Un destacado líder musulmán de la época proclamó: “Alemania y Hitler se han ido, pero al-Husseini continuará la lucha”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("13")]), _vm._v(" ¿Cómo podrían el islamismo radical y el nazismo, dos ideologías en conflicto, constituir la misma lucha? Podrían si fueran dos ramas de la misma raíz espiritual. Podrían si compartieran el mismo objetivo primordial, que sí lo tenían: la destrucción del pueblo judío. Era el mismo objetivo compartido por la entidad espiritual lo que los empoderaba. La lucha y la guerra pertenecían al Dragón. El nazismo y el islamismo radical eran instrumentos de esa guerra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No es casualidad que el padre del nacionalismo palestino fuera un agente del nazismo, ni que Adolf Hitler fuera el empleador del hombre que puso en marcha la agenda palestina. Cada uno era, a su vez, empleado del Dragón. El Mufti anhelaba un segundo Holocausto, uno que borrara a los judíos del Medio Oriente y destruyera la nación de Israel antes de su renacimiento. Lo que el Enemigo no pudo hacer a través de Adolf Hitler, ahora buscaría hacerlo a través del islamismo radical, inflamando al mundo árabe y luego resucitando a un enemigo antiguo de entre los muertos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El discípulo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En 1946, un año después del fin del Holocausto, luego que el Mufti huyera de Alemania y Europa a Egipto, conoció a un adolescente árabe que asistía a una escuela secundaria en El Cairo. Tomó al adolescente bajo su ala y lo reclutó para su causa. El joven se convirtió en su discípulo. Su nombre era "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Yasser Arafat")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El Mufti adoctrinó a Arafat y sus asociados en su odio por el pueblo judío y su ideología de exterminio. Así, Yasser Arafat fue enseñado y discipulado por el hombre que trabajó con y para Adolf Hitler. Arafat tomaría el manto de al-Husseini. Se convertiría en el líder y la cara del nacionalismo "), _c('span', {
    attrs: {
      "aria-label": "150",
      "epub:type": "pagebreak",
      "id": "page150",
      "role": "doc-pagebreak"
    }
  }), _vm._v("y el terrorismo palestinos. También sería crucial en la resurrección filistea, continuando donde al-Husseini lo dejó.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los guías arios")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Para entrenar a Arafat en las formas de la violencia y la guerra, el Mufti trajo secretamente a un excomando nazi a Egipto."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("15")]), _vm._v(" El comando enseñó a Arafat y sus compañeros cómo lanzar ataques contra el pueblo judío de Israel, cómo llevar a cabo una guerra de guerrillas y cómo derramar sangre judía. Así, Arafat sería entrenado en las tácticas tanto de los nazis como de los antiguos filisteos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Arafat continuaría en los pasos de al-Husseini, reclutando instructores nazis para la agenda palestina. Estos incluirían a Erich Altern, un líder en la sección de asuntos judíos de la Gestapo, y a Willy Berner, un miembro de la SS del campo de concentración de Matthausen."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("16")]), _vm._v(" Solo en años posteriores se revelaría que la Organización para la Liberación de Palestina estaba trabajando con y empleando a varios otros agentes nazis y neonazis.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La cadena del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así que tenemos una cadena que se extiende desde una cervecería en Múnich, Alemania, hasta las costas de Gaza. Dentro de esa cadena tenemos a un hombre citado como “el padre del nacionalismo palestino”, un empleado pagado de Adolf Hitler, un agente nazi también conocido como “el padre del terrorismo árabe.” El empleado de Hitler, a su vez, discipularía y entrenaría a Yasser Arafat para librar una guerra terrorista contra el pueblo de Israel. Entonces tenemos en un extremo de la cadena a Yasser Arafat y el 7 de octubre, y en el otro, a Adolf Hitler.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La unión de ideologías y movimientos tan dispares y en conflicto como el nazismo alemán y el nacionalismo palestino no debería sorprendernos. Porque estamos tratando con una guerra espiritual antigua. Tampoco debería alarmarnos el momento de estos eventos. No es coincidencia que justo cuando la resurrección de Israel estaba en marcha, Hitler y el nazismo comenzaran su ascenso. Incluso el nacimiento del Mufti fue parte del misterio. Se cree que fue en el año 1897 cuando Theodor Herzl convocó el Primer Congreso Sionista e inauguró oficialmente el movimiento del sionismo para el retorno de Israel. El Dragón respondería. Se cree que fue ese mismo año, 1897, cuando nació el niño que se convertiría en el Mufti de Jerusalén.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "151",
      "epub:type": "pagebreak",
      "id": "page151",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("La oscura cadena de causa y efecto no comenzó con Adolf Hitler, ni terminaría con Yasser Arafat. Continuaría hasta hoy, el presente. E involucraría otro mal, uno nacido en una antigua ciudad tenebrosa.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "152",
      "epub:type": "pagebreak",
      "id": "page152",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-97"
    }
  }, [_vm._v("Capítulo 40")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-98"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor039"
    }
  }), _vm._v("Hijo de la hermandad")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("assan al-Banna nació ")]), _c('span', [_vm._v("en 1906 en una ciudad rural del delta del Nilo, al noroeste de El Cairo.")]), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("1")]), _vm._v(" Él también desempeñaría un papel clave en el misterio.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La hermandad")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El padre de al-Banna era profesor de doctrina islámica, imán en una mezquita. Al llegar a la edad adulta, al-Banna se convirtió en maestro de escuela primaria. Preocupado por el abandono de las creencias y prácticas islámicas en la cultura egipcia, predicó un retorno a las enseñanzas del Corán. En marzo de 1928, fundó una organización dedicada al Islam y la yihad, la lucha contra los enemigos de la fe. Se llamaría "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hermandad Musulmana")]), _vm._v(". Al cabo de diez años, los Hermanos Musulmanes tenían sucursales en todo Egipto, y diez años más tarde, medio millón de miembros activos y muchos más simpatizantes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Mi Yihad”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los Hermanos Musulmanes nacieron al mismo tiempo que otro movimiento llegaba al poder, el nazismo. En el año del nacimiento de la Hermandad, los nazis obtuvieron sus primeros escaños en el parlamento alemán. Al igual que el Mufti, al-Banna estaba enamorado de Adolf Hitler. Le escribió repetidamente expresándole su admiración y su esperanza de que el Islam y el nazismo se convirtieran en colaboradores."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A partir de 1935, la Hermandad enviaría delegaciones para asistir a los mítines anuales del partido nazi en Nuremberg. Junto con otros escritos antisemitas de Occidente, la Hermandad tradujo al árabe la autobiografía y la diatriba de Hitler contra los judíos. En cuanto a su título, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mi lucha")]), _vm._v(", lo tradujeron como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mi Yihad")]), _vm._v(". Se publicaría ampliamente en todo el mundo árabe e islámico. A partir de la década de 1930, Hitler financió a la Hermandad. Los miembros de la Hermandad, a su vez, actuaron como espías nazis en Oriente Medio. Los nazis también ayudarían a los Hermanos Musulmanes en su organización, su difusión de propaganda y su guerra."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "153",
      "epub:type": "pagebreak",
      "id": "page153",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Metástasis")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Al-Banna también era un gran admirador del Mufti, y los dos se convertirían en colaboradores en su guerra contra los judíos. Cuando el Mufti llegó a Egipto después de trabajar para el Tercer Reich, fue al-Banna quien desempeñó el papel clave en la bienvenida del héroe brindada en su honor. El antisemitismo del Mufti, influenciado por los nazis, influiría a su vez en las ideas y la ideología de los Hermanos Musulmanes. La Hermandad, a su vez, los difundiría por todo el mundo islámico. Mucho después del fin del Tercer Reich, su antisemitismo se podía encontrar en todo el mundo árabe y se había convertido en un pilar central del pensamiento islámico radical."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5 ")]), _vm._v("Detrás de la furia de los predicadores y terroristas musulmanes radicales contra los judíos estaba la ira de Adolf Hitler, y detrás de esta estaba la del Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Guerra santa")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La nueva encarnación musulmana radical de la antigua ira contra los judíos fue única en el sentido de que ahora se enmarcaba como una guerra santa. Y lo mismo que sucedió con Hitler y el nazismo, también ocurrió con los musulmanes radicales: el exterminio judío no era periférico sino un principio fundamental de toda su cosmovisión y propósito.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cabría esperar que la ira del Medio Oriente infectado por los nazis encontrara su punto focal en el regreso de los judíos a su antigua tierra. Y así fue. El Mufti fue designado representante oficial de al-Banna en Palestina y supervisor de todas las actividades de la Hermandad allí."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" Así que, el hombre que sirvió de puente entre el nazismo y el Islam también serviría como conducto para traer a la Hermandad Musulmana a Israel. En el momento de la resurrección de Israel, las tropas de los Hermanos Musulmanes entraron en la tierra para destruir a la nación judía en su nacimiento.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El hijo de la hermandad")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Si el protegido y sucesor del Mufti en su guerra contra Israel fue Yasser Arafat, el protegido de los Hermanos Musulmanes en Israel vendría después. Aparecería en la ciudad que iba a servir como sede del Muftí como presidente del primer Estado Palestino: la ciudad de los antiguos enemigos de Israel. Nacería en Gaza.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "154",
      "epub:type": "pagebreak",
      "id": "page154",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("La Hermandad daría origen al "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Movimiento de Resistencia Islámica")]), _vm._v(". En árabe se llamaba "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Harakat al-Muqawama al-Islamiya")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")]), _vm._v(" El nombre se redujo a un acrónimo. El hijo de la Hermandad recibió el nombre de Hamas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Es posible que en los mismos cimientos sobre los que nació Hamas podamos encontrar la voz y el espíritu de Adolf Hitler?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "155",
      "epub:type": "pagebreak",
      "id": "page155",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-99"
    }
  }, [_vm._v("Capítulo 41")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-100"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor040"
    }
  }), _vm._v("La carta del loco")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("amas nació en ")]), _c('span', [_vm._v("Gaza el 10 de diciembre de 1987.")]), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("1")]), _vm._v(" El lugar y el momento de su nacimiento fueron significativos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La carta")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así como fue en Gaza donde se idearon antiguos males contra Israel, también fue allí donde se lanzó la Primera Intifada contra la nación judía. Explotó a principios de diciembre de 1987."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Fue al día siguiente del primer día de levantamiento y violencia cuando se fundó Hamas. El hijo palestino de la Hermandad nació en una tormenta de odio y rabia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Por qué surgió Hamas? La razón, junto con su declaración de misión, se dio en su carta fundacional de 1988. En esa carta es central la aniquilación de Israel. Todo estaba ahí desde el principio, en el preámbulo, donde decía:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Israel existirá y seguirá existiendo hasta que el Islam lo aniquile."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La voz del Führer")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Como la guerra del Dragón es espiritual y trasciende tiempo y espacio, la misión de Hamas no se limitó a los israelíes sino que fue contra todos los judíos, como dejaba claro la carta:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Porque nuestra lucha contra los judíos es extremadamente amplia y seria")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Y no solo los judíos que vivían en Israel eran el enemigo sino cualquiera que viviera en cualquier lugar de la tierra, tal como lo era para Hitler. La frase “nuestra lucha contra los judíos” es digna de mención, ya que Hitler usó las mismas palabras, “mi lucha”, “mein kampf”, como título de su autobiografía. La referencia no es casual, ya que gran parte de la carta podría haber sido tomada directamente de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mein Kampf")]), _vm._v(". El artículo veintidós de los estatutos de Hamas parece un compendio de calumnias antisemitas y de la locura de Hitler:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "156",
      "epub:type": "pagebreak",
      "id": "page156",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("[Los judíos] tomaron el control de los medios de comunicación mundiales, las agencias de noticias, la prensa, las editoriales, las estaciones de radiodifusión y otros. Con su dinero provocaron revoluciones en varias partes del mundo … Estuvieron detrás de la Revolución Francesa, la revolución comunista y la mayoría de las revoluciones … Con su dinero formaron sociedades secretas, como los masones, los clubes rotarios, los leones… con el propósito de sabotear las sociedades y lograr los intereses sionistas …No hay guerra en marcha en ningún lugar, sin que tengan el dedo en ello.")]), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Una conspiración judía")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Y lo siguiente podría haberse extraído, vocablo por vocablo, de cualquier cantidad de palabras escritas y habladas por Hitler contra los judíos:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Su objetivo es socavar las sociedades, destruir los valores, corromper las conciencias, deteriorar el carácter … Israel, el judaísmo y los judíos.")]), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Al igual que Hitler (no bastaba con declarar la guerra al pueblo judío), Hamas declaró la guerra incluso al judaísmo. En cuanto a la clásica acusación nazi y antisemita de una conspiración judía para apoderarse del mundo, la carta también incluye eso:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hoy es Palestina, mañana será un país u otro. El plan sionista no tiene límites")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Juntos al infierno”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los estatutos de Hamas dejan claro que no se puede hacer la paz con el pueblo judío —solo la guerra— en esta vida e incluso más allá:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("“Serán vencidos y arrojados juntos al infierno…”. Esta es la única manera de liberar a Palestina.")]), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La carta incluye una serie de citas de escritos islámicos para defender la destrucción de los judíos. Quizás el más crudo y revelador sea este:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "157",
      "epub:type": "pagebreak",
      "id": "page157",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Asaltaré y mataré, asaltaré y mataré, asaltaré y mataré")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Las palabras suenan como un mantra de alguien poseído satánicamente. Y en vista de lo que estamos tratando, exactamente así deberían sonar.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Escritores fantasmas")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Si uno quisiera destruir a un pueblo en particular y necesitara instrumentos de carne y sangre para destruirlo, describiría a ese pueblo como malvado por naturaleza, fuente de todo mal, y cuya existencia misma constituye un peligro existencial. Por eso, no es casualidad que gran parte de los estatutos de Hamas parezcan propaganda nazi y podrían haber sido escritos por Adolf Hitler. Sin Hitler, esa carta no podría existir. Tampoco podría existir sin el Dragón. Estaba escrita en su guion e impregnada de su intención asesina. Los fundadores de Hamas fueron solo sus escritores fantasmas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las semillas regadas durante mucho tiempo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("No fue casualidad que Hamas naciera en una ciudad señalada en la Biblia por su maldad y de la que, en la antigüedad, vino la muerte y la destrucción para los israelitas. Tampoco fue accidental que el 7 de octubre evocara tanto los actos de los nazis. Poco después de que los soldados de Israel entraron en Gaza en respuesta a la masacre, descubrieron allí un libro árabe con una imagen de Adolf Hitler en la portada: era "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mein Kampf")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")]), _vm._v(" Lo que había sucedido en la costa sur de Israel en octubre y lo que había ocurrido en la Alemania nazi surgió cada una de la misma fuente. Lo ocurrido el 7 de octubre estaba ordenado desde el principio, desde el momento en que se concibió Hamas. Los invasores de ese día estaban cumpliendo las palabras de su carta fundacional: “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Asaltaré y mataré, asaltaré y mataré, asaltaré y mataré")]), _vm._v("”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Se trataba de la fructificación de las semillas de la siembra del Dragón que habían sido regadas durante mucho tiempo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Es posible que Hamas se encuentre realmente en la Biblia? Y si es así, ¿qué revelaría?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "158",
      "epub:type": "pagebreak",
      "id": "page158",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-101"
    }
  }, [_vm._v("Capítulo 42")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-102"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor041"
    }
  }), _vm._v("Los lugares oscuros de la tierra")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("unque el nombre ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Hamas")]), _c('span', [_vm._v(" es un acrónimo del ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Movimiento de Resistencia Islámica")]), _vm._v(" en árabe, también es una palabra antigua del Medio Oriente.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Hamas en hebreo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En árabe, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hamas")]), _vm._v(" significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("celo, fuerza, pasión ")]), _vm._v("y"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" valentía")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")]), _vm._v(" Y así es como los líderes de Hamas querrían que su organización fuera vista en el mundo árabe. Pero "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hamas")]), _vm._v(" es único en el sentido de que existe no solo como palabra árabe sino también como término hebreo, un antiguo vocablo hebreo que aparece en la Biblia. En hebreo, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hamas")]), _vm._v(" significa algo muy diferente: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("violencia, maldad ")]), _vm._v("y"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" destrucción")]), _vm._v(". Y en el contexto de su uso específico en las Escrituras puede referirse a "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("brutalidad, inmoralidad, falsedad, anarquía, injusticia y actos de crueldad, saqueo, asesinato, matanza ")]), _vm._v("y"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" terror")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En 2007, la Franja de Gaza quedó bajo el dominio de Hamas. Desde un punto de vista bíblico y lingüístico, al quedar bajo el dominio de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hamas")]), _vm._v(", los habitantes de Gaza quedaron bajo el imperio de la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("violencia")]), _vm._v(". Al estar gobernado por la autoridad de Hamas, el pueblo de Gaza estaba gobernado por la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("anarquía")]), _vm._v(". Al recibir enseñanza en las escuelas de Hamas, a los habitantes de Gaza se les enseñó en las escuelas del terror. Al seguir a sus nuevos líderes de Hamas, estaban siguiendo al mal. Y al ser entrenados en los campos paramilitares de Hamas, estaban siendo entrenados para la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("destrucción")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Hamas en las Escrituras")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Las apariciones bíblicas de la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hamas")]), _vm._v(", por supuesto, se refieren —en contexto— a la violencia y el mal tal como se manifestaban en la antigüedad y como lo entenderían los antiguos israelitas. Por otro lado, la Palabra de Dios está llena de múltiples capas de significado y es dada por Aquel que tiene conocimiento de todos los eventos —pasados, presentes y futuros— incluido el futuro nacimiento de la organización terrorista que "), _c('span', {
    attrs: {
      "aria-label": "159",
      "epub:type": "pagebreak",
      "id": "page159",
      "role": "doc-pagebreak"
    }
  }), _vm._v("se conocería con el nombre de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hamas")]), _vm._v(". ¿Qué pasa entonces si buscamos la palabra hamas en el hebreo original de la Biblia?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El Salmo 140 comienza con esta oración por liberación:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Líbrame, oh Señor, de los hombres malos: guárdame de los hombres violentos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Pero en el original hebreo la segunda línea podría traducirse más literalmente: ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Presérvame de los hombres de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hamas")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Los lugares oscuros de la tierra”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hamas")]), _vm._v(" describía específicamente lo que los antiguos enemigos de Israel en Medio Oriente infligieron a su pueblo. A uno de esos enemigos se le daría una profecía de juicio y el motivo de ello:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Por la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hamas")]), _vm._v(" contra tu hermano Jacob, la vergüenza te cubrirá y serás cortado para siempre."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Hamas opera en la oscuridad. Oculta sus actividades terroristas detrás de escuelas, hospitales y otros centros de la vida civil. Convirtió la ciudad de Gaza en un centro de mando del terrorismo. Excavó en la tierra de la ciudad para construir más de quinientos kilómetros de túneles con fines de violencia, guerra y terrorismo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" Hamas operaba en una oscuridad metafórica o figurativa, pero también en una oscuridad física real. Sus agentes literalmente habitan en los lugares oscuros de la tierra. El Salmo 74 dice esto:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Porque los lugares oscuros de la tierra están llenos de viviendas de Hamas")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "161",
      "epub:type": "pagebreak",
      "id": "page161",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Una vara de maldad”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El 7 de octubre Hamas convirtió a sus miembros y agentes en un arma unificada y coordinada de violencia y maldad contra el pueblo de Israel. Cuando el profeta Ezequiel habla del día de la calamidad de Israel, dice esto:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hamas se ha convertido en un vara de maldad")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El 7 de octubre la tierra de Israel, sus pueblos y viviendas, se llenaron de violencia, crímenes, atrocidades y sangre. La profecía de Ezequiel continúa:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Porque la tierra está llena de crímenes de sangre y la ciudad está llena de hamas")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Jeremías profetizó el juicio de Babilonia por el mal y la destrucción que trajo sobre la tierra de Israel. Ese mal se encarna en una palabra:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Que los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hamas")]), _vm._v(" que me hicieron a mí y a mi carne caigan sobre Babilonia."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Pero en el versículo anterior aparece otra palabra, igualmente significativa. La palabra es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tannin")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tanim")]), _vm._v(". Es, insisto, la palabra hebrea para "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("dragón")]), _vm._v(". Así que, las palabras "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hamas")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tannin")]), _vm._v(" están conectadas. El Dragón es la fuente de Hamas, por lo que Hamas lleva la naturaleza de su padre.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Hamas ya no será escuchado”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Es sorprendente que una organización dedicada a traer el mal, la violencia y la destrucción a Israel haya elegido para su nombre una palabra árabe que era, al mismo tiempo, el vocablo hebreo para "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("mal, violencia ")]), _vm._v("y"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" destrucción")]), _vm._v(". No tenía idea de que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hamas")]), _vm._v(" era la misma palabra usada en la Biblia para hablar de lo que los enemigos de Dios trajeron sobre Israel, y el juicio y la destrucción que sobrevendrían a quienes lo hicieran. Pero Dios siempre tiene la última palabra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al profeta Isaías se le dio un vistazo de los días en que el reino de Dios se manifestará en la tierra y el Mesías reinará en el trono de Israel. En aquellos días ya no se conocerá la guerra y los hijos de Israel, por fin, encontrarán "), _c('span', {
    attrs: {
      "aria-label": "162",
      "epub:type": "pagebreak",
      "id": "page162",
      "role": "doc-pagebreak"
    }
  }), _vm._v("la paz. En Isaías 60 el profeta menciona específicamente una de esas bendiciones, una bendición no de lo que será sino de lo que ya no será.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La promesa es esta:")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ya no se oirá más a Hamas en vuestra tierra, ni destrucción ni desgracia dentro de vuestras fronteras."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En ese día, la violencia ya no amenazará ni oprimirá al pueblo judío ni a los hijos de Israel. Y todos aquellos que lucharon contra ellos, todos los que intentaron borrarlos de la faz de la tierra, desde el Faraón hasta Hitler y Hamas, habrán perecido.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Sus terrores habrán desaparecido hace mucho, sus amenazas habrán pasado hace mucho y su maldad y destrucción habrán quedado olvidadas hace mucho tiempo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("No fue solo la invasión del 7 de octubre la que siguió al antiguo misterio, sino la que vino después. Ahora veremos cómo la guerra que se desató ese día también fue presagiada siglos antes de que sucediera. En el camino descubriremos una conexión que lo une todo al Libro de Apocalipsis.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "163",
      "epub:type": "pagebreak",
      "id": "page163",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-103"
    }
  }, [_vm._v("Parte 10")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-104"
    }
  }, [_vm._v("La inundación  del Dragón")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "164",
      "epub:type": "pagebreak",
      "id": "page164",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-105"
    }
  }, [_vm._v("Capítulo 43")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-106"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor042"
    }
  }), _vm._v("Fuego en los muros")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("orque tomaron cautivas ")]), _c('span', [_vm._v("poblaciones enteras … ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Enviaré fuego contra los muros de Gaza que consumirá sus fortalezas.")]), _c('span', {
    staticClass: "SUPERSCRIPT CharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El profeta Amós no solo expuso el pecado de Gaza sino que predijo su juicio.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Juicio por fuego")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El juicio vendría por la transgresión de Gaza al llevar cautivas a “poblaciones enteras” de Israel y, según diversos comentarios bíblicos, por la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("extrema barbarie")]), _vm._v(". En vista de que los antiguos pecados de Gaza se repitieron el 7 de octubre, esperaríamos que se repitiera la misma dinámica, la invocación de su juicio.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Cómo vendría ese juicio? Según la profecía, vendría por fuego. “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Enviaré fuego contra el muro de Gaza")]), _vm._v("”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Y ese fuego vendría a través de la guerra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Se cumplió la profecía? Sí. En el siglo octavo a. C., el fuego de la guerra llegó a los muros de Gaza y Filistea a través de los ejércitos de Asiria y, en el siglo siguiente, a través de los ejércitos de Egipto y Babilonia."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Guerras de los reyes")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Pero el juicio también vendría a través de los ejércitos de Israel. El peligro constante e inmediato que Gaza y Filistea representaban para el pueblo de Israel no era sostenible. Así está registrado que el rey Uzías")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Fue a la guerra contra los filisteos y derribó los muros de Gat, Jabne y Asdod. Luego reconstruyó ciudades cerca de Asdod y en otros lugares entre los filisteos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El rey Ezequías hizo lo mismo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Ezequías derrotó a los filisteos "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hasta Gaza y sus alrededores")]), _vm._v(". Derrotó a todas las ciudades filisteas, desde el pueblo más pequeño hasta la ciudad más grande."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "165",
      "epub:type": "pagebreak",
      "id": "page165",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los muros de Gaza")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El 7 de octubre Israel se encontraba en estado de guerra. Buscaba rescatar a los cientos de rehenes tomados en Gaza y expulsar a Hamas del territorio. Llamaría a la gente de la Franja de Gaza a moverse hacia el sur para evitar que quedara atrapada en medio de la guerra."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" La batalla se enfocaría en Hamas para garantizar que nunca más volvería a haber otro 7 de octubre. Así que los soldados de Israel entrarían en la Franja de Gaza y en la ciudad de Gaza con dos objetivos: rescatar a los rehenes y poner fin al peligro y al terror de Hamas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En el otoño de 2023, la antigua dinámica registrada en los libros de Reyes y Crónicas se repitieron en el mismo suelo, de la misma manera, antes los ojos del mundo. El pueblo de Gaza y Filistea había atacado nuevamente a la tierra de Israel, otra vez asaltó sus aldeas, volvió a  cometer actos de derramamiento de sangre y atrocidades, y nuevamente tomó cautivos a civiles israelíes en la tierra de Filistea. E, insisto, sus actos provocarían destrucción. La guerra volvería a venir a la tierra de Filistea. Y el fuego volvería a arder "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("en los muros de Gaza")]), _vm._v(". Sus muros volverían a ser derribados y el fuego volvería a "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("devorar sus palacios")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Soldados resucitados en una tierra resucitada")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Las antiguas guerras entre Israel, Filistea y Gaza habían cesado siglos antes del renacimiento de Israel en el mundo moderno. Pero ahora habían regresado. En la antigüedad, los soldados de Israel lucharon en la ciudad de Gaza y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sus alrededores")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El mundo no lo sabía, pero estaba presenciando a los soldados resucitados de una nación resucitada luchando en una guerra resucitada en la tierra resucitada de su enemigo también  resucitado.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría el nombre dado a la guerra entre Israel y Gaza haber sido tomado, sin saberlo, de las guerras de los antiguos israelitas y filisteos?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "166",
      "epub:type": "pagebreak",
      "id": "page166",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-107"
    }
  }, [_vm._v("Capítulo 44")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-108"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor043"
    }
  }), _vm._v("Espadas de hierro")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("n el Libro ")]), _vm._v("de Ezequiel, Dios ordena a los líderes del pueblo judío que eliminen la violencia y el mal de la tierra. Fue una reprensión por sus pecados, una exhortación a los gobernantes de la nación. Pero en el idioma original en el que se dio la orden aparece algo más.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Deshazte de Hamas”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En hebreo, el comando une dos palabras: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hasiru")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hamas")]), _vm._v(". "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hasiru")]), _vm._v(", en este contexto, puede traducirse como apartar, separar, quitar, deshacerse, poner fin. El objeto directo de la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hasiru")]), _vm._v(" es la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hamas")]), _vm._v(". Por tanto, las primeras palabras del comando se pueden traducir como:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Pon fin a hamas.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("¡Deja de lado a hamas!")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Elimina a hamas.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Deshazte de hamas.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("A raíz del 7 de octubre, los líderes de Israel llegaron a la conclusión de que no podían seguir permitiendo que Hamas operara a poca distancia de su población y que lo que pasó ese día nunca podría volver a suceder. Para lograrlo, vieron que su única respuesta se resumía en las palabras del profeta: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hasiru")]), _vm._v(" "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hamas")]), _vm._v(". En otras palabras, había que expulsar a Hamas del territorio.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El muro, la honda y la cúpula")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Como hemos visto, la cuestión del hierro fue fundamental en las antiguas guerras entre filisteos e israelitas. Lo que ocurrió en el otoño de 2023 constituyó la mayor guerra entre Israel y Filistea desde la antigüedad. ¿Podría la cuestión del hierro volver a ser central en esa guerra? Lo fue. La guerra de octubre estaría especialmente imbuida de “hierro”.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "167",
      "epub:type": "pagebreak",
      "id": "page167",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("La guerra comenzó cuando los invasores filisteos violaron el sistema de seguridad israelí conocido como el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Muro de Hierro")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Mientras Hamas disparaba miles de cohetes desde la antigua Filistea hacia los pueblos y ciudades de Israel, el sistema de defensa central que intentaba derribarlos para evitar la destrucción era la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Cúpula de Hierro")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para ayudar a la Cúpula de Hierro a proteger la tierra de los misiles de Gaza en adelante estaba el sistema de defensa aérea de Israel conocido como la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Honda de David")]), _vm._v(". Aunque la honda original de David ciertamente no estaba hecha de hierro, fue David quien venció las armas de los filisteos y lo hizo empleando hierro.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El rayo y el aguijón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La guerra de octubre provocó el desarrollo y el uso por primera vez de nuevas armas israelíes. Una que entró en desarrollo acelerado fue un sistema de defensa aérea basada en láser llamado "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Iron Beam")]), _vm._v(". Otra que nunca antes se había utilizado en batalla fue el proyectil de mortero guiado por láser diseñado para minimizar los daños colaterales en la guerra al eliminar objetivos específicos con una precisión sin precedentes. Dado que los militantes de Hamas utilizan los centros urbanos como base de guerra y los edificios civiles como cobertura, la nueva arma se volvió especialmente importante. Se utilizó por primera vez a finales de 2023 en la guerra contra Hamas. Sería conocida como Aguijón de Hierro."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así fue como, en la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Cúpula de Hierro")]), _vm._v(", el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Muro de Hierro")]), _vm._v(", la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Viga de Hierro")]), _vm._v(" y el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Aguijón de Hierro")]), _vm._v(", el hierro, el elemento tan crucial en las antiguas guerras de Israel y Filistea, volvió a ocupar un lugar central en las guerras de sus homólogos modernos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Espadas de hierro")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Y había más. Vimos cómo impedían los filisteos que los israelitas forjaran armas de hierro:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("En todo el territorio de Israel no había un solo herrero, pues los filisteos no permitían que los hebreos se forjaran "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("espadas y lanzas")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La traducción aclara el meollo de la cuestión utilizando las palabras "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("espadas de hierro")]), _vm._v(". Aunque el original hebreo no es tan específico, el significado "), _c('span', {
    attrs: {
      "aria-label": "168",
      "epub:type": "pagebreak",
      "id": "page168",
      "role": "doc-pagebreak"
    }
  }), _vm._v("es claro e implícito. Los filisteos usaron "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("espadas de hierro")]), _vm._v(" para derrotar a los israelitas e hicieron todo lo que estuvo en su poder para evitar que los israelitas usaran "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("espadas de hierro")]), _vm._v(" contra ellos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Entonces, en el otoño de 2023, en la mayor guerra librada por los soldados de Israel contra los soldados de Filistea desde la antigüedad, hubo que elegir un nombre para la operación. Se le daría el nombre de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Espadas de Hierro")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("El Libro de Apocalipsis describe cómo el Dragón lucha contra la mujer. Lo que ahora estamos a punto de ver es cómo uno de los elementos de esa antigua visión jugó un papel central en la mañana del 7 de octubre.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "169",
      "epub:type": "pagebreak",
      "id": "page169",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-109"
    }
  }, [_vm._v("Capítulo 45")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-110"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor044"
    }
  }), _vm._v("La inundación del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("n la visión ")]), _c('span', [_vm._v("de Apocalipsis 12 el Dragón intenta destruir a la mujer abrumándola. El Dragón, también llamado la Serpiente, estaba ")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("persiguiendo a la mujer, arrojó por sus fauces agua como un río para que la corriente la arrastrara")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El potamon")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Escupe agua por la boca como un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("potamon")]), _vm._v(". "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Potamon")]), _vm._v(" puede traducirse como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("río, torrente, diluvio o inundación")]), _vm._v(". “Para que él pudiera hacer que ella fuera” "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("potamophoreton")]), _vm._v(". La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("potamophoreton")]), _vm._v(" significa ser arrastrado por un río, por una inundación o por un diluvio. Así que la criatura envía un mal de tal magnitud y fuerza que amenaza con abrumar a la mujer, ahogarla y arrastrarla en su corriente.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("De modo que el Enemigo buscará destruir al pueblo judío enviando contra ellos una inundación, un mal, una calamidad tan grande y poderosa que amenazará su existencia misma. La visión está fijada para el futuro pero, insisto, revela una estrategia central en la guerra del Dragón contra el pueblo judío. La historia judía está llena de inundaciones, desastres abrumadores, diluvios que han amenazado con destrucción. Detrás de ellos estaba la boca del Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La inundación de octubre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Es de destacar que las Escrituras utilizan la imagen de una inundación para simbolizar una invasión masiva de Israel por parte de los ejércitos de "), _c('span', {
    attrs: {
      "aria-label": "171",
      "epub:type": "pagebreak",
      "id": "page171",
      "role": "doc-pagebreak"
    }
  }), _vm._v("sus enemigos. Los asirios y los babilonios arrasaron la tierra en una inundación de destrucción, arrasando todo a su paso.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En Apocalipsis la inundación está conectada con el Enemigo. Es una de sus tácticas primordiales: una calamidad repentina, un mal abrumador, una invasión con oscuridad, un diluvio de destrucción. El vínculo entre el Enemigo y la inundación aparece en una conocida escritura de Isaías:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El Enemigo llega como una inundación."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("A lo largo de este libro se ha observado la conexión entre los acontecimientos del 7 de octubre y el Dragón. Pero ahora tenemos una más: la conexión del 7 de octubre específicamente con la inundación del Dragón. No es casualidad que el 7 de octubre tuviera las características de un fenómeno como la inundación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Esta llegó con una ferocidad repentina. Fue una invasión masiva de los enemigos de la nación, un diluvio sobre la tierra. Con sus miles de cohetes y múltiples brechas en el muro protector de la nación, llegó como una inundación y arrasó la tierra. Barrió esa tierra como un diluvio de muerte y destrucción y arrastró a sus víctimas fuera de sus hogares, sus vidas y su existencia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día del Tufan")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Quienes planearon el 7 de octubre le dieron un nombre a la operación. Dentro de ese nombre estaban las palabras "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Al-Aqsa")]), _vm._v(", en referencia a la mezquita islámica que está en el Monte del Templo. Pronto descubriremos el significado de esas palabras. Pero eran calificativos, añadidos al nombre para describir cuál era la operación, y lo que realmente fue el 7 de octubre.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El nombre que sus creadores dieron a la invasión comenzó con la palabra árabe "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Tufan")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" La invasión fue un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Tufan")]), _vm._v(". ¿Qué significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Tufan")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Tufan significa diluvio, inundación, desbordamiento, cataclismo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Tufan significa aluvión.")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así que el nombre dado a lo que abrumaría a Israel el 7 de octubre fue "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("inundación")]), _vm._v(". Quienes lo llamaron "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Tufan")]), _vm._v(", o Diluvio, sin duda no tenían idea de la visión dada en Apocalipsis y de la inundación enviada por el Dragón para destruir a la mujer, Israel. Tampoco estaban reflexionando sobre la palabra griega "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("potamon")]), _vm._v(". Sin embargo, lo llamaron "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Inundación")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y así como el Dragón produjo el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("potamon")]), _vm._v(", Hamas produjo el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Tufan")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El Enemigo envió su inundación, un diluvio de muerte y destrucción, para abrumar a los hijos de Israel.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "172",
      "epub:type": "pagebreak",
      "id": "page172",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Era una sombra del día en que el Dragón arrojará agua de su boca como una corriente de agua detrás de la mujer “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("para hacer que ella fuera arrastrada")]), _vm._v("”.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("La próxima corriente de misterios traerá lo que le fue dado a Israel en el Monte Sinaí (el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("moedeem")]), _vm._v(", los tiempos señalados, los días santos hebreos) junto con el ángel profanador.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "173",
      "epub:type": "pagebreak",
      "id": "page173",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-111"
    }
  }, [_vm._v("Parte 11")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-112"
    }
  }, [_vm._v("Los días impíos")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "174",
      "epub:type": "pagebreak",
      "id": "page174",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-113"
    }
  }, [_vm._v("Capítulo 46")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-114"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor045"
    }
  }), _vm._v("El profanador")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("l Dragón es ")]), _vm._v("profanador y padre de abominaciones.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Padre de las abominaciones")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La profanación es la consecuencia lógica de la voluntad del Enemigo. Dios es santo. Las cosas de Dios son santas. El Enemigo lucha contra Dios y las cosas de él. De modo que su guerra es, por definición, impía. Para destruir lo santo, trata de invertirlo, volcarlo sobre sí mismo. Dios hace lo que es santo. Dios consagra. El Enemigo busca convertir lo santo en impío. Lo que Dios consagra, el Enemigo lo profana.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Días de profanación")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Insisto, vemos al Enemigo en su papel de imitador. Profana lo santo al crear una imitación alterada: mentiras que imitan la verdad, dioses falsos que imitan a Dios y las tinieblas de lo oculto que imitan los poderes del Espíritu. Es por esta razón que lo oculto está lleno de lo que parecen ser elementos, ceremonias, cánticos y liturgias religiosos o “sagrados”: inversiones de lo sacro y profanaciones de lo santo. El concepto mismo de “adoración a Satanás” se basa en la adoración a Dios. Y así como el calendario de Dios consta de días santos, así el Diablo tiene su propio calendario de días impíos, fiestas y convocaciones, sus días sagrados de profanación.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Ahora abriremos otra dimensión que se esconde detrás de lo que ocurrió esa mañana de octubre en la llanura costera de Israel: los días impíos del Profanador.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "175",
      "epub:type": "pagebreak",
      "id": "page175",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-115"
    }
  }, [_vm._v("Capítulo 47")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-116"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor046"
    }
  }), _vm._v("El sábado negro")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Así quedaron terminados los cielos y la tierra … Dios bendijo el séptimo día y lo santificó porque en ese día descansó de toda su obra creadora."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El Shabat")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Fue el séptimo día el que selló la creación de Dios. Fue entonces cuando Dios descansó de sus obras. Detrás de la palabra traducida como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("descansó")]), _vm._v(" está el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("shabat")]), _vm._v(" hebreo. El séptimo día llegaría a ser identificado por el acto del descanso de Dios. Por lo que se llamaría "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Shabat")]), _vm._v(", el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sabbath")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Dios bendijo el séptimo día")]), _vm._v("”. Por tanto, el sábado era el día de las bendiciones de Dios. También era el día de la santidad. Es en conexión con el sábado que la raíz hebrea de la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("santo")]), _vm._v(" aparece por primera vez en la Biblia. Dios "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("santificado")]), _vm._v(" o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hecho santo")]), _vm._v(" el séptimo día. Ese fue el primero de todos los días santos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Santo invitado")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En el monte Sinaí, a Israel se le ordenó recordar el séptimo día y santificarlo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" El sábado era una señal del pacto de la nación con Dios. Dado que Dios bendijo la creación en el sábado, este también se convirtió en una conmemoración de la creación y de la bendición de Dios sobre ella, una celebración de vida, de paz, de renovación y de restauración.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para el pueblo judío el sábado no solo debía observarse: era para ser acogido. El sábado debía ser recibido en cada hogar judío como si uno estaba acogiendo a un invitado real. Se debían recitar oraciones especiales en su adviento, acoger con bendiciones la entrada del sábado en la casa, honra y alegría."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al ser el séptimo día el sello final de la creación de Dios, eso habla de su finalización y su perfección. Y, como el último de los días, fue visto como una sombra de lo postrero de todas las cosas: el reino de Dios, la era del Mesías, el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Olam Ha Bah")]), _vm._v(" y el reino de los cielos; cuando la guerra ya no existiría, cuando la paz cubriría la tierra, y cuando la presencia de Dios llenaría cada espacio y cada momento, cuando todo sería "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Shabat")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "176",
      "epub:type": "pagebreak",
      "id": "page176",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El sábado alterado")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Mientras el Dragón lucha contra la mujer, el Enemigo lo hace contra el pueblo de Israel, por lo tanto esperaríamos que él también hiciera la guerra contra el sábado, la señal del pacto de Israel. Y así, vuelvo a insistir, no fue casualidad que el acontecimiento más oscuro en la historia judía desde que se inició el Holocausto fuera en sábado. Era el sábado del Diablo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como el sábado iba a ser una conmemoración de la creación de vida, descanso y paz, el Enemigo la invertiría. Lo contrario o inverso de la paz es la guerra; lo inverso de la vida es la muerte. Así, en el día de descanso del pueblo judío, se les quitaría el descanso. Su paz sabática sería rota y reemplazada por la guerra, el horror y la devastación. Y tanto su conmemoración de la creación como la vida se convertirían para ellos, en cambio, en un día de muerte y destrucción.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día de los no invitados")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El día en que la bendición de Dios iba a hacer su entrada en los hogares judíos y cuando cada hogar recibiera su bendición y su presencia, todo fue alterado, revertido. El 7 de octubre se convirtió en el día en que algo muy diferente y oscuro hizo su entrada en los hogares judíos. El día que la presencia de Dios y sus ángeles iba a ser introducida en cada hogar judío, fue el Dragón el que entró y, con él, sus sirvientes. Y en vez de dar la bienvenida a sus invitados del sábado, las familias judías ese día lucharon para impedir que los visitantes del sábado entraran en sus casas y luego a sus habitaciones seguras. Era el día de los no invitados, los impíos e invitados no deseados de un sábado oscuro.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Sombras del infierno")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El día dado para conmemorar y santificar la creación de Dios fue secuestrado por el Enemigo, y la creación sería profanada. En el día que se considera un símbolo del reino de Dios en la tierra, cuando el Mesías reine y la paz cubra la tierra, fue la destrucción la que reinó, fue cuando el Diablo gobernó y la sangre cubrió la tierra. El oscuro sábado del 7 de octubre no fue un anticipo del reino de los cielos sino del infierno.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "177",
      "epub:type": "pagebreak",
      "id": "page177",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La profanación del Tzod")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Las profanaciones del sábado del 7 de octubre incluyeron la violación de las leyes de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tzod")]), _vm._v(". Las leyes de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tzod")]), _vm._v(" prohibían cualquier captura o confinamiento forzado en el día de reposo. Usualmente se referirían a la captura y confinamiento de cualquier vida animal. Pero el sábado del 7 de octubre, los profanadores violaron las leyes de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tzod")]), _vm._v(" al atrapar a civiles inocentes, forzar su confinamiento y tomarlos cautivos como rehenes. Todo el sábado se convirtió en una trampa para capturar la vida humana.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La profanación de Koshair")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Luego estaban las leyes del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("koshair")]), _vm._v(", que prohibían unir dos objetos. El sábado del 7 de octubre también se violaron las leyes de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("koshair")]), _vm._v(", cuando los profanadores ataron a sus rehenes y sus manos detrás de la espalda mientras se los llevaban cautivos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La profanación de Hotzaah")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Luego estaban las leyes de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hotzaah")]), _vm._v(". Estas prohibían la transferencia de cualquier objeto en el día de reposo de un dominio a otro. No se debía llevar un objeto de un dominio privado a un espacio público o de un espacio público a un dominio privado. Pero el sábado 7 de octubre se violaron las leyes de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hotzaah")]), _vm._v(", cuando los profanadores transportaron a hombres, mujeres y niños israelíes desde el dominio privado de sus casas a los dominios públicos de las calles y las vías públicas, y desde las esferas públicas de las reuniones al aire libre a los dominios privados de las cámaras ocultas de su cautiverio.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La profanación de Mavir")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Luego estaban las leyes de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("mavir")]), _vm._v(". Estas prohibían cualquier forma de encender y prender fuego, provocarlo, alimentarlo o propagarlo. De modo que los invasores del 7 de octubre violaron las leyes de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("mavir")]), _vm._v(". Sus armas dispararon mediante la ignición de la pólvora. Colocaron explosivos con fines destructivos. Y prendieron fuego a casas, kibutzim y aldeas israelíes.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "178",
      "epub:type": "pagebreak",
      "id": "page178",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La profanación del Shokhait")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Además estaban las leyes del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("shokhait")]), _vm._v(". Estas prohibían quitar la vida mediante el sacrificio o cualquier otro medio. No hace falta decir que el 7 de octubre violó las leyes del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("shokhait")]), _vm._v(". El Dragón convirtió el sábado de Dios en un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Shabat Shakhet")]), _vm._v(", un día que Israel recordaría como un sábado de matanza.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día más esquivo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los que cometieron esas profanaciones tenían poco o ningún conocimiento de las leyes detalladas que estaban infringiendo. Sin embargo, las violaron, directa y específicamente, una profanación del sábado tras otra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Es irónico que el único pueblo de todos los pueblos a quien se le concedió específicamente un día sagrado de paz y descanso sea el mismo para quien la paz y el descanso han sido lo más esquivo. Al regresar a su antigua patria, el pueblo judío creyó que finalmente había encontrado la paz. De hecho, la nación de Israel renació en un día de reposo. Al mismo tiempo, los enemigos de Israel eligieron ese día de reposo para lanzar una invasión total encaminada a la aniquilación. Así que el Enemigo que busca traer calamidad a Israel y la profanación de lo santo, el 7 de octubre lograría ambas cosas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Sábado negro")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("No pasó mucho tiempo después de la calamidad que el pueblo de Israel le dio al 7 de octubre un nombre hebreo. Hay una frase en castellano y en otros idiomas que se usa para hablar de una reunión ceremonial convocada con el propósito de realizar rituales ocultos, brujería y adoración al Diablo. Esa palabra denota una convocación impía, un sábado satánico.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El nombre que Israel le dio al 7 de octubre fue "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("HaShabbat HashHorah")]), _vm._v(". Es el mismo nombre que se le da a una convocación de Satanás.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Lo llamaron Sábado negro."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Sin embargo, el 7 de octubre fue más que un Shabat. Fue la fecha en que cayeron dos de los días santos anuales de Israel: uno entre los más antiguos "), _c('span', {
    attrs: {
      "aria-label": "179",
      "epub:type": "pagebreak",
      "id": "page179",
      "role": "doc-pagebreak"
    }
  }), _vm._v("y sagrados, y el otro entre los más alegres. ¿Podrían estos también haber jugado un papel en el misterio?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "180",
      "epub:type": "pagebreak",
      "id": "page180",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-117"
    }
  }, [_vm._v("Capítulo 48")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-118"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor047"
    }
  }), _vm._v("La fiesta del dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("l sábado en ")]), _vm._v("que sucedió la invasión no solo fue el primero de todos los días santos dados por Dios a Israel sino también el último.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Shemini Atzeret")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Todos los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("moedeem")]), _vm._v(", los tiempos sagrados señalados, o días santos, dados por Dios en el Monte Sinaí están registrados en Levítico 23. El último de ellos es la Fiesta de los Tabernáculos, conocida en hebreo como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sucot")]), _vm._v(". Al final de Sucot se produce una reunión sagrada que sella tanto la fiesta como el año sagrado. Así está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al octavo día celebrarán una asamblea sagrada en honor al Señor …Es una asamblea sagrada."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("De aquí proviene el día sagrado de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Shemini Atzeret")]), _vm._v(" o la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Reunión del octavo día")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día del regocijo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En Israel el día también sería conocido como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(", o la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Alegría de la Torá")]), _vm._v(". "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" marca la finalización de la lectura anual de la Torá, los primeros cinco libros de la Biblia, tal como figuran en los rollos de la sinagoga. En "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" se terminan las últimas escrituras del antiguo ciclo y comienza la primera del nuevo ciclo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Fiel a su nombre, la festividad está marcada por la alegría y el gozo. Su regocijo se materializa en cantos y bailes, la participación de los niños, ondear pancartas, la entrega de dulces y delicias, la exuberancia, la celebración y el júbilo. La alegría de la festividad no se limita a la sinagoga. Es costumbre que los celebrantes lleven su regocijo fuera de los muros de la sinagoga para cantar, bailar y regocijarse en las calles de sus ciudades y pueblos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En 2023, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" cayó el 7 de octubre.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "181",
      "epub:type": "pagebreak",
      "id": "page181",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El festival de música de Sucot")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Como cada día santo hebreo comienza al atardecer “la noche anterior”, así sucedió con "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(". Comenzó la noche del viernes 6 de octubre y culminó el día 7 de octubre. Fue esa noche anterior que se inició una celebración de música y baile en el desierto israelí. Su nombre oficial era Supernova "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sukkot")]), _vm._v(" Gathering. Debe su nombre a la festividad hebrea que entonces alcanzaba su clímax en Simchat Torá, la celebración de la alegría. Pero el Dragón tenía otros planes.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Alegría invertida")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Cómo se puede profanar un día santo designado para la alegría? ¿Cómo se pervierte un tiempo de regocijo? Se le da la vuelta. Y así se produjo la deformación de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(". El Enemigo transformó el día de alegría de Israel en uno de tristeza. Los sonidos de las risas, del regocijo y de los cantos fueron reemplazados por gemidos de llanto y lamentación. Dios había prometido convertir el duelo de Israel en gozo. Entonces el Enemigo transformó su alegría en luto. Hizo que los que deberían haberse regocijado se pusieran de luto, y que los que deberían haber estado de luto se regocijaran.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La impía Simchat Torá")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así como la profanación de lo santo crea una nueva realidad impía, después de profanar el día santo de Dios, el Diablo creó el suyo. La alegría y el regocijo que deberían haber ocurrido en Israel en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" tuvieron lugar en Gaza y Cisjordania. Las celebraciones masivas no estallaron por la finalización de la Palabra de Dios sino por la sangre derramada de los jóvenes y los aldeanos israelíes. La exuberancia y el júbilo que significó "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" y que el Enemigo había hecho cesar ahora se podían ver en los pueblos y ciudades de los enemigos de Israel. Era la fiesta del Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" el pueblo judío canta y baila de alegría, ahora —en la festividad del Dragón— fueron los enemigos de Israel quienes cantaron y bailaron de alegría.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" el pueblo judío sale de sus casas y sinagogas para celebrar y regocijarse en las calles, ese día fueron los pueblos de Gaza y Cisjordania los que salieron de sus casas y viviendas para celebrar y regocijarse por el derramamiento de sangre judía.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "182",
      "epub:type": "pagebreak",
      "id": "page182",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Y así se informó:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Un vídeo de la Red Al-Jazeera… titulado: “Palestinos "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("superencantados")]), _vm._v(" con la Operación Inundación de Al-Aqsa”, mostraba celebraciones en Gaza, Nablus, Jenin y Belén.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En la ciudad cisjordana de Naplusa:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Dispararon sus armas para "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("expresar su júbilo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Los temas de alegría y júbilo, como en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(", surgieron en más de un relato. Una agencia de noticias lo describió como:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Felicidad y júbilo ")]), _vm._v("por la inundación de Al-Aqsa."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Juego de niños")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En las celebraciones ortodoxas de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(", son los hombres y los niños los que toman la iniciativa en el baile y el regocijo del día."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" Así que, en las calles de Gaza y Cisjordania, fueron los hombres y los niños quienes predominaron bailando y expresando su júbilo por la calamidad de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" tanto los niños como las niñas pueden bailar con sus padres. De forma que, en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(", los enemigos de Israel trajeron a sus niños pequeños para celebrar con ellos, cargándolos sobre sus hombros mientras bailaban de alegría. Los pequeños, en su celebración, incluso imitaron a quienes habían provocado el derramamiento de sangre, como se observa en la descripción de una escena captada en video de ese día:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Se puede ver a una niña blandiendo al aire un rifle y una pistola."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Las banderas de colores")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Portar y ondear banderas coloridas es algo distintivo de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Tora")]), _vm._v(". Así que en ese "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" de 2023, los enemigos de Israel utilizaron la portabilidad y el ondeo de banderas en sus celebraciones: las banderas del celo islámico, del nacionalismo palestino y del terror. Y mientras ningún israelí estaba entonces ondeando sus banderas con alegría en ese día, las celebraciones palestinas e islámicas que reemplazaron a las judías incluían el acto placentero de quemar la bandera israelí."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "183",
      "epub:type": "pagebreak",
      "id": "page183",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día de los dulces")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Otro elemento especial de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" es la entrega de dulces y golosinas. De hecho, la práctica se convirtió en un problema importante justo antes de la calamidad. En los días previos al 7 de octubre, el gobierno israelí anunció que había lanzado una nueva iniciativa en observancia de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(". Distribuirían bolsas de dulces a 250.000 niños israelíes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")]), _vm._v(" A raíz de lo sucedido durante la festividad, la entrega de dulces se vio abrumada por el dolor.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y, sin embargo, ese día "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("se observó")]), _vm._v(" la práctica especial de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(", la entrega de dulces y golosinas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El caramelo del dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El Diablo, como maestro de la imitación, copió las costumbres de la festividad judía que había profanado. Así que en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" se observó la entrega de dulces, pero no por parte de los israelíes. Los relatos de las celebraciones palestinas del 7 de octubre incluyen este detalle:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("La televisión Mayadeen (Líbano), afiliada a Irán, emitió un informe sobre las celebraciones palestinas en Cisjordania, según el cual "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("se repartieron dulces")]), _vm._v(" en Nablus."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Un miembro de las Brigadas Al-Quds "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("distribuye caramelos")]), _vm._v(" en celebración del mortal ataque terrorista perpetrado por Hamas contra Israel… 7 de octubre de 2023."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Por supuesto, no es que los involucrados tuvieran idea de que estaban realizando el acto designado de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(". Era el Imitador el que hacía que lo remedaran sin darse cuenta. La imitación de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(" fue más allá de Gaza y Cisjordania. Un reporte informó:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("En todo Medio Oriente, la gente "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("distribuye golosinas, baila en las calles y celebra")]), _vm._v(" … Desde Ramala hasta Beirut, Damasco, Bagdad y El Cairo, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("la gente distribuyó dulces, bailó y coreó")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("La gente reparte golosinas, baila en las calles y celebra")]), _vm._v(". Esas palabras describen exactamente lo que sucede en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(". Solo que ahora "), _c('span', {
    attrs: {
      "aria-label": "184",
      "epub:type": "pagebreak",
      "id": "page184",
      "role": "doc-pagebreak"
    }
  }), _vm._v("describían la profanación de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(". El Dragón había creado una versión oscura de la festividad de Israel, mientras sus celebrantes bailaban en las calles y comían dulces regocijándose por la sangre judía que había sido derramada.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría el misterio de los tiempos señalados haber determinado no solo la época del año en que caería la calamidad sino el año exacto en el que sucedería?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "185",
      "epub:type": "pagebreak",
      "id": "page185",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-119"
    }
  }, [_vm._v("Capítulo 49")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-120"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor048"
    }
  }), _vm._v("El misterio de los jubileos")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("l más dramático ")]), _c('span', [_vm._v("de los tiempos señalados para Israel ocurre solo una vez cada cincuenta años. En hebreo se llama ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Yovel")]), _c('span', [_vm._v(". Lo conocemos como ")]), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Jubileo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El año de la restauración")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Yovel, ")]), _vm._v("o"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" Jubileo")]), _vm._v(", aparece por primera vez en Levítico 25:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El año cincuenta será declarado santo, y se proclamará en el país la liberación de todos sus habitantes. Será para ustedes un jubileo y cada uno volverá a su heredad familiar y a su propio clan."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El Jubileo era el año de liberación, libertad, retorno y restauración. Si uno había perdido su tierra ancestral, en el año del Jubileo le era restaurada. Cada uno volvía a su posesión. Así, el Jubileo era el año del retorno, cuando los desposeídos regresarían a aquello de lo que habían sido separados.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El jubileo profético")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Ningún otro pueblo ha estado tan separado y durante tanto tiempo de su posesión ancestral como el de Israel de su tierra. Ningún otro pueblo ha regresado jamás de manera tan dramática a su tierra ancestral como lo han hecho los hijos de Israel a la Tierra Prometida. Y a ninguna otra nación se le dio tal ley que ordenara el regreso a la tierra ancestral de uno. ¿Es entonces posible que ambas cosas puedan estar conectadas: la antigua ordenanza de regresar a la posesión ancestral y el regreso del pueblo judío a su tierra originaria?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La respuesta es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sí")]), _vm._v(". El antiguo Jubileo del retorno de Israel y el regreso profético de la nación a la tierra están unidos en un misterio, un misterio jubilar. Es lo que abrí en el libro llamado "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("El Oráculo")]), _vm._v(". Para los propósitos del presente misterio, daré aquí una breve descripción. Aunque nadie sabe "), _c('span', {
    attrs: {
      "aria-label": "186",
      "epub:type": "pagebreak",
      "id": "page186",
      "role": "doc-pagebreak"
    }
  }), _vm._v("cuándo observaron los antiguos israelitas el año jubilar, lo que estamos a punto de ver es cómo el regreso de Israel siguió el ciclo sorprendentemente preciso de cincuenta años de un jubileo profético.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El principio")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los turcos otomanos tomaron la tierra de Israel en el año 1517. En el año del Jubileo la tierra será liberada de quienes la ocupan y devuelta a aquellos a quienes pertenece. Contar siete ciclos de cincuenta años, desde la conquista otomana de esa tierra hasta el séptimo Jubileo, nos lleva al año 1867. Fue ese año cuando comenzó un cambio y se sembraron las semillas de la restauración. En 1867, el sultán otomano promulgó una ley que, en efecto, permitiría e iniciaría la liberación de la tierra de los que la ocupaban al pueblo judío."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En ese mismo año se inició otra restauración. En 1867, el arqueólogo británico Charles Warren tropezó accidentalmente con las ruinas ocultas de la Ciudad de David."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" La Ciudad de David fue la ciudad original de Jerusalén. Otra de las antiguas posesiones de Israel regresó ahora al mundo moderno.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En los años posteriores a 1867, los refugiados judíos empezaron a regresar a su tierra ancestral. Sería conocida como la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Primera Aliyah")]), _vm._v(","), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" el comienzo de la resurrección moderna de Israel. Fue en ese mismo período que la liberación de la tierra por parte del sultán condujo a su recompra, su recuperación, su redención, su replantación y, en última instancia, a su total restauración para quienes la habían perdido en la antigüedad.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El país natal")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El regreso había comenzado, pero la tierra todavía estaba bajo control otomano. Sin embargo, en el año del Jubileo los que ocupan la tierra deben abandonarla. Contar cincuenta años desde 1867 nos lleva al año 1917: el primer jubileo desde la primera liberación y el octavo desde el comienzo del dominio otomano.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En ese año jubilar, mientras la Primera Guerra Mundial hacía estragos en Medio Oriente, los ejércitos del imperio británico, bajo el mando del general Edmund Allenby, entraron en la tierra de Israel. Ante su avance, las tropas otomanas huyeron. Y así, en el año del jubileo, los que ocupaban la tierra comenzaron a abandonarla. Y ese mismo año el gobierno británico "), _c('span', {
    attrs: {
      "aria-label": "187",
      "epub:type": "pagebreak",
      "id": "page187",
      "role": "doc-pagebreak"
    }
  }), _vm._v("emitió la Declaración Balfour, la que, en efecto, prometía la devolución de la tierra al pueblo judío: la segunda restauración."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La Ciudad Santa")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Faltaba una cosa: Jerusalén. Jerusalén era el centro de Israel, su capital eterna. Incluso en el renacimiento de Israel como Estado-nación en 1948, la ciudad santa de Jerusalén se eludió, habiendo sido tomada por Jordania."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" Pero si el Jubileo ordena que uno debe regresar a la posesión perdida, también debe significar el regreso del pueblo judío a Jerusalén. Y las antiguas profecías de las Escrituras lo predijeron.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Contar cincuenta años desde el Jubileo de 1917 nos lleva al año 1967. En junio de 1967 estalló la Guerra de los Seis Días. Al tercer día de esa guerra, los soldados israelíes entraron por las puertas de la antigua ciudad. Se dirigieron al Muro Occidental, donde lloraron y oraron."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")]), _vm._v(" Después de casi dos mil años, el pueblo de Israel regresó a su ciudad más santa. Y así, en el año del Jubileo, “cuando cada uno de ustedes regrese a su posesión”, el pueblo judío regresó a su posesión más sagrada, Jerusalén.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La declaración")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En el año del Jubileo uno no solo regresa a su tierra ancestral, sino que también recibe el derecho legal y el reconocimiento de poseerla. Pero cuando Israel regresó a su antigua capital, el mundo se negó a reconocer eso. Y, sin embargo, ninguna nación podía reclamar tanto el derecho a una ciudad como Israel a Jerusalén. Su título de propiedad era la propia Biblia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Contar cincuenta años desde el Jubileo de 1967 nos lleva al año 2017. Y así fue en 2017, el Jubileo del regreso de Israel a Jerusalén, cuando finalmente se concedería el reconocimiento legal retenido durante cincuenta años. Comenzaría el 5 de junio de ese año cuando el Senado de los Estados Unidos aprobó una resolución que reconocía a Jerusalén como la capital de Israel y pedía al presidente que hiciera lo mismo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")]), _vm._v(" El 5 de junio de 2017 se cumplieron cincuenta años, un Jubileo, desde el inicio de la Guerra de los Seis Días, hasta el día exacto. Más tarde ese año, el presidente emitiría la Declaración de Jerusalén, en la que —por primera vez— Estados Unidos reconocería oficialmente a Jerusalén como la capital de Israel y autorizaría el traslado de la embajada estadounidense allí."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")]), _vm._v(" Fue un momento sin precedentes, no solo para Estados Unidos sino para el mundo. Era la "), _c('span', {
    attrs: {
      "aria-label": "188",
      "epub:type": "pagebreak",
      "id": "page188",
      "role": "doc-pagebreak"
    }
  }), _vm._v("primera vez que un líder o potencia mundial importante reconocía a Jerusalén como la capital de la nación judía desde la antigüedad.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La profanación jubilar")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Y así como el Enemigo lucha contra el retorno y la restauración de Israel, también lucharía contra el instrumento sagrado del retorno y la restauración de Israel, el Jubileo. Por tanto, buscaría su profanación.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Cómo entonces lo profanaría? Invirtiéndolo, alterándolo. Le daría a Israel un Jubileo, no de libertad sino de cautiverio, no de restauración sino de destrucción; le daría un jubileo del Diablo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría haber un evento que tuvo lugar décadas antes del 7 de octubre que contuviera el misterio de qué sucedería ese día y cuándo?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "189",
      "epub:type": "pagebreak",
      "id": "page189",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-121"
    }
  }, [_vm._v("Capítulo 50")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-122"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor049"
    }
  }), _vm._v("El jubileo del Diablo")]), _vm._v(" "), _c('p', {
    staticClass: "pf-2"
  }, [_c('span', {
    staticClass: "DROP-CAP"
  }, [_c('span', {
    staticClass: "_ _idGenCharOverride-3"
  }, [_vm._v("¿")])]), _c('span', {
    staticClass: "_idGenDropcap-2"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("uándo sucedería el ")]), _vm._v("jubileo del Diablo?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El ciclo de cincuenta años")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así como la restauración de Israel siguió el modelo de cincuenta años y el mismo calendario de la ordenanza del Jubileo, el Enemigo seguiría el mismo modelo y el mismo calendario, pero para destruir. Como el quincuagésimo año fue designado para la bendición de Israel, el Enemigo lo reutilizaría para la calamidad. Pero ¿cuándo comenzaría el ciclo de cincuenta años? En el caso de la restauración de Israel, cada restauración jubilar había ocurrido cincuenta años después de la restauración y bendición anterior. La cuenta regresiva del jubileo del Diablo comenzaría no con un evento de bendición y restauración sino de calamidad.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La calamidad de Yom Kipur")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Fue, sin duda, la guerra más desmoralizadora que Israel haya librado jamás desde su renacimiento. Se llamaría “el evento más traumático en la historia de Israel”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")]), _vm._v(" Robaría la confianza de la nación en los años venideros. Haría que su primer ministro considerara el suicidio y luego dimitiera de su cargo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Y llevaría a su máximo ministro de defensa a contemplar que la destrucción de la nación judía estaba al alcance de la mano. Se llamó "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Guerra de Yom Kipur")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Comenzó con una invasión masiva de fuerzas egipcias desde el Sinaí y fuerzas sirias desde los Altos del Golán. Israel fue tomado por sorpresa y abrumado por las enormes cifras involucradas. Egipto entró con doscientos mil soldados y más de dos mil tanques. Del lado israelí había dieciocho mil soldados y trescientos tanques. El ejército egipcio atravesó la línea defensiva israelí de Bar-Lev en cuestión de horas. El ejército sirio superaba en número a las tropas israelíes en una proporción de diez a uno. Israel sufriría tres veces más muertes "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("per cápita")]), _vm._v(" en esa guerra que las que habían sufrido los estadounidenses en más de diez años de la Guerra de Vietnam. La nación finalmente sobreviviría al ataque y le daría la vuelta "), _c('span', {
    attrs: {
      "aria-label": "190",
      "epub:type": "pagebreak",
      "id": "page190",
      "role": "doc-pagebreak"
    }
  }), _vm._v("hasta el punto de que triunfó."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" Pero el trauma de esa invasión y esa guerra permanecería en su conciencia nacional durante el siglo siguiente.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El año designado")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En el ámbito espiritual, fue lo más cerca que estuvo el Dragón en los tiempos modernos de destruir el estado de Israel. Y a partir de ese acontecimiento comenzaría su cuenta regresiva jubilar. De manera que, la mayor calamidad de Israel en los tiempos modernos conduciría a un Jubileo de oscuridad y destrucción.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La Guerra de Yom Kipur tuvo lugar en 1973. Contar cincuenta años hacia adelante nos lleva a 2023. Este sería el año del jubileo del Diablo. La Guerra de Yom Kipur comenzó como una invasión a Israel. Por lo tanto, podríamos esperar que en 2023 llegara otra invasión a la tierra de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En el año del Jubileo el pueblo de Israel debía regresar a sus posesiones, a sus hogares y a su herencia. Pero en el jubileo del Dragón todo sería al revés. El pueblo de Israel sería desarraigado de sus hogares, despojado de sus posesiones y separado de su herencia. En el año del Jubileo los que estaban esclavizados serían liberados. Pero en el jubileo del Dragón los que fueran libres serían esclavizados y llevados cautivos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La invasión jubilar")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Antes de la Guerra de Yom Kippur había señales de una próxima invasión. Pero el gobierno israelí no las tomó en serio, por lo que pagaría un alto precio. Cincuenta años más tarde, se repetiría con señales de advertencia en los días previos al 7 de octubre. Pero las agencias gubernamentales que recibieron esas advertencias no las consideraron serias por lo que, de la misma manera, se pagaría un gran precio.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La guerra de 1973 comenzó como una invasión terrestre masiva. Su Jubileo de 2023 vería otra invasión terrestre masiva de Israel, la primera de este tipo en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cincuenta años")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La invasión de Yom Kipur tomó a Israel por sorpresa, inconsciente y desprevenido. En el Jubileo de 2023, Israel volvería a ser sorprendido, inconsciente y desprevenido ante una calamidad masiva.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la invasión de 1973, Egipto y Siria emplearon gran velocidad y cantidades masivas, y abrumaron al pequeño número de soldados israelíes estacionados en la frontera y en la línea de ataque. Cincuenta años después, Hamas también emplearía una velocidad rápida y un número masivo de "), _c('span', {
    attrs: {
      "aria-label": "191",
      "epub:type": "pagebreak",
      "id": "page191",
      "role": "doc-pagebreak"
    }
  }), _vm._v("personas para invadir Israel. Comenzaría con el lanzamiento de cantidades masivas de cohetes y luego un ataque mortal de invasores armados. Como en la Guerra de Yom Kippur, abrumaría al pequeño número de soldados estacionados en la frontera y en la línea de ataque."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Sábado jubilar")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La Guerra de Yom Kipur se inició en sábado. Los enemigos de Israel sabían que al atacar a la nación judía en su día de descanso, cuando muchas de las funciones de la nación estaban cerradas, obtendrían una enorme ventaja estratégica."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" Cincuenta años más tarde, en el jubileo del Dragón, otro enemigo invadiría la tierra el sábado, el día de descanso de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ese sábado de 1973, la tranquila calma fue rota por los aullidos de las sirenas para advertir a la nación del ataque y para llamar desesperadamente a sus soldados de reserva a que acudieran en defensa de la nación."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" En su año de Jubileo, en 2023, la invasión volvería a ocurrir un sábado. Ese día, la tranquila calma del sábado israelí sería nuevamente violada por los aullidos de las sirenas y los llamados desesperados para que sus reservas acudieran en defensa de la nación.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El santo día jubilar")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Después de la Guerra de Independencia de 1948, la Guerra de Yom Kippur es la más sangrienta de los conflictos bélicos de Israel. El 7 de octubre sería el más sangriento de todos sus días.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La invasión de 1973 sucedió no solo un sábado sino también en un día santo hebreo: Yom Kippur, el Día de la Expiación. La invasión de 2023 tuvo lugar no solo en sábado sino en un día santo hebreo: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Shemini Atzeret")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Simchat Torá")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La invasión de 1973 llevaría a Israel a la guerra. El jubileo del Dragón de 2023 también llevaría a Israel a la guerra.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Y aún había más...")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "192",
      "epub:type": "pagebreak",
      "id": "page192",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-123"
    }
  }, [_vm._v("Capítulo 51")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-124"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor050"
    }
  }), _vm._v("El día 18.263 ")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("l misterio iría ")]), _vm._v("más allá, más allá del ámbito de los años y dentro del misterio de los días.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El misterio de octubre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Era un servicio de adoración el viernes por la noche en Beth Israel. "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("El manifiesto de Josías")]), _vm._v(", mi reciente libro, acababa de publicarse treinta días antes. Para el mensaje de la noche me vi impulsado a hacer algo diferente, a abrir uno de los misterios contenidos en el libro. Antes de que terminara aquella noche de viernes en Estados Unidos, la calamidad que conmocionaría al mundo había comenzado en la Franja de Gaza. Miles de cohetes comenzarían a llover sobre ciudades y pueblos israelíes, y luego llegarían los invasores.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aquellos que habían estado en el servicio ese viernes por la noche y se despertaron el sábado para escuchar las noticias de todo el mundo enviaron un mensaje al ministerio de que el misterio que yo había predicado la noche anterior anunció lo que ahora se estaba desarrollando en todo el mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La predicción de una plaga")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El misterio era el del ciclo jubilar de cincuenta años y sus manifestaciones en los tiempos modernos. Ese misterio había predicho algunos de los acontecimientos mundiales más cruciales. El misterio era preciso, señalaba esos acontecimientos hasta sus fechas exactas. Había predicho la llegada de una plaga, el día exacto en que el COVID-19 llegó oficialmente a suelo estadounidense. Había predicho lo que los medios llamaron “el día en que todo cambió”, cuando el brote se convirtió oficialmente en pandemia, cuando Estados Unidos fue puesto en cuarentena y cuando, para la mayoría de los estadounidenses, la realidad del virus cayó sobre sus vidas. El misterio había predicho estos y otros acontecimientos importantes hasta en sus fechas exactas y basándose en otro misterio que los había precedido miles de años.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "193",
      "epub:type": "pagebreak",
      "id": "page193",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Ese viernes por la noche de octubre, hablé de los cumplimientos del misterio hasta principios de 2023. Pero el misterio no había terminado. La noche del viernes en la que hablé del ciclo jubilar de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cincuenta años")]), _vm._v(" era el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("quincuagésimo")]), _vm._v(" aniversario de uno de los acontecimientos más significativos de 1973. Eran cincuenta años del día en que comenzó la Guerra de Yom Kipur.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La localización del 7 de octubre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El misterio había predicho no solo la calamidad que sobrevendría a Israel sino exactamente cuándo sería.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La invasión de Yom Kipur tuvo lugar en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("octubre de 1973")]), _vm._v(". Por lo tanto, la invasión sucedería en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("octubre de 2023")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dado que la Guerra de Yom Kippur ocurrió un sábado, si se celebrara en su paralelo jubilar, significaría que la calamidad venidera tendría que ocurrir en uno de los sábados de octubre de 2023. Eso lo reduciría a solo uno de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cuatro días")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Uno de los cuatro sábados de octubre de 2023 también tendría que caer en un día santo hebreo, uno de los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("moedeem")]), _vm._v(" sagrados, los tiempos señalados por Dios dados en Levítico 23, al igual que la Guerra de Yom Kipur.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Solo habría una fecha ")]), _vm._v("que caería en el año 2023, en el mes de octubre, en un día de reposo, en un día santo hebreo y en uno de los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("moedeem")]), _vm._v(" sagrados dados en Levítico 23. "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Esa fecha era el 7 de octubre de 2023, el día de la calamidad.")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El primer sábado de octubre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Incluso si no hubiéramos poseído ninguna de estas claves, todavía tendríamos otra. La Guerra de Yom Kippur se lanzó el primer sábado y, el primer sábado de octubre, de 1973. Así, el misterio predeciría una invasión calamitosa de Israel que ocurriría el primer sábado y el primer sábado de ese mes y año. Solo un día cumpliría esos criterios. El primer sábado de octubre de ese año fue el 7 de octubre de 2023.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "195",
      "epub:type": "pagebreak",
      "id": "page195-1",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("La Guerra de Yom Kipur comenzó el 6 de octubre de 1973."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_c('span', {
    attrs: {
      "aria-label": "195",
      "epub:type": "pagebreak",
      "id": "page195",
      "role": "doc-pagebreak"
    }
  }), _vm._v("1")]), _vm._v(" En 2023, el 6 de octubre cayó en viernes. En Estados Unidos, todavía sería el 6 de octubre cuando comenzara la invasión de Israel por parte de Hamas. Pero en Israel era sábado 7 de octubre. Si la invasión hubiera sucedido durante el día, como lo había hecho cincuenta años antes, pero el 6 de octubre, no habría correspondido al día de reposo de la invasión de Yom Kipur. Desde la invasión de Yom Kipur de 1973 hasta la invasión de Simchat Torá de 2023 hubo un Jubileo, cincuenta años, de sábado a sábado.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y, sin embargo, la diferencia de ese día, el 6 de octubre y el 7 de octubre, abrirá otro misterio más.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El contraataque del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En la visión de Apocalipsis 12 emergen una serie de patrones. El Dragón busca devorar al hijo de la mujer, el Mesías. Pero falla. Luego declara la guerra a la mujer que dio a luz al niño. A la mujer se le dan alas de águila para escapar. Luego, el Dragón envía una inundación contra la mujer. La tierra se traga el diluvio. El Dragón entonces arde de ira contra la mujer y hace la guerra a sus otros hijos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El Dragón intenta destruir a la mujer pero, finalmente, fracasa. Así que el Enemigo ha tratado de destruir al pueblo judío por años y ha fracasado. Como el Dragón no logra destruir a la mujer, lo intenta de nuevo con una estrategia diferente. Toma represalias; resiste, lanza un contraataque.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El contraataque profético")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuando Israel salió de la Guerra de los Seis Días, logró una de las mayores victorias militares de la historia. Pero también fue el cumplimiento de la profecía bíblica. Había recuperado Jerusalén. ¿Cuál sería la respuesta del Dragón? Se enfurecería, intentaría revertir su pérdida y tomaría represalias. Él devolvería el golpe. ¿Cómo vendría eso?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Vendría en forma de la Guerra de Yom Kipur. Sin entender el significado de la Guerra de los Seis Días, no se puede entender la Guerra de Yom Kipur. La invasión de Yom Kippur fue una respuesta directa a la Guerra de los Seis Días, tanto militar como políticamente. Fue el contraataque de los enemigos de Israel en un intento por deshacer la victoria de Israel en la Guerra de los Seis Días.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Sin embargo, más allá de los ámbitos político y militar está el espiritual. La profecía del fin de los tiempos, el regreso del Mesías y la venida del "), _c('span', {
    attrs: {
      "aria-label": "196",
      "epub:type": "pagebreak",
      "id": "page196",
      "role": "doc-pagebreak"
    }
  }), _vm._v("reino de Dios requieren que el pueblo judío regrese a Jerusalén. Durante casi dos mil años, el Dragón había mantenido en gran medida al pueblo judío alejado de Jerusalén. Ahora todo estaba deshecho. Y así, en 1973, el Dragón lanzaría una guerra tan repentina, intensa y masiva que amenazaría la existencia misma de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día 2.315")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Entonces, ¿cuánto tiempo pasaría desde la guerra mediante la cual se cumplieron los propósitos proféticos de Dios hasta la guerra en la que el Enemigo contraatacó para deshacer esos propósitos? ¿Cuánto tiempo pasaría desde la Guerra de los Seis Días hasta la Guerra de Yom Kipur? La Guerra de los Seis Días comenzó el 5 de junio de 1967."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" La Guerra de Yom Kippur comenzó el 6 de octubre de 1973. Desde el día que inició la Guerra de los Seis Días hasta el que inició la Guerra de Yom Kippur pasaron 2.315 días.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A la restauración física de Jerusalén al pueblo judío en 1967 le siguió cincuenta años después una restauración legal en 2017. Si uno cuenta cincuenta años, exactamente cincuenta, desde el día en que comenzó la Guerra de los Seis Días, la cuenta termina el 5 de junio de 2017, el día exacto en que el Senado de los Estados Unidos aprobó la resolución que reconoce a Jerusalén como la capital de Israel, otra victoria y avance en la restauración de Israel. Por lo tanto, se seguiría que el Dragón contraatacaría esa victoria y restauración. ¿Cuando?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si la Guerra de los Seis Días y la Guerra de Yom Kippur estuvieron separadas por 2.315 días, ¿qué pasa entonces con sus dos jubileos, sus dos cincuenta años de aniversario? Si partimos del quincuagésimo aniversario de la restauración de Jerusalén, el día de la resolución sobre Jerusalén en el Senado de los Estados Unidos el 5 de junio de 2017, y contamos 2.315 días, ¿en qué día termina la cuenta regresiva?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Debido a la variación de los años bisiestos entre los dos períodos, la cuenta atrás no termina el viernes 6 de octubre. El día 2.315 cae el 7 de octubre de 2023, fecha exacta de la invasión.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día 18.263")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Un misterio más en cuanto a días —de Jubileo en Jubileo— desde el inicio de la Guerra de los Seis Días, el 5 de junio de 1967, hasta su Jubileo el 5 de junio de 2017, el día de la Resolución de Jerusalén —desde la única "), _c('span', {
    attrs: {
      "aria-label": "197",
      "epub:type": "pagebreak",
      "id": "page197",
      "role": "doc-pagebreak"
    }
  }), _vm._v("restauración hasta la otra— ¿cuánto tiempo fue? ¿Cuántos días hay en el ciclo jubilar de la restauración de Jerusalén? 18.263 días.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como el Enemigo es un imitador, ¿qué pasaría si imitara el ciclo del Jubileo de Jerusalén? ¿Qué pasaría si tomara el número exacto de días en el ciclo de la restauración de Jerusalén y comenzara la cuenta regresiva no desde un día de victoria sino desde un día de calamidad, no para restaurar sino para contraatacar y deshacer? A partir de la invasión que inició la Guerra de Yom Kippur el 6 de octubre de 1973, y contando hacia adelante los 18.263 días del ciclo de Jerusalén, ¿a qué conduce ello? Debido a la variación de los años bisiestos en los dos ciclos, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("no conduce al")]), _vm._v(" 6 de octubre de 2023. ¿Cuándo es el día 18.263?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("El día 18.263 es el 7 de octubre de 2023")]), _vm._v(". Cae en el día exacto de la calamidad: el día del contraataque del Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría lo que ocurrió aquella mañana de octubre y lo que siguió a continuación ser una sombra de lo que estaba por venir? Ahora abrimos el fin de los tiempos.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "198",
      "epub:type": "pagebreak",
      "id": "page198",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-125"
    }
  }, [_vm._v("Parte 12")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-126"
    }
  }, [_vm._v("El fin de los tiempos")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "199",
      "epub:type": "pagebreak",
      "id": "page199",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-127"
    }
  }, [_vm._v("Capítulo 52")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-128"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor051"
    }
  }), _vm._v("El fin de los tiempos")]), _vm._v(" "), _c('p', {
    staticClass: "pf-2"
  }, [_c('span', {
    staticClass: "DROP-CAP"
  }, [_c('span', {
    staticClass: "_ _idGenCharOverride-3"
  }, [_vm._v("¿")])]), _c('span', {
    staticClass: "_idGenDropcap-2"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("uál es el ")]), _vm._v("fin de los tiempos? Las palabras son tan antiguas como la Torá, el comienzo mismo de las Escrituras. En hebreo se lee "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("akharit hayamim")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Akharit Hayamim")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La frase también puede traducirse como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("los últimos días, los últimos tiempos, los tiempos finales, el remanente de los días, el último fin de los días ")]), _vm._v("y"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" los últimos tiempos")]), _vm._v(". Las palabras no se refieren al “fin del mundo”, sino al fin de la era, los días que preceden y marcan el comienzo de la venida del Mesías y el reino de Dios. Una de las primeras apariciones del término se encuentra en las últimas palabras de Moisés a Israel:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y al cabo del tiempo, cuando hayan vivido en medio de todas esas "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("angustias")]), _vm._v(" y dolores, volverán al Señor su Dios y escucharán su voz."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El vocablo traducido aquí como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("volverán")]), _vm._v(" es la palabra hebrea "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("shuv")]), _vm._v(". "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Shuv")]), _vm._v(" también se puede representar como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("regreso")]), _vm._v(". El fin de los días estará, pues, marcado por el regreso. Será testigo del regreso del pueblo judío a su patria y de su retorno definitivo a Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Días del Enemigo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La palabra traducida como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("angustia")]), _vm._v(" es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tsar")]), _vm._v(" en hebreo. "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Tsar")]), _vm._v(" también puede traducirse como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tribulación, adversidad, aflicción ")]), _vm._v("y"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" tristeza")]), _vm._v(". La profecía bíblica habla constantemente del fin de los días como un tiempo de gran tribulación para la nación de Israel y el mundo, un tiempo de guerra, calamidad y destrucción sin precedentes.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tsar")]), _vm._v(" también puede traducirse como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("enemigo ")]), _vm._v("o"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" adversario")]), _vm._v(". El fin de los días también estará marcado por el empoderamiento de los enemigos de Dios y de los enemigos de Israel, y se librará una guerra contra ambos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El fin de los días también estará marcado por otro "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tsar")]), _vm._v(", otro enemigo, el Enemigo, el Dragón. No es casualidad que el Dragón desempeñe un "), _c('span', {
    attrs: {
      "aria-label": "200",
      "epub:type": "pagebreak",
      "id": "page200",
      "role": "doc-pagebreak"
    }
  }), _vm._v("papel clave en el Libro de Apocalipsis. Los últimos días estarán marcados por el mal y la apostasía, cuando la inmoralidad aumentará y “el amor de muchos se enfriará”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al unir las piezas, el fin de los tiempos estará marcado por el regreso, la adversidad, el mal, la guerra contra Dios e Israel, la persecución, la tribulación, la calamidad y el Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La profecía del pastor")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Imagínate que eres un pastor en el antiguo Medio Oriente. Tu tecnología no supera la del cayado de un pastor ni la de las piedras de una almazara. Pero tienes las Escrituras y, dentro de ellas, las profecías de los últimos días. Con solo eso, la Palabra de Dios, ¿qué podrías saber del futuro? ¿Qué te diría?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Eso te hablaría de un futuro en el que el pueblo judío habría regresado de una dispersión global a su antigua tierra, y en el que la nación de Israel resucitaría. Te diría que en ese futuro el foco del mundo entero estaría fijo en Israel. Te diría que las naciones considerarían a Israel como fuente de controversia y conflicto, y que se librarían guerras en relación con él. Te diría que el mundo en ese momento estaría marcado por la apostasía, el alejamiento de Dios, de la fe y de lo que durante mucho tiempo se había aceptado como moralidad, un mundo que promovía una moralidad antibíblica, un mundo sobre el cual la sombra de destrucción se avecinaba.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por lo tanto, sin ninguna tecnología mayor que la de nuestras varas de pastor, se podría hacer lo que ningún científico, ningún grupo de expertos y ninguna supercomputadora de la actualidad podría empezar a hacer. Se podría describir el mundo moderno siglos antes de su llegada.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En otras palabras, si hay una edad que se corresponda con lo que la profecía bíblica predice sobre el fin de los días, ya estamos allí.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La señal del fin")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("No es casualidad que el 7 de octubre de 2023, el peor día en la historia del Estado judío, encarnara la dinámica central profetizada de los últimos días: un Israel resucitado, un Israel en el centro de la controversia global y una campaña que buscaría erradicarlo. El 7 de octubre estuvo saturado de señales del fin de los tiempos. Como fue el día de las obras y el poder del Enemigo, así el fin de los tiempos estará marcado por muchos días de las obras y los poderes del Enemigo. Por tanto, lo que ocurrió ese día nos "), _c('span', {
    attrs: {
      "aria-label": "201",
      "epub:type": "pagebreak",
      "id": "page201",
      "role": "doc-pagebreak"
    }
  }), _vm._v("dará una idea de los días venideros, las tácticas, los planes y las estrategias del Dragón en los últimos tiempos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El 7 de octubre, el Enemigo atacó a Israel con una embestida masiva diseñada para arrasar todas las defensas, resistencias y vallas de protección. Esa es la estrategia del enemigo. A medida que su influencia aumente en los últimos días, buscará derribar toda resistencia, todas las defensas y todos los cercos de protección atacando las obras y los propósitos de Dios en una agresión masiva y abrumadora. Así como la operación que vino contra Israel llevó el nombre de Inundación, en los últimos tiempos el Enemigo vendrá sobre el mundo como una inundación abrumadora. Esta vendrá a través de la cultura, el gobierno, los medios de comunicación, las leyes, la tecnología, el adoctrinamiento, la propaganda, la economía, la religión y todos los medios a su disposición, incluida la guerra literal y física. Tratará de barrer a aquellos que se opongan a su agenda.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los días de la profanación")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El 7 de octubre, como hemos visto, estuvo marcado por la profanación. Por eso los últimos días se caracterizarán por la profanación, el sacrilegio y la contaminación. El Dragón buscará contaminar la creación de Dios, torcer las obras de Dios y subvertir, invertir y pervertir la imagen de Dios dondequiera que aparezca. Y así vendrá la profanación del hombre, de la mujer, del niño, de la sexualidad, del matrimonio, de la fe, del culto, de la vida, de todas las cosas. Así como la profanación del 7 de octubre imitó los tiempos señalados de Dios, también los últimos tiempos estarán marcados por la imitación, un dios falso y un mesías falso.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los días de la manía")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así como el 7 de octubre fue una manifestación del orgidzo del Dragón, su ira, los últimos días serán impulsados por el orgidzo del Dragón, gobernados y poseídos por él. Se manifestará en una animosidad creciente hacia las cosas de Dios en todos los ámbitos de la cultura y la vida, y en una guerra total para destruirlas. Así como los actos cometidos ese día fueron demoníacos, impulsados por el espíritu del Dragón, al final de la era el espíritu del Enemigo tomará posesión de la cultura mundial. Las naciones se verán impulsadas por él, los gobiernos gobernados por él y las culturas transformadas por él. Llevará a muchos a abrazar lo que alguna vez supieron que era malo, a practicarlo, regocijarse y celebrarlo. Bajo su influencia los "), _c('span', {
    attrs: {
      "aria-label": "202",
      "epub:type": "pagebreak",
      "id": "page202",
      "role": "doc-pagebreak"
    }
  }), _vm._v("puros serán contaminados, los buenos condenados y, como el 7 de octubre, se derramará la sangre de los inocentes. Eso dará origen a movimientos de irracionalidad, una manía satánica.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría un símbolo destacado de la guerra de Palestina contra Israel estar relacionado con una visión del Libro de Apocalipsis?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "203",
      "epub:type": "pagebreak",
      "id": "page203",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-129"
    }
  }, [_vm._v("Capítulo 53")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-130"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor052"
    }
  }), _vm._v("Los colores del Apocalipsis")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("n Apocalipsis 6 ")]), _vm._v("se abre un rollo encuadernado con siete sellos. A medida que se quita cada sello, ocurre un evento apocalíptico en la tierra conectado con el juicio allí. Los primeros cuatro sellos están vinculados a cuatro caballos y cuatro jinetes.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los cuatro jinetes")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Del primer jinete está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El jinete llevaba un arco; se le dio una corona y salió como vencedor, para seguir venciendo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Y así el primer acontecimiento apocalíptico está vinculado a la conquista. Del segundo jinete está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Al jinete se le entregó una gran espada; se le permitió quitar la paz de la tierra y hacer que sus habitantes se mataran unos a otros."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El segundo acontecimiento apocalíptico está, pues, relacionado con el conflicto y la guerra. Del tercer jinete está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Cuando el Cordero rompió el tercer sello, oí al tercero de los seres vivientes que decía: “¡Ven!”. Miré y apareció un caballo negro. El jinete tenía una balanza en la mano. Y oí como una voz en medio de los cuatro seres vivientes que decía: “Un kilogramo de trigo o tres kilogramos de cebada por el salario de un día; pero no dañes el aceite ni el vino”. "), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El tercer acontecimiento apocalíptico está vinculado al hambre, la miseria o la hambruna. Y del cuarto jinete está escrito:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "204",
      "epub:type": "pagebreak",
      "id": "page204",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Miré y apareció un caballo amarillento. El jinete se llamaba Muerte y el Hades lo seguía de cerca."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El cuarto acontecimiento está encarnado por la muerte.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los cuatro jinetes han llegado a ser conocidos como los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Cuatro Jinetes del Apocalipsis")]), _vm._v(". “Y se les otorgó poder sobre la cuarta parte de la tierra, para matar por medio de la espada, el hambre, las epidemias y las fieras de la tierra”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" Juntos constituyen una imagen siniestra del juicio venidero.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El azul y el blanco")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El chal de oración judío, el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("talit")]), _vm._v(", debe ser hecho de tela blanca enmarcada con rayas, idealmente de color azul. La bandera israelí fue adoptada oficialmente durante los primeros congresos sionistas a finales del siglo diecinueve, cincuenta años antes de la resurrección de la nación. Consistía en una tela blanca con una estrella de David azul enmarcada con dos franjas de color azul. Se parecía al paño de oración judío. Eso no fue un accidente. La bandera nacional de Israel se creó siguiendo el patrón del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("talit")]), _vm._v(" hebreo. Por tanto, los colores y patrones representados en la bandera de Israel están conectados con la oración, la adoración y Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La bandera palestina")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestina")]), _vm._v(" ya se ha convertido en el pararrayos del odio antiisraelí en todo el mundo. ¿Es posible que el asunto de Palestina pueda utilizarse para plantar semillas que fructifiquen en el apocalipsis? La bandera de Palestina fue adoptada por la Organización de Liberación de Palestina en 1964. Se basó en una bandera anterior que representaba la revuelta árabe. Esa bandera fue creada en la última parte de la Primera Guerra Mundial, al mismo tiempo que nacía la Declaración Balfour, que prometía al pueblo judío una patria en Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El caballo blanco")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La bandera de Palestina consta de un triángulo, tres franjas y cuatro colores vinculados a cuatro dinastías árabes. Pero más allá de las dinastías los cuatro colores de la bandera coinciden con algo más que nadie pretendía.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "205",
      "epub:type": "pagebreak",
      "id": "page205",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("El primero de los cuatro caballos del apocalipsis se llama, en griego, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("huppos leukos")]), _vm._v(". La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("leukos")]), _vm._v(" proviene del vocablo griego que quiere decir "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("luz")]), _vm._v(". Eso significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("blanco")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Miré y he aquí un caballo blanco")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El primer color de la bandera de Palestina es el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("blanco")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El caballo rojo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El segundo de los cuatro caballos se llama, en griego, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("huppos purrhos")]), _vm._v(". "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Purrhos")]), _vm._v(" proviene de la palabra griega que significa fuego. Quiere decir "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("rojo ")]), _vm._v("o"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" rojo brillante")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Otro caballo, de color rojo fuego, salió")]), _vm._v(". "), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El segundo color de la bandera de Palestina es el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("rojo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El caballo negro")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El tercero de los cuatro caballos se llama, en griego, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("huppos melos")]), _vm._v(". La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("melos")]), _vm._v(" significa negro.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Entonces miré, y he aquí un caballo negro")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El tercer color de la bandera de Palestina es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("negro")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El caballo verde")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El último de los cuatro caballos se llama, en griego, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("huppos khloros")]), _vm._v(". La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("khloros")]), _vm._v(" se traduce comúnmente aquí como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("pálido")]), _vm._v(". Pero "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("khloros")]), _vm._v(" significa algo más que pálido. De hecho, cada dos veces que aparece en el Nuevo Testamento, se traduce de otra manera. Se utiliza tres veces para describir el color de la hierba. Significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("verde")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Entonces miré, y he aquí un caballo verde")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El último color de la bandera de Palestina es el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("verde")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "206",
      "epub:type": "pagebreak",
      "id": "page206",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La bandera de los colores apocalípticos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así que, la bandera palestina, la bandera que fue creada para eliminar a la nación de Israel, la bandera que se ondea en todo el mundo con rabia contra la nación de Israel, resulta que lleva los cuatro colores de los cuatro caballos de los cuatro jinetes del Apocalipsis. No solo eso, sino que las naciones del mundo que enarbolan esos cuatro colores en sus banderas son casi exclusivamente las mismas que se han opuesto a la nación judía, que han librado de manera activa la guerra contra ella, o que están profetizadas que lo harán al final del siglo: blanco, rojo, negro y verde, los colores de Palestina, los colores del 7 de octubre y del apocalipsis.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría la ola de odio y rabia que arrasó el mundo después del 7 de octubre darnos una pista de los últimos días?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "207",
      "epub:type": "pagebreak",
      "id": "page207",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-131"
    }
  }, [_vm._v("Capítulo 54")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-132"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor053"
    }
  }), _vm._v("Las ranas")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y vi salir de la boca del dragón, de la boca de la bestia y de la boca del falso profeta tres espíritus malignos que parecían ranas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Espíritus … que parecían ranas”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La mayor parte de lo que se revela en la visión de Apocalipsis 12 tiene que ver con el fin de los tiempos. Es entonces cuando la guerra del Dragón contra la mujer alcanzará su mayor intensidad. Aunque la guerra se manifiesta en la tierra, en última instancia es espiritual. Según la profecía bíblica, finalmente engullirá al mundo entero. Entonces, a medida que se acerca ese día, esperaríamos ver erupciones del orgidzo del Dragón, estallidos de ira y odio contra el pueblo judío y la nación de Israel, y también que esas erupciones y brotes se extiendan por todo el mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Apocalipsis 16 describe espíritus inmundos “como ranas” que emergen de la boca del Dragón y sus instrumentos. Se dirigen a “los reyes del mundo”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" El objetivo de los espíritus es atraer al mundo a la voluntad del Dragón y a emprender la guerra contra Israel. ¿Podemos ver sombras de ese día venidero incluso ahora?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La furia global")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Aunque, inmediatamente después del 6 de octubre, hubo declaraciones de condolencia emitidas en todo el mundo, la respuesta más sorprendente a la calamidad no fue la compasión o la simpatía, sino la celebración. El orgidzo del Dragón que había poseído a los invasores del 7 de octubre ahora traspasaría las fronteras de Filistea y explotaría en todo el mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Las celebraciones y manifestaciones que se originaron entre los palestinos ahora estallaron en todo el mundo islámico, desde Egipto hasta Irak, desde Líbano hasta Irán. Pero no se detendrían ahí. También estallarían por toda Europa, desde Alemania hasta el Reino Unido. Incluso estallarían en la más proisraelí de las potencias mundiales: Estados Unidos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "208",
      "epub:type": "pagebreak",
      "id": "page208",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Frenesí sangriento")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La celebración no es una respuesta normal a las atrocidades y asesinatos en masa de cualquier pueblo. Tampoco es normal que quienes cometen atrocidades y asesinatos contra civiles inocentes sean aclamados como héroes. Pero las víctimas en este caso no fueron ningún pueblo: fueron judíos. Así que no se aplicaron las leyes normales, ni se sostuvieron las barreras del pensamiento racional. El fenómeno no era normal ni natural, sino impulsado por una entidad cuya naturaleza era a la vez antinatural y anormal.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Por qué pasó eso? La naturaleza del Dragón es depredadora. Para muchos depredadores, el olor de la sangre los impulsa a cazar y devorar a sus presas. En algunas especies, el olor de la sangre les provoca un frenesí asesino. Después del 7 de octubre, fue como si la matanza del pueblo judío hubiera desencadenado un frenesí sangriento en el reino espiritual que se manifestó en erupciones de ira y celebraciones de asesinato en todo el mundo. Y ni siquiera es que la rabia tuviera sus raíces en la respuesta de Israel al 7 de octubre de tratar de proteger a su pueblo de futuras calamidades. El frenesí generalizado de esa ira comenzó inmediatamente después de que se supo que se había derramado sangre judía.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El espíritu del depredador")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El depredador de Apocalipsis 12, el Dragón, persigue y caza a la mujer. A raíz del 7 de octubre, el mundo pudo vislumbrar esa cacería cuando el espíritu del Dragón desencadenó el acecho de los hijos de la mujer. En las ciudades occidentales, los judíos ortodoxos fueron perseguidos y atacados en las calles. Los judíos ahora escondían sus estrellas de David debajo de sus camisas y sus kipás debajo de sus gorras de béisbol. En la ciudad de Nueva York, los estudiantes judíos tuvieron que ser encerrados dentro de la biblioteca de la escuela para salvarlos de la violencia de la turba antiisraelí que arrasaba afuera. En los dos meses posteriores al 7 de octubre, los crímenes de odio contra los judíos se multiplicaron casi cinco veces más que un año antes. Y en todo el mundo los hijos de Israel fueron vilipendiados, atacados, perseguidos, aterrorizados y abusados. Y los rostros de los israelíes que Hamas mantenía como rehenes fueron arrancados de las paredes en las que estaban colocados o desfigurados."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "209",
      "epub:type": "pagebreak",
      "id": "page209",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Esvásticas sobre el despertar")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Y en el mundo del movimiento “Woke”, en el que la agresión y las sensibilidades violadas invariablemente son objeto de las más severas condenas y represalias, el asesinato del pueblo judío fue recibido con silencio o hasta aplausos. Fue entonces cuando el pueblo judío de todo el mundo despertó al darse cuenta de que la nueva izquierda que había pregonado las virtudes de la tolerancia y la inclusión estaba, en realidad, llena de una virulenta cepa de odio judío.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los grupos dedicados a contrarrestar el maltrato a las mujeres, incluidos los que operan dentro de las Naciones Unidas, al tratarse de violaciones y asesinatos de mujeres israelíes, guardaron un extraño y atronador silencio. Asimismo, las organizaciones dedicadas a la protección de los niños descubrieron que cuando se trataba del asesinato de niños judíos, no tenían nada que decir. Un capítulo estadounidense de la organización Black Lives Matter celebró el 7 de octubre publicando imágenes de hombres armados de Hamas volando en parapentes hacia suelo israelita para masacrar a los aldeanos. Las imágenes mostraban a los pistoleros como héroes. Y las manifestaciones en todo el mundo incluyeron caricaturas antisemitas al estilo nazi, cánticos de “Gasear a los judíos” y ondear esvásticas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El 7 de octubre estuvo lejos de ser la primera explosión de ira del Dragón contra el pueblo judío desde el renacimiento de Israel. No sería la última. Pero fue especial por el inmenso alcance y escala de la ira global contra el pueblo judío que encendió. Sirvió como un recipiente a través del cual la furia del Dragón contra Israel explotó en todo el mundo, un precursor de la salida de los espíritus inmundos de Apocalipsis que, de la misma manera, se apoderarán de la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El mundo filisteo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El virus filisteo infectó al mundo. Mientras que los antiguos filisteos celebraban la calamidad judía y el derramamiento de sangre en las calles de Filistea, las tenebrosas celebraciones habían hecho metástasis y se habían extendido por todo el mundo. Ahora se los podía ver en las calles de Londres, en los tribunales de Harvard,"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" y en los reportajes televisados de los canales de noticias por cable. Las semillas de la antigua Filistea se estaban sembrando en las naciones. Su profundo odio hacia Israel se estaba convirtiendo en una parte central de la cultura global. El mundo estaba "), _c('span', {
    attrs: {
      "aria-label": "210",
      "epub:type": "pagebreak",
      "id": "page210",
      "role": "doc-pagebreak"
    }
  }), _vm._v("asumiendo cada vez más los atributos, la naturaleza y el odio de los antiguos enemigos de Israel. Se estaba convirtiendo en una filistea global.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría una de las profecías bíblicas más controvertidas del fin de los tiempos estar relacionada con los acontecimientos del 7 de octubre?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "211",
      "epub:type": "pagebreak",
      "id": "page211",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-133"
    }
  }, [_vm._v("Capítulo 55")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-134"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor054"
    }
  }), _vm._v("Los asaltantes de Ezequiel")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("n el Libro ")]), _vm._v("de Ezequiel hay una profecía única que ha suscitado mucha atención y controversia entre los estudiosos del fin de los tiempos. Muchos creen que predice el próximo gran evento profético.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Después de muchos días”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La profecía se anuncia en Ezequiel 38 y 39. Aunque el lenguaje incluye imágenes de espadas y escudos, se cree que estas corresponden a sus contrapartes modernas y son el único lenguaje que podría haber sido empleado y comprendido por el profeta y su época. Pero hay muchos otros elementos de la profecía de Ezequiel que sitúan su cumplimiento firmemente al final de la era.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Primero, no hay evidencia de que lo predicho se haya cumplido en tiempos antiguos. Y dado que se trata de Israel, la única otra época en la que podría cumplirse es la de la nación judía moderna. Además, se refiere exclusivamente a naciones que no tienen frontera con la tierra de Israel, varias de las cuales están considerablemente distantes de las demás. Es por esa razón que varios comentarios bíblicos de épocas pasadas han tomado la profecía como figurativa y no literal. No creían que naciones tan geográficamente distantes entre sí pudieran desempeñar un papel en una invasión militar coordinada. Pero ese escenario es más que posible en el mundo moderno. Más allá de todo esto yace el contexto dado en la profecía misma:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Al cabo de muchos días se te encomendará una misión. Después de muchos años invadirás un país que ha sido rescatado de la espada. Ese país estuvo en ruinas durante mucho tiempo, pero ha sido reunido de entre los muchos pueblos en los montes de Israel. Ha sido sacado de entre las naciones y ahora vive confiado")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La profecía es para muchos días, una manera bíblica de denotar edades."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Está señalada para muchos días [los últimos años], una frase que denota específicamente el fin de la era. Se hace referencia a Israel como el que "), _c('span', {
    attrs: {
      "aria-label": "212",
      "epub:type": "pagebreak",
      "id": "page212",
      "role": "doc-pagebreak"
    }
  }), _vm._v("ha sido “rescatado de la espada” y “reunido de entre los muchos pueblos”. Esto nunca fue tan cierto en el caso de Israel como lo es en la actualidad. Además, habla de que la tierra “estuvo en ruinas durante mucho tiempo”. Esto tampoco se ha cumplido nunca tanto como en los tiempos modernos, cuando la tierra de Israel había permanecido desolada durante casi dos mil años.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La invasión del fin de los tiempos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Por tanto, ¿qué predice la profecía? Describe un ataque coordinado de naciones enemigas contra el Israel resucitado, una invasión masiva. Las naciones invasoras dirán:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Invadiré un país indefenso; atacaré a gente pacífica que habita confiada en ciudades sin muros, puertas y cerrojos. Lo saquearé y me llevaré el botín. Atacaré a las ciudades reconstruidas de entre las ruinas, al pueblo reunido allí de entre las naciones."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La descripción dada de la nación invadida, insisto, coincide con el Israel moderno después de su resurrección en el siglo veinte. Según la profecía, el ataque abrumará a la nación judía y tragará la tierra. Será entonces cuando Dios intervendrá y juzgará a los invasores."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" El evento parece servir como preludio y puente hacia el conflicto global predicho en Apocalipsis.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Identificación de los actores")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El 7 de octubre fue la primera invasión masiva de Israel en medio siglo. Si las naciones citadas en la profecía de Ezequiel van a lanzar una futura invasión de tal magnitud sobre Israel, ¿es posible que estén, de alguna manera, relacionadas con la invasión de octubre? ¿Y entonces es posible que la invasión de octubre sea precursora del cumplimiento de la profecía de Ezequiel?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Cuáles naciones? Sus nombres, tal como aparecen en la profecía, son Gog, Magog, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ésec, Tubal, Persia, Cus, Fut, Gomer ")]), _vm._v("y"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" Togarma")]), _vm._v(". También aparece la palabra Rosh,"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" pero como no podemos estar seguros de si se trata de un nombre propio que denota una nación o simplemente la palabra hebrea que significa cabeza o jefe, nos centraremos en aquellas de las que podemos estar seguros. Dejando, por ahora, la pregunta, la controversia y la posibilidad de que la profecía contenga una conexión con la Rusia "), _c('span', {
    attrs: {
      "aria-label": "213",
      "epub:type": "pagebreak",
      "id": "page213",
      "role": "doc-pagebreak"
    }
  }), _vm._v("moderna, comenzaremos a identificar a los invasores antiguos y profetizados, y revelaremos un secreto que todos tienen en común.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El misterio de Kush")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Quién es Kush o Cus? Los kushitas o cusitas eran un pueblo antiguo que vivía en la costa noreste de África junto al Mar Rojo. Gran parte de su historia se desarrolló a la sombra de Egipto. Los reinos de Cus y Egipto se invadieron y subyugaron alternativamente. La palabra Kush a menudo se ha traducido como Etiopía en la Biblia. Pero esto no debe confundirse con la nación que ahora lleva ese nombre. Entonces, ¿qué nación moderna comprende la tierra y corresponde a la antigua nación de Cus? La respuesta es "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Sudán")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La conexión Cus hasta el 7 de octubre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Entonces, si Sudán va a ser parte de una próxima invasión de Israel, ¿podría haber desempeñado un papel en la invasión de Israel del 7 de octubre? La respuesta es sí. Sudán, el Cus [Kush] bíblico de la profecía de Ezequiel, en realidad jugó un papel protagónico en la invasión del 7 de octubre. Sudán sirvió como conducto para suministrar a Hamas cantidades masivas de armamento que serían utilizados contra Israel ese día. Veamos un artículo de noticias sobre la Cus actual:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Sudán había... permitido que Hamas convirtiera su territorio en una importante ruta de contrabando de armas... hacia la Franja de Gaza."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Hamas pudo causar estragos en Israel porque las organizaciones terroristas")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("contrabandearon armas a Hamas por tierra a través del Sinaí vía "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sudán")]), _vm._v("… así como por mar."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("…Los contrabandistas beduinos radicados en el Sinaí traían artículos a "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Gaza")]), _vm._v(" a través de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sudán")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El papel de Sudán en el suministro de armas a Hamas fue tan grande que Israel lo expuso pública y repetidamente. Sudán también permitiría "), _c('span', {
    attrs: {
      "aria-label": "214",
      "epub:type": "pagebreak",
      "id": "page214",
      "role": "doc-pagebreak"
    }
  }), _vm._v("a Hamas acceder a millones de dólares en financiación para apoyar su guerra contra Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y aunque un reciente golpe de Estado en Sudán había restringido el apoyo de Hamas en esa tierra,"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("11")]), _vm._v(" un golpe que podía revertirse en cualquier momento, la nación que se profetizó que invadiría Israel en los días futuros había desempeñado un papel importante para ayudar a hacer posible el 7 de octubre. El 7 de octubre, Cus había invadido Israel por medio de un intermediario.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El misterio de Fut")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Quién es Fut? Los neobabilonios llamaron a la tierra de Fut, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Puta")]), _vm._v(". Los persas la conocían como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Putaya")]), _vm._v(". En el Libro de Nahum se les vincula con el pueblo Lubim."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("12")]), _vm._v(" El testimonio colectivo de escritos antiguos sitúa a Fut en la costa norte de África, al oeste de Egipto."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Entonces, ¿qué nación en el mundo moderno comprende la tierra o se corresponde con la antigua nación de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Fut")]), _vm._v("? La correspondencia puede incluir a Argelia y Túnez, pero se identifica más centralmente con una nación por encima de todas. Lleva el mismo nombre que estuvo asociado con Fut desde la antigüedad. El antiguo historiador judío Josefo escribe sobre un río en el norte de África llamado "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Fut")]), _vm._v(" y señala que su nombre fue cambiado a Lybyos, como Libia."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("14")]), _vm._v(" "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Fut")]), _vm._v(" corresponde a la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Libia")]), _vm._v(" moderna.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La conexión Fut con el 7 de octubre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Entonces, si Libia es un actor en la invasión de Israel en los últimos tiempos, ¿podría haber actuado también en la invasión del 7 de octubre? La respuesta es, insisto, sí. Libia, la bíblica Fut, fue uno de los proveedores más importantes de armas a Hamas en la Franja de Gaza. De un artículo de noticias sobre la conexión de Libia con Hamas vemos lo siguiente:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Las milicias libias... están ayudando al grupo armado palestino Hamas a eludir el bloqueo de Israel a la Franja de Gaza")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("De otro:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Los funcionarios israelíes advirtieron que Hamas estaba trabajando con contrabandistas de armas libios …Las fuerzas "), _c('span', {
    attrs: {
      "aria-label": "215",
      "epub:type": "pagebreak",
      "id": "page215",
      "role": "doc-pagebreak"
    }
  }), _vm._v("de seguridad egipcias confiscaron 138 cohetes Grad traídos desde Libia y destinados a Gaza")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Y:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("“"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Todos los misiles que puedas ver en Gaza”…incluyen transferencias por mar y aparentes entregas desde Libia")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Libia hizo posible los miles de cohetes que llovieron sobre Israel desde Gaza el 7 de octubre.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por lo tanto, estos dos invasores de Israel profetizados —Cus, en la forma de Sudán, y Fut, en la forma de Libia— desempeñaron un papel fundamental en la invasión de Israel en octubre de 2023.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Gog y sus hordas")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Quiénes son entonces Gog, Magog, Mesej y Tubal? Por los escritos de historiadores y cronistas antiguos, sabemos que habitaban la tierra conocida como Anatolia. También se identifica que los nombres de Gomer y Togarma habitaron en esa misma región. La región era una encrucijada de culturas y poblaciones, por lo que con la migración de pueblos es posible que se incluyan naciones adicionales en la profecía de Ezequiel. Pero las pistas más fuertes que tenemos son que fueron los antiguos habitantes de Anatolia, también conocida como Asia Menor. ¿Qué nación del mundo moderno se corresponde con Asia Menor? Solo puede ser Turquía."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La conexión Gog hasta el 7 de octubre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Podría Turquía haber participado también en la invasión del 7 de octubre?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La respuesta es sí, y mucho. Turquía fue fundamental a la hora de proporcionar los fondos que Hamas necesitaba para armarse e invadir Israel. Veamos un artículo del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(" que expone la red financiera que ayuda a Hamas, una red que se remonta a Turquía:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Aunque la cartera de inversiones abarcaba muchos países, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Turquía fue clave")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El apoyo de Turquía a Hamas fue tan central que el Departamento del Tesoro de Estados Unidos presionó al gobierno turco para que dejara de "), _c('span', {
    attrs: {
      "aria-label": "216",
      "epub:type": "pagebreak",
      "id": "page216",
      "role": "doc-pagebreak"
    }
  }), _vm._v("proteger fondos destinados al grupo terrorista. Turquía estuvo incluso detrás de la operación libia de transporte de armas a Hamas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("20")]), _vm._v(" Un titular decía:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Grupo respaldado por Turquía en Libia contrabandea armas a Hamas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Entonces Turquía, o Gog, Magog, Mésec y Tubal, trabajaron con Libia, Fut, para atacar y fomentar una invasión de la tierra de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El misterio de Paras")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Solo queda un invasor más citado en la profecía de Ezequiel: la nación de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Paras")]), _vm._v(". En cuanto a su identidad, no cabe duda. "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Paras")]), _vm._v(" jugaría un papel clave en la historia judía antigua y uno muy diferente en los tiempos modernos. En árabe se le conocía como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Faris")]), _vm._v(". Los griegos la llamaban "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Persis")]), _vm._v(". Se llamó a sí mismo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Parsa")]), _vm._v(" en honor a una de sus tribus. En latín se convirtió en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Persia")]), _vm._v(", nombre con el que occidente la identificaría durante mucho tiempo. "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Paras ")]), _vm._v("es"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" Irán")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La conexión de Paras hasta el 7 de octubre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Podría Irán haber desempeñado también un papel en la invasión de Israel del 7 de octubre? La respuesta es sí, y más que cualquier otra nación. No se puede subestimar el papel de Irán en el patrocinio y armamento de Hamas. En muchos sentidos, era el poder de las sombras detrás de todo. Lo siguiente proviene de una variedad de artículos sobre Irán, Hamas o el 7 de octubre:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hamas… dependía principalmente de Irán para financiar su ala militar…")]), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Funcionarios estadounidenses afirman que Irán proporciona fondos, armas y entrenamiento a Hamas")]), _vm._v("…"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("24")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Hamas lucha con un mosaico de armas construidas por Irán..."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Desde entonces, Irán ha suministrado material y conocimientos técnicos para que Hamas construya un considerable arsenal de "), _c('span', {
    attrs: {
      "aria-label": "217",
      "epub:type": "pagebreak",
      "id": "page217",
      "role": "doc-pagebreak"
    }
  }), _vm._v("cohetes, y en el conflicto actual se han disparado más de 10.000 cohetes y granadas de mortero.")]), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("El patrocinio iraní jugó un papel importante al permitir que Hamas comenzara los combates del mes pasado en Gaza")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Sin Irán, los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Paras")]), _vm._v(" profetizados en Ezequiel 38, la invasión del 7 de octubre nunca podría haber ocurrido.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Retraducción del misterio")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Qué sucede si tomamos esas noticias, artículos y titulares y reemplazamos sus nombres modernos con sus nombres antiguos? Esto es lo que pasa:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Grupos respaldados por "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Gog")]), _vm._v(" en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Fut")]), _vm._v(" contrabandean armas a Hamas...")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Israel")]), _vm._v(" acusó repetidamente a "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Paras")]), _vm._v(", "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Persia")]), _vm._v(", de transbordar armas a Hamas a través de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Cus")]), _vm._v("…")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Paras")]), _vm._v(" y Hezbolá han contrabandeado armas a Hamas por tierra a través del Sinaí vía "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Cus")]), _vm._v(" y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Fut")]), _vm._v("…")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Las milicias de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Fut")]), _vm._v(" financiadas por "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Paras, Persia... ")]), _vm._v("y"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" Gog")]), _vm._v(", "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mésec ")]), _vm._v("y"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" Tubal")]), _vm._v(" están ayudando al grupo armado "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("filisteo")]), _vm._v(" Hamas a eludir el bloqueo de Israel a "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Filistea")]), _vm._v("...")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Lo que sucede es que las palabras de las noticias comienzan a transformarse a la semejanza de la antigua profecía de Ezequiel 38 y 39.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Sin precedente")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuando la profecía de Ezequiel fue escrita por primera vez en pergamino, la mayoría de los pueblos y naciones que mencionaba no solo no estaban en guerra con Israel, sino que tenían poco o nada que ver con ella."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("28")]), _vm._v(" Durante siglos, la profecía desconcertó a los comentaristas bíblicos que la estudiaban. Y, sin embargo, dos mil quinientos años después, contra todo pronóstico, todos los pueblos o naciones mencionados en la profecía se han convertido y han actuado activamente como enemigos del Estado judío.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "218",
      "epub:type": "pagebreak",
      "id": "page218",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Las mismas naciones profetizadas en Ezequiel para librar guerra contra un Israel resucitado, a partir del 7 de octubre de 2023, a través de sus intermediarios, han peleado contra esa misma nación. Las mismas que la profecía predijo que serían parte de la invasión de Israel ahora han tenido un papel en esa misma cosa: una invasión de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El cumplimiento de la profecía aún está por darse. El camino que conduce a ello puede estar lleno de giros, reveses y desviaciones. Pero el momento está en manos de Dios. Sin embargo, el 7 de octubre de 2023, por primera vez, las naciones mencionadas en la profecía de Ezequiel implicadas en una futura invasión masiva de Israel estuvieron todas involucradas en una invasión masiva de Israel. Los signos del 7 de octubre indican, por tanto, que estamos más cerca del día del cumplimiento de la profecía de lo que podríamos haber imaginado.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los poderes de las sombras")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Cómo logró Hamas obtener armas a pesar de un bloqueo establecido para evitar precisamente eso? Sucedió debido a los poderes en la sombra que financiaron y armaron a la organización terrorista con el propósito de desatar la guerra contra Israel. Y de todas las naciones y poderes que pudieron haber desempeñado ese papel, las que lo hicieron resultaron ser las mismas que se predicen en la antigua profecía de Ezequiel. Sin ellas, Hamas nunca habría podido lanzar su invasión. Así que el 7 de octubre fue posible gracias a los actores específicamente citados en Ezequiel 38 y 39, dos mil quinientos años antes: Gog, Magog, Mésec, Tubal, Gomer, Togarma, Cus, Fut y Persia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La tormenta")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La profecía de Ezequiel describe la invasión de Israel de esta manera:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Tú lo invadirás como un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("huracán")]), _vm._v(" [o tormenta]. Tú, con todas tus tropas y todos tus aliados."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("29")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La invasión vendría sobre la tierra como un huracán repentino, masivo y feroz. Del mismo modo, la invasión de Israel el 7 de octubre llegó repentinamente, de manera masiva y feroz, como un huracán. Pero no solo es que la invasión compartiera esos atributos. El nombre oficial de la invasión, Tufan, que significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("inundación")]), _vm._v(", tenía una traducción alterna. También "), _c('span', {
    attrs: {
      "aria-label": "219",
      "epub:type": "pagebreak",
      "id": "page219",
      "role": "doc-pagebreak"
    }
  }), _vm._v("podría traducirse como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tormenta")]), _vm._v(". Y así, según esta traducción, la invasión llevaba el mismo nombre que la palabra dada en la profecía de Ezequiel.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La palabra hebrea real para "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tormenta")]), _vm._v(" en la profecía de Ezequiel es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("shoah")]), _vm._v(", que puede traducirse como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tormenta, huracán, devastación, destrucción, desolación ")]), _vm._v("o"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" catástrofe repentina")]), _vm._v(". Como el peor día en la historia judía desde el Holocausto, el 7 de octubre se comparó con esa calamidad. Pero en hebreo, Holocausto no se dice así. Se llama "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Shoah")]), _vm._v(". De forma que el nombre en clave árabe para el 7 de octubre coincidía con el nombre hebreo para Holocausto.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y por primera vez, las naciones que fueron profetizadas en Ezequiel 38 y 39 para participar en una invasión de Israel que vendría sobre la tierra como una tormenta realmente participaron en una invasión de Israel que llevaba el nombre de “Tormenta”. Y la misma palabra árabe por la que se nombró esa invasión, Tufan, también coincidía con la palabra griega que aparece en Apocalipsis 12 para hablar de la inundación del Dragón contra la mujer, “Potamon”, mientras que al mismo tiempo coincidía con el vocablo hebreo dado para nombrar la campaña más mortífera del Dragón jamás lanzada contra el pueblo judío, el Holocausto o "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Shoah")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Se trata de una de las entidades más misteriosas identificadas en las Escrituras. Es posible que todavía exista y esté operando en nuestros días, incluso dirigiendo el curso de los acontecimientos mundiales?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "220",
      "epub:type": "pagebreak",
      "id": "page220",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-135"
    }
  }, [_vm._v("Capítulo 56")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-136"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  }), _vm._v("Los Sar Paras")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Y estalló la guerra en el cielo.")]), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("n medio de ")]), _vm._v("Apocalipsis 12 estalla una guerra en los reinos celestiales. De un lado están las fuerzas angelicales de Dios y del otro, el Dragón y sus ángeles. Una de las realidades del reino espiritual es la guerra. Lo que estamos a punto de ver se relaciona con esa guerra y su convergencia con los acontecimientos mundiales. Para descubrirlo debemos remontarnos a la antigüedad y a la corte de un rey pagano.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El hombre junto al Tigris")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El profeta Daniel fue llevado cautivo de Israel a Babilonia."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Allí, en la corte real, recibiría profecías de Dios acerca del fin de los días. Mientras estaba de pie junto al río Tigris, vio a un “hombre”, un ángel, que le había sido enviado con una revelación profética."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" El ángel dijo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("No tengas miedo, Daniel. Tu petición fue escuchada desde el primer día en que te propusiste ganar entendimiento y humillarte ante tu Dios. En respuesta a ella estoy aquí. Pero durante veintiún días el príncipe del reino de Persia ["), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sar Malkhut Paras")]), _vm._v("] se me opuso."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("El ángel le dice a Daniel que habría venido antes pero que otra entidad se lo impidió. La entidad se identifica en hebreo como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sar Malkhut Paras")]), _vm._v(". La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sar")]), _vm._v(" puede traducirse como príncipe, jefe, gobernante, capitán, guardián, mayordomo, señor o amo. La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("malkhut")]), _vm._v(" significa reino. Y la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Paras")]), _vm._v(", tal como apareció en Ezequiel 38, significa Persia. Persia, en ese momento, estaba en el apogeo de su poder y acababa de establecer su imperio en todo el mundo del Medio Oriente."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Qué tipo de entidad era "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sar Paras")]), _vm._v("? Había luchado contra un ángel. Eso lo convertiría en una entidad espiritual. Aquel que entra en batalla contra un ángel de Dios es malo. Era un ángel de las tinieblas. El "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sar Paras")]), _vm._v(" es una entidad demoníaca.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "221",
      "epub:type": "pagebreak",
      "id": "page221",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Un ángel oscuro")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Por qué trató de obstaculizar al ángel enviado a Daniel? El ángel tenía una misión:")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Ahora he venido para hacerte entender lo que le sucederá a tu pueblo en los últimos días, porque la visión se refiere a muchos días aún por venir."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sar Paras")]), _vm._v(" estaba luchando para detener la transmisión de una revelación acerca de los propósitos de Dios para Israel en los últimos días. La revelación se referiría a la ciudad de Jerusalén, el Templo restaurado de Jerusalén, el Libro de Apocalipsis, el Anticristo, el fin de los tiempos y el regreso del Mesías. Era esto lo que la entidad demoníaca estaba tratando de evitar. En el momento de la profecía, la mayoría del pueblo judío estaba exiliado de la tierra. La profecía requería su regreso a la tierra, a Jerusalén, y la reconstrucción del Templo de Dios. Al alejarse del profeta, el ángel retomaría su batalla con la entidad demoníaca.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Entonces el Sar Paras lucha contra los propósitos de Dios. Busca detenerlos antes de su cumplimiento. Más específicamente, lucha contra los propósitos de Dios con respecto a Israel e intenta frustrarlos. Y aún más específicamente, lucha contra los propósitos de Dios para Israel en los últimos días, el fin de los tiempos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Príncipe de Persia")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Esta entidad demoníaca única está vinculada a una nación en particular: Persia. El título "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sar Paras")]), _vm._v(" puede traducirse como Príncipe de Persia, o Señor y Señor persa de Persia. Como Persia se convirtió en Irán, la entidad puede ser llamada Gobernante de Irán, Señor iraní o Señor y amo de Irán. Así busca controlar la nación de Persia, Irán, para dirigirla, impulsarla, impulsarla y utilizarla como instrumento de sus propósitos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los espíritus no mueren. Así pues, Sar Paras no pereció en la antigüedad: todavía existe. Y dado que lucha específicamente contra la nación de Israel y los propósitos de Dios con esa nación en los últimos tiempos, ¿qué esperaríamos que sucediera con el regreso de Israel al mundo moderno y del pueblo judío a Jerusalén? Es de esperar que desencadene y reactive a Sar Paras y su antigua guerra.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "222",
      "epub:type": "pagebreak",
      "id": "page222",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La transformación de Paras")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Bajo el Sha Reza Pahlavi, Irán e Israel disfrutaron de relaciones amistosas. Pero a finales de los años 1970, el Sha fue derrocado. Un Irán nuevo y radical se desató en el escenario mundial. Así como Sar Paras busca detener los propósitos de Dios del fin de los tiempos con respecto a Israel, el nuevo Irán se obsesionó con la nación de Israel. Se estableció como la némesis de Israel, su archienemigo entre las naciones. Se involucraría en una campaña implacable de oposición, frustración y guerra contra la nación judía. Así como Sar Paras busca en última instancia la destrucción de Israel, el nuevo Irán radical haría lo mismo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como los espíritus demoníacos poseen y utilizan a otros como sus recipientes, agentes y apoderados, el Irán impulsado por Sar Paras también utilizaría a otros como sus instrumentos, agentes y apoderados. Y así como los espíritus demoníacos utilizan a otros para inspirar terror y miedo, el Irán radical se convertiría en un Estado terrorista que patrocinaría el terrorismo en todo el mundo. Subvencionaría y facilitaría el terrorismo, el radicalismo y el odio contra Israel en Irak, Líbano, Bahréin, Yemen, Pakistán y Siria, entre otras naciones. Financiaría, entrenaría y apoyaría a la organización terrorista Hezbolá en su guerra implacable contra la nación judía."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Espíritus de destrucción")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Eso llegaría hasta Gaza. Allí, Irán se convertiría en el principal patrocinador de la organización terrorista Hamas."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")]), _vm._v(" Detrás del empoderamiento de Hamas en Gaza estaban Sar Paras. Detrás del contrabando de armas, la transferencia de fondos y el entrenamiento de tropas para atacar a Israel estaba el antiguo espíritu demoníaco persa. Fue Sar Paras el que provocó el lanzamiento de miles de cohetes contra viviendas israelíes. Y en la locura de quienes invadieron Israel el 7 de octubre estaba la locura de Sar Paras.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los espíritus demoníacos buscan la muerte y la destrucción. Tan habitado por el espíritu antiguo, Irán buscó la muerte y la destrucción, por lo que se convirtió en una amenaza para el orden mundial. Se obsesionó con lograr capacidades nucleares con las que pudiera atacar a otras naciones, particularmente a Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")]), _vm._v(" Se llevaron a cabo esfuerzos masivos por parte de las naciones en un intento por reducir el peligro que Irán representaba para el mundo. El problema era que creían que se trataba de una nación. "), _c('span', {
    attrs: {
      "aria-label": "223",
      "epub:type": "pagebreak",
      "id": "page223",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Estaban tratando con un espíritu. Irán se había convertido en una potencia única entre las naciones así como la entidad que lo poseía era una potencia única entre los espíritus.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Sar Israel")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El ángel enviado para darle la profecía a Daniel no estaba solo en su lucha contra la entidad demoníaca. Él le contó al profeta:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Así que acudió en mi ayuda Miguel, uno de los principales príncipes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("A Michael, que se pronuncia Me-kha-el, se llama aquí príncipe principal. El ángel también lo llama “el gran príncipe que representa a los hijos de tu pueblo”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("12")]), _vm._v(" Detrás de la palabra príncipe está la palabra hebrea sar, la misma palabra hebrea de Sar Paras. Entonces, así como Sar Paras está conectado con Persia o Irán, Miguel está conectado y lucha por los hijos de Israel. Él es su príncipe, su general, su guardián. Él es el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sar Israel")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y así, detrás de Irán está Sar Paras, el Príncipe de Persia. Y detrás de Israel está Miguel, el Sar Yisrael, el Príncipe de Israel. Entonces, ¿qué esperaríamos de estas dos naciones en los últimos días? Si las dos entidades que representan a las dos naciones están luchando en el ámbito espiritual, ¿qué esperaríamos entonces de las dos naciones? Simplemente, que las dos naciones se convirtieran en enemigos mortales. Y eso es exactamente lo que ha pasado. Porque detrás del reino terrenal y los acontecimientos de ese reino hay realidades, fuerzas y agentes espirituales. Y tras el conflicto de Israel e Irán yace el problema de dos entidades, cada una identificada miles de años antes, cada una librando una guerra en el reino angelical.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Miguel y el Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Las apariciones de Miguel en las Escrituras son raras. Aparte de en Daniel, su aparición más destacada se encuentra en el Libro de Apocalipsis. Y ocurre en medio de la visión del Dragón:")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y estalló la guerra en el cielo: Miguel y sus ángeles lucharon contra el Dragón; y el Dragón y sus ángeles lucharon."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En Daniel, Miguel lucha contra Sar Paras. En Apocalipsis lucha contra el Dragón y sus ángeles. Así, el Dragón y Sar Paras luchan y son combatidos por el mismo oponente. Están del mismo lado de la misma guerra. "), _c('span', {
    attrs: {
      "aria-label": "224",
      "epub:type": "pagebreak",
      "id": "page224",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Son del mismo ejército. Sar Paras es uno de los ángeles del Dragón. Cada uno de ellos librará una guerra especialmente contra Israel y el pueblo judío en los últimos días. Cada uno de ellos batallaron contra Israel el 7 de octubre. Y los que realmente llevaron a cabo la invasión, los agentes de Hamas, también estaban sirviendo en el mismo ejército, las tropas terrestres del Dragón y sus ángeles.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Y aún había más. El misterio continuaría desarrollándose y explotando en el escenario mundial. En algún momento, incluso conduciría a la posibilidad de una guerra regional y global. Y sucedería mientras yo estaba escribiendo estas páginas. Por lo tanto, originalmente no se planeó escribir los dos capítulos siguientes, pero se escribieron porque el misterio no ha detenido su desarrollo.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "225",
      "epub:type": "pagebreak",
      "id": "page225",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-137"
    }
  }, [_vm._v("Capítulo 57")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-138"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor056"
    }
  }), _vm._v("El general persa")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("uando comencé a ")]), _vm._v("escribir el capítulo sobre la profecía de Ezequiel acerca de la invasión de Israel en los últimos tiempos, uno de los acontecimientos más significativos relacionados con el cumplimiento de esa profecía nunca había ocurrido, pero sucedió.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El General Zahedi")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Mohammad Reza Zahedi era el general iraní al mando de la Fuerza Quds en Siria y el Líbano, una figura militar de alto rango del Cuerpo de la Guardia Revolucionaria Islámica. Estados Unidos había designado a ambos grupos como organizaciones terroristas. Zahedi fue fundamental al brindar ayuda, asesoramiento y apoyo militar a las fuerzas antiisraelíes en la región. Jugó un papel decisivo en el fortalecimiento de grupos terroristas como Hezbolá en la frontera norte de Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A raíz del 7 de octubre, Hezbolá comenzó a lanzar ataques con misiles contra Israel, lo que obligó a la evacuación masiva de la región norte de Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" La guerra total entre Israel y Hezbolá se convirtió en una perspectiva muy real. Para hacer la situación más peligrosa, la capacidad de Hezbolá de infligir destrucción en la tierra de Israel era mucho mayor que la de Hamas. Zahedi fue un agente clave subyacente al poder y las acciones de Hezbolá. Israel lo sabía. Eso daría lugar a una cadena de acontecimientos que llevarían a Oriente Medio al borde de la guerra, todos desbordados a partir del 7 de octubre.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El golpe")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El 1 de abril de 2024, la Fuerza Aérea de Israel atacó un edificio anexo al consulado iraní en Siria. Zahedi estaba celebrando una reunión ahí. Él y quienes estaban con él fueron asesinados inmediatamente. El gobierno iraní condenó el ataque y prometió tomar represalias."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" El conflicto israelí-iraní estaba a punto de entrar en un ámbito nuevo y mucho más peligroso.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dos días después de su muerte, el Consejo de Coalición Iraní de las Fuerzas Revolucionarias Islámicas, una organización afiliada al ayatolá Jamenei, líder supremo de Irán, envió un comunicado elogiando a Zahedi. "), _c('span', {
    attrs: {
      "aria-label": "226",
      "epub:type": "pagebreak",
      "id": "page226",
      "role": "doc-pagebreak"
    }
  }), _vm._v("MEMRI, el Instituto de Investigación de Medios de Medio Oriente con sede en Estados Unidos, tradujo la comunicación al castellano. Decía:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El papel estratégico del mártir Zahedi en la consolidación y fortalecimiento del frente de resistencia, y en la planificación y ejecución de la inundación de Al-Aqsa…"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Elogiaba al general Zahedi por haber desempeñado un papel decisivo en la invasión de Israel del 7 de octubre.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Al borde")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Durante más de una semana, el mundo observó con ansiedad y tensión las represalias de Irán contra Israel, temiendo que desencadenara una guerra regional, si no algo aún mayor y más peligroso. Y, poco más tarde, eso llegó. El 13 de abril, Irán, junto con la Resistencia Islámica en Irak, los hutíes en Yemen y Hezbolá en el Líbano, lanzaron más de 120 misiles balísticos, 170 drones y más de 30 misiles crucero hacia la tierra de Israel. Fue el mayor ataque con misiles jamás lanzado por Irán y el mayor ataque con drones en la historia militar."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" Su objetivo era abrumar las capacidades defensivas de Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El ataque marcó un momento decisivo. Hasta esa fecha, Irán había atacado a Israel solo de forma indirecta y encubierta, utilizando agentes y representantes. Pero esta era la primera vez que lanzaba un ataque directo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")]), _vm._v(" Con Israel aliado con Estados Unidos y Occidente, e Irán con Rusia y China, el peligro no era solo que pudiera desencadenar una guerra importante en el Medio Oriente sino que podría escalar hasta convertirse en una guerra mundial. Y todo surgió del 7 de octubre. La Operación Inundación del Dragón había llevado al mundo al borde de la calamidad.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Territorio inexplorado")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Israel, con sus aliados, derribó aproximadamente el 99 % de los misiles entrantes. Menos de una semana después, Israel respondió. Decidió hacerlo con un ataque muy moderado contra diversos emplazamientos militares iraníes, sirios e iraquíes para demostrar su capacidad de reducir la tensión de la situación."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")]), _vm._v(" Aunque la crisis inmediata disminuyó, se había roto una línea que no se había tocado. Irán había atacado la tierra de Israel, e Israel la tierra de Irán. Oriente Medio y el mundo habían entrado en un territorio inexplorado y peligroso.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "227",
      "epub:type": "pagebreak",
      "id": "page227",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Según la profecía")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Fue un hito histórico, y más que eso. Fue un hito profético. Ezequiel había predicho que, en los últimos días, Persia o Irán lanzarían un ataque contra un Israel que había sido “recogido de las naciones”. Eso nunca había sucedido. Y eso no había sucedido cuando comencé a escribir el capítulo sobre esa misma profecía y su conexión con Irán. Pero el 13 de abril de 2024, por primera vez en la historia, Persia, Irán, lanzó un ataque directo contra la resucitada nación de Israel. Aún no era la plenitud de lo profetizado, pero era el paso más definitivo jamás dado hacia su cumplimiento. Se había cruzado una línea profética.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El 7 de octubre marcó la primera vez que prácticamente todos los pueblos o naciones identificables citados en la profecía de Ezequiel desempeñaron un papel en una invasión de Israel. El 13 de abril marcaría la primera vez que cualquiera de esas naciones profetizadas atacaría realmente a la nación resucitada de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("En los Ouranos, los celestiales")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La guerra de Miguel y sus ángeles contra el Dragón y sus ángeles se describe en el Libro de Apocalipsis como que se despliega en el cielo. La palabra traducida como cielo es el vocablo griego "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ouranos")]), _vm._v(". Su significado principal es cielo. Los cielos, el lugar de la guerra espiritual, están representados en el ámbito físico por el cielo. La guerra de Irán e Israel tuvo lugar en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ouranos")]), _vm._v(", el cielo, en los cielos, sobre cada tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Que el 99 % de los misiles disparados contra los cielos israelíes fueran derribados antes de alcanzar sus objetivos, lo que se consideró un milagro. El que pelea en los lugares celestiales a favor de Israel es Sar Yisrael, Miguel. ¿Es posible que el milagro de la protección de Israel en los cielos implicara algo más que sistemas de defensa de alta tecnología? ¿Podría haber involucrado una entidad espiritual a la que se le ha confiado la protección de Israel y que lucha en los lugares celestiales?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El general iraní")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El ataque de Irán contra Israel se centró en el general Zahedi. Como Zahedi se especializó en empoderar y movilizar a terroristas, milicias y facciones radicales contra Israel, podría ser visto como un recipiente, un instrumento, si no una encarnación, de Sar Paras. En 1 Crónicas 27 está escrito:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "228",
      "epub:type": "pagebreak",
      "id": "page228",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y el general del ejército del rey era Joab."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La palabra general es el término hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sar")]), _vm._v(". Y entonces Sar Paras puede traducirse como el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("general")]), _vm._v(" "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("persa")]), _vm._v(" o el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("general iraní")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Zahedi no solo fue un agente de destrucción de Israel: fue el general iraní que llevó a Oriente Medio al borde de la guerra. En hebreo era un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sar Paras")]), _vm._v(". Por lo tanto, en vista de las realidades espirituales tras el conflicto, no debería sorprender que Israel derribara a un Sar Paras, el general iraní, o que cuando el Sar Paras fuera derribado, se desatara el infierno.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Sin embargo, había otro actor, aún más importante en la guerra de Irán contra Israel, uno que tocaría un antiguo pacto que terminaría destruyéndolo.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "229",
      "epub:type": "pagebreak",
      "id": "page229",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-139"
    }
  }, [_vm._v("Capítulo 58")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-140"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor057"
    }
  }), _vm._v("Contra las montañas")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("É")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("l era el ")]), _vm._v("poder detrás del general Zahedi. Presidió el proceso de armamento y fortalecimiento de Hamas antes de la invasión del 7 de octubre. Su nombre era Ebrahim Raisi.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El carnicero de Teherán")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Raisi fue presidente de Irán bajo el ayatolá Jamenei."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")]), _vm._v(" Por lo tanto, fue aun más crítico que Zahedi como agente del caos en la región y como líder de facciones y representantes que trabajaban para la destrucción de Israel. Él también fue un instrumento de los Sar Paras.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Como Sar Paras es una entidad empeñada en la muerte, Raisi era famoso entre su propio pueblo como ministro de la muerte. Lo llamaban el “Carnicero de Teherán”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Fue responsable de la brutal represión de los disidentes iraníes. Se desempeñó como juez en la Comisión de Muerte de Irán. Sería acusado de condenar a muerte sin juicio a miles de iraníes inocentes. Fue citado por cometer crímenes contra la humanidad. Y era el presidente de Irán cuando ese país lanzó su ataque con misiles contra Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los otros Sar Paras")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sar")]), _vm._v(" puede traducirse como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("jefe, gobernante ")]), _vm._v("o"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" líder")]), _vm._v(". Por tanto, Sar Paras puede traducirse como gobernante de Irán o líder iraní. Bajo el ayatolá, Raisi era gobernante y líder de Irán: un Sar Paras. Pero había más. Raisi, una forma abreviada de un apellido más largo, es una palabra persa basada en un título árabe. Sar es la palabra hebrea para jefe o gobernante. Raisi significa jefe y gobernante. Y como su nombre corresponde con el nombre persa de jefe o gobernante, equivale a gobernante persa o Sar Paras. Así que Raisi no solo sirvió como instrumento y encarnó a los Sar Paras; su propio nombre hablaba de ello.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "230",
      "epub:type": "pagebreak",
      "id": "page230",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Ebrahim")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Raisi estaba en la cima de sus poderes y muchos lo presumían como el sucesor del ayatolá. Pero eso no iba a ser. El 19 de mayo de 2024, el helicóptero en el que sobrevolaba la provincia iraní de Azerbaiyán Oriental se estrelló contra una montaña. Uno de los gobernantes más poderosos del mundo ya no existía. ¿Qué pasa con el nombre de pila de Raisi, Ebrahim? Ebrahim es la forma persa de Abraham. Abraham es el padre del pueblo judío, el abuelo de Israel de quien toma el nombre la nación judía. Por eso Raisi recibió el nombre del padre de la nación contra la que luchó. A Abraham se le dio la promesa de que sus hijos heredarían la tierra de Dios. Raisi, que llevaba el nombre del hombre que recibió esa promesa, fortaleció y armó a quienes buscaban sacar a los hijos de Abraham de la tierra que Dios les había dado.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El pacto")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El nombre Ebrahim también apuntaba al hombre con quien Dios hizo un pacto especial, el pacto abrahámico. Consistía en estas palabras:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Bendeciré a los que te bendigan, y maldeciré a los que te maldigan."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En otras palabras, aquellos que bendigan a los hijos de Abraham, el pueblo judío, la nación de Israel, serán benditos. Los que los maldigan serán maldecidos. Implica, también, la dinámica de la reciprocidad: lo que le hagas a Israel, para bien o para mal, a su vez, te será hecho a ti. Es, para quienes bendicen al pueblo judío, una palabra de aliento, y para quienes se enfurecen contra ellos, para los antisemitas del mundo, una palabra de advertencia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El ojo de Dios")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Raisi maldijo a la nación de Israel. Pero hizo más que eso. Les hizo la guerra. Fue el único presidente en la historia de Irán que realmente lanzó un ataque contra la nación de Israel, para enviar misiles a la tierra de Israel. En el libro de Zacarías está escrito acerca de los que tocan a Israel:")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "231",
      "epub:type": "pagebreak",
      "id": "page231",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El que te toca, toca la niña de sus ojos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En otras palabras, tocar a Israel es tocar los ojos de Dios. Raisi supervisó el lanzamiento de misiles contra Israel el 13 de abril. Tocó el ojo de Dios. Un mes y seis días después estaba muerto.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("A través de los cielos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En su muerte operó el funcionamiento de la reciprocidad. Raisi intentó llevar muerte y destrucción a Israel. Y así atrajo muerte y destrucción. Más específicamente, había tratado de traer destrucción a Israel a través de los cielos. Así fue que la destrucción llegaría a Raisi a través del cielo. Había enviado objetos aéreos a los cielos de Israel para causar destrucción al estrellarse contra la tierra. Entonces sería un objeto aéreo, el que lo llevó a través de los cielos de Irán, el que le traería destrucción al estrellarse contra la tierra. Como había hecho con Israel, así le fue hecho a él.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y, sin embargo, hizo más que eso.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La amenaza")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Solo unos días después de haber enviado los misiles a Israel, Raisi selló sus acciones y su destino. Poco después de que Israel intentara reducir la crisis con una respuesta silenciosa, Raisi emitió una declaración pública. Fue una amenaza. Dijo que si Israel tomaba alguna medida futura contra Irán, muy posiblemente Israel sería aniquilado. No quedaría nada de ellos. La declaración fue noticia en todo el mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El presidente iraní amenaza con la aniquilación de Israel..."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Nada quedará de Israel…"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Raisi estaba amenazando al Estado judío con una destrucción total, la que se produciría a través de Irán y, por tanto, bajo su liderazgo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")]), _vm._v(" En otras palabras, Raisi sería el que lo destruiría.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Se dice que fue la última declaración pública que haría."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")]), _vm._v(" No solo había atacado a Israel; selló sus acciones con una maldición y una amenaza de destrucción total. Amenazar y planear la destrucción de Israel es algo "), _c('span', {
    attrs: {
      "aria-label": "232",
      "epub:type": "pagebreak",
      "id": "page232",
      "role": "doc-pagebreak"
    }
  }), _vm._v("sumamente peligroso. Un mes después, Israel todavía estaba allí, pero Raisi no. Fue abatido. Y no quedó nada de su miserable vida.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Una mano invisible")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Hemos visto la conexión en el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ouranos")]), _vm._v(" griego entre los “cielos” del reino espiritual (el reino de la guerra angelical, de los Sar Paras y el Sar Yisrael) y los cielos sobre la tierra, los cielos del reino físico. Raisi había enviado la muerte a través de los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ouranos")]), _vm._v(", los cielos, los cielos de Israel. Ahora la muerte le llegaría, igualmente, a través de los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ouranos")]), _vm._v(", mediante los cielos de Irán. Ese día tres helicópteros formaban un convoy que sobrevolaba Azerbaiyán Oriental. Dos llegaron a su destino, solo uno no pudo hacerlo. Miguel es Sar Yisrael, la entidad angelical encargada de proteger a Israel. Ese cargo incluye impedir que se cumplan las amenazas de destrucción. Él pelea en los "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ouranos")]), _vm._v(", las regiones celestiales. No se cree que ninguna mano humana haya estado involucrada en el accidente del helicóptero de Raisi. ¿Es posible que hubiera otra mano en el cielo ese día, la mano del Sar Yisrael?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Contra las montañas”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En la profecía de Ezequiel sobre la invasión de Israel en los últimos tiempos, Dios da esta palabra a los invasores:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Te enviaré contra los montes de Israel … Caerás sobre los montes …"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Los que atacan a Israel serán juzgados en las montañas. Raisi fue el primer líder de una nación citada en la profecía que realmente lanzó un ataque contra Israel. ¿Y cuál fue su destino? Fue llevado a las montañas, fue llevado contra los montes. Su destino fue el de aquellos que, en el momento señalado, ataquen la tierra de Israel. Apenas un mes después de que la primera de las naciones mencionadas en Ezequiel atacara la tierra de Israel, su líder literalmente “caería sobre los montes”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando la profecía llegue a su cumplimiento, los invasores caerán sobre las montañas de Israel. Pero como el ataque de Irán fue una sombra del ataque venidero, la caída de Raisi puede tomarse como una representación de su próximo juicio sobre las montañas.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "233",
      "epub:type": "pagebreak",
      "id": "page233",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día del quebrantamiento del Faraón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El primer reino o potencia que vino contra la nación de Israel fue Egipto. El día que violó el poder de Egipto y su gobernante, el Faraón, fue la Pascua. La Pascua conmemora la liberación de Israel del poder de Faraón y de la esclavitud de Egipto. El presidente Raisi era el líder de una nación moderna que buscaba la destrucción de Israel. Emitió su amenaza de aniquilar a Israel el 23 de abril de 2024."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("11")]), _vm._v(" ¿Podría ser significativo el momento de esa amenaza? Lo fue.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Él anunció su amenaza en Pesaj. Un gobernante malvado amenazó con la destrucción de Israel el día en que Dios le dio la victoria a Israel sobre un gobernante malo. El enemigo de Israel lo había amenazado con la aniquilación el día en que se quebrantó el poder del enemigo de Israel. ¿Podría el hecho de que Raisi lanzara su amenaza de destruir a Israel ese día, entre todos los días, haber constituido una señal que presagiaba la destrucción de su poder y de su existencia?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El día que Raisi amenazó con destruir a Israel, el pueblo de Israel estaba celebrando la Pascua, la conmemoración del día en que Dios los libró del poder de un líder malvado. Dios los libraría otra vez.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El acto de blasfemia")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Lo que Raisi hizo ese día de Pesaj fue más que una amenaza. Estaba amenazando con la aniquilación de la eterna nación de Dios: destruir la obra de Dios, anular la promesa de Dios y erradicar los propósitos divinos. Fue un acto de blasfemia. El hecho de que lo cometiera en un día santo hebreo, la Pascua, fue una doble blasfemia. Y el que lo hiciera después de intentar realmente llevar destrucción a esa nación y golpear a “la niña de los ojos de Dios” fue una triple blasfemia. No tenía idea de lo que estaba haciendo ni de lo que estaba invocando.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La palabra designada")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cada día de reposo hay un pasaje de las Escrituras designado desde épocas pasadas para que se lea ese sábado en particular. Raisi sería asesinado al día siguiente del sábado. Así que el día antes de su muerte, había una escritura señalada. Sería leída, recitada y cantada por el pueblo judío en todo Israel y en todo el mundo. ¿Cuál fue la palabra designada?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "234",
      "epub:type": "pagebreak",
      "id": "page234",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("La palabra señalada provenía del Libro de Levítico y hablaba de los días santos de Israel, comenzando con la Pascua, el día en que Raisi había cometido su blasfemia. Pero concluiría con una cuenta única y luego un comando. Hablaba de un hombre que había cometido un acto de blasfemia. Así que Raisi había cometido un acto de blasfemia. Los actos de Raisi fueron únicos en la historia del conflicto iraní-israelí. Había golpeado la tierra de Israel y luego había seguido con un acto de blasfemia. No terminaría bien. Y la Escritura designada lo había predicho.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Será ejecutado”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La Escritura continúa proclamando este mandamiento:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Todo el que pronuncie el nombre del Señor al maldecir será condenado a muerte."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Esta es la ley relativa a la blasfemia. No se aplica solo al pueblo judío. La escritura citada aclara que se aplica tanto al extranjero como al nacido en la tierra."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Raisi blasfemó el nombre del Señor. La última de las palabras finales de las Escrituras se proclamó el día antes de su muerte: el hombre que cometió blasfemia fue sacado del campamento y ejecutado."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("14")]), _vm._v(" Raisi sería llevado fuera del campamento de su pueblo, a las montañas, afueras de Irán, y allí fue ejecutado el que había blasfemado contra el Señor. Había pronunciado la blasfemia el 23 de abril. Al mes siguiente, el 23 de mayo, exactamente treinta días después de haberla pronunciado, pusieron su cuerpo en una tumba.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La caída de los monstruos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Raisi estaba en la cima del poder. Pero no había previsto el hecho de que al hacer la guerra contra Israel, el Dios de Israel se la haría a él. Tampoco había negociado el pacto hecho con el hombre cuyo nombre llevaba, y que mediante ese pacto se le haría a él lo que había hecho y planeado hacer a Israel. Tampoco había considerado que cuando atacó la tierra de Israel, tocó la niña de los ojos de Dios y que al amenazar con la aniquilación de Israel, había cometido un acto de blasfemia. Luego se fue.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y así se unió a una larga lista de tiranos caídos, malhechores, antisemitas, blasfemos y una variedad de monstruos de la historia que aprendieron "), _c('span', {
    attrs: {
      "aria-label": "235",
      "epub:type": "pagebreak",
      "id": "page235",
      "role": "doc-pagebreak"
    }
  }), _vm._v("por las malas que el Dios del universo también resulta ser el Dios de Israel, y sucede que el Dios de Israel también es el Todopoderoso.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Detrás de todas las cosas")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Qué nos dice todo esto?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aunque el mundo no lo sabe, el curso de la historia —en última instancia— no está determinado por lo que vemos sino por lo que no vemos. Hay otro ámbito y otros agentes que se mueven detrás de los acontecimientos de nuestro tiempo.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Detrás del 7 de octubre estaban los militantes y terroristas de Gaza.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y detrás de los militantes y terroristas de Gaza estaba Hamas.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Pero detrás de Hamas estaban las naciones profetizadas dos mil quinientos años antes en Ezequiel 38 y 39.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y detrás de una de esas naciones estaba la antigua entidad llamada Sar Paras.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y detrás de Sar Paras estaba el Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Pero detrás de Israel está Sar Yisrael, Miguel.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y detrás de Sar Yisrael está el Mesías.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y detrás de todas las cosas está Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Todo comenzó con el ataque del Dragón aquel sábado de octubre. Todo terminaría, en última instancia, en el Libro de Apocalipsis.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Pasamos ahora a la figura humana más controvertida de la profecía bíblica. ¿Podría lo que se manifestó al mundo en el día de la tragedia de Israel y en los días siguientes darnos una idea de esa figura, de la naturaleza de la Bestia?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "236",
      "epub:type": "pagebreak",
      "id": "page236",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-141"
    }
  }, [_vm._v("Capítulo 59")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-142"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor058"
    }
  }), _vm._v("La Bestia")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y vi una bestia que surgía del mar … El Dragón le dio su poder."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El therion")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La visión de la guerra del Dragón conduce a la de una bestia que surge del mar. La palabra traducida como bestia proviene del griego "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("therion")]), _vm._v(", que denota un animal peligroso, salvaje, venenoso, un depredador. Así que, la Bestia comparte la naturaleza de la Serpiente y el Dragón, y con razón. Es el Dragón quien le da a la Bestia su poder, su autoridad y su reinado. Como entidad espiritual, el Dragón necesita instrumentos de carne y sangre para actuar y hacer la guerra en la tierra. A lo largo de la historia, es a través de tales instrumentos que ha traído calamidad y destrucción al pueblo judío. El 7 de octubre fueron los invasores de Gaza quienes le sirvieron de buques. El receptor definitivo del Dragón llegará al final de la era: la Bestia. Así como la visión de la guerra del Dragón revela las fuerzas espirituales en juego al final de la era, la visión de la Bestia revela cómo se manifestarán esas fuerzas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El hijo del dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La Bestia existirá como la personificación y manifestación del Dragón en la tierra. Por tanto, esperaríamos que encarnara la naturaleza del Dragón. Así como el nombre "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Satán ")]), _vm._v("y"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(" Diábolo")]), _vm._v(" hablan de aquel que se opone y hace guerra, la naturaleza de la Bestia será oponerse y hacer guerra contra todo lo que es de Dios. Por eso el apóstol Pablo escribe que el fin no vendrá a menos que la Bestia, el hombre de pecado,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("el hombre de maldad, el que está destinado a la destrucción. Este se opone…"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Su naturaleza es desafiar. Así como el Dragón buscó exaltarse a sí mismo en vez de Dios y desafiándolo, la Bestia buscará hacer lo mismo. Él es el que")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "237",
      "epub:type": "pagebreak",
      "id": "page237",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("se levanta contra todo lo que lleva el nombre de dios o es objeto de adoración."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Así como la naturaleza del Dragón es orgullo y blasfemia, también es la naturaleza de la Bestia. De forma que en Apocalipsis está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Abrió la boca para blasfemar contra Dios, para maldecir su nombre y su santuario y a los que viven en el cielo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El tornado")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El Dragón es el tornado que retuerce la realidad, dobla el tejido de la existencia, alejando la creación de su condición de ser. Así también la Bestia torcerá, doblará y girará lo que es. Como está escrito que lo hará.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("tratará de cambiar las fechas importantes y también las leyes."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La raíz latina de "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cambiar")]), _vm._v(" es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("vert")]), _vm._v(". De modo que la Bestia invertirá, revertirá, convertirá, desviará, pervertirá y subvertirá. Luchará contra el Creador invirtiendo, pervirtiendo y subvirtiendo el orden creado. El suyo será un reino antinatural, uno que hace la guerra contra el orden de la creación. De ese modo, tratará de torcer la naturaleza de la humanidad para que se convierta en algo que no sea humano, más que humano, menos que humano e inhumano. Intentará descomponer la naturaleza del hombre, de la mujer, del género, de la familia, de la sociedad, de la civilización. Y así como el Dragón lucha contra la existencia, la Bestia luchará contra la vida, su esencia y su santidad. Alterará valores, definiciones y percepciones. Torcerá y doblará la imagen de Dios para poder destruirla.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Anti-Mesías")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así como la naturaleza del mal debe tomar el lugar del bien, y la naturaleza del Dragón el lugar de Dios, la naturaleza de la Bestia será tomar el lugar del Mesías. Será así el mesías sustituto, el Anti-Mesías, el Anticristo. Así como el Dragón busca imitar a Dios para reemplazarlo, la Bestia vendrá imitando al Mesías. Como el Mesías es el Salvador, la Bestia será el falso salvador. Así como el Mesías traerá paz a la tierra, la Bestia traerá una paz falsa. Así como el Mesías reinará sobre un reino que cubrirá la tierra, "), _c('span', {
    attrs: {
      "aria-label": "238",
      "epub:type": "pagebreak",
      "id": "page238",
      "role": "doc-pagebreak"
    }
  }), _vm._v("la Bestia gobernará sobre una civilización y un estado unimundial. Y así como el mundo ha venerado al Mesías, venerará a la Bestia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El archidepredador")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Aunque la Bestia viene con la apariencia del Mesías, él es su opuesto y antítesis. El Mesías es la redención de la vida, por eso la Bestia es su negación. El Mesías personifica la humildad; la Bestia, la arrogancia. El Mesías es el sanador, el restaurador de los quebrantados; la Bestia es la que hiere y la destructora. El Mesías reconcilia al mundo con Dios; la Bestia aleja al mundo de Dios. El Mesías es el pastor; la Bestia es el depredador. El Mesías es el Cordero; la Bestia es el lobo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El gran profanador")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El 7 de octubre fuimos testigos de la profanación del sábado, los días santos y el jubileo por parte del Dragón. Por tanto, la Bestia —como descendencia del Dragón— dará paso a un reino de profanación. Contaminará a los puros, degradará la creación, pervertirá lo santo y satanizará a los piadosos. No es casualidad que las Escrituras profeticen su venida a la Ciudad Santa, Jerusalén. Es el lugar más santo que más puede ser profanado. Allí se sentará ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("como Dios en el Templo de Dios, mostrándose como Dios."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Su profanación del Templo personificará la manera en que profana al hombre.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La Bestia antisemita")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Finalmente, así como el Dragón hace la guerra contra la mujer, la Bestia la hará contra Israel. Será la culminación de todos los líderes tenebrosos de la historia cuya maldad y brutalidad solo fueron igualadas por su obsesión mortal con el pueblo judío. Pero él los superará a todos. Figuras demoníacas como Hitler y Himmler palidecerán en comparación. Así como el Dragón es el padre del antisemitismo, la Bestia será su encarnación. Él implementará los planes del Dragón para los hijos de Israel y el intento final de aniquilarlos.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "239",
      "epub:type": "pagebreak",
      "id": "page239",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Señales de la Bestia")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("A medida que los días de la Bestia se acerquen, las señales de su venida se harán cada vez más visibles. Esperaríamos que su naturaleza y características marcaran, moraran y caracterizaran cada vez más la cultura moderna. Las Escrituras hablan del espíritu del Anticristo como presente en el mundo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")]), _vm._v(" Así que a medida que se acerca el tiempo de su venida, esperemos que el espíritu de la Bestia se vuelva cada vez más manifiesto, descarado y dominante. Deberíamos esperar ver el surgimiento de una civilización que manifieste los atributos de la Bestia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por lo tanto, esperaríamos ver…")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Un alejamiento sin precedentes de Dios, de su Palabra, de sus caminos, del Mesías, un movimiento masivo de apostasía.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("La reversión de normas y fundamentos que se han mantenido desde la antigüedad, el cambio de valores, leyes, moralidad y percepción.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Una guerra sin precedentes contra la naturaleza, contra la creación, contra la masculinidad, la feminidad, los niños, la sexualidad, el matrimonio, la familia y la vida.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Una animosidad creciente contra Dios y sus caminos, y el predominio de eso sobre las principales instituciones de la cultura.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El surgimiento de un virulento espíritu antiisraelí y antijudío. Lo que estalló el 7 de octubre en Israel y luego en todo el mundo fue un atisbo de ese surgimiento. Esperaríamos que ese espíritu se apoderara cada vez más de la generación emergente y de la corriente principal de la cultura mundial.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En definitiva, las señales de la Bestia ya se están manifestando, y el espíritu de la Bestia ya se está moviendo, transformando, poseyendo y preparando el mundo para ese día.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "240",
      "epub:type": "pagebreak",
      "id": "page240",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría haber más en la cuestión de Palestina de lo que hemos imaginado? ¿Podría revelar una dinámica y una estrategia detrás de lo que está transformando la civilización occidental y las culturas nacionales? ¿Podría estar alterando incluso ahora la naturaleza humana, el hombre, la mujer, el matrimonio, la familia y nuestras vidas? Para revelar este otro lado, vayamos al meollo de la cuestión para abrir el misterio de Palestina.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "241",
      "epub:type": "pagebreak",
      "id": "page241",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-143"
    }
  }, [_vm._v("Capítulo 60")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-144"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor059"
    }
  }), _vm._v("El misterio y la estratagema de Palestina")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("a cuestión de ")]), _c('span', [_vm._v("Palestina involucra a Israel, Medio Oriente y, cada vez más, a todas las naciones. Está detrás de actos de terrorismo, resoluciones de la ONU, levantamientos, conflictos globales e incluso hasta es posible que detrás de una guerra mundial. ¿Pero podría el problema ser aún mayor? ¿Podría revelar un plan maestro que afecte prácticamente a todos los ámbitos de la vida? ¿Podría exponer la estrategia y la agenda del Enemigo para el fin de los tiempos? Llegamos ahora a la esencia, al corazón del asunto: el misterio y la estratagema de Palestina.")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll ParaOverride-2"
  }, [_vm._v("La estratagema palestina")]), _vm._v(" "), _c('p', {
    staticClass: "pab ParaOverride-2"
  }, [_vm._v("¿Cuál es la esencia de la estrategia del Enemigo en cuanto a tocar la Tierra Prometida? Es tomar la tierra que pertenece especialmente a Dios, la tierra dada a un pueblo específico, Israel, y para un propósito determinado, la redención, y separarla de ese pueblo y de ese propósito. Es borrar la identidad de la tierra, tachar su historia y divorciarla del llamado que se le dio. Luego se reemplazará la identidad borrada con una alterna, una inventada y una identidad conflictiva nacida de los antiguos enemigos de la tierra. Ese es el significado de Palestina: es aquello que lucha contra lo que Dios se propuso y lo reemplaza. Es sacar a Israel de la tierra de Israel y la promesa de la Tierra Prometida y, con eso, destruir los propósitos de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Sin embargo, la estratagema va mucho más allá de la Tierra Prometida. Es la estratagema maestra del Enemigo para todos los ámbitos: tomar lo que pertenece a Dios y separarlo de él, de su identidad y propósito, para luego darle una identidad alterna, fabricada y un propósito que lucha contra la razón de su existencia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll ParaOverride-2"
  }, [_vm._v("La palestinización de la cultura")]), _vm._v(" "), _c('p', {
    staticClass: "pab ParaOverride-2"
  }, [_vm._v("La estratagema se puede ver en todos los ámbitos de las obras del Enemigo y se hará cada vez más evidente en los últimos tiempos. Incluso ahora, está "), _c('span', {
    attrs: {
      "aria-label": "242",
      "epub:type": "pagebreak",
      "id": "page242",
      "role": "doc-pagebreak"
    }
  }), _vm._v("transformando la civilización occidental. El plan del Enemigo es tomar una civilización nacida sobre un fundamento bíblico e imbuida de una identidad y un propósito cristianos, y separarla de ese fundamento, esa identidad y ese propósito. Así como la tierra de Israel fue separada de Israel, la civilización occidental está siendo progresivamente apartada de los cimientos cristianos y bíblicos sobre los que se ha sustentado desde la antigüedad.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como la tierra de Israel pasó a llamarse Palestina y, por lo tanto, se le dio una identidad que era antiDios, antibíblica y pagana, ahora somos testigos de la misma transformación de la civilización occidental, el surgimiento de una identidad nueva y alterna que es, igualmente antibíblica, antiDios y pagana. Estamos siendo testigos de la palestinización de la civilización occidental.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Este mismo proceso y transformación se puede ver en funcionamiento en prácticamente todas las naciones y culturas dentro de la civilización occidental, a medida que cada una se divorcia poco a poco de su fundamento bíblico y de su identidad judeocristiana para asumir una identidad alterna y antibíblica. Y así como la estratagema palestina tiene como objetivo, en última instancia, borrar la memoria de Israel, también está en juego, en toda la civilización occidental, un borrado masivo, una reescritura de la historia y una alteración de la memoria colectiva, en la que se supriman sus fundamentos cristianos y bíblicos o sean borrados por completo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La palestinización de la naturaleza humana")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La estratagema, sin embargo, es más profunda. Ahora está tocando la propia naturaleza humana. Y así la humanidad es redefinida y separada de su estado natural de ser, separada de su conexión con Dios y su propósito creado. Los hombres son progresivamente separados de la paternidad, el matrimonio, la familia (de la virilidad) y luego se les otorgan identidades alternas, antinaturales y desmasculinizadas, identidades que luchan contra su naturaleza creada. De la misma manera, las mujeres son progresivamente separadas de la maternidad, el matrimonio, la familia (de la condición de mujer) y, del mismo modo, se les otorgan identidades opcionales, antinaturales y desfeminizadas que luchan contra su naturaleza original. Y así como la tierra de Israel llevaba un nombre que luchaba contra su esencia, Palestina, los hombres se llaman ella y ellos, y las mujeres, él y ellos. La estratagema corta todas las cosas, las redefine todas y las altera todas: el matrimonio, la familia, la vida, la existencia.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "243",
      "epub:type": "pagebreak",
      "id": "page243",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Y por eso no es casualidad que el mismo mundo que lucha contra la promesa y el propósito de Dios con respecto a Israel, también se enfurezca contra los propósitos y el plan de Dios con respecto al hombre, la mujer, los niños, el matrimonio, la familia, la sociedad y la humanidad. Tampoco es casual que el mismo mundo que celebra a Palestina, la identidad alterna dada a la Tierra Prometida, también celebre las identidades opcionales dadas al hombre. Y por la misma razón, no es casualidad que aquellos en el mundo que defienden con más firmeza los propósitos de Dios para el orden creado sean abrumadoramente los mismos que, de igual manera, defienden con mayor firmeza los propósitos de Dios para Israel. No es un accidente, porque los dos reinos están intrínsecamente ligados.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La palestinización de la vida")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("No podemos concluir la estratagema palestina sin llevarla a su ámbito y aplicación más personales. Así como el Enemigo aplica la estrategia a Israel y al mundo, a la civilización y a la naturaleza humana, también la aplica a cada vida. Es su estrategia separar cada vida de Dios y de la identidad y propósito para el cual fue creada. Luego les da a cada uno una identidad alterna y caída, un propósito alterno y caído, y una vida opcional y caída. La identidad alterna lucha contra la verdadera identidad, el propósito alterno reemplaza al verdadero propósito y la vida opcional mantiene a cada uno alejado de la vida para la que cada quien fue creado.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y, sin embargo, aun cuando la Tierra Prometida fue llamada Palestina, incluso cuando languideció en su estado caído, incluso bajo sus ruinas y los símbolos de una identidad extranjera, seguía siendo la tierra de Israel. Debajo de todo eso todavía estaba la Tierra Prometida, la tierra que Dios había prometido y dado a los hijos de Israel. Y las promesas de Dios todavía estaban sobre él. Así también, incluso en nuestras identidades alternas y caídas, aun en nuestros pecados y las ruinas de la vida, debajo de todo está lo que Dios creó a su imagen y un vacío con la forma de Dios que solo puede llenarse con su presencia. Debajo de todo eso hay todavía una promesa, un llamado y la esperanza de redención. Y debajo de todo hay un corazón que clama por redención. De modo que, solo al recibir la presencia de Dios puede llegar la redención a esa vida, sanar su quebrantamiento, florecer sus desiertos y cumplirse su promesa, como en la resurrección de una Tierra Prometida.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "244",
      "epub:type": "pagebreak",
      "id": "page244",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Es el destino de la historia mundial, su cataclismo final. ¿Es posible que los acontecimientos del 7 de octubre y los que le siguieron se relacionen con lo que se conoce como Armagedón?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "245",
      "epub:type": "pagebreak",
      "id": "page245",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-145"
    }
  }, [_vm._v("Capítulo 61")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-146"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor060"
    }
  }), _vm._v("Armagedón y la locura del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("ay tres espíritus ")]), _vm._v("inmundos que proceden “como ranas” del Dragón, la Bestia y el falso profeta: ¿cuál es su propósito y misión? Ellos salen")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("salen a reunir a los reyes del mundo entero para la batalla … en el lugar que en hebreo se llama Armagedón."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Armagedón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Armagedón")]), _vm._v(" ha llegado a significar la guerra final, o la última guerra antes de la venida del Mesías. Pero es el nombre de un lugar, un valle en el norte de Israel. Solo en este versículo aparece la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Armagedón")]), _vm._v(". Por tanto, es significativo que su aparición esté vinculada al Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Armagedón es el terreno en el que se reunirán los ejércitos del mundo para librar la guerra final. ¿Cuál será el propósito de esa batalla? El escenario presentado en Apocalipsis se fusiona con profecías similares dadas en las Escrituras hebreas en las que las naciones del mundo convergen en una guerra contra Israel. La idea de que el mundo entero esté librando una guerra contra una pequeña nación del Medio Oriente podría parecer absurda, si no imposible. Pero no es más absurdo o imposible que las profecías de una nación que se levantará de entre los muertos después de dos mil años. Y, sin embargo, lo que la Biblia predijo se ha cumplido.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Bajo la influencia")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Por lo revelado en el Libro de Zacarías, las naciones vendrán contra Israel en una guerra que amenaza su existencia. ¿Por qué? ¿Por qué el mundo entero quiere destruir la nación judía? Parece algo totalmente irracional. La respuesta se da en Apocalipsis. Lo harán bajo la influencia del Dragón, así como, bajo la misma influencia —el Tercer Reich—, de manera igualmente irracional y demoníaca, buscó borrar a la nación judía de la faz de la tierra.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "246",
      "epub:type": "pagebreak",
      "id": "page246",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando el pueblo judío fue esparcido por toda la tierra, también se esparció por toda la tierra la guerra del enemigo contra ellos. Pero con su reunión y concentración en la tierra de Israel, su guerra también se concentrará allí. Así vendrá Armagedón. Bajo la influencia del Dragón, las naciones buscarán aniquilar al pueblo judío.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Un tiempo de posesión")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La implicación de la profecía es que los espíritus que se dirigen a los reyes de la tierra, de alguna manera, los poseerán para ejecutar la voluntad del Dragón. Según la profecía bíblica, la civilización del fin de los tiempos será aquella que se habrá apartado de Dios y se habrá despojado de su presencia. Una civilización así es más vulnerable a la posesión del enemigo. También en esto el 7 de octubre nos ofrece un vistazo de lo que vendrá.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La ira satánica mortal de ese día fue un presagio de una ira aún más mortífera y satánica que, en los últimos días, poseerá a las naciones. La propagación de esa rabia y la explosión de odio antiisraelí y antijudío en todo el mundo a raíz del 7 de octubre nos dan otra visión de lo que llevará a las naciones al Armagedón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El juego de ajedrez")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Es un juego de ajedrez jugado por el Dragón. La furia que estalló en todo el mundo contra Israel lo hizo en nombre de "), _c('span', {
    staticClass: "ITAL CharOverride-1"
  }, [_vm._v("Palestina")]), _vm._v(". Porque la resurrección de Filistea siempre fue algo más allá de los palestinos. El Enemigo sabía que, por sí solos, no podrían destruir la nación de Israel. Pero si pudiera convertirlos en la causa, el pararrayos, el detonante y el catalizador para impulsar al mundo a enfurecerse contra Israel y buscar su destrucción, lograría su fin.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El nombre "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestina")]), _vm._v(" siempre ha hecho referencia a la existencia de Israel, o más bien a la eliminación de su existencia. El Enemigo utilizó el 7 de octubre para revivir la cuestión de Palestina y encender el odio contra Israel en todo el mundo. Por lo tanto, lo que ocurrió aquella mañana de octubre y lo que desencadenó en todo el mundo puede darnos una idea de la dinámica del Armagedón. La cuestión de Palestina puede no solo presagiar ese acontecimiento del fin de los tiempos, sino que en realidad puede ser una de las semillas utilizadas para provocar su llegada.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "247",
      "epub:type": "pagebreak",
      "id": "page247",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Dragón va a la universidad")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Mientras escribo estas palabras, los acontecimientos se están desarrollando una vez más en el mundo de acuerdo con los misterios y profecías considerados en estos capítulos. Fue después de que comencé a escribir sobre Armagedón y la locura del Dragón que una ola de locura del Dragón, un torrente de odio y furia antiisraelí, antijudío y antisemita, explotó en las universidades estadounidenses. Los cánticos de “¡Viva Hamas!” y “¡Muerte a los judíos!” se podía escuchar en las universidades más destacadas y elitistas del país.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Lo que fue igualmente sorprendente fue dónde estaba sucediendo. No era en una nación musulmana o árabe, ni en una nación en guerra con Israel. Estaba sucediendo en Estados Unidos, el aliado más cercano de Israel. Es ese hecho el que es especialmente significativo con respecto a la profecía del fin de los tiempos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El antiguo contagio en suelo americano")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En vista del misterio y de la guerra librada desde la antigüedad hasta ahora, no debería sorprendernos que Israel se haya convertido en el principal objetivo y chivo expiatorio del movimiento Woke, tal como ha sido el principal objetivo y chivo expiatorio de innumerables movimientos y odios a lo largo de todo el mundo. las edades. Tampoco debería sorprendernos que incluso el aliado más fiel de Israel, Estados Unidos, esté infectado por el orgidzo del Dragón. El contagio es mucho más antiguo que Estados Unidos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La Biblia profetiza que, al final, todas las naciones vendrán contra la nación de Israel. Todas las naciones tendría que incluir a Estados Unidos. La idea de que este país, el mayor aliado de Israel, algún día pueda declarar la guerra a Israel parecería imposible, pero el hecho de que quienes lideran las manifestaciones antiisraelíes en todo el país representen el futuro de Estados Unidos dice lo contrario. Y las manifestaciones fueron solo el síntoma de un cambio siniestro que se estaba produciendo entre los jóvenes estadounidenses contra la nación judía, un cambio que se alinea con la profecía bíblica. En otras palabras, el giro de Estados Unidos contra Israel equivale a Armagedón.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "248",
      "epub:type": "pagebreak",
      "id": "page248",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Planeta extraño")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En vista de la profecía de Armagedón, uno debe considerar el hecho de que ya estamos viviendo en un mundo en el que las naciones se reúnen regularmente para condenar no sus dictaduras, ni sus brutales regímenes totalitarios, ni aquellas naciones que han masacrado a millones de sus propios ciudadanos, sino más bien critican y asedian a una pequeña democracia en Medio Oriente, por el crimen de existir. Se ha observado en tiempos recientes que las Naciones Unidas han condenado a Israel más que a todas las demás naciones juntas. Se han enfurecido contra la misma nación que surgió de las cenizas del Holocausto y que, el día de su nacimiento, tuvo que luchar por su existencia mientras las naciones circundantes buscaban aniquilarla; la misma nación cuyo nacimiento la mayoría de las naciones del mundo conmemoran como una nakba, una calamidad, un holocausto.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Una modalidad de locura")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Si los visitantes de otro mundo observaran cosas así, concluirían no solo que algo muy extraño y más que natural estaba sucediendo, sino que habían llegado a un planeta que padecía una forma aguda de locura. Y estarían en lo correcto. Pero esa locura es antigua, la misma que requirió el nacimiento de un Israel en primer lugar para que el pueblo judío pudiera ser protegido de la aniquilación. Es la misma locura que una vez salió de la boca de Adolf Hitler en Nuremberg, la misma que operó las cámaras de gases en Auschwitz, la misma que condujo a la masacre del 7 de octubre, y la misma que conducirá a la mundo al Armagedón. Es una locura satánica, una manía apocalíptica. Es la locura del Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Ahora que hemos revelado el fin de los días, podemos descubrir un último misterio detrás del día calamitoso de Israel, uno que está directamente relacionado con el apocalipsis, el Libro de Apocalipsis y el lugar más sagrado.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "249",
      "epub:type": "pagebreak",
      "id": "page249",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-147"
    }
  }, [_vm._v("Parte 13")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-148"
    }
  }, [_vm._v("Secreto en EL MONTE")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "250",
      "epub:type": "pagebreak",
      "id": "page250",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-149"
    }
  }, [_vm._v("Capítulo 62")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-150"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor061"
    }
  }), _vm._v("El epicentro de la profecía")]), _vm._v(" "), _c('p', {
    staticClass: "pf-2"
  }, [_c('span', {
    staticClass: "DROP-CAP"
  }, [_c('span', {
    staticClass: "_ _idGenCharOverride-3"
  }, [_vm._v("¿")])]), _c('span', {
    staticClass: "_idGenDropcap-2"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("odría un evento ")]), _vm._v("predicho en la profecía del fin de los tiempos y en el Libro de Apocalipsis ser en realidad la causa oculta y el secreto detrás del 7 de octubre?")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Cuando el dragón se vio arrojado a la tierra, persiguió a la mujer que había dado a luz al varón. Pero a la mujer se le dieron las dos alas de la gran águila, para que volara al desierto, al lugar donde sería sustentada durante un tiempo y tiempos y medio tiempo, lejos de la vista de la serpiente."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En la visión de la guerra del Dragón, la mujer es llevada al desierto para hallar seguridad. La duración de su ocultamiento se da en una frase misteriosa: “un tiempo y tiempos y medio tiempo”. ¿Qué significa eso?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Cuando todas estas cosas acaben”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En los capítulos finales de Daniel, un ángel le da al profeta una visión del futuro de Israel en los siglos venideros y en los últimos días. La visión incluye la guerra, la persecución y el gobernante al que se hace referencia en el Apocalipsis como la Bestia. Al final de la profecía, un segundo ángel pregunta cuánto tiempo pasará hasta que todo se cumpla. La respuesta dada es esta:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Faltan un tiempo, tiempos y medio tiempo. Todo esto se cumplirá, cuando termine la destrucción del pueblo santo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Es la misma frase dada para describir el momento en que la mujer se escondió del Dragón. Anteriormente en el Libro de Daniel, un ángel le da al profeta otra revelación acerca de la Bestia y el fin de los días:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Hablará en contra del Altísimo y oprimirá a sus santos; tratará de cambiar las fechas importantes y también las leyes, y los "), _c('span', {
    attrs: {
      "aria-label": "251",
      "epub:type": "pagebreak",
      "id": "page251",
      "role": "doc-pagebreak"
    }
  }), _vm._v("santos quedarán bajo su poder por un tiempo, dos tiempos y medio tiempo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Desde Daniel hasta el Libro de Apocalipsis, la coherencia de las Escrituras es sorprendente, como lo es la reaparición de la frase “un tiempo y tiempos y medio tiempo”. Cada aparición hace referencia a un tiempo de persecución. La persecución es orquestada por el Dragón y llevada a cabo por la Bestia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El dominio de la bestia")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La profecía de la Bestia en Apocalipsis 13 coincide precisamente con la dada en Daniel:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y se le dio boca que hablaba grandes cosas y blasfemias, y se le dio autoridad para actuar cuarenta y dos meses."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En Daniel es por un tiempo y tiempos y medio tiempo. En Apocalipsis es por cuarenta y dos meses. Cuarenta y dos meses son tres años y medio. Así, un tiempo es un año, tiempos son dos años y medio tiempo es medio año: tres años y medio. Este es el tiempo del dominio de la Bestia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El refugio")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El significado de la frase se confirma aún más en otro versículo de Apocalipsis 12, donde el tiempo de refugio de la mujer del Dragón se da en términos de días:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Entonces la mujer huyó al desierto, donde tiene un lugar preparado por Dios, para que allí la alimenten "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("mil doscientos sesenta días")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Mil doscientos sesenta días es otra versión de tres años y medio. Entonces se dan tres años y medio para el reinado de la Bestia, el poder del Dragón y la persecución demoníaca de la mujer, Israel.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "252",
      "epub:type": "pagebreak",
      "id": "page252",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Monte del Templo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Pero las Escrituras nos dan una revelación aún más específica sobre lo que sucederá en ese tiempo. Todo se centra en el Monte del Templo. En Apocalipsis 11 un ángel le dice al discípulo que mida el Monte del Templo con una excepción:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Pero deja fuera el atrio que está fuera del templo, y no lo midas, porque ha sido dado a los gentiles. Y hollarán la ciudad santa durante "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("cuarenta y dos meses")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Insisto, tenemos un lapso de cuarenta y dos meses. En ese tiempo los atrios del Templo y la ciudad de Jerusalén serán entregados a los enemigos de Dios y a los enemigos de Israel. El principal de esos enemigos será la Bestia. Entonces, el reinado del Anticristo al final de los tiempos está conectado con el Monte del Templo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Shikutzim: las abominaciones")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Daniel 9 nos da una pista más de lo que sucederá en el Monte del Templo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Luego confirmará un pacto con muchos durante una semana; pero "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("a mitad de la semana")]), _vm._v(" pondrá fin al sacrificio."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La palabra traducida aquí como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("semana")]), _vm._v(" es la palabra hebrea "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("shavuah")]), _vm._v(", que habla de un lapso de tiempo marcado por el número siete, en este caso siete años. Esto se conoce como el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Período de la Tribulación")]), _vm._v(", los últimos siete años previos al regreso del Mesías. "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("La mitad de la semana")]), _vm._v(", o siete dividido por dos, resulta nuevamente en tres años y medio, un tiempo, tiempos y medio tiempo. ¿Qué pasará entonces? El Anticristo abolirá las ofrendas y sacrificios del Templo. La profecía continúa:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y en el ala de las abominaciones estará el desolador."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("La palabra traducida como abominaciones es el vocablo hebreo "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("shikutzim")]), _vm._v(". La misma palabra se usa en las Escrituras hebreas para hablar de ídolos. Esto es lo que el Mesías llamó la “abominación desoladora”. Comúnmente se entiende como la instalación de un ídolo por parte del Anticristo "), _c('span', {
    attrs: {
      "aria-label": "253",
      "epub:type": "pagebreak",
      "id": "page253",
      "role": "doc-pagebreak"
    }
  }), _vm._v("en el Monte del Templo durante los últimos tres años y medio del Período de Tribulación, provocando así la profanación del lugar santo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El epicentro de la profecía")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así que todo se centra en el pedazo de tierra conocido como el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Monte del Templo")]), _vm._v(". La posesión de esa montaña por parte de la Bestia constituirá su conquista definitiva. Su profanación representará su acto último. ¿Por qué el Monte del Templo? El Monte del Templo es el centro de Jerusalén, el centro de Israel, el centro de los propósitos de Dios en la tierra. Es el terreno más sagrado. Fue allí donde el pueblo de Israel ascendió para adorar al Señor, observó sus días santos señalados y celebró sus fiestas. Fue allí donde se levantó la casa de Dios y reposó su presencia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por tanto, si el Monte del Templo es el terreno central de los propósitos de Dios, también se convertirá en el terreno central de los propósitos del Enemigo. Y si el Monte del Templo es lo más parecido en la tierra al trono de Dios, y el Enemigo busca sentarse en el trono de Dios, entonces es inevitable que intente tomar posesión de él.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Además, si el Monte del Templo es el lugar desde el cual reinará el Mesías, y el Enemigo busca detener los propósitos de Dios, entonces buscará establecer en ese Monte su propio reinado. Por último, si el Monte del Templo es el terreno más santo de Dios, entonces debe convertirse en el terreno de las profanaciones más impías del Enemigo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por eso era inevitable que el Monte del Templo se convirtiera en el terreno más disputado de la tierra, el espacio central en la guerra de Dios y el Enemigo, la mujer y el Dragón, el Cordero y la Bestia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El territorio de la criatura")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El Dragón es una criatura territorial. Nunca cede terreno sin luchar. Para que la tierra de Israel fuera devuelta al pueblo judío fue necesaria la Primera Guerra Mundial. Para que la tierra se convirtiera realmente en la nación de Israel, se requirió de la Guerra de Independencia. Para que Jerusalén fuera devuelta al pueblo judío, fue necesaria la Guerra de los Seis Días. En cada caso el enfoque se redujo, desde la tierra a la nación y a la ciudad. En cada caso se produjo a través de la guerra y el derramamiento de sangre. La reducción final del enfoque debe referirse al Monte del Templo. Y así, el más mínimo movimiento con respecto a ese terreno puede provocar "), _c('span', {
    attrs: {
      "aria-label": "254",
      "epub:type": "pagebreak",
      "id": "page254",
      "role": "doc-pagebreak"
    }
  }), _vm._v("una tormenta de fuego. Lo que estamos a punto de ver es que en realidad ya sucedió, y todos fuimos testigos de ello.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Si el Monte del Templo es el terreno central de la guerra del Dragón y la mujer, ¿podría haber desempeñado un papel en la calamidad del 7 de octubre? ¿Podría ser, de hecho, el misterio profético que se esconde detrás de todo esto?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "255",
      "epub:type": "pagebreak",
      "id": "page255",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-151"
    }
  }, [_vm._v("Capítulo 63")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-152"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor062"
    }
  }), _vm._v("Las vacas rojas")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("n el segundo ")]), _c('span', [_vm._v("capítulo de Isaías se nos da una visión profética del reino de Dios en la tierra:")])]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("En los últimos días, ")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("    el monte del Templo del Señor será establecido")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("    como el más alto de los montes;")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("se alzará por encima de las colinas")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("    y hacia él correrán todas las naciones."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("El monte del Señor")]), _vm._v(" es, más específicamente, el Monte del Templo. De ese monte saldrá la palabra de Dios al mundo, el conocimiento de Dios a las naciones, y el reino de Dios hasta los confines de la tierra. Y desde allí reinará el Mesías.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El dragón en el monte")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En vista de la importancia del Monte del Templo para el reino de Dios, supondríamos que el enemigo buscara poseerlo. Con su posesión, lo siguiente que buscaría sería impedir, a toda costa, una posesión o un lugar para cualquier persona judía en su interior. Con ello, impediría que las profecías se cumplieran allí, que el Templo se construyera allí, que las festividades y los días santos de Israel se observaran allí y que el Mesías reinara allí. Incluso podríamos esperar que llegara tan lejos como para impedir que las oraciones del pueblo judío se dijeran allí.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El terreno más peligroso")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Cómo haría el enemigo todo eso? Utilizando a aquellos que actuarían como sus peones involuntarios, los que lucharían para mantener al pueblo "), _c('span', {
    attrs: {
      "aria-label": "256",
      "epub:type": "pagebreak",
      "id": "page256",
      "role": "doc-pagebreak"
    }
  }), _vm._v("judío o cualquier manifestación de adoración y observancia judía alejado del monte.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Lo que esperaríamos que hiciera el Dragón, ya lo ha hecho. Al momento de escribir esto, no se permite que ningún templo o casa de adoración judía se erija en el Monte del Templo. Allí no se permite celebrar ninguna festividad judía ni ningún día santo judío. Incluso hace tiempo que está prohibido pronunciar oraciones judías allí."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Cualquier incumplimiento de esas prohibiciones amenaza con causar una explosión. Y así, el Monte del Templo se ha convertido en el terreno más peligroso de la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Si pierde el control")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Habiendo expulsado al pueblo judío de su montaña sagrada y prohibido su regreso a adorar allí, ¿qué pasaría entonces si existiera el riesgo de que el Dragón pudiera perder, en cualquier grado, su control o posesión del Monte? ¿Qué pasaría si existiera la posibilidad de que el culto o la observancia judía regresara de alguna manera al Monte del Templo? ¿Qué pasaría si hubiera algún informe, rumor o el más mínimo movimiento sobre el regreso del pueblo judío al Monte, para orar u observar uno de los días santos designados por Dios?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Esperaríamos que eso fuera una amenaza para el Dragón. Esperaríamos una explosión de su rabia y su locura. Esa explosión, en realidad, se produciría el 7 de octubre. Pero, ¿qué tiene que ver el 7 de octubre con el Monte del Templo? Todo. La extraña verdad es que no se puede entender lo que pasó ese día sin comprender su conexión con el Monte del Templo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“No jueguen con fuego”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En la primavera de 2023, en medio de informes de judíos que buscaban observar un día santo judío en el Monte del Templo, estalló un enfrentamiento en la cima del Monte en la Mezquita de Al-Aqsa entre palestinos y la policía israelí. Los palestinos atacaron a las autoridades con piedras y fuegos artificiales. La policía respondió con balas de goma y granadas paralizantes. Al menos una docena de personas resultaron heridas y cientos fueron arrestadas. La noche siguiente, se produjo otro enfrentamiento en el mismo lugar."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("A raíz de ese conflicto en el Monte del Templo, se dispararon cohetes contra Israel desde Gaza y el Líbano."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" Posteriormente, Hamas advirtió a Israel que estaba “jugando con fuego”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" Seis meses después, el 7 de octubre , se produjo el incendio.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "257",
      "epub:type": "pagebreak",
      "id": "page257",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los orígenes secretos del 7 de octubre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Inmediatamente después de la invasión del 7 de octubre, el líder de Hamas, Ismail Haniyeh, pronunció un discurso en el que le dijo al mundo el motivo del día de esas matanzas y atrocidades. Fue, dijo, la respuesta a lo que había sucedido en el Monte del Templo la primavera anterior. Afirmó que Israel había considerado oportuno sembrar corrupción en la sagrada "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mezquita de Al-Aqsa")]), _vm._v(" [el Monte del Templo] en "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Al-Quds")]), _vm._v(" ["), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jerusalén")]), _vm._v("]. Les dijimos: “No jueguen con fuego”… han invadido la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mezquita de Al-Aqsa")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("No es un tema de debate. En palabras de quienes lo idearon, el 7 de octubre fue la respuesta a lo que había ocurrido en el Monte. Haniyeh continuó:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y cuando la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mezquita Al-Aqsa")]), _vm._v(" se encuentre en peligro inminente… este gobierno [israelí] se prepara para imponer su soberanía y su autoridad sobre la bendita "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mezquita Al-Aqsa")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Incluso el rumor de que la soberanía judía regresaría de cualquier manera y en cualquier grado al Monte del Templo fue suficiente para desencadenar el derramamiento de sangre y la calamidad del 7 de octubre. Todo comenzó con la Mezquita de Al-Aqsa y, según Haniyeh, todo terminaría allí:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Con una derrota aplastante que lo expulsará [a Israel] de nuestras tierras, de nuestra ciudad santa de Al-Quds, de nuestra Mezquita de Al-Aqsa."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Un comunicado emitido por Fatah calificó el 7 de octubre como un día de victoria, alegría y orgullo, en el que se")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("libró la batalla para defender su honor y "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("sus lugares sagrados, y el más destacado de ellos, la bendita Mezquita de Al-Aqsa")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Lo que ocurrió el 7 de octubre estuvo intrínsecamente ligado al Monte del Templo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Monte del Templo, el Dragón y el 11 de septiembre")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El 7 de octubre no fue la primera vez que la cuestión del Dragón y el Monte del Templo conduciría a una calamidad. Una de esas calamidades fue "), _c('span', {
    attrs: {
      "aria-label": "258",
      "epub:type": "pagebreak",
      "id": "page258",
      "role": "doc-pagebreak"
    }
  }), _vm._v("dirigida contra Estados Unidos, Nueva York y Washington, DC. Se conoció como el 11 de septiembre. Aunque la mayoría de la gente no tenía idea, la tragedia que azotó a Estados Unidos el 11 de septiembre de 2001 y que provocó la muerte de tres mil estadounidenses se relacionaba con la montaña santa de Dios en Jerusalén, el Monte del Templo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cuando Osama Bin Laden escribió su carta a Estados Unidos exponiendo las razones para planear la calamidad del 11 de septiembre, la principal de ellas era la cuestión de Palestina. Estados Unidos era el aliado y partidario más importante de Israel. Por eso había que golpearlo y castigarlo. Mientras Bin Laden arremetía contra los judíos de Israel, escribió esto:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Con su ayuda y bajo su protección, los israelíes están planeando destruir la Mezquita de Al-Aqsa."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Comparemos las palabras de Bin Laden después del 11 de septiembre con las de quienes planearon el 7 de octubre:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Este gobierno [israelí] se está preparando para imponer su soberanía y autoridad sobre la bendita Mezquita de Al-Aqsa")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Las acusaciones son prácticamente idénticas, al igual que la redacción. Y, sin embargo, fueron hechas por dos personas diferentes en dos declaraciones distintas y separadas por más de veinte años. Uno fue el fundamento dado para la calamidad del 7 de octubre de 2023; el otro, el 11 de septiembre de 2001. Sin embargo, ambos se remontaban a la misma acusación y al mismo terreno: el Monte del Templo. Sus paralelos, sus causas comunes y el hecho de que cada uno de ellos resultó en una invasión mortal y destructiva dan testimonio de la realidad más que natural que había detrás de ellos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Entonces, mientras los estadounidenses veían cómo ardía en llamas el Pentágono y el World Trade Center se derrumbaba, no tenían idea de que detrás de su calamidad nacional se escondía un terreno antiguo y una entidad antigua. Detrás de la calamidad del 11 de septiembre, al igual que detrás de la del 7 de octubre, estaba un dragón en el Monte del Templo.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "259",
      "epub:type": "pagebreak",
      "id": "page259",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“La llegada de las vacas rojas”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("A cien días de la guerra que comenzó con la calamidad de Israel, Abu Obeida, portavoz de las Brigadas Al-Qassam, el ala militar de Hamas, emitió un comunicado en el que atribuyó el día de la matanza a")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("una agresión que alcanzó su punto máximo contra nuestro camino (Al Quds) y Al-Aqsa, con el inicio de su actual división temporal y espacial."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Al igual que los autores intelectuales del 7 de octubre, Obeida reafirmó la conexión con Al-Aqsa y el Monte del Templo. Pero su declaración también contenía una referencia misteriosa que desconcertó a la mayoría de los que la escucharon. El derramamiento de sangre también tuvo que ver con las vacas, o como él dijo,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("la traída de vacas rojas como aplicación de un detestable mito religioso…"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("¿Cuáles eran esas vacas rojas? ¿Y cómo fue el 7 de octubre una respuesta para traerlas? Las vacas rojas eran novillas rojizas. Según una antigua ordenanza, las novillas alazanas eran parte obligatoria en una de las funciones del templo. En el otoño de 2022, cinco novillas rojas llegaron a Israel desde Estados Unidos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("14")]), _vm._v(" ¿Cómo causaría eso el alboroto satánico del 7 de octubre? No tendría sentido en el ámbito natural. Pero, insisto, no nos ocupamos de ese ámbito.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Vaca roja, Dragón rojo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El rito de la novilla alazana está relacionado con el Templo. Implica su reconstrucción. Aquellos que trajeron las vacas a Israel lo hicieron con la esperanza de ser parte de la futura restauración del Templo en el Monte."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("15")]), _vm._v(" A los ojos del Dragón la presencia de novillas rojas en la tierra de Israel constituiría una amenaza a su dominio sobre el lugar. La presencia de tropas israelíes en el Monte constituiría otro. En vista de la misión del Dragón de mantener el Monte del Templo alejado del pueblo de Israel y el Templo de Dios del Monte, ¿qué esperaríamos que sucediera? Exactamente lo que "), _c('span', {
    attrs: {
      "aria-label": "260",
      "epub:type": "pagebreak",
      "id": "page260",
      "role": "doc-pagebreak"
    }
  }), _vm._v("pasó; desencadenaría una explosión satánica: el 7 de octubre. El misterio lo había ordenado.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Operación Inundación de Al-Aqsa")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La conexión entre el Monte del Templo y el 7 de octubre fue tan central y tan fuerte que incluso pudo verse en el nombre que Hamas le dio. La llamó la inundación. Pero su nombre completo era Amaliyyat Tufan Al-Aqsa, o Inundación de Al-Aqsa."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("16")]), _vm._v(" Se trataba del Monte del Templo. De eso era de lo que se trataba: del Monte del Templo. Tenía que ver con la posesión de ese Monte por parte del Dragón y con la guerra que allí se libraba por los propósitos de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así que, la invasión del 7 de octubre llevó el nombre de una inundación y de la mezquita situada en el Monte del Templo. Ese día, un diluvio de furia descendió del monte y sobre el pueblo de Israel desde la boca del Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría el acontecimiento más calamitoso de Israel, desde el Holocausto, estar relacionado con su primer y último día?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "261",
      "epub:type": "pagebreak",
      "id": "page261",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-153"
    }
  }, [_vm._v("Capítulo 64")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-154"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor063"
    }
  }), _vm._v("El primero y el último de los días")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("os días santos ")]), _vm._v("de Israel debían celebrarse en la tierra santa: el Monte del Templo. El monte fue designado para los días y los días para el monte. Ya hemos sido testigos de cómo la guerra del Dragón implicó la profanación de los días santos de Israel. Pero la perspectiva de que esos días llegaran al Monte del Templo presentaría al Dragón una doble amenaza. ¿Podría tal conexión y tal amenaza haber jugado un papel en lo que ocurrió el 7 de octubre?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El primero de los días")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El año sagrado hebreo empieza en la primavera. La primera de sus fiestas, la Pascua, cae en el primero de los meses hebreos, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Nisán")]), _vm._v(", nombre que significa comienzo. Así está ordenado,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("La Pascua del Señor comienza el día catorce del mes primero, al comenzar la noche."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Era el sacrificio de Pascua lo que marcaba el comienzo del año sagrado. En la antigüedad, se ofrecía en los atrios del templo el decimocuarto día de Nisán. Así, el año de los tiempos sagrados comenzaba con la celebración de la Pascua en el Monte del Templo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El año calamitoso de Israel también comenzaría con la Pascua y el Monte del Templo. El 7 de octubre marcó el comienzo del mismo día santo que distingue el inicio del año sagrado de Israel. El conflicto estalló la noche del 4 de abril. El día hebreo comienza al atardecer, y la noche del 4 de abril era el 14 de Nisán. El 14 de Nisán es el día que marca el comienzo "), _c('span', {
    attrs: {
      "aria-label": "263",
      "epub:type": "pagebreak",
      "id": "page263",
      "role": "doc-pagebreak"
    }
  }), _vm._v("de la Pascua y el año sagrado de Israel. Pero en 2023, el Dragón celebraría su propia Pascua y daría inicio a un año de días tenebrosos e impíos. Así como Dios usó la Pascua para traer redención y libertad a Israel, el Dragón usaría la festividad para traer a Israel calamidad y terror. La mera idea de que se celebrara la Pascua en el Monte del Templo fue suficiente para provocar la explosión.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Fue en la primavera de 2023 que varios israelíes observantes esperaban celebrar la Pascua en el Monte del Templo y ofrecer el sacrificio del cordero pascual."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")]), _vm._v(" Era lo más cerca que había estado la Pascua del Monte del Templo en mucho tiempo: demasiado cerca para el enemigo. Ese día no se ofrecería ningún sacrificio, pero la posibilidad de que sucediera era todo lo que se necesitaba. Los sacrificios, el derramamiento de sangre, vendrían después.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Sus siniestras fiestas religiosas”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuando el portavoz de Hamas explicó al mundo el motivo de la masacre del 7 de octubre, hizo mención específica de un festival bíblico. Él dijo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("…durante sus siniestras fiestas religiosas han invadido la Mezquita de Al-Aqsa. La profanaron y mancillaron."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("A lo que el portavoz de Hamas se refiere como “sus siniestras fiestas religiosas” son los días sagrados asignados por Dios a Israel en el Monte Sinaí. Fue una inversión asombrosa. El Monte del Templo, desde su inicio, debía servir como terreno en el que se celebrarían los días santos de Israel. Pero para Hamas los días sagrados señalados por Dios, los días santos de Israel, eran festivales religiosos siniestros. Entonces surge la pregunta: “¿Quién vería el día santo de Dios como una profanación y siniestro?” El alterador. El Dragón, para quien lo santo es una profanación y la profanación es santa, y para todos sus hijos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El último de los días")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Si la Pascua es el día inaugural y de apertura del año bíblico sagrado, ¿cuál es entonces su fin, su día de consumación? El último de todos los días santos dados por Dios es el vigésimo segundo día de Tishri. Es aquello que culmina todos los tiempos señalados de Dios y cierra el año sagrado. Así, "), _c('span', {
    attrs: {
      "aria-label": "264",
      "epub:type": "pagebreak",
      "id": "page264",
      "role": "doc-pagebreak"
    }
  }), _vm._v("el calendario sagrado comienza en primavera, el día catorce de Nisán, y termina en otoño, el día veintidós de Tishri.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y entonces, si el día señalado para dar comienzo al año sagrado hebreo, la Pascua, marcó el comienzo del año y el día de la calamidad de Israel, ¿qué pasa con el día señalado para cerrar ese año sagrado hebreo? En otras palabras, ¿cuándo, en el año 2023, cayó el último y penúltimo día del calendario sagrado de Israel, el veintidós de Tishri?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cayó el "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("7 de octubre")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Todo convergió en el último y culminante día de los tiempos señalados de Israel, Shemini Atzeret.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Del 14 de Nisán al 22 de Tishri")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los dos días santos, Pesaj y Sheminí Atzeret, el 14 de Nisán y el 22 de Tishri, el primero y el último, de los tiempos señalados por Dios se unen para enmarcar el año sagrado. En 2023 se volvieron a unir pero, esta vez, por el Dragón. Su calendario de calamidades nació el día de apertura del calendario sagrado de Dios, el 14 de Nisán, y llegaría a su fin en el día culminante de ese calendario. El gran imitador había falsificado todo el calendario sagrado de Dios para profanarlo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El misterio de las profanaciones")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Era un día santo hebreo, el 14 de Nisán, que amenazaba el control del Dragón sobre el Monte del Templo, por lo que elegiría un día santo hebreo como su momento para la venganza: el 7 de octubre. Y como era el primero de los días santos de Dios, la Pascua, el que amenazaba con “profanar” su posesión del Monte, de igual manera profanaría el último de los días santos de Dios, Sheminí Atzeret. Todo comenzó en el primero de los días antiguos, y todo volvería a casa en el último.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Había un secreto más en el día más calamitoso de Israel. Para descubrirlo, debemos remontarnos a una reunión en el Monte del Templo encabezada por uno de los líderes antiguos más famosos de la nación: el rey Salomón.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "265",
      "epub:type": "pagebreak",
      "id": "page265",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-155"
    }
  }, [_vm._v("Capítulo 65")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-156"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor064"
    }
  }), _vm._v("El secreto del rey Salomón")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("emos visto lo ")]), _vm._v("que no estaba destinado para el Monte del Templo. ¿Qué pasa con lo que sí lo estaba?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La dedicación del templo")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Todo comenzó hace tres mil años, cuando el rey Salomón se presentó ante el pueblo de Israel en el Monte del Templo. Se habían reunido allí con un propósito santísimo: dedicar el recién construido Templo de Dios. Así quedó escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("…cuando Salomón terminó de hacer toda esta oración y súplica al Señor, se levantó de delante del altar del Señor, de rodillas con las manos extendidas al cielo. Entonces se levantó y bendijo a toda la asamblea de Israel."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Y así con oración, acción de gracias y sacrificio, se dedicó el Templo de Dios:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Así fue como el rey y todos los israelitas dedicaron el Templo del Señor."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El sello del octavo día")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Entonces el pueblo celebró una fiesta al Señor. Así quedó registrado:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y así, en presencia del Señor nuestro Dios, Salomón y todo Israel celebraron la fiesta durante siete días, extendiéndola … siete días más."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Al octavo día se selló la dedicación:")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Al octavo día despidió al pueblo; y bendijeron al rey."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "266",
      "epub:type": "pagebreak",
      "id": "page266",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("La fiesta que selló la dedicación del Templo fue la Fiesta de los Tabernáculos, Sucot. El pueblo judío lo celebra cada otoño. Un festival relacionado con la construcción del Templo de Dios en el Monte del Templo representaría un desafío a la posesión de ese Monte por parte del Dragón; más aún, el octavo y último día que selló la dedicación del Templo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En 2023, el día santo que selló la dedicación del Templo en el Monte cayó el 7 de octubre. Ese sería el día de la venganza del Dragón. No fue solo que atacó a Israel en un día santo hebreo, sino que "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("lo hizo en el día santo hebreo específico que selló la dedicación del Templo en el Monte del Templo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El canto")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Está previsto que en la reunión del octavo día, Shemini Atzeret, se abran los rollos de la Palabra de Dios y se recite y cante un pasaje de las Escrituras, especialmente designado para ese día. ¿Cuál es la escritura señalada para ese día? Es el relato de la dedicación del Templo. Así que el 7 de octubre no fue solo el día que conmemoró el sellamiento de la dedicación del Templo, sino que fue el día en el que las palabras del relato de esa dedicación fueron recitadas y cantadas públicamente en sinagogas y hogares de todo el mundo judío."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("De hecho, cada escritura citada en este capítulo sobre la dedicación del Templo fue tomada del pasaje específico designado para ser leído y cantado en Shemini Atzeret. Así fueron las palabras proclamadas el 7 de octubre de 2023. Y todas se centran en el Templo de Dios en el Monte del Templo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El día más apropiado")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Solo hay un día de todo el año judío en el que esas palabras deben proclamarse así. En el año 2023 cayó el 7 de octubre. Y así, en la mañana del 7 de octubre de 2023, en toda la tierra de Israel y en todo el mundo se proclamaron las palabras que declaraban la consagración del Templo en el Monte del Templo. Para el Dragón, esa proclamación representaría un desafío a su posesión del Monte. Y por eso sería el día más apropiado para atacar a Israel en una incursión relacionada con la posesión del Monte.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por eso el 7 de octubre Hamas inició su Operación Inundación de Al-Aqsa, refiriéndose al Monte del Templo, mientras el pueblo de Israel se preparaba para recitar la escritura que también hablaba del Monte del Templo. Cada uno hablaba del mismo Monte, uno en hebreo, el otro en árabe; uno, "), _c('span', {
    attrs: {
      "aria-label": "267",
      "epub:type": "pagebreak",
      "id": "page267",
      "role": "doc-pagebreak"
    }
  }), _vm._v("de labios del rabino y cantor judío, el otro de labios de Hamas, el desbordamiento de una inundación que brota de la boca del Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El autor intelectual")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El verdadero cerebro del 7 de octubre no fue Hamas. No podrían haber conocido todos los detalles, complejidades y convergencias involucradas en el hebreo sagrado. El cerebro fue el Dragón. Fue él quien planeó que el ataque cayera el día que selló la construcción y dedicación del Templo en el Monte del Templo. Ahora había hecho en el reino del tiempo lo que ya había hecho en el reino del espacio. Él ya había tomado posesión de la tierra santa de Dios; ahora tomó posesión de su día santo. Como aquel que busca apoderarse y poseer las cosas de Dios, era su naturaleza hacerlo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Al igual que con el 11 de septiembre, el mundo no podría haber imaginado lo que había detrás de lo que sucedió el 7 de octubre. En este caso era un misterio que se remontaba a los días del rey Salomón y, en última instancia, al Libro de Apocalipsis, al Cordero, el Bestia, el reino de Dios y un Dragón furioso en el monte del Señor.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Hay una dimensión más en la guerra del Dragón, una que está unida a la nación de Israel y, sin embargo, va más allá de ella.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "268",
      "epub:type": "pagebreak",
      "id": "page268",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-157"
    }
  }, [_vm._v("Parte 14")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-158"
    }
  }, [_vm._v("Los otros")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "269",
      "epub:type": "pagebreak",
      "id": "page269",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-159"
    }
  }, [_vm._v("Capítulo 66")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-160"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor065"
    }
  }), _vm._v("El resto de sus descendientes")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Entonces el dragón se enfureció contra la mujer y se fue a hacer guerra contra el resto de sus descendientes, los cuales obedecen los mandamientos de Dios y se mantienen fieles al testimonio de Jesús."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("F")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("rustrado en su ")]), _vm._v("búsqueda de la mujer, el Dragón hace la guerra al “resto de sus descendientes”. ¿Quiénes son entonces "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("el resto de sus descendientes")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los demás")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Si la mujer es Israel, de alguna manera deben ser hijos de Israel. Entonces, ¿quiénes son el resto de sus hijos? Hay dos posibles respuestas, una más específica y otra más universal. Lo más específico es que “el resto de sus descendientes” son los hijos de carne y hueso de Israel, el pueblo judío que sigue al Mesías, como los apóstoles, los discípulos y los creyentes que, al principio de la era, constituían la mayoría de la fe y le dieron al mundo el evangelio.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La respuesta más universal es que “el resto de sus hijos” se refiere a todos los creyentes, aquellos que siguen al Mesías de cada nación, tribu y lengua. Pero si no son nacidos de Israel, ¿cómo podrían llamarse “sus hijos”? La respuesta, según el Nuevo Testamento, es que son sus hijos: que todo verdadero seguidor del Mesías es, por el Espíritu, un hijo de Abraham, adoptado en la casa de Dios y espiritualmente judío. Asimismo, la fe conocida en el mundo como cristianismo nació de un vientre judío, de la matriz de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Emperadores y jefes")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Entonces, ¿qué significa la guerra del Dragón contra “el resto de sus descendientes”? Significa que así como ha librado la guerra contra Israel, también hará la guerra contra sus hijos espirituales. Que el pueblo del Mesías, los "), _c('span', {
    attrs: {
      "aria-label": "270",
      "epub:type": "pagebreak",
      "id": "page270",
      "role": "doc-pagebreak"
    }
  }), _vm._v("creyentes de todas las naciones, aquellos a quienes la Biblia declara hijos de Israel en virtud del nuevo nacimiento, serán igualmente objeto de la ira del Dragón. Así que fue el Dragón quien hizo que los emperadores de Roma establecieran la guerra contra los primeros cristianos, para demonizarlos, encarcelarlos, crucificarlos y exponerlos a los animales salvajes. Fue el Dragón quien hizo que los gobernantes y los caudillos de otros reinos y otras tierras libraran la guerra contra aquellos que les trajeron el evangelio o quienes, de su propio pueblo, lo abrazaron. Pero el “resto de sus descendientes” tiene un enfoque aún más específico.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Hacer la guerra contra los santos”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La búsqueda del Dragón de los hijos de la mujer en Apocalipsis 12 se produce en el contexto de la búsqueda de la mujer que hará en los últimos días, cuando Israel regrese al mundo. Así que la guerra del Dragón contra los hijos de la mujer se centrará especialmente y alcanzará su estado más intenso "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("al final de la era")]), _vm._v(". Esto va de la mano con lo que se revela de la Bestia en el siguiente capítulo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Le fue concedido "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hacer guerra contra los santos")]), _vm._v(" y vencerlos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Esto, a su vez, coincide con las palabras dadas en el Libro de Daniel acerca de la Bestia y el pueblo de Dios:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Y los santos le serán entregados")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Entonces, ¿qué significa todo esto para el creyente, para el verdadero cristiano, para aquellos que guardan los mandamientos de Dios y el testimonio del Mesías?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“La apostasía es lo primero”")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Al juntar las claves proféticas, se nos presenta una imagen. El fin de los tiempos verá una gran persecución contra los seguidores del Mesías. Esa persecución no surgirá de la nada. El gobierno del Anticristo se producirá en el contexto de una cultura y un mundo preparados y propicios para él. Así también con la persecución del pueblo de Dios, las señales de su venida aparecerán antes de su plena manifestación. "), _c('span', {
    attrs: {
      "aria-label": "271",
      "epub:type": "pagebreak",
      "id": "page271",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Cuando el apóstol Pablo habla del Anticristo y de la segunda venida del Mesías, dice esto:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Ese día no llegará a menos que venga primero la apostasía y se manifieste el hombre de pecado."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Así que primero debe venir una gran apostasía. La palabra griega para “caer” es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("apostasía")]), _vm._v(". Significa "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("irse, apartarse de la posición anterior, como en una deserción de la verdad, un alejamiento de la fe")]), _vm._v(". Así que antes de la gran persecución vendrá primero una gran apostasía de la fe. Es ese alejamiento de la fe lo que abrirá la puerta a todo lo que está por venir.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La anticristianización")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Solo hay una civilización que puede alejarse de la fe cristiana: una civilización “cristiana” o “judeocristiana”, una que ha conocido la fe cristiana. Entonces, según la profecía, esperaríamos ver una civilización que alguna vez fue cristiana y se aleja del cristianismo. Esperaríamos ver una metamorfosis en la que se transforma en una civilización no cristiana, secular o neutral y, después de eso, en una civilización anticristiana.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Esto es lo que estamos presenciando en el presente. Hemos visto la secularización y la descristianización de la civilización occidental. Ahora somos testigos de la siguiente etapa: la anticristianización. Una civilización que alguna vez defendió y veneró los valores bíblicos ahora libra cada vez más guerra contra ellos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La víspera de la persecución")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El Anticristo gobernará sobre toda “tribu, lengua y nación” y, al mismo tiempo, “hará guerra contra los santos”. Por lo tanto, guerreará contra aquellos bajo su gobierno. Y así, la guerra contra los creyentes se librará a través de instituciones gubernamentales y gobernantes: la persecución. No es casualidad que incluso ahora los gobiernos que alguna vez defendieron el evangelio estén cada vez más apuntando, procesando y persiguiendo a aquellos que lo defienden dentro de sus jurisdicciones. Cuando las naciones, muchas de las cuales alguna vez fueron consideradas cristianas y muchas que todavía lo son de nombre, persiguen a los cristianos por defender valores y puntos de vista cristianos y bíblicos básicos, han llegado los días de la apostasía. Y cuando los gobiernos de tales países tratan a los creyentes "), _c('span', {
    attrs: {
      "aria-label": "272",
      "epub:type": "pagebreak",
      "id": "page272",
      "role": "doc-pagebreak"
    }
  }), _vm._v("como extranjeros, obstáculos, problemas, agitadores y peligros (tal como los consideró una vez el gobierno de Roma y como los considera siempre el Dragón), uno está viviendo en vísperas de una gran persecución.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La civilización de la Bestia")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Otra señal de lo que se avecina es que lo que antes se asociaba con dictaduras comunistas y fascistas se está manifestando cada vez más como una característica emergente de la civilización occidental. Estamos siendo testigos de un creciente totalitarismo progresista en el que el gobierno, la economía y la cultura están siendo utilizados como armas contra los valores bíblicos y tradicionales, y contra quienes los defienden. Aunque se enmascara con terminología progresista, es sin embargo una manifestación de totalitarismo, una manifestación que incluso busca cancelar, prohibir, destituir, desfinanciar, despedir, expulsar, procesar, castigar y encarcelar a quienes no la apruebe. Incluso busca decretar qué palabras y pensamientos son aceptables y cuáles deben ser eliminados. Es la preparación para la próxima civilización y gobierno de la Bestia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Esta oscuridad presente")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Tanto en Oriente como en Occidente, en el mundo nunca cristiano y en el otrora cristiano, los creyentes viven, incluso ahora, bajo persecución. En las épocas más avanzadas y sofisticadas, los cristianos son perseguidos no menos que en épocas pasadas, sino más. De hecho, la persecución de los cristianos es mayor ahora que en los días de Roma y, en efecto, peor que en cualquier otro momento de la historia de la humanidad. Y, sin embargo, esto es exactamente lo que esperaríamos de un mundo cada vez más alejado de Dios y progresivamente impulsado por el espíritu del Dragón. Eso es exactamente lo que las profecías de las Escrituras y la visión del Dragón predicen que vendría.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Del Cordero a la Bestia")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Qué le sucede a una civilización que ha conocido a Dios pero luego se aleja de él? No hace falta mirar más allá del caso de la Unión Soviética o el de la Alemania nazi. Cuando Dios es expulsado, el Dragón entra. No es casualidad que en ambos casos se lanzara una guerra de persecución contra aquellos que defendían los caminos de Dios. Tampoco es un accidente "), _c('span', {
    attrs: {
      "aria-label": "273",
      "epub:type": "pagebreak",
      "id": "page273",
      "role": "doc-pagebreak"
    }
  }), _vm._v("que cada caso haya producido una sombra de la Bestia, una en la forma de Joseph Stalin y la otra en la forma de Adolf Hitler. Cada uno también produjo una sombra del reino de la Bestia: por un lado, la Unión Soviética y, por el otro, el Tercer Reich.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así como la civilización cristiana que alguna vez conocimos procedió del Cristo, el Mesías, así la civilización anticristiana que estamos llegando a conocer procederá hacia el Anticristo, la Bestia. Si uno se aleja del Cordero, inevitablemente se encontrará volviéndose hacia la Bestia.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Y por eso el pueblo de Dios debe prepararse para la persecución y para una aun mayor. Porque la Bestia luchará contra los santos, y el Dragón contra el resto de sus hijos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Lo que al principio estaba separado, al final debe volver a unirse. Es un misterio que concierne a cada hijo de Israel y a cada seguidor del Mesías, incluso al mundo entero.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "274",
      "epub:type": "pagebreak",
      "id": "page274",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-161"
    }
  }, [_vm._v("Capítulo 67")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-162"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor066"
    }
  }), _vm._v("La reunión del final de los días")]), _vm._v(" "), _c('p', {
    staticClass: "pf-2"
  }, [_c('span', {
    staticClass: "DROP-CAP"
  }, [_c('span', {
    staticClass: "_ _idGenCharOverride-3"
  }, [_vm._v("¿")])]), _c('span', {
    staticClass: "_idGenDropcap-2"
  }, [_vm._v("Q")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("ué tiene que ")]), _vm._v("ver Israel, y qué le sucede a Israel, con el seguidor de Jesús, Yeshúa?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Todo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Lo físico y lo espiritual")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En primer lugar, como hemos señalado, ambos están intrínsecamente ligados. El uno nació del otro. El cristianismo, en esencia fue, es y será siempre una fe judía y, al mismo tiempo, universal para todos los pueblos. Los verdaderos cristianos están unidos espiritualmente a la nación de Israel, como se revela en el Nuevo Testamento, injertados en el olivo de Israel. Su Salvador es el Mesías de Israel, y su esperanza del reino de Dios viene solo en la redención de Israel. Como Israel es la nación física, de carne y hueso de Dios, lo que se llama la “iglesia” es la nación espiritual, un Israel de espíritu, un Israel espiritual. Uno corresponde al otro y el otro al uno.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Pero en la visión de Apocalipsis 12 los dos están unidos por otra razón. El Dragón lucha tanto contra la mujer como contra sus hijos, Israel y “aquellos que tienen el testimonio de Yeshúa, Jesús”. Por lo tanto, los dos también están unidos en el sentido de que son el objeto de la ira del Dragón y los puntos focales de su guerra. Y dado que esa guerra, en los últimos días, se intensificará contra cada uno, los dos, Israel y aquellos que siguen al Mesías, deben y estarán cada vez más y efectivamente unidos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Dos reinos, un cordero y un dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En Apocalipsis, el Dragón y la Bestia hacen la guerra contra el Cordero. Hay dos entidades en la tierra que están unidas al Cordero: la iglesia e Israel. La iglesia está unida al Cordero en espíritu y porque él es su Salvador y Redentor. Israel está unido a él en carne y sangre y como él es el Mesías de Israel, Rey de los judíos. Uno lo representa en espíritu y el otro en carne y sangre. Y entonces el Dragón hace la guerra contra ambos. Son dos bandos de una misma guerra, el Dragón y el Cordero.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "275",
      "epub:type": "pagebreak",
      "id": "page275",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Tanto Israel como la iglesia son esenciales para la venida del reino de Dios a la tierra. Si la iglesia cumple su misión en el mundo, e Israel sus propósitos en la tierra, el reino vendrá. Entonces el Dragón guerreará para alejar a la iglesia de su misión y a Israel de sus propósitos. Buscará marginar y alienar a Israel de las naciones y a la iglesia de la sociedad. Buscará la deslegitimación de cada uno. Él desafiará su derecho a existir. Provocará hostilidad contra la iglesia y furia contra Israel. Intentará la destrucción espiritual de la iglesia y la destrucción física de Israel. Las naciones, a su vez, perseguirán a los seguidores del Mesías y buscarán la aniquilación de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La reunión del fin de los días")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Cuanto más nos acerquemos al fin de los días, más importante será que los dos pueblos del Mesías permanezcan como uno solo. La unión ya ha comenzado. Que los mejores amigos de Israel son aquellos que siguen al Mesías, Yeshúa, y que son conocidos como cristianos, es más evidente ahora que nunca. En cuanto a la iglesia, se ha estado moviendo cada vez más hacia la recuperación de sus raíces bíblicas y su herencia judía a medida que se aleja cada vez más de Roma hacia Jerusalén. La furia del Dragón contra cada uno acelerará su reencuentro. Porque al final cada uno estaba destinado a reunirse con el otro, del mismo modo que cada uno se unirá como punto focal de la furia del Dragón, en su ira contra la mujer y su guerra contra el resto de sus hijos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría haber otro regreso y otra resurrección, no de lo terrenal sino del Espíritu?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "276",
      "epub:type": "pagebreak",
      "id": "page276",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-163"
    }
  }, [_vm._v("Capítulo 68")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-164"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor067"
    }
  }), _vm._v("De vuelta al principio")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("ay otro regreso ")]), _vm._v("y otra resurrección. Para encontrar eso, debemos volver al principio.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El ejemplo del Libro de los Hechos ")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Si Israel y la iglesia están intrínsecamente unidos, si uno corresponde al otro, ¿no apuntarían entonces el regreso y la resurrección de Israel a un retorno y resurrección correspondientes de la iglesia? Si al final de los tiempos el pueblo judío ha regresado a donde estaban al principio de los tiempos —a Israel— entonces, ¿no sería también el momento para que los seguidores del Mesías regresaran a donde estaban al principio de la edad? ¿Y dónde estaban al principio de la era? Estaban en el Libro de los Hechos. Es hora de volver al Libro de los Hechos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("De lo revolucionario al "), _c('span', {
    staticClass: "Impa-i _idGenCharOverride-1"
  }, [_vm._v("statu quo")])]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Al comienzo de la época, la iglesia no estaba establecida ni formaba parte del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("statu quo")]), _vm._v(". No se sentía cómoda en el mundo ni estaba dotada de poder mundano. No fue favorecida ni apoyada por el poder institucional o la cultura dominante, sino que más bien estos se le opusieron. Y, sin embargo, en los siglos siguientes se uniría cada vez más al mundo y al poder mundano. Y al ser así, perdería el poder espiritual que alguna vez tuvo. Pasaría de ser una entidad revolucionaria a una del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("statu quo")]), _vm._v(". Y, sin embargo, nunca fue tan pura, tan poderosa, tan transformadora de vidas, tan transformadora del mundo como lo fue en el Libro de los Hechos, al comienzo de la era. Fue entonces, cuando su poder mundano estaba al mínimo, cuando su poder espiritual estaba en su máximo. Y fue entonces, cuando menos formaba parte del "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("statu quo")]), _vm._v(", cuando poseyó su mayor poder para "), _c('span', {
    attrs: {
      "aria-label": "277",
      "epub:type": "pagebreak",
      "id": "page277",
      "role": "doc-pagebreak"
    }
  }), _vm._v("cambiarlo. Y fue entonces cuando fue más radical. No fue tanto cultural como contracultural, no del orden establecido sino revolucionario.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Del "), _c('span', {
    staticClass: "Impa-i _idGenCharOverride-1"
  }, [_vm._v("statu quo")]), _vm._v(" a lo revolucionario")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Para el pueblo judío, regresar a Israel significaba dejar de lado una identidad que había adquirido en sus dos mil años de destierro y peregrinaje. Significaba retomar y restaurar la identidad de la que habían estado separados por mucho tiempo. La iglesia, los seguidores del Mesías, deben hacer lo mismo. Deben dejar de lado la identidad que habían adquirido durante siglos de estar unidos al mundo y al "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("statu quo")]), _vm._v(". Deben retomar la identidad que poseían al principio. La fuerza de la persecución no obstaculizará ese proceso: lo acelerará. Así como el pueblo judío tuvo que recuperar su antigua herencia, la iglesia también debe recuperar su antigua herencia en el Libro de los Hechos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En otras palabras, la fe cristiana debe alejarse de su unión con el mundo y volver a ser una entidad radical. Debe volver a ponerse su manto revolucionario y transformador del mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El llamado olvidado")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así como el pueblo judío que regresó a Israel fue encargado de revivir una tierra muerta hace mucho tiempo, también cada creyente de este tiempo final debe revivir la vida y el poder perdidos hace mucho y que vemos en el Libro de los Hechos. Cada uno debe emprender los caminos largamente recorridos por aquellos que, en los albores de la era, transformaron el mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Los creyentes del fin deben tomar el manto del principio. Deben elegir vivir como vivieron, no por el poder mundano, sino por el poder del Espíritu. Deben permanecer como lo hicieron los primeros creyentes, en fe, esperanza, valor y victoria, y no ser vencidos por el mundo sino que, por el poder de Dios, vencerlo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Y así como los primeros creyentes resistieron y prevalecieron frente a la guerra del Dragón contra ellos, también debe hacerlo el creyente de los últimos tiempos. Y para eso debemos descubrir un secreto más, una clave crucial para el triunfo del pueblo de Dios.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "278",
      "epub:type": "pagebreak",
      "id": "page278",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-165"
    }
  }, [_vm._v("Capítulo 69")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-166"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor068"
    }
  }), _vm._v("El misterio de los israelíes secretos")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("hora llegamos a ")]), _vm._v("una clave crucial. En el Libro de Efesios hay una palabra para aquellos que no nacieron de las naciones pero que luego llegaron a la fe en el Mesías:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("recuerden que en ese entonces ustedes estaban separados de Cristo, excluidos de la "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ciudadanía de Israel")]), _vm._v(" y ajenos a los pactos de la promesa … Por lo tanto, ustedes ya no son extraños ni extranjeros, sino "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("conciudadanos")]), _vm._v("."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El secreto del fin de los tiempos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El creyente en el Mesías, el verdadero cristiano, en virtud del nuevo nacimiento, no solo está unido al pueblo judío, sino también es conciudadano de la comunidad o gobierno de Israel: israelita espiritual. Es otra verdad olvidada hace mucho tiempo entre la mayoría de los llamados cristianos. Pero incluso entre aquellos en épocas pasadas que se dieron cuenta de que eran israelitas espirituales, lo hicieron cuando en realidad no existía una nación en el mundo llamada Israel. Pero ahora la hay. Entonces, ¿existe una conexión entre los israelitas espirituales y el estado resucitado de Israel?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La mayoría ve la palabra "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("israelí")]), _vm._v(" como moderna, ligada al mundo de los siglos veinte y veintiuno y al renacido Estado de Israel. Pero no es así. La palabra israelí es una traducción de una traducción latina de una traducción griega de una palabra hebrea. La palabra real que aparece en las Escrituras hebreas es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("israelí")]), _vm._v(". De modo que el creyente en Jesús no es solo espiritualmente judío, un israelita espiritual; él o ella es un israelí espiritual. Y dado que en realidad existe una nación de Israel en el mundo como la había cuando se escribió el Libro de Efesios, y dado que los ciudadanos de la nación moderna de Israel se llaman israelíes, ¿podría esto abrir una revelación para el creyente de los últimos tiempos?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "279",
      "epub:type": "pagebreak",
      "id": "page279",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El israelí y el dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Aquí es donde se unen dos misterios: el del Dragón y el del Israelí. El israelí ha llegado a existir no solo gracias a Dios sino gracias al Dragón o, más bien, en respuesta al Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En el ámbito de lo natural, la nación de Israel regresó al mundo debido a casi dos mil años de persecución y calamidad. Las primeras oleadas de refugiados judíos que regresaron a su tierra fueron provocadas por las persecuciones antijudías y los pogromos de la Rusia zarista. Detrás de esas calamidades y derramamiento de sangre estaba el Dragón. Las siguientes oleadas de retorno se produjeron como resultado del aumento del antisemitismo en Europa, el ascenso de Hitler y luego el Holocausto. Detrás de esas calamidades estaba, nuevamente, el Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Así, los israelíes nacieron desafiando dos mil años de persecución, desafiando al Dragón y su guerra contra ellos. Durante la mayor parte de ese tiempo, habían sido víctimas de esa guerra. Pero desde el momento de su resurrección nacional, serían luchadores. Ellos contraatacarían.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("“Un ejército extremadamente grande”")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y el espíritu entró en ellos; entonces vivieron y se pusieron de pie. ¡Era un "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ejército numeroso")]), _vm._v("!"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En las épocas en que vagaban por la tierra, el pueblo judío no era visto como luchador. Pero con la resurrección de Israel todo eso cambió. Nacidos entre las cenizas del Holocausto y rodeados por un mar de naciones que buscaban su destrucción, se dieron cuenta de que, a menos que aprendieran a luchar, no sobrevivirían.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y así, un pueblo que durante mucho tiempo y en gran medida había sido reacio a luchar, a hacer la guerra, aprendió rápidamente a ejercerla. En 1948, cuando los ejércitos de múltiples naciones convergieron contra la nación recién nacida, la existencia de Israel corrió peligro. Aquellos que nunca antes habían luchado en una guerra y estaban equipados con armas de segunda mano traídas de contrabando desde otros países, fueron encargados de defender a la nación contra la destrucción."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" Y ganaron por un milagro.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Las Fuerzas de Defensa de Israel, las FDI, formadas por refugiados y sobrevivientes del Holocausto, se convertirían en uno de los cuerpos militares más poderosos del planeta, un ejército temido por sus enemigos y venerado en todo el mundo. De no ser así, Israel habría dejado de existir hace mucho tiempo.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "280",
      "epub:type": "pagebreak",
      "id": "page280",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los otros israelíes")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Si los israelíes en espíritu están conectados con los israelíes de carne y sangre, entonces, así como el pueblo judío, como israelíes, tuvo que aprender a luchar, también los que siguen al Mesías deben aprender a luchar en los últimos días. Así como la nación de Israel está compuesta de soldados, también la iglesia del fin de los tiempos debe estar hecha de soldados. Así como los israelíes de carne y sangre tuvieron que convertirse en luchadores en el ámbito terrenal, los israelíes de espíritu deben convertirse en luchadores en el ámbito espiritual.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por la misma razón que los israelíes tuvieron que convertirse en guerreros en el mundo, el pueblo del Mesías debe convertirse en guerreros en el Espíritu, debido al Dragón. En los últimos días este guerreará tanto contra Israel como contra ambos israelíes. Los israelíes deben luchar. En una época cada vez más hostil a su fe, sus costumbres y su existencia, el pueblo del Mesías no tendrá más opción que los israelíes sino volverse especialmente fuerte en la lucha, en la guerra, en este caso en el Espíritu. En una época así no basta con mantener la propia postura: hay que resistir la oscuridad. Hay que contrarrestarlo. Uno debe adoptar la postura de un guerrero, de desafío piadoso, de resistencia divina, de guerra y lucha espiritual.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Y nadie le hará temer")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Es de destacar que la visión de Ezequiel del valle de los huesos secos predice no solo la resurrección de una nación israelita sino también la de un ejército israelí. El profeta Jeremías predijo que después de que Dios haya reunido nuevamente a Israel en su tierra, que nadie lo asustará."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")]), _vm._v(" La imagen que el mundo tenía del victimismo judío frente a la persecución se transformó en el soldado israelí, en una imagen de fortaleza. El luchador judío había regresado al mundo y nadie lo atemorizaba. Esa es la postura que también deben adoptar los israelíes espirituales, el pueblo de Dios de los últimos días. Deben levantarse con audacia, coraje y confianza en la voluntad y el poder de Dios, para que nadie los asuste.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los pasos de los antiguos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("No es que los judíos nunca hubieran sabido lo que era luchar y hacer la guerra como hijos de Israel. Lo habían hecho una vez. Pero fue hace miles "), _c('span', {
    attrs: {
      "aria-label": "281",
      "epub:type": "pagebreak",
      "id": "page281",
      "role": "doc-pagebreak"
    }
  }), _vm._v("de años. El mundo lo había olvidado. Y ellos también. Pero en la antigüedad el pueblo judío era conocido como luchador. Una vez habían estado con escudo y espada en innumerables campos de batalla y contra innumerables enemigos. Ahora tenían que volver a ponerse las sandalias de sus antiguos predecesores. Tuvieron que retomar, como nueva identidad, su antigua identidad. Fue por esa razón que los soldados del Israel resucitado prestaron juramento de servicio en la cima de Masada, donde los soldados de Israel, en la antigüedad, habían hecho su última resistencia."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El guerrero judío había regresado y volvería a luchar por su pueblo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("De la misma manera, los creyentes del fin de los tiempos, los israelíes espirituales, deben asumir como nueva identidad su antigua identidad. Deben tomar la armadura espiritual de sus antiguos precursores, los creyentes, los discípulos, los apóstoles, los mensajeros del Mesías, los que se levantaron al principio de la era, los que libraron guerra en los reinos espirituales, los que resistieron y lucharon contra las tinieblas y vencieron al mundo. Deben seguir sus pasos, empuñar sus espadas espirituales y, nuevamente, vencer al mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Como aquellos que luchan contra él")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así como los israelíes deben estar solos en el mundo, separados en el mundo y contra el flujo del mundo, también los israelíes espirituales deben estar dispuestos a estar solos en el mundo, separados del mundo y contra el flujo espiritual de su mundo y su época. En un día marcado por el gobierno del Dragón, si uno va a seguir a Dios, debe desafiar la rebeldía, resistir la tenacidad, mantenerse firme y luchar contra la oscuridad. Hay que librar esa guerra en el mundo que nos rodea y en la propia vida. En una época así no basta con tener fe, esperanza y rectitud; ahora uno debe adoptar una fe combativa, una esperanza combativa, una santidad combativa, un amor combativo y un gozo combativo. El pueblo de Dios debe convertirse en un pueblo victorioso, un ejército celestial, un ejército espiritual de Israel. Ya no deben ser contados como víctimas del Dragón, sino como aquellos que luchan contra él.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Para concluir, debemos abordar aquello que involucra y afectará a todos los que leen estas palabras. Porque todos debemos enfrentarnos al Dragón. "), _c('span', {
    attrs: {
      "aria-label": "282",
      "epub:type": "pagebreak",
      "id": "page282",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Y por eso ahora nos centraremos en la última y definitiva superación del Dragón.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "283",
      "epub:type": "pagebreak",
      "id": "page283",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "PART--",
    attrs: {
      "id": "_idParaDest-167"
    }
  }, [_vm._v("Parte 15")]), _vm._v(" "), _c('p', {
    staticClass: "PART-TITLE _idGenParaOverride-1",
    attrs: {
      "id": "_idParaDest-168"
    }
  }, [_vm._v("LOS ASESINOS DE DRAGONES")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "284",
      "epub:type": "pagebreak",
      "id": "page284",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-169"
    }
  }, [_vm._v("Capítulo 70")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-170"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor069"
    }
  }), _vm._v("El cazador de dragones")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El dragón se plantó delante de ella para devorar a su hijo tan pronto como naciera."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La antítesis del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El Mesías es el epítome de Israel y de la existencia judía, y la antítesis del Dragón. Por lo tanto, él es el punto focal de la guerra y la ira del enemigo. En la visión de Apocalipsis 12 el primer objeto de la furia del Dragón es el niño, el Mesías. Solo después persigue a la mujer, a Israel y a sus hijos. En esto hay un misterio; la guerra del Dragón contra la mujer está relacionada con la guerra contra el hijo de ella. Y la persecución del enemigo al pueblo judío está conectada con su guerra contra el Mesías. Y los sufrimientos del Mesías están conectados con los sufrimientos de Israel. Uno es el microcosmos del otro y, el otro, el macrocosmos del otro.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Cordero Mesías")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El Cordero es la antítesis del Dragón y el Dragón es la del Cordero. La guerra entre ambos llega a su punto culminante en la cruz. Es allí donde las fuerzas del infierno convergen contra la encarnación del bien y allí donde las tinieblas crucifican la Luz. Allí el Dragón asesta su golpe al Cordero. Es la peor de las situaciones: la crucifixión del bien. Y, sin embargo, es al mismo tiempo lo más hermoso: el amor de Dios que se entrega en sacrificio para traer redención y vida. Es el pináculo del bien y del mal.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Clavadas en la cruz sobre la cabeza del Mesías estaban las palabras Rey de los judíos. Porque la cruz es también el epítome de la guerra del Dragón contra el pueblo judío. Y así también el pueblo judío ha sido crucificado, el cual también ha resucitado.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por último, la cruz es el epítome de la guerra del Dragón contra todos los que siguen y pertenecen a Dios, y todos los que llevan su imagen. Es una sombra del fin de esa guerra, ya que es a través de la cruz que el amor de Dios vence todo juicio y odio, la luz prevalece contra las tinieblas y la "), _c('span', {
    attrs: {
      "aria-label": "285",
      "epub:type": "pagebreak",
      "id": "page285",
      "role": "doc-pagebreak"
    }
  }), _vm._v("vida vence a la muerte. Porque el Dragón, con todos sus poderes, no pudo vencer, pero el Cordero vence al Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El pastor Mesías ")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Al Mesías también se le llama el Pastor de Israel. ¿Qué sucede entonces si un rebaño se separa de su pastor? Ese rebaño se dispersará y quedará indefenso frente a sus depredadores. Y entonces si Yeshúa, Jesús, es el Mesías, él es el Pastor de Israel. Y si los hijos de Israel se separan de él, serán como ovejas sin pastor. Se dispersarán y vagarán por la tierra y quedarán indefensos, como presa de los depredadores del mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y eso es exactamente lo que ha pasado. Los dos mil años de historia judía que siguieron a la aparición de Yeshúa dan testimonio de que él es su Mesías, su Pastor. Durante dos mil años vagaron por la tierra como ovejas sin Pastor. Durante dos mil años se convirtieron en presa de sus depredadores y de su archienemigo, el Dragón. Entonces su Pastor lloró por ellos tal como lo había previsto. Mientras se acercaba a Jerusalén,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Jesús vio la ciudad y lloró por ella. Dijo:")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("—¡Cómo quisiera que hoy supieras lo que te puede traer paz! Pero eso ahora está oculto a tus ojos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Esas eran las lágrimas del Pastor que lloraba por el destino de su rebaño. Y durante dos mil años su paz les ha estado oculta, incluso hasta el día de hoy.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El Rey Mesías")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En los últimos dos mil años, cuando una nación o potencia ha venido contra el pueblo judío, siempre hubo otro refugio, nación o esperanza en el horizonte. Pero al final, cuando todas las naciones vengan contra ellos, no habrá tal refugio ni esperanza. Y así será entonces que él vendrá. El Mesías regresará. El rebaño de Israel volverá a su Pastor y será salvo por su mano. Y vendrá el reino, y su nombre será Israel, y su Rey será el Mesías. En ese día, todos los servidores del Dragón, los Hitler, los terroristas y los anticristos se desvanecerán en el reino de la memoria. Y el lobo se acostará con el cordero, y el hijo de Israel y el hijo de Palestina caminarán juntos como uno solo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "286",
      "epub:type": "pagebreak",
      "id": "page286",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Qué pasa si ahora llevamos el misterio de la guerra del Dragón al ámbito más personal?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "287",
      "epub:type": "pagebreak",
      "id": "page287",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-171"
    }
  }, [_vm._v("Capítulo 71")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-172"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor070"
    }
  }), _vm._v("La respuesta del misterio")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("emos visto la ")]), _vm._v("realidad del mal y la guerra del Dragón. Hemos visto la guerra que subyace a la historia mundial. Pero esa guerra tiene lugar no solo en el escenario mundial y a escala global, sino a un nivel mucho más personal.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El enemigo de todos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así como el Enemigo se opone a todas las obras de Dios, también se opone a cada una de las obras de Dios. Como enemigo de Dios, él es el enemigo de cada vida creada a imagen de Dios. Él libra guerras contra cada uno de nosotros. Él quiere y busca el rompimiento de cada vida, cada alma, cada relación, cada matrimonio, cada hogar, cada esperanza y sueño, cada corazón. Y así hiere, degrada, oprime, intimida, aterroriza, paraliza, paraliza, aplasta y descarta.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Para algunos, él lucha a través de la esclavitud, la adicción y la esclavitud. Con otros, a través de la ira del hombre, el rechazo, el abandono y el abuso. A otros los paraliza por la culpa, la contaminación, el fracaso, el arrepentimiento, la vergüenza y las apariciones del pasado. Y para otros, lucha más lentamente, a través del continuo endurecimiento del corazón, el gradual oscurecimiento del alma y el adormecimiento del espíritu. Por un medio u otro busca la destrucción de cada alma y cada vida.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El antídoto del dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Cuál es el antídoto contra el Dragón y la respuesta a su guerra contra nuestras vidas? Es la misma respuesta a la guerra que tiene contra Israel: el Mesías. Porque el Pastor de Israel es también el Pastor de las almas, Yeshúa, Jesús, cuyo mismo nombre significa no solo la salvación de todos, sino la de cada uno. Y así como el poder del Enemigo radica en la separación de todos y cada uno de Dios, el poder del Mesías se manifiesta en el fin de esa separación y el regreso de todos y cada uno a Dios. Esa separación solo puede terminar con el fin del mal, la anulación del pecado. Y es solo en el Cordero, en su sacrificio, que se puede poner fin al mal y borrar "), _c('span', {
    attrs: {
      "aria-label": "288",
      "epub:type": "pagebreak",
      "id": "page288",
      "role": "doc-pagebreak"
    }
  }), _vm._v("los pecados. Solo en el Cordero se puede deshacer nuestra separación de Dios y destruir las obras del Dragón. Así está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Para esto fue manifestado el Hijo de Dios, para deshacer las obras del diablo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La redención ")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En la expiación del Mesías se aparta la separación, se condena la condenación, se rompe la brecha y se lleva el fin a su logro. Es el doble negativo de la redención. Solo así podemos ser renovados, nacidos de nuevo. Por eso está escrito que para todos los que están en el Mesías la vida vieja pasó y comenzó una vida nueva. Son liberados del poder del Dragón y han pasado de las tinieblas a la luz, de la muerte a la vida y al reino de los cielos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El bien y el mal se eligen libremente. Así debe ser también con la salvación. Es la elección de cada uno. Puede ser elegido en cualquier momento y comenzar en cualquier lugar: en una oración, en la apertura del corazón, en el alejamiento de las tinieblas y en el acercamiento a la luz, en la recepción del perdón, la purificación, el amor de Dios, la paz de Dios y el Espíritu de Dios. Un nuevo comienzo, Yeshúa, Jesús, salvación, un nuevo nacimiento y el inicio de una nueva vida.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La respuesta del misterio")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Comenzamos con el problema y el misterio del mal: aquello que no debería existir pero existe. Es por eso mismo, porque existe y no debería, que no podemos solucionarlo. Solo se puede resolver dejando de existir. Solo Aquel que puede traer a la existencia lo que no es, puede sacar de la existencia lo que es. Y así, el problema del mal solo puede ser respondido por Aquel que es la Respuesta, y solo recibiendo la Respuesta en la vida de uno. Porque solo el bien puede vencer al mal, y solo el Cordero puede vencer al Dragón, en la tierra, en el cosmos y en nuestras vidas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "289",
      "epub:type": "pagebreak",
      "id": "page289",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Siendo que no hay nadie a imagen de Dios que no sea el foco del Dragón, ¿cómo luchamos? ¿Cómo vencemos?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "290",
      "epub:type": "pagebreak",
      "id": "page290",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-173"
    }
  }, [_vm._v("Capítulo 72")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-174"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor071"
    }
  }), _vm._v("Nikao")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("s uno de ")]), _vm._v("los estímulos más importantes que se le da al creyente de los últimos tiempos. Y se encuentra en Apocalipsis 12, en la visión del Dragón y la mujer. Es esto:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Ellos lo han vencido")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("    por medio de la sangre del Cordero")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("    y por el mensaje del cual dieron testimonio;")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("no valoraron tanto su vida")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("    como para evitar la muerte."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Los luchadores contra el Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Ellos")]), _vm._v(" se refieren a los creyentes en el Mesías. "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Él")]), _vm._v(" se refiere al Dragón. ¿Qué hacen "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("ellos")]), _vm._v(" con respecto a "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("él")]), _vm._v("? Ellos vencen. Esta es la otra cara de la historia. Y para el creyente es el lado más importante de la misma. No está condicionado por el tiempo ni las situaciones. No importa la edad ni las circunstancias en las que se encuentre el creyente. Porque el Dragón hace la guerra a todo creyente en todo momento y lugar. Y la promesa es cierta independientemente. Así que, desde ahora hasta la victoria final de la venida del Mesías, los creyentes estarán en guerra. ¿Cómo debemos vivir entonces?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Debemos vivir como luchadores contra el Dragón. La perspectiva de luchar contra dragones evoca imágenes de la mitología antigua, los cuentos medievales o las sagas de la fantasía y la ciencia ficción modernas. Pero este es el único caso en el que la lucha con dragones no es mitología, fantasía ni ficción. La lucha es, por supuesto, en el ámbito espiritual, y el Dragón es la encarnación del mal. Pero, no obstante, es un dragón, y por eso el llamado de todo creyente (hombre, mujer y niño, en el Mesías) es luchar contra el Dragón. Porque aunque la visión se centra en un lado de la guerra, este versículo es suficiente para establecer el otro. El Dragón hace la guerra contra todo creyente, y cada creyente debe, de la misma manera, convertirse en un luchador contra el dragón y hacer la guerra contra él.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "291",
      "epub:type": "pagebreak",
      "id": "page291",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Lo vencieron, en tiempo pasado y por venir")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Con todo lo que ha sido revelado en la visión del Dragón y el resto del Libro de Apocalipsis, ¿cómo podemos enfrentarlo y mucho menos luchar contra él?")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La palabra aquí traducida como "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("vencido")]), _vm._v(" tiene sus raíces en la palabra griega "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("nikao")]), _vm._v(", que significa no solo vencer sino conquistar, someter, triunfar, obtener la victoria. Y aunque la palabra aparece en Apocalipsis 12 para hablar de cosas venideras, lo hace en tiempo pasado. La victoria es segura y absoluta; y, prácticamente, está hecha. Y esa debe ser la postura, la estrategia, la actitud y la vida del creyente en los días venideros: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("nikao")]), _vm._v(", en tiempo pasado y aún por venir.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El fin del mal")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("¿Por qué está destinado el pueblo de Dios a la victoria y el Dragón a la derrota? Eso se remonta al principio: la naturaleza del mal es parasitaria. Por lo tanto, no puede existir por sí solo sino en relación con el bien contra el cual lucha. A diferencia del bien, el mal no es primario sino secundario y contingente. De manera que, cuanto más lucha el mal contra el bien, más se separa de la realidad por la que existe. Por lo tanto, al final no puede permanecer. Y en su guerra contra el bien, al final no puede prevalecer.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La naturaleza serpentina y reptiliana")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Es de destacar que el llamado Dragón y Serpiente lleva el nombre de dos criaturas que comparten una naturaleza común. Las criaturas serpentinas y reptiles carecen de resistencia. Aunque algunos pueden moverse rápido, no pueden hacerlo por mucho tiempo. Así que, como serpiente y reptil, el Enemigo también carece de la capacidad de resistir. El poder del Dragón, el poder del mal, reside en lo temporal y lo momentáneo. Su dominio es efímero. No puede durar. Es incapaz de perdurar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("En la visión de la guerra del Dragón está escrito:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El diablo, lleno de furor, ha descendido a ustedes,")]), _vm._v(" "), _c('p', {
    staticClass: "BLOCK-2"
  }, [_vm._v("    porque sabe que le queda poco tiempo."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("2")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "292",
      "epub:type": "pagebreak",
      "id": "page292",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("Aunque esto se aplica en última instancia al futuro, en otro sentido siempre es cierto: el Dragón tiene poco tiempo. En ese tiempo, se enfurecerá, por lo que causará estragos y terror, pero sus días están contados. Lo mismo ocurre con el mal: sus días son finitos; su tiempo es limitado. Aunque puede parecer abrumador e implacable en su guerra contra el bien, solo puede hacerlo por un tiempo. Y aun así, la apariencia es falsa. Porque el mal existe en el reino de la falsedad y la ilusión; luego desaparece.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El mal, por naturaleza, conduce a la destrucción, incluso a la propia. No es casualidad que la figura más malvada del mundo, Adolf Hitler, muriera por su propia mano. Tampoco es un accidente que aquellos más cercanos a él y los mayores cómplices de sus actos murieran también por sus propias manos."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("3")]), _vm._v(" El mal, opuesto por naturaleza, contiene su propia oposición, su propia ruina, las semillas de su fin. No durará... porque no puede hacerlo. Y no prevalecerá, porque sería su propia destrucción.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La eternidad del bien")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Con el bien ocurre todo lo contrario. A diferencia del mal, el bien no es secundario ni contingente sino primario y absoluto. No puede separarse de la existencia, ya que esta nace del bien. Es existencia. Y así, a diferencia del mal, el bien no es pasajero ni temporal. A diferencia del Dragón y del mal, el Cordero y los buenos son de sangre caliente. El bien perdurará para siempre porque debe ser así. Eso es así, por naturaleza, eterna. De modo que, mientras que los días de la maldad del Dragón están contados y no pueden durar, los del amor y la bondad de Dios son innumerables y no terminarán, como está escrito: “Su misericordia perdura para siempre”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y así es el cielo, para siempre; porque para siempre es lo que tarda en contener la bondad de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Corderitos y dragones")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("El conflicto final, tal como se revela en el Libro de Apocalipsis, es entre el Dragón y el Cordero. Este es inocente e inofensivo, un animal de presa, indefenso. Aquel es depredador, feroz y mortal. Un encuentro entre ambos parecería, más que un conflicto, una matanza. Y, sin embargo, es el Cordero el que vence al Dragón. Porque el Cordero es la encarnación del bien, y el Dragón, la del mal. Y al final el bien siempre vencerá, prevalecerá y permanecerá.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "293",
      "epub:type": "pagebreak",
      "id": "page293",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("La batalla del Dragón y el Cordero se puede ver a lo largo de la historia. Cuando el imperio romano lanzó sus persecuciones contra los primeros cristianos y los arrojó a los leones,"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("5")]), _vm._v(" fue la guerra del Dragón contra el Cordero. Los cristianos eran inocentes y parecían indefensos. Y, sin embargo, prevalecieron. El Cordero venció al Dragón. Cuando la Unión Soviética intentó acabar con la fe y persiguió a los seguidores del Mesías,"), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("6")]), _vm._v(" se trataba nuevamente de la guerra del Dragón contra el Cordero. Otra vez parecía una batalla unilateral y desesperada. Pero la Unión Soviética pasó a la historia. El Dragón fue vencido y el Cordero prevaleció.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El poder de Nikao")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En la batalla entre el bien y el mal, este último a menudo tomará la forma de un dragón y el bien —a menudo— asumirá la de un cordero. El mal a menudo aparecerá fuerte, colosal, imparable, feroz y mortal, como un dragón; y el bien, débil, indefenso y sin esperanza de prevalecer, como un cordero. Pero al final el bien prevalecerá, el mal se desmoronará y el Cordero vencerá al Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Solo el Cordero puede vencer al Dragón. Sin el Cordero estamos sujetos al gobierno del Dragón y no podemos vencer el poder del mal, de las tinieblas o del pecado. Pero en el Cordero se nos da el poder de vencer al Dragón.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El nikao está con el Cordero. Es el Cordero el que saldrá victorioso, y aquellos que sigan al Cordero serán los que, al final, serán triunfantes.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("¿Podría haber, en este mundo y en medio de la historia humana, un testimonio, una confirmación, una señal de que el mal al final no puede prevalecer y que el bien no cesará, que la Palabra de Dios es verdadera, que se cumplirán sus promesas y que sus propósitos vencerán todas las cosas?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "294",
      "epub:type": "pagebreak",
      "id": "page294",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-175"
    }
  }, [_vm._v("Capítulo 73")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-176"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor072"
    }
  }), _vm._v("Los inconquistables")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("ay un hecho ")]), _vm._v("más que es necesario señalar. Con respecto a la guerra del Dragón, es el más importante, más amplio y el contexto definitivo. Y, como ocurre con muchas otras cosas de lo que hemos presenciado, también está contenida en la visión de Apocalipsis 12.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El más débil de todos los pueblos")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("La guerra del Dragón contra los hijos de Israel se ha librado en todo el mundo y en cada generación desde la antigüedad hasta ahora. Como hemos visto, el pueblo judío se ha convertido en el más perseguido, oprimido, atacado, asediado, bombardeado, abatido, masacrado y combatido en la historia mundial. Y, al mismo tiempo, se han encontrado en la posición más débil posible para resistir tal ataque, habiendo sido destrozados como nación, esparcidos por toda la tierra, sin rey, sin liderazgo, sin gobierno, sin ejército, sin armas, sin poder efectivo, sin unidad, sin tierra, sin derechos, sin defensa y sin esperanza. Tan indefensos como corderos, corderos sin pastor, una nación de corderos. Y sus enemigos alzándose sobre ellos, feroces y mortíferos como dragones.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Contra todo pronóstico")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Según las leyes de la historia humana, deberían haber desaparecido de la tierra hace mucho tiempo. Naciones más fuertes y formidables se han derrumbado al no haber tal oposición, ni tal situación, ni tales adversidades. Ninguna otra nación ha existido en tal estado y durante tanto tiempo, con tantas y colosales fuerzas en su contra y tantas probabilidades en contra de su supervivencia, y a favor de su aniquilación. Los hijos de "), _c('span', {
    attrs: {
      "aria-label": "295",
      "epub:type": "pagebreak",
      "id": "page295",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Israel deberían haber seguido el camino de los hititas, los hurritas y los babilonios hace siglos. Hace tiempo que deberían haber sido consignados a las páginas de la historia antigua y a las exhibiciones arqueológicas de las paredes de los museos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La gran contradicción")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los imperios más grandes y poderosos del mundo: Egipto, Asiria, Babilonia y Roma, por nombrar solo algunos, trataron de erradicar a los hijos de Israel de la faz de la tierra y de borrar el nombre de Israel de la historia.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Pero…")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Los faraones desaparecieron.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Asiria quedó en ruinas.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Babilonia cayó.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Roma se desmoronó.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El Tercer Reich fue borrado de la tierra.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("La Unión Soviética se derrumbó.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Todos los enemigos de Israel han caído y han desaparecido de la tierra y ya no existirán.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Pero…")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("La nación de Israel vive.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Porque el Dios de Israel vive.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El Salvador de Israel vive.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("El Mesías de Israel vive.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "296",
      "epub:type": "pagebreak",
      "id": "page296",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("Los más débiles y vulnerables, al final, han prevalecido y han demostrado ser los pueblos más fuertes.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La nación más combatida y asediada ha resultado, al final, la más duradera.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y la nación más desesperada se ha convertido, al final, en el epítome de la esperanza.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La nación que una vez habitó entre los antiguos egipcios, asirios y babilonios sigue siendo, después del paso de los siglos, tan joven y llena de vida como siempre. Todavía desafía las leyes de las naciones. Todavía desacata las leyes de la historia. Y todavía desobedece las leyes de la decadencia y la muerte.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("¿Por qué?")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Porque él es")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Dios creó la nación de Israel para dar testimonio de su existencia. Son porque él es. Existen porque él existe. Y continúan existiendo porque él todavía existe. Sobrevivirían a pesar de los intentos de todo el infierno por destruirlos, porque más real que cualquier otra realidad es la realidad de Dios, y más poderoso que cualquier poder es la potestad de Dios. Que hayan sobrevivido contra todo pronóstico y contra todo el infierno, es motivo de regocijo. Para el judío es el microcosmos del hombre. Por eso, si los hijos de Israel se levantan, entonces todos pueden levantarse. Y si resucitan de la muerte, todos pueden resucitar de la muerte.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("El que queda en pie")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En Apocalipsis 12, el Dragón persigue a la mujer para destruirla, pero no puede. Es incapaz de hacerlo porque no puede vencer la voluntad y los propósitos de Dios. Y así, por todo lo que el Enemigo ha hecho y ha tratado de hacer para aniquilar al pueblo judío a lo largo de los siglos, por todas las calamidades, las opresiones, las destrucciones, los exterminios y por todos los poderes oscuros de la furia del Dragón, a pesar de lo que suceda, no puede destruirlos. ¿Por qué? Porque el poder de Dios es más fuerte y la realidad de Dios más real. Y por eso no han dejado de existir. Porque dan testimonio del Eterno, que no tiene fin.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Es así que el pueblo judío ha vagado por la tierra, entre el cielo y el infierno, entre la vida y la muerte, entre la muerte y la resurrección. Han "), _c('span', {
    attrs: {
      "aria-label": "297",
      "epub:type": "pagebreak",
      "id": "page297",
      "role": "doc-pagebreak"
    }
  }), _vm._v("estado en el centro de las promesas de Dios y de la furia del Dragón. Y por eso la suya ha sido la más dramática de las historias. No podría haber sido de otra manera.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Se presentan como testigos en el escenario de la historia humana para testificar de lo que subyace a toda la historia humana y a cada vida, dos realidades, un bien trascendente y un mal trascendente, la realidad del Dragón y esa realidad que es mucho mayor: la de Dios. Y para ellos también lo es la más milagrosa de las historias: una historia que da testimonio del hecho de que, después de todo lo dicho y realizado, al final solo una de esas dos realidades quedará en pie. Y sabemos cuál es.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("La promesa")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Todo estaba ahí en la antigüedad. Miles de años antes del mundo moderno, todo estaba predicho. La palabra del Señor vino al profeta Jeremías y dijo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Así dice el Señor, cuyo nombre es el Señor de los Ejércitos, quien estableció el sol para alumbrar el día, la luna y las estrellas para alumbrar la noche y agita el mar para que rujan sus olas: “Si alguna vez fallaran estos estatutos”, afirma el Señor, “entonces la descendencia de Israel ya nunca más sería mi nación especial”."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("En otras palabras, mientras el sol, la luna y las estrellas iluminen la tierra y se respeten las leyes de la naturaleza, los hijos de Israel, el pueblo judío, no dejará de existir. Sobrevivirá. Del mundo antiguo al mundo medieval, al mundo moderno y más allá, de época en época, perdurarán; sobrevivirán; existirán.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("¿Por qué?")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Porque Dios es real. Y porque Dios, el Dios del universo, es el Dios de Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Y la Palabra de Dios es verdadera.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Y las promesas de Dios son buenas.")]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Su fidelidad nunca termina.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "298",
      "epub:type": "pagebreak",
      "id": "page298",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "paa"
  }, [_vm._v("Y su amor perdura para siempre.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Y, finalmente, ¿qué tiene que ver contigo ese misterio?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "299",
      "epub:type": "pagebreak",
      "id": "page299",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-177"
    }
  }, [_vm._v("Capítulo 74")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-178"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor073"
    }
  }), _vm._v("Tú")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("o que hemos ")]), _vm._v("descubierto y visto debe aplicarse al ámbito más importante: "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("tu vida")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Tu vida y la guerra del Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Esto es para ti que estás leyendo estas palabras. La guerra del Dragón no se libra solo contra un mundo, naciones, pueblos y otros gentilicios. Se libra contra ti. Portas la imagen de Dios, por lo que para el Dragón eres su enemigo. Si conoces y sigues a Dios, y defiendes sus caminos, eres aún más su enemigo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Él ha hecho la guerra contra ti desde el principio de tu vida. Fue Dios el que te llamó a la existencia. Y por eso es el Dragón quien busca sacarte de la existencia.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Es Dios quien habla sobre tu vida las palabras y dice “Hágase”. Y es el Dragón el que pronuncia sobre tu vida las palabras “Que deje de existir”.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Dios te creó con un propósito elevado y sagrado. El Dragón ha buscado alejarte de él, de la vida, de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("El Dragón ha tratado de herirte y marcarte, contaminarte y degradarte, esclavizarte y oprimirte, perturbarte y frustrarte, quebrantar tu espíritu, paralizarte y derrotarte, aplastarte y destruirte. Él está librando una guerra contra ti, en este mismo momento.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Tu vida y el poder de nikao")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Sin embargo, si eres del Cordero, del Mesías, la palabra dada para tu vida y tu batalla con el Dragón es "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("nikao")]), _vm._v(": triunfo, victoria. Dios no te llamó a la derrota, sino a "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("nikao")]), _vm._v(", a triunfar, a vencer, a conquistar.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La superación requiere aquello que debes vencer. La victoria requiere una lucha. Por tanto, no puedes temer a la lucha, a la adversidad, a los ataques ni a la batalla. Porque son precisamente las cosas que hacen posible que salgas victorioso.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "300",
      "epub:type": "pagebreak",
      "id": "page300",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Tu vida y el llamado")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("En este libro hemos sido testigos de la realidad de la guerra más larga y colosal jamás librada en este mundo, una batalla que continúa hasta el día de hoy. Y, sin embargo, hemos visto que, contra todo pronóstico, el pueblo de Dios, los hijos de Israel, han sobrevivido y prevalecido.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Aquí hay un mensaje para todos los que sigan los caminos y las huellas de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Si Dios ha cumplido su palabra y su promesa a Israel, cumplirá su palabra y su promesa contigo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y si Dios ha sido fiel a Israel, también lo será contigo.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y, si después de todo lo que le fue impuesto Israel ha vencido, también tú vencerás en todas las cosas.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("Tu vida y el poder de vencer")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Así como el Cordero prevalecerá contra el Dragón, tú —que andas en las huellas del Cordero— también prevalecerás contra el Dragón. Cualquiera que sea la oscuridad, el mal y el ataque, sea de tu mundo, de tus circunstancias o de tu vida, al final no prevalecerá. Vencerás en el nombre del Cordero.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cualquiera que sea la oscuridad, cualquiera que sea el mal, si sigues al Cordero, si caminas en su voluntad, prevalecerás. No importa cuán grande sea el mal, al final será vencido. Y no importa cuán oscura sea la noche, la oscuridad, al final, se desvanecerá con la luz del amanecer.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Por el poder del Cordero puedes vencer todas las cosas. Por tanto, no te dejes vencer por el mal, vence al mal con el bien. Por tanto, no te dejes vencer por el miedo, ni por el odio, ni por la desesperación, ni por la tristeza; al contrario, vence el mal con el bien, el miedo con la fe, el odio con el amor, la desesperación con la esperanza y la tristeza con la alegría. Por el poder de la vida, vence el poder de la muerte. Por el poder de Dios, vence lo imposible. Y por el poder del cielo, vence al mundo.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_vm._v("A todos los que siguen adelante")]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Sigan adelante con confianza, con valentía, con amor, con lo verdadero, lo correcto, lo celestial y lo bueno.")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "301",
      "epub:type": "pagebreak",
      "id": "page301",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Pase lo que pase, sigue adelante.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("Porque el bien prevalecerá y el amor de Dios no se rendirá.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("Todos los que sigan corriendo, ganarán la carrera.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("Todos los que sigan luchando, ganarán la batalla.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("Y todos los que sigan adelante con el poder del Cordero, saldrán victoriosos.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab _idGenParaOverride-1"
  }, [_vm._v("Sin embargo, ¿qué pasa con el final?")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "302",
      "epub:type": "pagebreak",
      "id": "page302",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "CHAP--",
    attrs: {
      "id": "_idParaDest-179"
    }
  }, [_vm._v("Capítulo 75")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-180"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor074"
    }
  }), _vm._v("AL fin sin Dragón")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("l final de ")]), _vm._v("la Biblia, en las últimas páginas del Libro de Apocalipsis, la guerra del Dragón —en definitiva— llega a su fin. El ángel invertido, el Diablo, Satán, el Enemigo, el Dragón, serán entonces vencidos. El poder del mal desaparecerá. El bien prevalecerá y nunca terminará.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Entonces el reino de Dios se manifestará en su gloria. El Mesías, el Cordero, reinará en el trono. Y tanto la voluntad como los propósitos de Dios se cumplirán. Entonces, será revelado aquello de lo que escribió el apóstol Pablo:")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Ningún ojo ha visto, ningún oído ha escuchado, ningún corazón ha concebido lo que Dios ha preparado para quienes lo aman."), _c('span', {
    staticClass: "SUPERSCRIPT _idGenCharOverride-2"
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "paa"
  }, [_vm._v("Entonces todo el pueblo de Dios lo verá y lo sabrá. Ya no habrá más oscuridad. Porque el Señor Dios será su luz, y el Cordero, su iluminación. Y todas las cosas serán hechas nuevas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y ya no habrá más Dragón que se enfurezca contra los hijos de Israel, el pueblo de Dios y la creación de sus manos. Ya no aterrorizará a las naciones; ya no herirá, marcará, estropeará ni destruirá. Las tinieblas del Dragón ya no oscurecerán la luz, ni su maldad volverá a ocultar el rostro de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Entonces no habrá...")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("más guerras,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más prisiones,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más odio,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más violencia,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más invasiones,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más terroristas,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más matanzas,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más holocaustos,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más miedo,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más dolor,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más cementerios,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más dolor,")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "303",
      "epub:type": "pagebreak",
      "id": "page303",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más muerte,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más luto,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("más llanto,")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("ni más dolor.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Los días del Dragón habrán pasado. Hace tiempo que sus huellas habrán sido borradas de la memoria, y los hijos de Dios no recordarán más sus obras.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y Dios enjugará toda lágrima de nuestros ojos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y entonces habitará entre nosotros. Y seremos su pueblo. Y él será nuestro Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("La guerra del Dragón habrá terminado.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Y el cielo habrá comenzado.")]), _vm._v(" "), _c('p', {
    staticClass: "sbtll"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "pab"
  }, [_vm._v("Hasta entonces, sé fuerte en el Señor.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-f"
  }, [_vm._v("Y en el poder de su fuerza.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("Pelea la buena batalla.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("Termina lo que empezaste.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("No te rindas nunca.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("Ni te canses.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M"
  }, [_vm._v("Sigue adelante hacia la victoria.")]), _vm._v(" "), _c('p', {
    staticClass: "ind-M _idGenParaOverride-1"
  }, [_vm._v("¡Y vence al Dragón!")]), _vm._v(" "), _c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-181"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor075"
    }
  }), _c('span', {
    attrs: {
      "aria-label": "304",
      "epub:type": "pagebreak",
      "id": "page304",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Notas")]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 4")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Juan 8:44.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Isaías 14:14.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Juan 8:44.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 5")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Números 23:9.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Éxodo 19:6.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Génesis 12:3.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Isaías 43:10.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 6")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 12:10.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Efesios 6:11.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 7")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 12:1.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Génesis 37:9.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 12:3.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 12:9, traducción del autor.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 12:2.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 12:5.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 12:4, traducción del autor.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 12:13, traducción del autor.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 12:15, traducción del autor.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Apocalipsis 12:17, traducción del autor.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 8")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Lucas 21:20, 24, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Deuteronomio 28:64, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Deuteronomio 28:66.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Deuteronomio 30:3, 5, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Oseas 3:4.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jeremías 31:8–9.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jeremías 31:10.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Oseas 3:5, nasb, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 9")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ezequiel 37:7–8.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 37:10.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 37:11–12.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Juan 19:19.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 37:3.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Thomas Hockenhull, “The Shekel: A Modern-Day Coin With 5,000 Years of History”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Coin World")]), _vm._v(", November 14, 2014, www.coinworld.com/news/world-coins/coinworld-shekel-history-numismatics-israel-world-coins-ancient-collecting-hobby.html; “The Arch of Titus Project”, Center for Israel Studies, Yeshiva University, accessed June 10, 2024, www.yu.edu/cis/activities/arch-of-titus.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(", s.v. “David Ben-Gurion”, accessed May 28, 2024, www.britannica.com/biography/David-Ben-Gurion.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jeremías 31:4, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("esv")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "305",
      "epub:type": "pagebreak",
      "id": "page305",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 10")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("2 Corintios 11:14, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Isaías 14:13–14.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 11")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 13:4.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jeremías 51:34, mev, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 29:3, mev, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 12:9, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 12")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Julia Fridman, “Riddle of the Ages Solved: Where Did the Philistines Come From?”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Haaretz")]), _vm._v(", September 21, 2015, www.haaretz.com/archaeology/2015-09-21/ty-article/philistine-homeland-found-and-surprise/0000017f-e10f-d568-ad7ff36f8bb00000;Assaf Yasur-Landau, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Philistines and Aegean Migration at the End of the Late Bronze Age ")]), _vm._v("(Cambridge University Press, 2010), 328–34.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(", s.v. “Sea People”, accessed May 13, 2024, www.britannica.com/topic/Sea-People; “The Philistines in Canaan and Palestine”, Luwian Studies, accessed May 8, 2024, https://luwianstudies.org/the-philistines-in-canaan-andpalestine/; Ann E. Killebrew, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Biblical Peoples and Ethnicity: An Archaeological Study of Egyptians, Canaanites, Philistines, and Early Israel, 1300–1100 B.C.E. ")]), _vm._v("(SBL Press).")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Kenton L. Sparks, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Ethnicity and Identity in Ancient Israel ")]), _vm._v("(Eisenbrauns, 1998), 96–97, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ilan Ben Zion, “The Philistine Age”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Archaeology")]), _vm._v(", July/August 2022, www.archaeology.org/issues/473-2207/features/10600-levant-philistine-#art_page2; Don Knebel, “Medinet Habu: Philistines in Egypt”, Biblical Archaeology Society, September 3, 2019, www.biblicalarchaeology.org/daily/medinet-habu-philistines-in-egypt/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("James Henry Breasted, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Ancient Records of Egypt")]), _vm._v(", vol. 4, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Twentieth to the Twenty-Sixth Dynasties ")]), _vm._v("(Chicago University Press, 1906), 201, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ben Zion, “The Philistine Age.”")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Owen Jarus, “Who Were the Philistines?”, Live Science, July 16, 2016, www.livescience.com/55429-philistines.html.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 13")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("“Josephus Describes the Romans’ Sack of Jerusalem”, PBS, accessed May 28, 2024, www.pbs.org/wgbh/pages/frontline/shows/religion/maps/primary/josephussack.html;Abraham Malamat, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("A History of the Jewish People ")]), _vm._v("(Harvard University Press, 1976), 308, 332–33.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Peter Schäfer"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(", The History of the Jews in the Greco-Roman World: The Jews of Palestine From Alexander the Great to the Arab Conquest ")]), _vm._v("(Routledge, 2003), 163.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Oxford Classical Dictionary")]), _vm._v(", s.v. “Judaea-Palaestina”, updated May 29, 2020, https://doi.org/10.1093/acrefore/9780199381135.013.3500.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 14")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "306",
      "epub:type": "pagebreak",
      "id": "page306",
      "role": "doc-pagebreak"
    }
  }, [_c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jonathan Laden, “Jews and Arabs Descended From Canaanites”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Bible History Daily, ")]), _vm._v("November 25, 2023, www.biblicalarchaeology.org/daily/ancient-cultures/ancientnear-eastern-world/jews-and-arabs-descended-from-canaanites/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Megan Gannon, “Ancient DNA Sheds New Light on the Biblical Philistines”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Smithsonian Magazine")]), _vm._v(", July 3, 2019, www.smithsonianmag.com/science-nature/ancient-dna-sheds-new-light-biblical-philistines-180972561/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Laden, “Jews and Arabs Descended From Canaanites.”")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(", s.v. “Theodor Herzl”, updated April 30, 2024, www.britannica.com/biography/Theodor-Herzl.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Perwez Anwer, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestine, Part 1 ")]), _vm._v("(IBTN Publications, June 21, 2022), preface.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“For the Record: Palestine: From Partition to Independence 1947–1988”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Palestine Yearbook of International Law Online ")]), _vm._v("4, no. 1 (1987): 247, https://doi.org/10.1163/221161488X00089; "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopedia of the Modern Middle East and North Africa")]), _vm._v(", s.v. “All-Palestine Government”, accessed May 23, 2024, www.encyclopedia. com/humanities/encyclopedias-almanacs-transcripts-and-maps/all-palestinegovernment.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Douglas J. Feith, “The Forgotten History of the Term ‘Palestine,’” "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mosaic, ")]), _vm._v("December 13, 2021, www.hudson.org/node/44363.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 15")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("The Learning Network, “Nov. 29, 1947: U.N. Partitions Palestine, Allowing for Creation of Israel”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(", accessed May 13, 2024, https://archive.nytimes.com/learning.blogs.nytimes.com/2011/11/29/nov-29-1947-united-nations-partitions-palestine-allowingfor-creation-of-israel/; Benny Morris, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("1948: A History of the First Arab-Israeli War ")]), _vm._v("(Yale University Press, 2008), 72.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Mordechai Nisan, “The Conundrum of Israeli-Arab Citizenship”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Middle East Quarterly")]), _vm._v(", Summer 2020, www.meforum.org/61033/the-conundrum-of-israeliarab-citizenship; “A Brief History of Gaza’s Centuries of War”, Reuters"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(", ")]), _vm._v("accessed May 10, 2024, www.reuters.com/world/middle-east/brief-history-gazascenturies-war-2023-10-13/; “The Tragedy of Palestine”, The Hashemite Kingdom of Jordan, accessed May 10, 2024, http://www.kinghussein.gov.jo/his_palestine.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Mazen Masri, “The PLO and the Crisis of Representation”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Muftah")]), _vm._v(", October 15, 2010, https://web.archive.org/web/20160322193612/http://muftah.org/the-plo-and-the-crisisof-representation-by-mazen-masri/#.VvGernbei3B; Encyclopedia.com, s.v. “Palestine Liberation Army”, accessed May 13, 2024, www.encyclopedia.com/politics/dictionaries-thesauruses-pictures-and-press-releases/palestine-liberation-army.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“The Six-Day War: Israel Launches Preemptive Strike”, Jewish Virtual Library, accessed May 10, 2024, www.jewishvirtuallibrary.org/background-and-overview-six-daywar#pre.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“The Six-Day War: The Liberation of the Temple Mount and Western Wall”, Jewish Virtual Library, accessed May 10, 2024, www.jewishvirtuallibrary.org/theliberation-of-the-temple-mount-and-western-wall-june-1967.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Fatah”, Palestinian Academic Society for the Study of International Affairs, accessed May 13, 2024, http://passia.org/media/filer_public/b8/db/b8db1845-9729-4802-8e34-6d6b46884cfb/factsheet_fateh.pdf.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2 ParaOverride-6"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Interactive Encyclopedia of the Palestine Question")]), _vm._v(", s.v. “The Palestinian National Liberation Movement—Fatah (1) 1957–1990”, accessed May 13, 2024"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(", ")]), _vm._v("www.palquest.org/en/highlight/23292/palestinian-national-liberation-movement-%E2%80%93-fatah-i.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Patrick Martin, “At Six Years Old, Yasser Arafat Dreamed of the Conquest of Palestine, a Dream That Would Become His”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Globe and Mail")]), _vm._v(", November 6, 2004, www.theglobeandmail.com/news/world/at-six-years-old-yasser-arafat-dreamed-of-theconquest-of-palestine-a-dream-that-would-become-his/article4091466/; Tass Saada, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Once an Arafat Man ")]), _vm._v("(Tyndale House Publishers, 2008), 4; David N. Bossie and Christopher M. Gray, “Yasser Arafat: Architect of Terror”, Citizens United Foundation, accessed May 14, 2024, www.citizensunitedfoundation.org/yasserarafat-architect-of-terror/; “19 Years Since the Martyrdom of the Leader and Symbol Yasser Arafat”, Alquds, November 11, 2023, www.alquds.com/en/posts/100326.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Éxodo 23:31, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("mev")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Laurie Kellman, “‘From the River to the Sea’: Why These 6 Words Spark Fury and Passion Over the Israel-Hamas War”, Associated Press, November 10, 2023, https://apnews.com/article/river-sea-israel-gaza-hamas-protests-d7abbd756f481fe50b6fa5c0b907cd49, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Rick Gladstone, “An Annual Day of Palestinian Grievance Comes Amid the Upheaval”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times, ")]), _vm._v("May 15, 2021, www.nytimes.com/2021/05/15/world/middleeast/ nakba-day.html.")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "307",
      "epub:type": "pagebreak",
      "id": "page307",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 16")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Carl S. Ehrlich, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Philistines in Transition: A History From ca. 1000–730 BCE ")]), _vm._v("(E.J. Brill, 1996), 7–8; “Canaan and Ancient Israel”, University of Pennsylvania Museum of Archaeology and Anthropology, accessed May 28, 2024, www.penn.museum/sites/Canaan/IronAgeI.html; Roger Atwood, “Egypt’s Final Redoubt in Canaan”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Archaeology, ")]), _vm._v("July/August 2017, www.archaeology.org/issues/262-1707/features/5627-jaffa-egypt-canaan-colony.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(", s.v. “1948 Arab-Israeli War”, accessed May 10, 2024, www.britannica.com/event/1948-Arab-Israeli-War; Julia Frankel, “Gaza Has Long Been a Powder Keg. Here’s a Look at the History of the Embattled Region”, Associated Press, October 20, 2023, https://apnews.com/article/gaza-history-israel-palestinianshamas-egypt-688d202c53c0cc72bf2242dccb47fcd5; “A Brief History of Gaza’s 75 Years of Woe”, Reuters, October 11, 2023, www.reuters.com/world/middle-east/briefhistory-gazas-75-years-woe-2023-10-10/; "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica, ")]), _vm._v("s.v. “Palestine and the Palestinians (1948–67)”, accessed May 28, 2024, www.britannica.com/place/Palestine/Palestine-and-the-Palestinians-1948-67; Beryl Cheal, “Refugees in the Gaza Strip, December 1948–May 1950”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Journal of Palestine Studies ")]), _vm._v("18, no. 1 (October 1988): 138, www.researchgate.net/publication/249978298_Refugees_in_the_Gaza_Strip_DeDecemb_1948May_1950.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Génesis 10:19.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ben Zion, “The Philistine Age.”")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ken Feisel, “The Philistine Age”, image, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Archaeology")]), _vm._v(", July/August 2022, www.archaeology.org/images/JA2022/Philistines/Philistines-Map.jpg; "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica, ")]), _vm._v("s.v. “Gaza Strip”, image, accessed May 10, 2024, www.britannica.com/place/Gaza-Strip#/media/1/227456/100799.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 17")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Éxodo 13:17, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("S. R. Driver, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Book of Exodus in the Revised Version ")]), _vm._v("(Cambridge University Press, 1911), 111, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Christopher Eames, “Uncovering the Bible’s Buried Civilizations: The Philistines”, Armstrong Institute of Biblical Archaeology, March 26, 2017, https://armstronginstitute.org/30-uncovering-the-bibles-buried-civilizations-the-philistines, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Byron Chesney, “Jeremy 47:1–7—Oracle Against the Philistines”, Bible Outlines, accessed May 28, 2024, www.bibleoutlines.com/Jeremías-471-7-oracle-againstthe-philistines/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Interactive Encyclopedia of the Palestine Question")]), _vm._v(", s.v. “Battle of al-Karama, 1968”, accessed May 14, 2024, www.palquest.org/en/highlight/165/battle-al-karama-1968.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Release: Bipartisan Group of 50 to Administration: Negotiate an End to Martyr Payments to Terrorists”, Office of Rep. Josh Gottheimer, July 18, 2023, https://gottheimer.house.gov/posts/release-bipartisan-group-of-50-to-administration-negotiate-an-end-tomartyr-payments-to-terrorists.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Palestinian Public Opinion Polls: Attitudes About Terrorism (2002–2023)”, Jewish Virtual Library"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v(", ")]), _vm._v("accessed May 10, 2024, www.jewishvirtuallibrary.org/palestinians-attitudes-about-terrorism.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 25:15, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("hcsb")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Ezequiel 25: Mateo Poole’s Commentary”, Bible Hub, accessed May 28, 2024, https://biblehub.com/commentaries/poole/Ezequiel/25.htm, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“Ezequiel 25”, Bible Hub.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("John Gill, “Exposition on Ezequiel 25”, Bible Hub, accessed May 28, 2024, https://biblehub.com/commentaries/gill/Ezequiel/25.htm, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Carl Friedrich Keil and Franz Delitzsch, “Ezequiel 25”, Bible Hub, accessed June 11, 2024, https://biblehub.com/commentaries/kad/Ezequiel/25.htm.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 18")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "308",
      "epub:type": "pagebreak",
      "id": "page308",
      "role": "doc-pagebreak"
    }
  }, [_c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1 Samuel 17:33, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Itamar Marcus, “The Palestinian Authority’s Child Soldier Strategy Against Israel—Opinion”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jerusalem Post")]), _vm._v(", February 3, 2022, www.jpost.com/opinion/article-695445.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Hamas and Islamic Jihad Summer Camps in Gaza: A Framework for Jihadi Indoctrination, Military Training”, Middle East Media Research Institute, June 28, 2021, www.memri.org/reports/hamas-and-islamic-jihad-summer-camps-gazaframework-jihadi-indoctrination-military-training.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Joe Truzman, “Islamic Jihad Begins Military Summer Camp for Palestinian Youth”, Foundation for Defense of Democracies, accessed May 28, 2024, www.fdd.org/analysis/2023/06/13/islamic-jihad-begins-military-summer-camp-for-palestinian-youth; “Fatah Summer Campers in the Nablus District Undergo Military Training”, Meir Amit Intelligence and Terrorism Information Center, July 31, 2022, www.terrorism-info.org.il/en/fatah-summer-campers-in-the-nablus-district-undergo-military-training/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Nan Jacques Zilberdik, “The PA Summer Camps for Terror and Martyrdom”, Palestinian Media Watch, August 3, 2023, https://palwatch.org/page/34418.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Hamas’ Indoctrination of Children to Jihad, Martyrdom, Hatred of Jews”, MEMRI, November 3, 2023, www.memri.org/reports/hamas-indoctrination-childrenjihad-martyrdom-hatred-jews; Bethania Palma, “Did Gaza Preschoolers Perform a Mock Execution of an Israeli Soldier?”, Snopes, June 6, 2018, www.snopes.com/news/2018/06/06/gaza-preschoolers-mock-execution-israeli-soldier/; Steve Israel, “The Roots of Hamas’ Terror Attack Can Be Found in Gaza’s Schools”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Forward")]), _vm._v(", October 25, 2023, https://forward.com/opinion/566841/hamas-schools-indoctrination-antisemitictextbooks-gaza/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Itamar Marcus and Nan Jacques Zilberdik, “Are Palestinian Mothers Genuinely Joyous Over the Deaths of Their Children as ‘Martyrs’ or Are They Just Keeping Up Appearances?”, MEMRI, September 22, 2021, https://palwatch.org/page/29176; “Palestinian Authority Media Glorifies Murderers”, Meir Amit Intelligence and Terrorism Information Center, accessed May 28, 2024, www.terrorism-info.org.il/en/17793/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Alan Rowe, “The Temples of Dagon and Ashtoreth at Beth-Shan”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Museum Journal ")]), _vm._v("17, no. 3 (September 1926): 295–304, www.penn.museum/sites/journal/1392/; “Did the Canaanites Really Sacrifice Their Children?”, Bible Reading Archeology, May 13, 2016, https://biblereadingarcheology.com/2016/05/13/did-the-canaanites-sacrifice-theirchildren/.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 19")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "309",
      "epub:type": "pagebreak",
      "id": "page309",
      "role": "doc-pagebreak"
    }
  }, [_c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Aren M. Maeir and Joe Uziel, eds., "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Tell es-Safi/Gath II Excavations and Studies ")]), _vm._v("(Munster, Zaphon, 2020), 24.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Samuel 31:1–3, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("James Moyer, “The Bible: Weapons and Warfare in Ancient Israel”, Grace Communion International, accessed May 11, 2024, https://archive.gci.org/articles/weapons-andwarfare-in-ancient-israel/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Alan Johnson, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Israel and the Palestinians: A Guide to the Debate ")]), _vm._v("(n.p.: We Believe in Israel, 2020), 24; “Rocket Threat From the Gaza Strip, 2000–2007”, Intelligence and Terrorism Information Center at the Israel Intelligence Heritage & Commemoration Center, December 2007, https://web.archive.org/web/20110813152324/http://www.terrorism-info.org.il/malam_multimedia/English/eng_n/html/rocket_threat_e.htm; Wikipedia, s.v. “Palestinian Rocket Attacks on Israel”, modified April 24, 2024, 14:50, https://en.wikipedia.org/wiki/Palestinian_rocket_attacks_on_Israel.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Oxford Languages, ")]), _vm._v("s.v. “missile”, accessed May 11, 2024, www.google.com/search?q=missile.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Merriam-Webster")]), _vm._v(", s.v. “arrow”, accessed May 11, 2024, www.merriam-webster.com/dictionary/arrow, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel Whedon, “Bible Commentaries—1 Samuel 31: Whedon’s Commentary on the Bible”, StudyLight.org, accessed May 28, 2024, www.studylight.org/commentaries/eng/whe/1-samuel-31.html, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Peter Pett, “Bible Commentaries—1 Samuel 31: Pett’s Commentary on the Bible”, StudyLight.org, accessed May 28, 2024, www.studylight.org/commentaries/eng/pet/1-samuel-31.html, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 20")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1 Samuel 17:50.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Blue Letter Bible, s.v. “"), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("qela‘")]), _vm._v("”, accessed May 28, 2024, www.blueletterbible.org/lexicon/h7050/nkjv/wlc/0-1/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“The First Intifada Against Israel”, Al Jazeera, accessed May 12, 2024, www.aljazeera.com/gallery/2023/12/8/history-illustrated-the-first-intifada-against-israel; “The First Intifada”, Yplus, accessed May 12, 2024, https://yplus.ps/2023/12/26/the-first-intifada-2/; Joe Stork, “The Significance of Stones”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Middle East Report, ")]), _vm._v("September/October 1988, https://merip.org/1988/09/the-significance-of-stones/; Brian Whitaker, “Intifada 2000 Dwarfs the Original”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Guardian, ")]), _vm._v("October 26, 2000, www.theguardian.com/world/2000/oct/27/israel1.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Samuel 17:51.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Benny Morris, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Righteous Victims ")]), _vm._v("(Vintage Books, 2001), énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Moslih Kanaaneh et al., eds., "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestinian Music and Song: Expression and Resistance Since 1900 ")]), _vm._v("(Indiana University Press, 2013), 152, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 21")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Judaica")]), _vm._v(", 2nd ed., s.v. “Philistines”, accessed May 28, 2024, https://ketab3.wordpress.com/wp-content/uploads/2014/11/encyclopaedia-judaica-v-16-pes-qu.pdf.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Samuel 13:19.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Moyer, “The Bible.”")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Linah Alsaafin and Ashraf Amra, “Gaza Recycles Rubble as Israel Upholds Ban on Construction Goods”, Al Jazeera, June 17, 2021, www.aljazeera.com/news/2021/6/17/gaza-recycles-rubble-as-israel-upholds-ban-on-construction-goods.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Marc Espanol, “Hamas Weaponry: Made in Gaza”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("El Pais")]), _vm._v(", February 3, 2024, https://english.elpais.com/international/2024-02-03/hamas-weaponry-made-in-gaza. html; Brad Lendon, “How Does Hamas Get Its Weapons? A Mix of Improvisation, Resourcefulness and a Key Overseas Benefactor”, CNN, October 12, 2023, www.cnn.com/2023/10/11/middleeast/hamas-weaponry-gaza-israel-palestine-unrest-intlhnk-ml/index.html; Michael Biesecker, “Hamas Fights With a Patchwork of Weapons Built by Iran, China, Russia and North Korea”, Associated Press, January 15, 2024, https://apnews.com/article/israel-hamas-war-guns-weapons-missiles-smuggling-adae9dae4c48059d2a3c8e5d565daa30; Daniel Sonnenfeld, “Made in Gaza: Hamas Rockets the Product of Foreign Aid and Smuggled Material”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Media Line")]), _vm._v(", December 30, 2021, https://themedialine.org/top-stories/made-in-gaza-hamas-rockets-the-product-of-foreign-aidand-smuggled-material/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Iron Dome Family”, Rafael Advanced Defense Systems, accessed May 11, 2024, www.rafael.co.il/iron-dome/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Vasudevan Sridharan, “‘Iron Spade’—Israel’s New Weapon Against Hamas Terror Tunnels”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("International Business Times")]), _vm._v(", August 17, 2014, www.ibtimes.co.uk/ironspade-israels-new-weapon-against-hamas-terror-tunnels-1461480.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Israel Completes ‘Iron Wall’ Underground Gaza Barrier”, Al Jazeera, December 7, 2021, www.aljazeera.com/news/2021/12/7/israel-announces-completion -ofunderground-gaza-border-barrier.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Yuval Azulay, “Beam Me Up: Israel’s New Laser System Is a Security Game Changer”, CTech, April 30, 2023, www.calcalistech.com/ctechnews/article/t7ac5asht.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“David’s Sling”, Rafael Advanced Defense System, accessed May 11, 2024, www.rafael.co.il/system/medium-long-range-defense-davids-sling/.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 23")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "310",
      "epub:type": "pagebreak",
      "id": "page310",
      "role": "doc-pagebreak"
    }
  }, [_c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 20:2, tlb, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Pedro 5:8, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 12:9, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Will Timmons, “Wolves in Sheep’s Clothing 4: Their Paternity”, Bible by Day, May 25, 2023, https://biblebyday.com/blog/wolves-in-sheeps-clothing-paternity.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 24")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Becky Sullivan, “What Is a Kibbutz? The Roots of Israel’s Communal Villages Where Violence Raged”, NPR, October 12, 2023, www.npr.org/2023/10/12/1205284601/what-is-a-kibbutz-the-roots-of-israels-communal-villages-where-violence-raged;Liam Hoare, “Left in the Dust”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Slate")]), _vm._v(", March 17, 2015, https://slate.com/news-andpolitics/2015/03/meretz-may-cease-to-exist-after-the-israeli-election-the-campaign-tooust-benjamin-netanyahu-may-cause-chaos-on-the-israeli-left.html; Annick Cojean, “Israel, the Weissmann Family’s Pioneer Dream”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Le Monde")]), _vm._v(", December 1, 2023, www.lemonde.fr/en/international/article/2023/12/01/israel-the-weissmanns-pioneeringdream_6305191_4.html; Chris McCullough, “Israeli Dairy Farmers Slaughtered by Hamas as They Milked Their Cows”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Tri-State Livestock News")]), _vm._v(", October 13, 2023, www.tsln.com/news/israeli-dairy-farmers-slaughtered-by-hamas-as-they-milked-theircows/; Tamar Mor Sela, “‘I Moved to Israel Driven by a Strong Love for the Country. But the State Has Left Us to Fend for Ourselves,’” Times of Israel, December 30, 2023, www.timesofisrael.com/uprooted-guido-cohen-24-from-kibbutz-ein-hashlosha-this-ishis-story/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Crónicas 11:11.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Crónicas 11:10.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Mark Weiss, “Israel Completes Construction of ‘Iron Wall’ Around Gaza”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Irish Times")]), _vm._v(", December 8, 2021, www.irishtimes.com/news/world/middle-east/israelcompletes-construction-of-iron-wall-around-gaza-1.4749888/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Times of Israel and "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Agence France-Presse ")]), _vm._v("staff, “Years of Subterfuge, High-Tech Barrier Paralyzed: How Hamas Busted Israel’s Defenses”, Times of Israel, October 11, 2023, www.timesofisrael.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 25")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("“Sea Peoples (Bronze Age)”, The History Files, accessed May 28, 2024, www.historyfiles.co.uk/KingListsMiddEast/AnatoliaSeaPeoples.htm.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Samuel 7:13, niv, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Crónicas 21:16–17.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Crónicas 28:16–18.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Patrick Reevell, “Reporter’s Notebook: In Israeli Kibbutz Rampaged by Hamas, Volunteers Still Cleaning Blood From Homes”, ABC News, November 15, 2023, https://abcnews.go.com/International/israeli-kibbutz-kfar-aza-volunteers-cleaning-blood/story?id=104848791.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Noga Tarnopolsky, Shira Rubin, and Miriam Berger, “‘Humiliated and Defeated’: Fear, Shock Grip Israel After Hamas Assault”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Washington Post")]), _vm._v(", October 7, 2023, www.washingtonpost.com/world/2023/10/07/israel-gaza-hamas-attack-netanyahu/.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 26")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("2 Crónicas 28:18, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Negev Desert”, Tourist Israel, accessed May 28, 2024, www.touristisrael.com/negev/295/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Joshua 15”, STEP Bible, accessed May 28, 2024, www.stepbible.org.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Bible Commentaries: Joshua 15”, StudyLight.org, accessed May 28, 2024, www.studylight.org/commentaries/eng/bnb/joshua-15.html#verses-21.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Josúe 15:33, 46–47, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jacoba Urist, “Israeli Music Festival That Hamas Attacked on 7 October Is Re-Created in New York Exhibit”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Art Newspaper")]), _vm._v(", April 22, 2024, www.theartnewspaper. com/2024/04/22/nova-music-festival-israel-hamas-war-exhibition-new-york.")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "311",
      "epub:type": "pagebreak",
      "id": "page311",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 27")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("2 Crónicas 21:17, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Samuel 30:3–4.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Joel 3:4, 6, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Benson Commentary: Amós 1:6–8”, Bible Hub, accessed May 23, 2024, https://biblehub.com/commentaries/amos/1-6.htm, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Josef Federman and Issam Adwan, “Hamas Surprise Attack Out of Gaza Stuns Israel and Leaves Hundreds Dead in Fighting, Retaliation”, Associated Press, October 7, 2023, https://apnews.com/article/israel-palestinians-gaza-hamas-rockets-airstrikes-tel-aviv-11fb98655c256d54ecb5329284fc37d2.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Hamas, Islamic Jihad: Holding Hostages Is a War Crime”, Human Rights Watch, October 20, 2023, www.hrw.org/news/2023/10/19/hamas-islamic-jihad-holding-hostages-war-crime.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Benson Commentary”, Bible Hub, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Benson Commentary”, Bible Hub, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Newsnation Live, “Israeli Grandmother Held Hostage ‘Won’t Let Them Humiliate Her,’” YouTube, October 16, 2023, www.youtube.com/watch?v=xKKS0wv5-_0; Roni Caryn Rabin, “Families Fear for the Health of Ailing, Frail Israelis Held Hostage”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(", November 21, 2023, www.nytimes.com/2023/11/21/world/middleeast/hamas-hostages-health.html; Raphaelle Bacqué, “A Hostage Freed by Hamas Campaigned All Her Life for Palestinian Rights”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Le Monde")]), _vm._v(", October 27, 2023, www.lemonde.fr/en/international/article/2023/10/27/a-hostage-freed-by-hamas-campaigned-all-her-life-for-palestinian-rights_6207124_4.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("1 Samuel 30:3.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Sue Surkes, “Kibbutz Kfar Aza, Devastated on October 7, Becomes a Grim Place of Pilgrimage”, Times of Israel, January 5, 2024, www.timesofisrael.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“Now-Freed Hostage Seen in Video Fighting Against Her 7 Hamas Kidnappers on October 7”, Times of Israel, December 5, 2023, www.timesofisrael.com/footage-shows-now-freed-hostage-fighting-against-hamas-kidnappers-on-october-7/; “Why Hamas Took So Many People Hostage—and How That Complicates Israel’s Response”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Radio Canada International")]), _vm._v(", October 10, 2023, https://ici.radio-canada.ca/rci/en/news/2016715/why-hamas-took-so-many-people-hostage-and-how-that-complicates-israels-response.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Rabin, “Families Fear for the Health of Ailing, Frail Israelis Held Hostage.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 28")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 12:4.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 29")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "312",
      "epub:type": "pagebreak",
      "id": "page312",
      "role": "doc-pagebreak"
    }
  }, [_c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ezequiel 32:23, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 32:24, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 32:26, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 32:30, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Samuel 17:11, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Robert Bain, “Women, Fundamentalism and Terror: Echoes of Ancient Assyria”, Heinrich Böll Stiftung, February 9, 2017, https://lb.boell.org/en/2017/02/09/women-fundamentalism-and-terror-echoes-ancient-assyria.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("David Makovsky, “Death of a Symbol: Yasser Arafat Leaves Behind a Complicated Legacy of Nationalism and Terrorism”, The Washington Institute for Near East Policy, November 11, 2004, www.washingtoninstitute.org/policy-analysis/death-symbol-yasser-arafat-leaves-behind-complicated-legacy-nationalism-and; David Holden, “Article 7”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(", March 23, 1975, www.nytimes.com/1975/03/23/archives/article-7-no-title-arafat.html; Kali Robinson, “Who Governs the Palestinians?”, Council on Foreign Relations, updated March 19, 2024, www.cfr.org/backgrounder/who-governs-palestinians.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jewish Telegraph Agency, “Was Hamas’s Attack on Saturday the Bloodiest Day for Jews Since the Holocaust?”, Times of Israel, October 9, 2023, www.timesofisrael.com; Avner Cohen et al., “Deadliest Day for Jews Since the Holocaust Shakes the Foundations of Israel as a Safe Homeland, Says Double Macarthur-Winning Historian”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Fortune")]), _vm._v(", October 15, 2023, https://fortune.com/2023/10/15/deadliest-day-for-jews-since-holocaust-shakes-zionism-israeli-historian-says/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 32:2, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 30")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "313",
      "epub:type": "pagebreak",
      "id": "page313",
      "role": "doc-pagebreak"
    }
  }, [_c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Harriet Sherwood, “How the Hamas Attack on the Supernova Festival in Israel Unfolded”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Guardian")]), _vm._v(", October 9, 2023, www.theguardian.com/world/2023/oct/09/how-the-hamas-attack-on-the-supernova-festival-in-israel-unfolded; “The Nova Music Festival October 7”, The Nova Music Festival Exhibition, accessed May 11, 2024, www.nova0629exhibition.com/aboutthenovafestival.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("American Jewish Committee, “Tal Shimony Survived the Hamas Attack on the Nova Music Festival: Hear Her Story of Courage, Resilience, and Remembrance”, February 1, 2024, in "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("People of the Pod")]), _vm._v(", podcast, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.ajc.org/news/podcast/tal-shimony-survived-the-hamas-attack-on-the-nova-music-festival-hear-her-story-of-courage")]), _vm._v("; Sherwood, “How the Hamas Attack on the Supernova Festival in Israel Unfolded”; Loveday Morris et al., “How a Night of Dancing and Revelry in Israel Turned Into a Massacre”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Washington Post")]), _vm._v(", October 8, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.washingtonpost.com/world/2023/10/08/israel-festival-attack-gaza-militants/")]), _vm._v("; “Survivors Confront Their Trauma at Site of Hamas Massacre of Music Festival”, Times of Israel, April 14, 2024, www.timesofisrael.com/survivors-confront-their-trauma-at-site-of-hamas-massacre-of-music-festival/; Mustafa Abu Ganeyeh and Leonardo Benassatto, “‘I Was Reborn’ on Oct. 7 Says Survivor of Hamas Attack on Israeli Festival”, Reuters, October 31, 2023, www.reuters.com/world/middle-east/i-was-reborn-oct-7-says-survivor-hamas-attack-israeli-festival-2023-10-31/; Renee Ghert-Zand, “Sheryl Sandberg’s New Film Testifies to Hamas’s Brutal Sexual Violence on October 7”, Times of Israel, April 26, 2024, www.timesofisrael.com/sheryl-sandbergs-new-film-testifies-to-hamass-brutal-sexual-violence-on-october-7/; “Israeli Forensic Teams Describe Signs of Torture, Abuse”, Reuters, October 15, 2023, www.reuters.com/world/middle-east/israeli-forensic-teams-describe-signs-torture-abuse-2023-10-15/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Agence France-Presse, “Survivor Recalls Watching Israel Music Fest Massacre From Atop Tree”, NDTV, November 11, 2023, www.ndtv.com/world-news/survivor-recalls-watching-israel-music-fest-massacre-from-atop-tree-4565949; The Independent, “Festival Goers Hide in Undergrowth During Deadly Hamas Attack”, YouTube, accessed May 11, 2024, www.youtube.com/watch?v=8uPkD_JJx9w; David Browne, Nancy Dillon, and Kory Grow, “They Wanted to Dance in Peace. And They Got Slaughtered”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Rolling Stone")]), _vm._v(", October 15, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.rollingstone.com/music/music-features/hamas-israel-nova-music-festival-massacre-1234854306/")]), _vm._v("; Sumanti Sen, “Exclusive: ‘We Pretended to Be Dead, but They Found Us and Then…,’ Israel Music Fest Survivor Recounts Horror”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Hindustan Times")]), _vm._v(", October 10, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.hindustantimes.com/world-news/exclusive-we-pretended-to-be-dead-but-they-found-us-and-then-israel-music-fest-survivor-recounts-horror-101696902733579.html")]), _vm._v("; American Jewish Committee, “Tal Shimony Survived the Hamas Attack on the Nova Music Festival”; “Nova Music Festival”, October7.org, accessed May 28, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.october7.org/nova-festival")]), _vm._v("; Sinéad Baker, “Israeli Festival Attendees Played Dead for Hours to Try to Stay Alive During Hamas Attack”, Business Insider, October 9, 2023, www.businessinsider.com/israel-festival-attendees-played-dead-for-hours-during-hamas-attack-2023-10.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Samuel 13:6.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Robert Jamieson, A. R. Fausset, and David Brown, “1 Samuel 13:6”, Bible Hub, accessed May 28, 2024, https://biblehub.com/commentaries/1_samuel/13-6.htm.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jamieson, Fausset, and Brown, “1 Samuel 13:6.”")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Madhur Sharma, “Israel-Hamas War: How Hamas’s Mass Murder Unfolded at Desert Music Festival, Survivors Recount Hours of Horrors”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Outlook")]), _vm._v(", updated October 10, 2023, www.outlookindia.com/international/israel-hamas-war-how-hamas-mass-murder-unfolded-at-desert-music-festival-survivors-recount-hours-of-horrors-news-323643, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("John Gill, “1 Samuel 13:6”, John Gill’s Exposition of the Bible, Bible Study Tools, accessed May 28, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.biblestudytools.com/commentaries/gills-exposition-of-the-bible/1-samuel-13-6.html")]), _vm._v(", énfasis añadido. ")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Deborah Danan, “‘The Holocaust, All Over Again’: The Supernova Festival Massacre, in Survivors’ Words”, Times of Israel, October 12, 2023, www.timesofisrael.com/the-holocaust-all-over-again-the-supernova-festival-massacre-in-survivors-words/, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Gill, “1 Samuel 13:6”, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“Release of Two More Hostages Gives Some Hope to Families of Others Abducted in the Attack on Israel”, Associated Press, updated October 23, 2023, https://apnews.com/article/hostages-israel-hamas-war-what-to-know-406920c384818fa4fe3525327adf3f50.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Eliza Mackintosh et al., “How a Rave Celebrating Life Turned Into a Frenzied Massacre”, CNN, October 14, 2023, www.cnn.com/interactive/2023/10/middleeast/hamas-music-festival-attack-investigation-cmd-intl/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("David Guzik, “1 Samuel 14—Victory Over the Philistines”, Enduring Word, 2022, https://enduringword.com/bible-commentary/1-samuel-14/, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“5 Hostages of Hamas Are Free, Offering Some Hope to Families of More Than 200 Still Captive”, Arab News, November 4, 2023, www.arabnews.com/node/2402946/amp, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("1 Samuel 14:11, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“1 Samuel 14 Commentary”, Precept Austin, accessed May 28, 2024, www.preceptaustin.org/1-samuel-14-commentary, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Joel B. Pollak, “Family of Russian-Israeli Hostage: He Escaped Hamas, Was Recaptured by Palestinian Civilians”, ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Breitbart,")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(" November 27, 2023, www.breitbart.com/middle-east/2023/11/27/family-of-russian-israeli-hostage-he-escaped-hamas-was-recaptured-by-palestinian-civilians/, énfasis añadido.")])]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ganeyeh and Benassatto, “I Was Reborn”, énfasis añadido.")])]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Sam Mednick, “New Signs Emerge of ‘Widespread’ Sexual Crimes by Hamas, as Netanyahu Alleges Global Indifference”, ")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Associated Press,")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("December 6, 2023, https://apnews.com/article/sexual-assault-hamas-oct-7-attack-rape-bb06b950bb6794affb8d468cd283bc51.")])]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Alexi Demetriadi, “Sydney’s Jewish Community: ‘Me Too, Unless You’re a Jew?,’” ")]), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Australian")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("December 17, 2023, www.theaustralian.com.au.")])]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Survived to Tell (@survived.to.tell), Survivor stories from Israel, Instagram, accessed May 28, 2024, www.instagram.com/p/CyPA8sRIsuu/, énfasis añadido.")])]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Katie Bain, “Artist Manager Describes Israeli Rave Massacre: ‘It Turned Into a Nightmare,’” ")]), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Billboard")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("October 8, 2023, www.billboard.com/music/music-news/israel-music-festival-attack-artist-manager-account-massacre-1235436829/, énfasis añadido.")])]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("1 Samuel 13:6, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 31")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Isaías 20:2.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Isaías 20:3–4.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Liza Rozovsky, “15 Witnesses, Three Confessions, a Pattern of Naked Dead Bodies. All the Evidence of Hamas Rape on October 7”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Haaretz")]), _vm._v(", April 18, 2024, www.haaretz.com/israel-news/2024-04-18/ty-article-magazine/witnesses-confessions-naked-dead-bodies-all-the-evidence-of-hamas-rape-on-oct-7/0000018e-f114-d92e-abfe-f77f7e3f0000.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Shani Louk, 22: German-Israeli Partygoer Had ‘a Huge Heart,’” Times of Israel, November 3, 2023, www.timesofisrael.com/shani-louk-22-german-israelis-kidnap-video-seen-globally/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Watson’s Biblical and Theological Dictionary")]), _vm._v(", s.v. “Captives”, StudyLight.org, accessed May 28, 2024, www.studylight.org/dictionaries/eng/wtd/c/captives.html.")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "314",
      "epub:type": "pagebreak",
      "id": "page314",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 32")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1 Samuel 31:8–10.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Crónicas 10:9–10.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Father of Fallen Soldier: Terrorist Decapitated My Son, Tried to Sell Head for $10,000”, Times of Israel, January 18, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.timesofisrael.com")]), _vm._v("; Qanta Ahmed, “I Saw the Children Hamas Beheaded With My Own Eyes. Shame on Queen Rania”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Newsweek")]), _vm._v(", December 27, 2023, www.newsweek.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 33")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Priyanka Chandani, “American Artist in Israel for a Wedding Cleared Dead Bodies After Hamas Attack: ‘It Is Incredibly Hard to Narrate This, but I Will Try,’” "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Orato")]), _vm._v(", November 27, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://orato.world/2023/11/27/american-artist-in-israel-for-a-wedding-cleared-dead-bodies-after-hamas-attack-it-is-incredibly-hard-to-narrate-this-but-i-will-try/")]), _vm._v("; Aaron Poris, “Evidence on Display at Israel’s Forensic Pathology Center Confirms Hamas’ Atrocities”, Medialine, November 6, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://themedialine.org/top-stories/evidence-on-display-at-israels-forensic-pathology-center-confirms-hamas-atrocities/")]), _vm._v("; Jeffrey Gettleman, Anat Schwartz, and Adam Sella, “‘Screams Without Words’: How Hamas Weaponized Sexual Violence on Oct. 7”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(", updated March 25, 2024, www.nytimes.com/2023/12/28/world/middleeast/oct-7-attacks-hamas-israel-sexual-violence.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Reyes 8:12, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Grzegorz Rossoliński-Liebe, “Holocaust Amnesia: The Ukrainian Diaspora and the Genocide of the Jews”, in "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("German Yearbook of Contemporary History")]), _vm._v(", vol. 1 (Berlin: De Gruyter Oldenburg, 2016), 107–143, https://muse.jhu.edu/article/846190/pdf.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 35")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jueces 16:2.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jueces 16:12, 20.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jueces 16:21.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Guest Contributor, “Israel Shows Foreign Press Footage of Hamas Massacre”, EU Reporter, October 25, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.eureporter.co/world/israel/palestinian-authority-pa/hamas/2023/10/25/israel-shows-foreign-press-footage-of-hamas-massacre/")]), _vm._v("; Frank Hofmann, “Israel Shows Hamas Terror Videos to Document Horrific Attack”, Deutsche Welle, November 4, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.dw.com/en/israel-shows-hamas-terror-videos-to-document-horrific-attack/a-67305110")]), _vm._v("; Joe Barnes, “Israel Yet to Identify Baby Murdered by Hamas in Photograph That Shocked World”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Telegraph")]), _vm._v(", October 13, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.telegraph.co.uk/world-news/2023/10/13/israel-still-trying-to-identify-baby-murdered-by-hamas/")]), _vm._v(". ")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Amnon Sofrin, “The Intelligence Failure of October 7—Roots and Lessons”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jerusalem Strategic Tribune")]), _vm._v(", November 2023, https://jstribune.com/sofrim-the-intelligence-failure-of-october-7-roots-and-lessons/, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Aric Toler, “How Hamas Attacked Israel’s Communications Tower”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(", October 10, 2023, www.nytimes.com/2023/10/10/world/middleeast/hamas-israel-attack-gaza.html, énfasis añadido. ")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Shira Rubin and Loveday Morris, “How Hamas Broke Through Israel’s Border Defenses During Oct. 7 Attack”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Washington Post")]), _vm._v(", October 27, 2023, www.washingtonpost.com/world/2023/10/27/hamas-attack-israel-october-7-hostages/, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jueces 16:21, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("hcsb")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel Ben-David, “Sheryl Sandberg Film Details Horrific Sexual Crimes Committed by Hamas on October 7”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jewish Chronicle")]), _vm._v(", April 26, 2024, www.thejc.com/news/israel/sheryl-sandberg-film-details-horrific-sexual-crimes-committed-by-hamas-on-october-7-gxmsu7bz.; Howard Goller, “Freed Israeli Hostages Tell Families of Beatings and Death Threats”, Reuters, November 29, 2023, www.reuters.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 36")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "315",
      "epub:type": "pagebreak",
      "id": "page315",
      "role": "doc-pagebreak"
    }
  }, [_c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jueces 16:21, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jueces 16:21.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Gaza Tunnels Stretch at Least 350 Miles, Far Longer Than Past Estimate—Report”, Times of Israel, January 16, 2024, www.timesofisrael.com; Peter Saidel, Summer Said, and Anat Peled, “Hamas Took More Than 200 Hostages From Israel. Here’s What We Know”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Wall Street Journal")]), _vm._v(", updated May 8, 2024, www.wsj.com/world/middle-east/hamas-hostages-israel-gaza-41432124.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Amós 1:6, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Amós 1:6, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("niv")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Amós 1:6, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("nlt")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Charles John Ellicott, “Curse on Philistia”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Ellicott’s Commentary for English Readers")]), _vm._v(", Bible Hub, May 28, 2024, https://biblehub.com/commentaries/amos/1-6.htm, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Amós 1:6, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("amp")]), _vm._v(", énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 37")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jueces 16:23.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jueces 16:25.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Drew Harwell and Elizabeth Dwoskin, “Hamas Turns to Social Media to Get Its Message Out—and to Spread Fear”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Washington Post")]), _vm._v(", October 18, 2023, www.washingtonpost.com/technology/2023/10/18/hamas-social-media-terror/; Camilla Turner, “Israeli Hostage Paraded Through Gaza Like a ‘Trophy,’” "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Telegraph")]), _vm._v(", March 13, 2024, www.telegraph.co.uk/world-news/2024/03/13/israeli-held-hostage-by-hamas-paraded-through-gaza-trophy/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Isaías 14:29, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Isaías 14:29, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("kjv")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Samuel 1:19–20, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 25:6, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jueces 16:24.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Aaron Feis, “Watch: Gazan Mob Swarms Hamas Hostages With Shouts of ‘God Is Great,’” MSN, November 29, 2023, www.msn.com/en-us/news/world/watch-gaza-residents-swarm-israeli-hostages-shout-allahu-akbar-during-hamas-handover/ar-AA1kJR; Hadas Gold et al., “Hamas Captures Hostages as Israelis Share Photos of Those Missing”, CNN, October 8, 2023, www.cnn.com/2023/10/07/middleeast/hostages-hamas-israel-gaza/index.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“Palestinians in Gaza and the West Bank Celebrate on October 7, Hand Out Sweets, Fire Guns in the Air, Following Hamas’s Invasion and Massacre of Israeli Civilians in the Gaza Envelope”, MEMRI TV, October 7, 2023, www.memri.org/tv/palestinians-gaza-west-bank-celebrate-october-seven-massacre-hand-out-sweets-fire-guns/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“Education for Terrorism in Palestinian Schools: 2023 Israel-Hamas War”, Impact-se, November 2023, www.impact-se.org/wp-content/uploads/Education-for-Terrorism-in-Palestinian-Schools.pdf.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 38")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jueces 16:25–26.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jueces 16:27.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jueces 16:23.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Arieh Elad, “Pico, Hamas Terror Flipped the Switch on Happiest Holiday of the Year”, Boiling Point, December 7, 2023, https://shalhevetboilingpoint.com/outside-news/2023/12/07/from-israel-to-pico-hamas-terror-flips-the-switch-on-happiest-holiday-of-the-year/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jueces 16:23.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jueces 16:23, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Stories That Teach: Shmini Atzeret”, Orthodox Union, June 29, 2006, www.ou.org/holidays/stories_that_teach/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Yoav Zitun, “New Estimate: About 3,000 Terrorists Infiltrated Israel on October 7”, Ynetnews.com, November 1, 2023, www.ynetnews.com/article/hytrcje76.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jueces 16:27, énfasis añadido.")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "316",
      "epub:type": "pagebreak",
      "id": "page316",
      "role": "doc-pagebreak"
    }
  }, [_c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 39")]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "317",
      "epub:type": "pagebreak",
      "id": "page317",
      "role": "doc-pagebreak"
    }
  }, [_c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Philip Mattar, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Mufti of Jerusalem Al-Hajj Amin al-Husayni and the Palestinian National Movement")]), _vm._v(", rev. ed. (Columbia University Press, 1988), 6, 10; "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Holocaust Encyclopedia")]), _vm._v(", s.v. “Hajj Amin Al-Husayni: Arab Nationalist and Muslim Leader”, United States Holocaust Memorial Museum, accessed May 12, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://encyclopedia.ushmm.org/content/en/article/hajj-amin-al-husayni-arab-nationalist-and-muslim-leader")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Oren Kessler, “Herbert Samuel’s Secret 1937 Testimony on the Infamous Mufti of Jerusalem Revealed”, Times of Israel, August 19, 2023, www.timesofisrael.com/uk-reveals-herbert-samuels-secret-1937-testimony-on-the-infamous-mufti-of-jerusalem/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Nadav Shragai, “Father of the Lie: Haj Amin al-Husseini”, Jerusalem Center for Public Affairs, accessed May 12, 2024, https://jcpa.org/al-aksa-is-in-danger-libel/al-aksa-libel-advocate-mufti-haj-amin-al-husseini/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("John Rosenthal, “The Mufti and the Holocaust”, Hoover Institution, March 28, 2008, www.hoover.org/research/mufti-and-holocaust; Shragai, “Father of the Lie.” ")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Bernard Lewis, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Jews of Islam")]), _vm._v(" (Princeton, NJ: Princeton University Press, 1984), 190; “Full Official Record: What the Mufti Said to Hitler”, Times of Israel, October 21, 2015, www.timesofisrael.com/full-official-record-what-the-mufti-said-to-hitler/; Ben Cohen, “The Mufti and the Holocaust, Revisited”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Algemeiner")]), _vm._v(", October 23, 2015, www.algemeiner.com/2015/10/23/the-mufti-and-the-holocaust-revisited/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Steven Wagner, “Unmasking Hajj Amin al-Husseini Through His Wartime Letters and Diaries”, Brunel University London, December 10, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.brunel.ac.uk/research/projects/unmasking-hajj-amin-al-husseini-through-his-wartime-letters-and-diaries")]), _vm._v("; "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Holocaust Encyclopedia")]), _vm._v(", s.v. “Hajj Amin Al-Husayni: Wartime Propagandist”, accessed May 28, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://encyclopedia.ushmm.org/content/en/article/hajj-amin-al-husayni-wartime-propagandist")]), _vm._v("; Rosenthal, “The Mufti and the Holocaust”; Daniel Carpi, “The Rescue of Jews in the Italian Zone of Occupied Croatia”, Shoah Resource Center, International School for Holocaust Studies, accessed May 14, 2024, www.yadvashem.org/odot_pdf/Microsoft%20Word%20-%204803.pdf.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jeffrey Herf, “Haj Amin al-Husseini, the Nazis and the Holocaust: The Origins, Nature and Aftereffects of Collaboration”, Jerusalem Center for Public Affairs, January 5, 2016, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://jcpa.org/article/haj-amin-al-husseini-the-nazis-and-the-holocaust-the-origins-nature-and-aftereffects-of-collaboration/")]), _vm._v("; Shaul Shay, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Islamic Terror and the Balkans")]), _vm._v(" (Transaction, December 31, 2011), 33; David G. Dalin and John F. Rothman, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Icon of Evil: Hitler’s Mufti and the Rise of Radical Islam")]), _vm._v(" (Random House, 2008), 60; George Lepre, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Himmler’s Bosnian Division: The Waffen-SS Handschar Division, 1943–1945")]), _vm._v(" (Schiffer Military History, June 10, 2008), 32.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Wolfgang G. Schwanitz, “Amin al-Husaini and the Holocaust. What Did the Grand Mufti Know?”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("World Politics Review")]), _vm._v(", May 8, 2008, www.worldpoliticsreview.com/amin-al-husaini-and-the-holocaust-what-did-the-grand-mufti-know/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Norman A. Stillman, “Frenchmen, Jews, or Arabs? Jews of the Arab World Between European Colonialism, Zionism, and Arab Nationalism”, in "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Judaism and Islam: Boundaries, Communications, and Interaction: Essays in Honor of William M. Brinner")]), _vm._v(" (August 4, 2021), 134, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Jeffrey Herf, “Nazi Antisemitism & Islamist Hate”, Tablet, July 5, 2022, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.tabletmag.com/sections/history/articles/the-nazi-roots-of-islamist-hate")]), _vm._v("; “Backgrounder: Hajj Amin al-Husseini”, Middle East Forum, October 30, 2015, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.meforum.org/5597/backgrounder-hajj-amin-husseini")]), _vm._v("; Matthias Küntzel, “The 1948 Arab War Against Israel: An Aftershock of World War II?”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Fathom")]), _vm._v(", June 2023, https://fathomjournal.org/the-1948-arab-war-against-israel-an-aftershock-of-world-war-ii/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Ben Sales, “Who Was Haj Amin al-Husseini, the Grand Mufti of Jerusalem?”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Haaretz")]), _vm._v(", October 22, 2015, www.haaretz.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“Arabs Pick Mufti to Head Assembly; Delegates at Gaza Gathering Give a Confidence Vote to Provisional Government”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(", October 2, 1948, ­www.nytimes.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("That leader was Hassan al-Banna. (Herf, “Haj Amin al-Husseini.”)")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Danny Rubinstein, “Yasser Arafat, 1929-2004: Father of the Palestinian Nation”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Haaretz")]), _vm._v(", November 9, 2004, www.haaretz.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Wolfgang G. Schwanitz, “Twofold Germans and Islamism in the Cold War”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Outre-mers")]), _vm._v(" 98, no. 372–373 (2011): 63–94, www.persee.fr/doc/outre_1631-0438_2011_num_98_372_4571.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("David G. Dalin, “Hitler’s Mufti”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("First Things")]), _vm._v(", August 2005, www.firstthings.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 40")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Oxford Bibliographies")]), _vm._v(", s.v. “Hasan al-Banna”, December 14, 2009, www.oxfordbibliographies.com/display/document/obo-9780195390155/obo-9780195390155-0006.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Gudrun Kramer, “Hasan al-Banna”, in "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Makers of the Muslim World")]), _vm._v(" (Oneworld: 2013), 19, 35, 40–43, 48; “History of the Muslim Brotherhood in Egypt”, Ikhwanweb (The Muslim Brotherhood’s Official English website), accessed May 12, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://ikhwanweb.com/history-of-the-muslim-brotherh/")]), _vm._v("; "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(", s.v. “Muslim Brotherhood”, April 11, 2024, www.britannica.com/topic/Muslim-Brotherhood.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Holocaust Encyclopedia")]), _vm._v(", s.v. “The Nazi Party”, accessed May 28, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://encyclopedia.ushmm.org/content/en/article/the-nazi-party-1")]), _vm._v("; “Hassan al-Banna Praises Hitler as a Model for Attaining Fortune, Influence and Success”, Point de Bascule Canada, February 4, 2014, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://pointdebasculecanada.ca/hassan-al-banna-praises-hitler-as-a-model-for-attaining-fortune-influence-and-success/")]), _vm._v("; John Loftus, “The Muslim Brotherhood, Nazis and Al-Qaeda”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jewish Community News")]), _vm._v(", April 10, 2006, www.ocnus.net/artman2/publish/Dark_Side_4/The-Muslim-Brotherhood-Nazis-and-Al-Qaeda.shtml.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("David Patterson, “Islamic Jihad and the Holocaust: From Hitler to Hamas”, SHERM 4, no. 1 (Summer 2022): 65, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.shermjournal.org/vol-4-no-1")]), _vm._v("; “The Qatari Regime, Hamas and the Muslim Brotherhood: The Globalisation of Antisemitism and Anti Democracy”, The Institute for the Study of Global Antisemitism and Policy, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://isgap.org/wp-content/uploads/2023/11/QATAR-REGIME_HAMAS_MB_FINAL.pdf")]), _vm._v("; Amir Darwish, “Fascistic Tendencies in the Muslim Brotherhood”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Fair Observer")]), _vm._v(", November 18, 2022, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.fairobserver.com/politics/fascistic-tendencies-in-the-muslim-brotherhood/#")]), _vm._v("; David Patterson, “The Muslim Brotherhood and the Evolution of Jihadist Antisemitism”, Flashpoint, January 17, 2018, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://isgap.org/flashpoint/the-muslim-brotherhood-and-the-evolution-of-jihadist-antisemitism/")]), _vm._v("; Matthias Küntzel, “National Socialism and Anti-Semitism in the Arab World”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jewish Political Studies Review")]), _vm._v(" 17, no. 1/2 (Spring 2005), "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://jcpa.org/article/national-socialism-and-anti-semitism-in-the-arab-world/")]), _vm._v("; Amichai Chikli (@AmichaiChikli), “This Amazing document from the British archive reveals, Hassan al-Banna, the founder of the Muslim Brotherhood, served as a spy for Nazi Germany”, X, May 6, 2024, 11:07 a.m., https://twitter.com/AmichaiChikli/status/1787514542248866234; “Saudi Arabia Escalates the Conflict With the Muslim Brotherhood (MB): Saudi Government Daily Claims MB Founder Hassan Al-Bana Worked for the Nazis”, MEMRI, February 18, 2020, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.memri.org/reports/saudi-arabia-escalates-conflict-muslim-brotherhood-mb-saudi-government-daily-claims-mb")]), _vm._v("; John C Zimmerman, “Book Review of Martyn Frampton, The Muslim Brotherhood and the West: A History of Enmity and Engagement”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Current Research Journal of Social Sciences and Humanities")]), _vm._v(" 7, no. 1 (2024), https://bit.ly/49Pwww5.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Evin Ismail, “The Antisemitic Origins of Islamist Violence: A Study of the Muslim Brotherhood and the Islamic State”, doctoral thesis, Uppsala (Sweden) University, 2022, 14–15, 227, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://uu.diva-portal.org/smash/get/diva2:1650054/FULLTEXT01.pdf")]), _vm._v("; “Nazi Antisemitism & Islamist Hate”; Markos Zografos, “Genocidal Antisemitism: A Core Ideology of the Muslim Brotherhood”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Occasional Paper Series ")]), _vm._v("(Institute for the Study of Global Antisemitism and Policy) 4 (2021): 9, 18–19, https://isgap.org/wp-content/uploads/2021/06/GenocidalAntisemitism-Markos-Zografos.pdf.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Joseph S. Spoerl, “Parallels Between Nazi and Islamist Anti-Semitism”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jewish Political Studies Review")]), _vm._v(" 31, no. 1/2 (2020): 214, www.jstor.org/stable/26870795.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Counter Terrorism Guide")]), _vm._v(", s.v. “Hamas”, Office of the Director of National Intelligence, accessed May 12, 2024, www.dni.gov/nctc/ftos/hamas_fto.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Counter Terrorism Guide")]), _vm._v(", “Hamas.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 41")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Samia Nakhoul, “How Hamas Secretly Built a ‘Mini-Army’ to Fight Israel”, Reuters, October 16, 2023, www.reuters.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jodi Rudoren, “In Jerusalem Unrest, Signs of a ‘Run-Over Intifada’ for the 21st Century”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(", Nov. 6, 2014, www.nytimes.com/2014/11/07/world/middleeast/israel-palestinians-jerusalem-unrest-al-aqsa.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Hamas Covenant 1988: The Covenant of the Islamic Resistance Movement”, Lillian Goldman Law Library, Yale Law School, accessed May 28, 2024, https://avalon.law.yale.edu/20th_century/hamas.asp, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“The Charter of Allah: The Platform of the Islamic Resistance Movement (Hamas)”, Federation of American Scientists, accessed May 12, 2024, https://irp.fas.org/world/para/docs/880818.htm, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Hamas Covenant 1988”, Lillian Goldman Law Library, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Hamas Covenant 1988”, Lillian Goldman Law Library, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Hamas Covenant 1988”, Lillian Goldman Law Library, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Hamas Covenant 1988”, Lillian Goldman Law Library, énfasis añadido. (“Ye shall be overcome, and thrown together into hell” is credited in the charter to Al-Imran, verse 12, in the Koran.)")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“The Charter of Allah”, Federation of American Scientists, énfasis añadido. (The charter credits this line to two famed medieval Islamic scholars who compiled "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("hadiths")]), _vm._v(", Al-Bukhari and Imam Muslim.)")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("J. Fitz-Gibbon, “Arabic Copy of Adolf Hitler’s ‘Mein Kampf’ Found Inside Child’s Room in Gaza”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Post")]), _vm._v(", November 12, 2023, https://nypost.com/2023/11/12/news/arabic-copy-of-adolf-hitlers-mein-kampf-found-inside-childs-room-in-gaza.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 42")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(",  s.v. “Hamas: Definition, History, Ideology, & Facts”, updated May 10, 2024, www.britannica.com/topic/Hamas.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(", s.v. “Hamas”; Muhammad Maqdsi, “Charter of the Islamic Resistance Movement (Hamas) of Palestine”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Journal of Palestine Studies")]), _vm._v(" 22, no. 4 (summer 1993), 127, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.palestine-studies.org/sites/default/files/attachments/jps-articles/2538093.pdf")]), _vm._v("; Said Khatib, “Hamas Run Palestinian Youth Military Camp in Gaza”, photographs, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Daily Telegraph")]), _vm._v(", January 31, 2015, www.telegraph.co.uk/news/picturegalleries/worldnews/11380165/In-pictures-Hamas-run-Palestinian-youth-military-camp-in-Gaza.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Salmos 140:1, People’s Edition (C.A. Bartlett, 1843).")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Abdías 10, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Adolfo Arranz et al., “Inside the Tunnels of Gaza”, Reuters, December 31, 2023, www.reuters.com/graphics/ISRAEL-PALESTINIANS/GAZA-TUNNELS/gkvldmzorvb/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Salmos 74:20, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 7:11, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 7:23, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jeremías 51:35, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Isaías 60:18, traducción del autor, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 43")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Amós 1:6–7, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("niv")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Amós 1:7, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Silvie Zamazalová, “Before the Assyrian Conquest in 671 B.C.E.: Relations Between Egypt, Kush and Assyria”, paper from master’s dissertation, University College London, 2009, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.ucl.ac.uk/sargon/downloads/zamazalova_crossroads.pdf")]), _vm._v("; Hussein Bassir, “The Egyptian Expansion in the Near East in the Saite Period”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Journal of Historical Archaeology and Anthropological Sciences ")]), _vm._v("3, no. 2 (March 16, 2018), https://medcraveonline.com/JHAAS/the-egyptian-expansion-in-the-near-east-in-the-saite-period.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Crónicas 26:6, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("niv")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Reyes 18:8, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("erv")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Emanuel Fabian et al., “Footage Shows Hostages Being Rescued From Hamas Captivity in Daring Rafah Operation”, Times of Israel, February 12, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.timesofisrael.com")]), _vm._v("; Michelle Nichols, “Israel Warns Half of Gaza’s Population to Move South, UN Says”, Reuters, October 12, 2023, www.reuters.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 44")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Yuval Azulay, “Elbit CEO: ‘We Recruited Hundreds of Employees and Brought Back Retirees Due to Demand and War,’” "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Calcalist")]), _vm._v(", November 28, 2023, www.calcalistech.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Samuel 13:19, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("erv")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Operation Swords of Iron”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jerusalem Post")]), _vm._v(", accessed May 12, 2024, www.jpost.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 45")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 12:15, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Isaías 59:19.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Brandon Friedman and Joshua Krasna, “Between Swords of Iron and the Al Aqsa Deluge: The Regional Politics of the Israel-Hamas War”, Foreign Policy Research Institute, November 1, 2023, www.fpri.org.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 47")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Génesis 2:1–3.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Éxodo 20:8.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Shabbat 101”, My Jewish Learning, accessed May 12, 2024, www.myjewishlearning.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Patrick Anidjar, “Opening the Gates of Hell: How Hamas Carnage Unfolded on Israel’s ‘Black Shabbat,’” Times of Israel, October 27, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.timesofisrael.com/opening-the-gates-of-hell-how-hamas-carnage-unfolded-on-israels-black-shabbat/")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 48")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Levítico23:36.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Shemini Atzeret and Simchat Torah”, Judaism 101, accessed May 13, 2024, www.jewfaq.org/shemini_atzeret.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Shemini Atzeret-Simchat Torah: FAQ”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Tablet")]), _vm._v(", October 9, 2009, www.tabletmag.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Palestinians in Gaza and the West Bank Celebrate on October 7”, MEMRI TV.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Simchat Torah: About”, Sephardic U, accessed May 13, 2024, https://sephardicu.com/holidays/simchat-torah/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Palestinians in Gaza and the West Bank Celebrate on October 7”, MEMRI TV.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("AFT and TOI staff, “Arab Support for Palestinians Swelled by Euphoria Over Hamas Blow to Israel”, Times of Israel, October 10, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.timesofisrael.com/arab-support-for-palestinians-swelled-by-euphoria-over-hamas-blow-to-israel/")]), _vm._v("; Mataeo Smith, “US and Israel Flags Burned Across World as Terrifying Scenes Show Tensions Explode”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mirror US")]), _vm._v(", October 8, 2023, www.themirror.com/news/world-news/israel-flags-burned-across-world-133663.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Religious Services Ministry to Distribute 100,000s of Shekels Worth of Sweets to Children”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jerusalem Post")]), _vm._v(", September 28, 2023, www.jpost.com/breaking-news/article-760904.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Palestinians in Gaza and the West Bank Celebrate on October 7”, MEMRI TV.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("AFT and TOI staff, “Arab Support for Palestinians Swelled by Euphoria Over Hamas Blow to Israel”, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("AFT and TOI staff, “Arab Support for Palestinians Swelled by Euphoria Over Hamas Blow to Israel”, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 49")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Levítico 25:10.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Nimrod Luz, “The Holy Land From the Mamluk Sultanate to the Ottoman Empire: (1260–1799)”, in "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Oxford History of the Holy Land")]), _vm._v(", abstract, accessed May 13, 2024, https://academic.oup.com/book/45676/chapter-abstract/398062280; Ahmed H. Ibrahim, “Viewing the Tanzimat From Tulkarm”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jerusalem Quarterly ")]), _vm._v("70 (September 19, 2017): 132, www.palestine-studies.org/sites/default/files/jq-articles/Pages_from_JQ_70_-_Ibrahim_0.pdf.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Arthur Penrhyn Stanley, in Charles William Wilson, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Recovery of Jerusalem: A Narrative of Exploration and Discovery in the City and the Holy Land")]), _vm._v(" (D. Appleton, 1871).  ")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Immigration to Israel: The First Aliyah (1882–1903)”, Jewish Virtual Library, accessed May 14, 2024, www.jewishvirtuallibrary.org/the-first-aliyah-1882-1903.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Palestine Campaign”, New Zealand History, accessed May 13, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://nzhistory.govt.nz/war/palestine-campaign/overview")]), _vm._v("; Tom Segev, “View With Favor”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(", August 20, 2010, www.nytimes.com/2010/08/22/books/review/Segev-t.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Gerald Steinberg, “Remembering the Jordanian Occupation of Jerusalem”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Mosaic")]), _vm._v(", May 26, 2020, https://mosaicmagazine.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Arab Threats Against Israel”, Committee for Accuracy in Middle East Reporting and Analysis, accessed May 13, 2024, www.sixdaywar.org/precursors-to-war/arab-threats-against-israel/; “The Six-Day War: The Liberation of the Temple Mount and Western Wall”, Jewish Virtual Library.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“S.Res.176—A Resolution Commemorating the 50th Anniversary of the Reunification of Jerusalem”, Congress.gov, accessed May 13, 2024, www.congress.gov/bill/115th-congress/senate-resolution/176/text.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Presidential Proclamation Recognizing Jerusalem as the Capital of the State of Israel and Relocating the United States Embassy to Israel to Jerusalem”, Trump White House Archives, December 6, 2017, https://trumpwhitehouse.archives.gov/presidential-actions/presidential-proclamation-recognizing-jerusalem-capital-state-israel-relocating-united-states-embassy-israel-jerusalem/.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 50")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Olivia B. Waxman, “How the Yom Kippur War Changed Israel”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Time")]), _vm._v(", October 11, 2023, https://time.com/6322802/yom-kippur-war-israel-history/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Mrs. Meir Was Close to Suicide at Early Stages of the Yom Kippur War”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jewish Telegraph Agency")]), _vm._v(", December 14, 1979, www.jta.org/archive/mrs-meir-was-close-to-suicide-at-early-stages-of-the-yom-kippur-war; Waxman, “How the Yom Kippur War Changed Israel.”")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Waxman, “How the Yom Kippur War Changed Israel”; Lorris Beverelli, “The Importance of the Tactical Level: The Arab-Israeli War of 1973”, The Strategy Bridge, November 19, 2019, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://thestrategybridge.org/the-bridge/2019/11/19/the-importance-of-the-tactical-level-the-arab-israeli-war-of-1973")]), _vm._v("; Steven Simon, “The Israel That Fought the Yom Kippur War No Longer Exists”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Responsible Statecraft")]), _vm._v(", October 6, 2023, https://responsiblestatecraft.org/yom-kippur-war-50th-anniversary/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Adam Goldman et al., “Where Was the Israeli Military?”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(", January 3, 2024, www.nytimes.com/2023/12/30/world/middleeast/israeli-military-hamas-failures.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Isabel Kershner, “Hamas Attack Has Haunting Echoes of the 1973 Yom Kippur War”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(", October 7, 2023, www.nytimes.com/2023/10/07/world/middleeast/for-many-israelis-the-attacks-have-haunting-echoes-of-the-1973-yom-kippur-war.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Kershner, “Hamas Attack Has Haunting Echoes of the 1973 Yom Kippur War.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 51")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Kershner, “Hamas Attack Has Haunting Echoes of the 1973 Yom Kippur War.”")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(", s.v. “Six-Day War”, updated May 5, 2024, www.britannica.com.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 52")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Deuteronomio 4:30, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Mateo 24:12.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 53")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 6:2.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 6:4.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 6:5–6.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 6:8.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 6:8.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(", s.v. “Flag of Palestine Liberation Organization”, accessed May 13, 2024, www.britannica.com/topic/flag-of-Palestine-Liberation-Organization; Elie Podeh, “The Symbolism of the Arab Flag in Modern Arab States: Between Commonality and Uniqueness”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Nations and Nationalism")]), _vm._v(" 17, no. 2 (January 2011): 423–4, www.researchgate.net/publication/230308624_The_symbolism_of_the_Arab_flag_in_modern_Arab_states_Between_commonality_and_uniqueness.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 6:2, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 6:4, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 6:5, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Apocalipsis 6:8, traducción del autor, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 54")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 16:13, traducción del autor.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 16:14.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Amr Hamzawy, “Pay Attention to the Arab Public Response to the Israel-Hamas War”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Emissary")]), _vm._v(", November 1, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://carnegieendowment.org/2023/11/01/pay-attention-to-arab-public-response-to-israel-hamas-war-pub-90893")]), _vm._v("; “Germany Announces Complete Ban of Hamas Activities”, Al Jazeera, November 2, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.aljazeera.com/news/2023/11/2/germany-announces-complete-ban-of-hamas-activities")]), _vm._v("; Yash Bajaj, “London: People, With Palestine Flags, Celebrate Hamas’ Attack on Israel”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Times Now")]), _vm._v(", October 8, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.timesnownews.com/world/london-people-with-palestine-flags-celebrate-hamas-attack-on-israel-video-article-104248832")]), _vm._v("; Mauricio Casillas, “Crowds Rally in DC to Stand in Solidarity, Pressure US After Hamas Attack on Israel”, NBC4 Washington, October 9, 2023, www.nbcwashington.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Jewish Man and Woman Attacked in Ypres”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Brussels Times")]), _vm._v(", October 12, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.brusselstimes.com/735385/jewish-man-and-woman-attacked-in-ypres")]), _vm._v("; Etan Smallman, “Jews Are Not Safe on Britain’s Campuses”, UnHerd, November 9, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://unherd.com/2023/11/jews-are-no-longer-safe-on-britains-campuses/?=refinnar")]), _vm._v("; Kelsey Osgood, “Orthodox Jews Aren’t Safe in New York”, UnHerd, November 15, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://unherd.com/2023/11/orthodox-jews-arent-safe-in-new-york/")]), _vm._v("; “ADL Records Dramatic Increase in U.S. Antisemitic Incidents Following Oct. 7 Hamas Massacre”, Anti-Defamation League, October 24, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.adl.org")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ariel Zilber, “Coca-Cola Has Quietly Scrubbed References to Hamas-Supporting BLM From Its Website”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Post")]), _vm._v(", October 23, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://nypost.com/2023/10/23/business/coca-cola-quietly-removed-references-to-hamas-supporting-blm-from-website/")]), _vm._v("; Patrick Staveley, “Australian Jewish Community Argues NSW Police’s Claims Pro-Palestine Protesters Chanted Where’s the Jews’ Is No Better”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("SkyNews")]), _vm._v(", February 2, 2024, www.skynews.com.au/australia-news/mob-of-thugs-executive-council-of-australian-jewry-shut-down-police-Apocalipsis-of-what-propalestinian-protesters-really-shouted-at-opera-house/news-story/98faca7992cdec9f4b1b4700eb43ddb3; Dara Horn, “Why the Most Educated People in America Fall for Anti-Semitic Lies”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Atlantic")]), _vm._v(", February 15, 2024, www.theatlantic.com/ideas/archive/2024/02/jewish-anti-semitism-harvard-claudine-gay-zionism/677454/; Lucas Tress, “Pair of Swastikas Spotted at Pro-Palestinian Rally at NYC Christmas Tree Lighting”, Times of Israel, November 30, 2023, www.timesofisrael.com/pair-of-swastikas-spotted-at-pro-palestinian-rally-at-nyc-christmas-tree-lighting/; TOI Staff, “Antisemitic Cartoons Proliferate in Mideast Amid Israel-Hamas War, ADL Report Finds”, Times of Israel, December 21, 2023, www.timesofisrael.com/antisemitic-cartoons-proliferate-in-mideast-amid-israel-hamas-war-adl-report-finds/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ryan Chatelain, “Harvard President Faces Backlash Over Response to Hamas Attacks on Israel”, Spectrum News NY1, October 11, 2023, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://ny1.com")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 55")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Ezequiel 38:8, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Don Stewart, “What Is the Age/Day Theory?”, Blue Letter Bible, accessed May 12, 2024, www.blueletterbible.org/faq/don_stewart/don_stewart_657.cfm.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 38:11–12.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 38:15–23.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 27:10; 36:8; 38:2, 5.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(", “Sudan: History, Map, Area, Population, Religion, & Facts”, May 11, 2024, www.britannica.com/place/Sudan/The-kingdom-of-Kush#ref245867; “Room 65, Sudan, Egypt and Nubia: Prehistory—AD 1000s”, British Museum, accessed May 12, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.britishmuseum.org/collection/galleries/sudan-egypt-and-nubia#")]), _vm._v("; “Representing Cush in the Hebrew Bible—Biblical Archaeology Society”, Biblical Archaeology Society, accessed May 12, 2024, www.biblicalarchaeology.org.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Nakhoul, “How Hamas Secretly Built a ‘Mini-Army’ to Fight Israel”, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Wikileaks: Iranian Weapons Pass Through Sudan to Hamas”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Sudan Tribune")]), _vm._v(", December 19, 2010, https://sudantribune.com/article37017/, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Marwa Awad, “Egypt’s Bedouin Smugglers Ply Arms Trade to Gaza”, Reuters, December 15, 2010, www.reuters.com, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“Sudan Blames Israel for Khartoum Arms Factory Blast”, BBC News, October 24, 2012, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.bbc.com/news/world-africa-20050781")]), _vm._v("; Khalid Abdelaziz, Nafisa Eltahir, and John Irish, “After Fall of Bashir, Sudan Closes Door on Support for Hamas”, Reuters, September 23, 2021, www.reuters.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Abdelaziz et al., “After Fall of Bashir.” ")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Nahum 3:9.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Rick Wadholm Jr., “Gog, Magog, and Premillennialism”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("W.onderful W.orld of W.adholms")]), _vm._v(", July 18, 2014, https://rickwadholmjr.wordpress.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Flavius Josephus, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The Antiquities of the Jews")]), _vm._v(", trans. William Whiston (Project Gutenberg), chap. 6, 1, accessed May 12, 2024, www.gutenberg.org/files/2848/2848-h/2848-h.htm. ")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Samer Al-Atrush Tunis, “Marwan alAshqar: Hamas Envoy to Libya Attempted to Smuggle Missiles Into Gaza”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Times")]), _vm._v(" (London), accessed May 12, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("www.thetimes.co.uk/article/marwan-alashqar-hamas-envoy-to-libya-attempted-to-smuggle-missiles-into-gaza-thclb0t68")]), _vm._v(", énfasis añadido. ")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Ido Levy, “How Iran Fuels Hamas Terrorism”, Washington Institute for Near East Policy, June 1, 2021, www.washingtoninstitute.org/policy-analysis/how-iran-fuels-hamas-terrorism, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Levy, “How Iran Fuels Hamas Terrorism”, énfasis añadido")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("J. Richardson, “The Nations of Gog and Magog”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The New Moody Atlas of the Bible")]), _vm._v(", accessed May 12, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://joelstrumpet.com/wp-content/uploads/2018/04/The-Location-of-Magog-Meshech-and-Tubal-1.pdf")]), _vm._v("; Seton H. F. Lloyd et al., “Anatolia: Definition, History, Map, People, & Facts”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopedia Britannica")]), _vm._v(", March 28, 2024, www.britannica.com/place/Anatolia.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Jo Becker and Justin Scheck, “Israel Found the Hamas Money Machine Years Ago. Nobody Turned It Off”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New York Times")]), _vm._v(", updated December 28, 2023, www.nytimes.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Jonathan Spicer, “U.S. Presses Sceptical Turkey to Curb Hamas Fundraising”, Reuters, November 30, 2023, www.reuters.com, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Abdullah Bozkurt, “Turkish-Backed Group in Libya Smuggling Arms to Hamas”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Nordic Monitor")]), _vm._v(", January 17, 2024, "), _c('a', {
    attrs: {
      "href": "#/."
    }
  }, [_vm._v("https://nordicmonitor.com")]), _vm._v(", énfasis añadido. ")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Online Etymology Dictionary")]), _vm._v(", s.v. “Persia”, accessed May 12, 2024, www.etymonline.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Becker and Scheck, “Israel Found the Hamas Money Machine Years Ago”, énfasis añadido")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Kenneth Katzman, “Iran’s Foreign and Defense Policies (R44017)”, Congressional Research Service, January 30, 2020, www.google.com/url?q=https://crsreports.congress.gov.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Michael Biesecker, “Who Builds the Weapons That Hamas Fighters Use”, AP News, January 15, 2024, https://apnews.com/article/israel-hamas-war-guns-weapons-missiles-smuggling-adae9dae4c48059d2a3c8e5d565daa30, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Ido Levy, “How Hamas Built an Army”, Washington Institute for Near East Policy, January 2, 2024, www.washingtoninstitute.org, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Levy, “How Hamas Built an Army”, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(", “Ezequiel: Hebrew Prophet & Biblical Visionary”, April 12, 2024, www.britannica.com/biography/Ezequiel-Hebrew-prophet; “Judaea: Ancient Region, Middle East History & Culture”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(", May 27, 1999, www.britannica.com/place/Judaea.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Ezequiel 38:9, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 56")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 12:7, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel 1:1–6.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel 10:4–5.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel 10:12–13, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Persian Empire”, History, May 30, 2023, www.history.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel 10:14.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“From Friends to Foes: How Iranian-Israeli Relations Transformed Over 70 Years”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("The")]), _vm._v(" "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("New Arab")]), _vm._v(", October 23, 2023, www.newarab.com/news/how-iran-and-israel-went-being-allies-bitter-foes; Behnam Ben Taleblu, “When Iran Says ‘Death to Israel,’ It Means It”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Atlantic")]), _vm._v(", July 15, 2022, www.dailyalert.org/rss/Mainissues.php?id=84381.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Country Reports on Terrorism 2021: Iran”, US Bureau of Counterterrorism, accessed May 13, 2024, www.state.gov/reports/country-reports-on-terrorism-2021/iran/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Country Reports on Terrorism 2021”, US Bureau of Counterterrorism.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Efraim Inbar, “Iran and Israel: The Inevitable War?”, Abstract, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("SIRIUS—Zeitschrift für Strategische Analysen")]), _vm._v(", 4, no. 4 (2020), De Gruyter, November 27, 2020,https://doi.org/10.1515/sirius-2020-4007.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Daniel 10:13.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Daniel 12:1, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("hnv")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Apocalipsis 12:7, traducción del autor, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 57")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Maziar Motamedi, “Who Was Mohammad Reza Zahedi, an Iranian General Killed by Israel in Syria?”, Al Jazeera, April 2, 2024, www.aljazeera.com/news/2024/4/2/who-was-mohammad-reza-zahedi-the-iranian-general-assassinated-by-israel; “Counter Terrorism Designations; IRGC Foreign Terrorist Organization Designation”, US Department of the Treasury, April 15, 2019, https://ofac.treasury.gov/recent-actions/20190415_33; “Spotlight on Terrorism: Hezbollah, Lebanon and Syria (April 8–15, 2024)”, The Meir Amit Intelligence and Terrorism Information Center, April 16, 2024, www.terrorism-info.org.il/en/spotlight-on-terrorism-hezbollah-lebanon-and-syria-april-8-15-2024/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Hezbollah Barrages Deal Heavy Damage in Northern Israel”, Agence France-Presse, May 24, 2024, www.france24.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Motamedi, “Who Was Mohammad Reza Zahedi?”")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Coalition Council of Islamic Revolution Forces: Zahedi ‘Played a Strategic Role’ in ‘the Planning and Execution of Al-Aqsa Flood,’” MEMRI, April 9, 2024, www.memri.or.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Maziar Motamedi, “‘True Promise’: Why and How Did Iran Launch a Historic Attack on Israel?”, Al Jazeera, April 14, 2024, www.aljazeera.com/news/2024/4/14/true-promise-why-and-how-did-iran-launch-a-historic-attack-on-israel.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ben Aris, “Iran’s Attempt at a ‘Goldilocks Retaliation’ Strike on Israel Was Designed to Fail, but Tensions Remain High”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("bne IntelliNews")]), _vm._v(", April 14, 2024, www.intellinews.com/iran-s-attempt-at-a-goldilocks-retaliation-strike-on-israel-was-designed-to-fail-but-tensions-remain-high-320918/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Aris, “Iran’s Attempt at a ‘Goldilocks Retaliation’ Strike on Israel Was Designed to Fail.”")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("John Jeffay, “15 Things You Don’t Know About Israel’s Air Defense Systems”, Israel21c, April 22, 2024, www.israel21c.org/15-things-you-dont-know-about-israels-air-defense-systems/; Mark Vitner and Saul Vitner, “Israel Responds With a Precise, Limited Strike”, Piedmont Crescent Capital, April 23, 2024, https://piedmontcrescentcapital.com/israel-responds-with-a-precise-limited-strike/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Crónicas 27:34, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 58")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jon Gambrell, “Iran’s President and Foreign Minister Die in Helicopter Crash at Moment of High Tensions in Mideast”, Associated Press, May 20, 2024, https://apnews.com/article/iran-president-ebrahim-raisi-426c6f4ae2dd1f0801c73875bb696f48.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Doha Madani, “Iranian President Ebrahim Raisi, Known for Brutal Crackdowns Against Political Opposition, Dies at 63”, NBC News, May 20, 2024, www.nbcnews.com/news/world/iranian-president-ebrahim-raisi-dead-63-helicopter-cras-rcna152967.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Madani, “Iranian President Ebrahim Raisi”; Gambrell, “Iran’s President and Foreign Minister Die in Helicopter Crash at Moment of High Tensions in Mideast.”")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Génesis 12:3.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Zacarías 2:8.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Reuters and TOI staff, “Iranian President Threatens Israel’s Annihilation If Major Attack Occurs”, Times of Israel, April 23, 2024, www.timesofisrael.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("TOI staff and Agencies, “‘Nothing Will Be Left of Israel’ If It Attacks Us, Iranian Commander Threatens”, Times of Israel, September 28, 2019, www.timesofisrael.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Nothing Will Remain of Israeli Regime If It Attacks Iran: Raisi”, Islamic Republic News Agency, April 23, 2024, https://en.irna.ir.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Former Iran President Threatens Israel in Final Public Speech”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Middle East Monitor")]), _vm._v(", May 20, 2024, www.middleeastmonitor.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Ezequiel 39:2–4.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“Nothing Will Remain of Israeli Regime if It Attacks Iran”, Islamic Republic News Agency. ")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Levítico 24:16.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Levítico 24:16.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Levítico 24:23.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 59")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 13:1–2, traducción del autor.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Tesalonicenses 2:3–4, esv, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Tesalonicenses 2:4.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 13:6.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel 7:25, leb.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Tesalonicenses 2:4, traducción del autor.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Juan 4:3.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 61")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 16:14, 16.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 62")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 12:13–14, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel 12:7, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel 7:25, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 13:5, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 12:6, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 11:2, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel 9:27, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel 9:27.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 63")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Isaías 2:2.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Ben Gvir Reportedly Makes It a Ministry Policy to Change Temple Mount Status Quo”, Times of Israel, April 17, 2024, www.timesofisrael.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Nidal Al-Mughrabi and Sinan Abu Mayzer, “Violence Erupts Again at Jerusalem’s Al-Aqsa Mosque”, Reuters, April 5, 2023, www.reuters.com/world/middle-east/cross-border-fire-gaza-after-israeli-police-raid-al-aqsa-mosque-2023-04-05/.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Richard Allen Greene et al., “Attacks in West Bank, Tel Aviv as Tensions Remain High Following Israeli Strikes”, CNN, April 8, 2023, www.cnn.com/2023/04/06/middleeast/lebanon-rockets-israel-intl/index.html.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Resistance Groups Warn Israel Against ‘Playing With Fire’ After Al-Aqsa Mosque Incursion”, PressTV, April 26, 2023, www.presstv.ir/Detail/2023/04/26/702244/Palestinian-groups-warn-Israel-against-%E2%80%98playing-with-fire%E2%80%99-after-incursion-into-Aqsa-Mosque-prayer-space.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Haniyeh Outlines Context and Objectives of Hamas Operation Al-Aqsa Flood”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Middle East Monitor")]), _vm._v(", October 9, 2023, www.middleeastmonitor.com/20231009-haniyeh-outlines-context-and-objectives-of-hamas-operation-al-aqsa-flood/, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Haniyeh Outlines Context and Objectives of Hamas Operation Al-Aqsa Flood”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Middle East Monitor")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Haniyeh Outlines Context and Objectives of Hamas Operation Al-Aqsa Flood”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Middle East Monitor")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Nan Jacques Zilberdik, “Fatah: Hamas Massacre Brought ‘a Morning of Victory, Joy, [and] Pride,’” Palestinian Media Watch, October 8, 2023, https://palwatch.org/page/34628, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Giulia Carbonaro, “Osama Bin Laden’s Letter to America: Transcript in Full”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Newsweek")]), _vm._v(", November 18, 2023, www.newsweek.com/osama-bin-laden-letter-america-transcript-full-1844662, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“Haniyeh Outlines Context and Objectives of Hamas Operation Al-Aqsa Flood”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Middle East Monitor")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“Resistance Strikes Will Increase in Coming Days—Abu Obeida’s Speech on the 100th Day of War”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestine Chronicle")]), _vm._v(", January 14, 2024, www.palestinechronicle.com/resistance-strikes-will-increase-in-coming-days-abu-obeidas-speech-on-the-100th-day-of-war/, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("“Resistance Strikes Will Increase in Coming Days”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Palestine Chronicle")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Mateo Tostevin, “Holy War: Red Cows, Gaza and the End of the World”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Newsweek")]), _vm._v(", April 5, 2024, www.newsweek.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Tostevin, “Holy War.”")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2-10-"
  }, [_vm._v("Abdennour Toumi, “Al-Aqsa Flood Operation: Reactions in the Maghreb”, NATO Defense College Foundation, March 13, 2024, www.natofoundation.org.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 64")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Levítico23:5.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Gaza, Temple Mount, and the Passover Lamb: A Story of Holiday Conflict”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Israel Today")]), _vm._v(", April 5, 2023, www.israeltoday.co.il.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("“Haniyeh Outlines Context and Objectives of Hamas Operation Al-Aqsa Flood”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Middle East Monitor")]), _vm._v(", énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 65")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1 Reyes 8:54–55.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Reyes 8:63.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Reyes 8:65.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("1 Reyes 8:66.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Yitzi Hurwitz, “The Dedication of the Holy Temple”, Chabad-Lubavitch Media Center, October 16, 2017, www.chabad.org/library/article_cdo/aid/3816050/jewish/The-Dedication-of-the-Holy-Temple.htm#.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 66")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 12:17, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 13:7, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Daniel 7:25, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("hcsb")]), _vm._v(", énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("2 Tesalonicenses 2:3, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 69")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Efesios 2:12, 19, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("hcsb, ")]), _vm._v("énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Ezequiel 37:10, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Aaron Leibel, “The Unknown Story of Smuggling Weapons to Help Win Israel’s Independence”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Jerusalem Post")]), _vm._v(", June 4, 2020, www.jpost.com.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Jeremías 30:10; 46:27, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("esv")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Eric Black, “An Oath and a Chant”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Frontline")]), _vm._v(", accessed May 13, 2024, www.pbs.org.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 70")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 12:4, traducción del autor.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Lucas 19:41–42.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 71")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1 Juan 3:8, traducción del autor.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 72")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Apocalipsis 12:11.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Apocalipsis 12:12, traducción del autor, énfasis añadido.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Christian Goeschel, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Suicide in Nazi Germany")]), _vm._v(" (Oxford University Press, 2009).")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Salmos 136, "), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("niv")]), _vm._v(".")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Shushma Malik and Caillan Davenport, “Mythbusting Ancient Rome—Throwing Christians to the Lions”, University of Queensland, November 22, 2016, https://hpi.uq.edu.au/article/2016/11/mythbusting-ancient-rome-%E2%80%93-throwing-christians-lions.")]), _vm._v(" "), _c('li', {
    staticClass: "ENDNOTES-2"
  }, [_vm._v("Lyubov Soskovets, Sergei Krasilnikov, and Dina Mymrina, “Persecution of Believers as a Systemic Feature of the Soviet Regime”, "), _c('span', {
    staticClass: "ITAL _idGenCharOverride-1"
  }, [_vm._v("Semantic Scholar")]), _vm._v(" (2016), https://doi.org/10.1051/shsconf/20162801098.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 73")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Jeremías 31:35–36, traducción del autor, énfasis añadido.")])]), _vm._v(" "), _c('p', {
    staticClass: "ENDNOTE-HEAD"
  }, [_vm._v("Capítulo 75")]), _vm._v(" "), _c('ol', [_c('li', {
    staticClass: "ENDNOTES-1 _idGenParaOverride-1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1 Corintios 2:9.")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "318",
      "epub:type": "pagebreak",
      "id": "page318",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "Marco-de-texto-b-sico",
    attrs: {
      "id": "_idContainer092"
    }
  }, [_c('p', {
    staticClass: "CHAP-TITLE",
    attrs: {
      "id": "_idParaDest-182"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor076"
    }
  }), _vm._v("Sobre Jonathan Cahn")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("J")]), _c('span', {
    staticClass: "SM-CAP"
  }, [_vm._v("onathan Cahn causó ")]), _vm._v("un gran revuelo en todo el mundo con el lanzamiento del best seller El presagio, destacado por la lista del New York Times así como también sus posteriores obras galardonadas. Cahn fue seleccionado, junto con Billy Graham, como uno de los líderes espirituales más importantes de los últimos cuarenta años “que cambiaron radicalmente nuestro mundo”. Ha hablado en las Naciones Unidas, en el Capitolio, en el Congreso de Estados Unidos y a millones de personas. Es conocido como una voz profética para nuestros tiempos, respaldado por la revelación que ha expuesto acerca de los profundos misterios de Dios. Sus enseñanzas en YouTube han sido vistas por más de 100 millones de personas.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Jonathan Cahn dirige Hope of the World, un ministerio que lleva la Palabra de Dios al mundo y patrocina proyectos de compasión para los más necesitados del orbe. Además, lidera Beth Israel The Jerusalem Center, su base ministerial y centro de adoración en Wayne, Nueva Jersey, en las afueras de la ciudad de Nueva York.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("Cahn ministra y dicta conferencias en todo Estados Unidos y el mundo. Para ponerte en contacto con él, recibir actualizaciones proféticas y obsequios de su ministerio (mensajes especiales y mucho más), así como para obtener más información o participar en la Gran Comisión, lo puedes hacer a través de los siguientes contactos.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('strong', {
    staticClass: "b _idGenCharOverride-1"
  }, [_vm._v("Facebook:")]), _vm._v("\tJonathan Cahn (Official Site)     ")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('strong', {
    staticClass: "b _idGenCharOverride-1"
  }, [_vm._v("YouTube:")]), _vm._v("\tJonathan Cahn Official")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('strong', {
    staticClass: "b _idGenCharOverride-1"
  }, [_vm._v("X (formerly Twitter):")]), _vm._v("\t@Jonathan_Cahn")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('strong', {
    staticClass: "b _idGenCharOverride-1"
  }, [_vm._v("Instagram:")]), _vm._v("\tjonathan.cahn")]), _vm._v(" "), _c('p', {
    staticClass: "p _idGenParaOverride-1"
  }, [_c('strong', {
    staticClass: "b _idGenCharOverride-1"
  }, [_vm._v("Email:")]), _vm._v("\tcontact@hopeoftheworld.org")])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "319",
      "epub:type": "pagebreak",
      "id": "page319",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer093"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/Johnathan_Cahn-publicidad.png"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "320",
      "epub:type": "pagebreak",
      "id": "page320",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer094"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/333.png"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "321",
      "epub:type": "pagebreak",
      "id": "page321",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer095"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/335.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "322",
      "epub:type": "pagebreak",
      "id": "page322",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer096"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/336.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "323",
      "epub:type": "pagebreak",
      "id": "page323",
      "role": "doc-pagebreak"
    }
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "IMAGEN-RELATIVO-AL-FLUJO-DE-TXT",
    attrs: {
      "id": "_idContainer097"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/contra_CVR_la_profecia_del_dragon.jpg"
    }
  })])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781960436634',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(64)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(66);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 66 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.89b7d84264cf66cc907b.js